(function () {
    'use strict';
    angular.module('rsplCharityV2', [
        'ngAnimate',
        'ui.router',
        'ui.bootstrap',
        'ui.select',
        'ngFileUpload',
        'angular-ladda',
        'uiGmapgoogle-maps',
        'ngPrint',
        'ngTagsInput',
        'angularMoment',
        'slickCarousel',
        'ngSanitize',
        'daterangepicker',
        'timer',
        'ngScrollbars',
        'infinite-scroll',
        'textAngular',
        'ngMap',
        'ngActionCable',
        'ngclipboard',
        'chart.js',
        'colorpicker.module',
        'textAngular'
    ]).constant('moment', moment)
        .factory('httpInterceptor', function ($q, $location, $rootScope, apiVersion) {
            return {
                request: function (config) {
                    if (localStorage.getItem('rspl-token')) {
                        config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('rspl-token');
                        config.headers['X-Api-Version'] = apiVersion;
                    }
                    config.headers['Accept'] = 'application/json';
                    return config;
                },
                responseError: function (response) {
                    if (response.status === 401) {
                        if (localStorage.getItem('rspl-token')) {
                            $rootScope.$broadcast('refresh-token');
                        } else {
                            localStorage.clear();
                            $location.url('#/login');
                        }
                    }
                    return $q.reject(response);
                }
            };
        })
        .provider('loginRedirect', loginRedirect)
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('loginRedirect');
        }])
        .config(function (ScrollBarsProvider) {
            ScrollBarsProvider.defaults = {
                scrollButtons: {
                    enable: false
                },
                theme: 'dark-3',
                autoHideScrollbar: true,
                advanced: {
                    updateOnContentResize: true
                }
            };
        });
    var loginState = 'login',
        lastState = 'calendar',
        lastStateParamas = {};

    function loginRedirect() {
        /* jshint validthis:true */
        this.$get = LoginRedirect;

        /* @ngInject */
        function LoginRedirect($location, $injector, $rootScope, $timeout) {
            var stateChange = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                    $injector.get('$uibModalStack').dismissAll();
                    if (localStorage.getItem('rspl-token')) {
                        var user = localStorage.getItem('rspl-user');
                        if (user) {
                            try {
                                user = angular.fromJson(user);
                            } catch (e) {
                                localStorage.clear();
                                $injector.get('$state').go('login');
                            }
                            if (!user.first_name) {
                                localStorage.clear();
                                $injector.get('$state').go('login');
                            } else if (localStorage.getItem('rspl-contract-signed') !== 'true' && toState.name !== 'payment') {
                                $timeout(function () {
                                    $injector.get('$state').go('calendar');
                                    // $injector.get('$state').go('payment');
                                }, 0)
                            }
                        }
                    }
                    var token = localStorage.getItem('rspl-token');
                    if (token && token !== '') {
                        // user is authenticated
                        if (toState.name === loginState) {
                            //user tries to access login or register state
                            var onboardingData = location.href.split('?')[1];
                            if (!onboardingData) {
                                event.preventDefault();
                                $injector.get('$state').go(lastState);
                            } else {
                                // localStorage.clear();
                                // location.reload(true);
                            }
                        }
                    }
                    else if (toState.name !== loginState) {
                        event.preventDefault();
                        $injector.get('$state').go(loginState);
                    }
                }
            );
            $rootScope.$on('$destroy', stateChange);
            return {
                redirectPreLogin: function () {
                    if (lastState && lastState !== loginState) {
                        $injector.get('$state').go(lastState, lastStateParamas);
                        $injector.get('$location').replace();
                        lastState = '';
                    } else {
                        $location.path('');
                    }
                }
            };
        }
    }

    moment.updateLocale('en', {
        calendar: {
            lastDay: '[Yesterday]',
            sameDay: '[Today]',
            nextDay: '[Tomorrow]'
        }
    });
    moment.fn.daysBefore = function () {
        var date = this;
        var today = moment().endOf('day');
        var tomorrow = moment().add(1, 'day').endOf('day');
        var yesterday = moment().add(-1, 'day').endOf('day');
        var day_before_yesterday = moment().add(-2, 'day').endOf('day');

        if (date > day_before_yesterday && date <= yesterday) return 'yesterday';
        else if (date > yesterday && date <= today) return 'today';
        else if (date > today && date <= tomorrow) return 'tomorrow';

        return date.fromNow();
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DeleteContactController', DeleteContactController);

    /** @ngInject */
    function DeleteContactController($uibModalInstance, contact) {
        var vm = this;

        vm.close = close;
        vm.deleteContact = deleteContact;

        vm.contact = contact;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function deleteContact() {
            vm.deletingContact = true;
            $uibModalInstance.close();
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('rsplCharityV2')
    .controller('PickupReportGalleryController', PickupReportGalleryController);

  /** @ngInject */
  function PickupReportGalleryController($uibModalInstance, photos, index, imageBaseUrl) {
    var vm = this;

    vm.imageBaseUrl = imageBaseUrl;

    vm.photos = photos;
    vm.current = index;

    vm.close = close;

    function close() {
      $uibModalInstance.dismiss();
    }


  }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('NoTrucksPromptController', NoTrucksPromptController);

    /** @ngInject */
    function NoTrucksPromptController($uibModalInstance, promptData) {
        var vm = this;

        vm.close = close;

        vm.promptData = promptData;

        function close() {
            $uibModalInstance.close();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('GalleryController', GalleryController);

    /** @ngInject */
    function GalleryController($uibModalInstance, donation, baseUrl, imageBaseUrl, $document) {
        var vm = this;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;
        vm.donation = donation;

        vm.close = close;

        $document.on('keydown', function(e) {
            if(e.keyCode === 37) {
                angular.element('.rspl-icon.icon-arrow-right.single-donation-arrow').click();
            }
            if(e.keyCode === 39) {
                angular.element('.rspl-icon.icon-arrow-left.single-donation-arrow').click();
            }
        });


        vm.slickConfig = {
            dots: false,
            arrows: true,
            focusOnSelect: true,
            nextArrow: '<span class="rspl-icon icon-arrow-right single-donation-arrow"></span>',
            prevArrow: '<span class="rspl-icon icon-arrow-left single-donation-arrow"></span>'
        };

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('EditUserController', EditUserController);

    /** @ngInject */
    function EditUserController($uibModalInstance, user, UsersService) {
        var vm = this;

        vm.close = close;
        vm.editUser = editUser;
        vm.editingUser = false;
        vm.user = user;

        // init();

        // function init() {
        //   UsersService.getUserRoles(vm.user.id)
        //   .success(function (roles) {
        //       console.log(roles);
        //   })
        //   .error(function (errorData) {
        //       console.log(errorData);
        //       vm.addAlert('danger', errorData.message);
        //   })
        // }

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function editUser(user) {
            vm.editingUser = true;
            UsersService.updateUser(user)
                .success(function (data) {
                    $uibModalInstance.close(data);
                    vm.editingUser = false;
                })
                .error(function (errorData) {
                    vm.editingUser = false;
                    console.log(errorData);
                    vm.addAlert('danger', errorData.message);
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('AddUserController', AddUserController);

    /** @ngInject */
    function AddUserController($uibModalInstance, UsersService) {
        var vm = this;

        vm.role = 'charity_admin';
        vm.roles = ['charity_admin', 'charity_driver'];
        vm.close = close;
        vm.add = add;
        vm.adding = false;


        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function add() {
            vm.adding = true;
            UsersService.createUser(vm.user)
                .success(function (data) {
                  UsersService.createUserRole(data.id, vm.role, localStorage.getItem('rspl-charity-id'))
                  .success(function (role) {
                    $uibModalInstance.close(data);
                    vm.adding = false;
                  })
                  .error(function (errorData) {
                    var additionalMsg = '';
                    vm.adding = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                })

                })
                .error(function (errorData) {
                    var additionalMsg = '';
                    vm.adding = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ViewDonorController', ViewDonorController);

    /** @ngInject */
    function ViewDonorController(donor, $uibModal, $uibModalInstance, baseUrl, imageBaseUrl, DonationsService, $state, $window, $timeout) {
        var vm = this;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;
        vm.contact = donor;

        vm.getTaxReceipt = getTaxReceipt;
        vm.startConversation = startConversation;
        vm.print = print;
        vm.close = close;
        vm.nextPage = nextPage;
        vm.openDonation = openDonation;

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function close() {
            $uibModalInstance.dismiss();
        }

        activate();

        function activate() {
            vm.page = 1;
            vm.slickConfig = {
                dots: true,
                arrows: true,
                focusOnSelect: true,
                nextArrow: '<span class="rspl-icon icon-arrow-right"></span>',
                prevArrow: '<span class="rspl-icon icon-arrow-left"></span>',
                dotsClass: 'custom_paging',
                customPaging: function (slider, i) {
                    return (i + 1) + '/' + slider.slideCount;
                }
            };

            vm.isLoading = true;
            getDonations();
        }

        function getDonations() {
            vm.isLoading = true;
            DonationsService.searchDonations({contact_id: vm.contact.id, page: vm.page}).then(function (data) {
                vm.page = data.headers().current_page;
                vm.totalPages = data.headers().total_pages;
                if (!vm.donations) {
                    vm.donations = data.data;
                } else {
                    vm.donations = vm.donations.concat(data.data);
                }
                vm.isLoading = false;
            }).catch(function (errorData) {
                var additionalMsg = '';
                vm.isSubmitting = false;
                for (var prop in errorData.additional_data) {
                    additionalMsg += prop + " " + errorData.additional_data[prop];
                }
                vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
            })
        }


        function startConversation(donation, event) {
            event.stopPropagation();
            close();
            localStorage.setItem('rspl-start-conversation', angular.toJson({
                id: donation.request.donor.id,
                first_name: donation.request.donor.first_name,
                last_name: donation.request.donor.last_name
            }));
            $state.go('messages');
        }

        function getTaxReceipt(donation, event) {
            if (event) event.stopPropagation();
            if (donation.tax_receipt_pdf_ready && donation.tax_receipt_pdf_url) {
                $window.open(donation.tax_receipt_pdf_url, '_blank');
            } else if (!donation.tax_receipt_pdf_ready && !donation.tax_receipt_pdf_url) {
                DonationsService.getTaxLink(donation.id)
                    .then(function (response) {
                        donation.tax_receipt_pdf_url = response.data.url;
                        if (!response.data.url) {
                            $timeout(function() {
                                vm.getTaxReceipt(donation)
                            }, 1000);
                        } else {
                            $window.open(donation.tax_receipt_pdf_url, '_blank');
                        }
                    })
                    .catch(function (error) {
                        vm.addAlert('danger', 'Something went wrong, ' + error.message);
                    })
            } else if (donation.tax_receipt_pdf_ready && !donation.tax_receipt_pdf_url) {
                $window.open(baseUrl + '/tax-receipts/' + donation.id + '/tax-receipt.pdf', '_blank');
            }
        }

        function print(donation, event) {
            event.stopPropagation();
            close();
            $state.go('single', {
                id: donation.id,
                print: true
            });
        }

        function nextPage() {
            vm.page++;
            getDonations();
        }

        function openDonation(donationId, shouldPrint, e) {
            if (e) e.stopPropagation();
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'single-donation-modal',
                templateUrl: 'app/donations/prompts/single/single.donation.html',
                controller: 'SingleDonationController',
                controllerAs: 'singleCtrl',
                resolve: {
                    donationId: donationId,
                    print: shouldPrint
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function () {
                    //action
                })
        }

        function showTaxReceiptNotReadyModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/donations/prompts/no-tax/no-tax.html',
                controller: 'NoTaxController',
                controllerAs: 'noTaxCtrl',
                size: 'sm'
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('RemoveDonorController', RemoveDonorController);

    /** @ngInject */
    function RemoveDonorController($uibModalInstance, donor) {
        var vm = this;

        vm.close = close;
        vm.remove = remove;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function remove() {
            vm.isLoading = true;
            donor;
            // DonationsService.cancelDonation(donation.id, donation.request.id, vm.reason)
            //     .success(function () {
            vm.isLoading = false;
            $uibModalInstance.close();
            // })
            // .error(function (errorData) {
            //     vm.addAlert('danger', 'Oops, Something went wrong, ' + errorData.message);
            // });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ExportContactsModalController', ExportContactsModalController);

    /** @ngInject */
    function ExportContactsModalController($uibModalInstance, UsersService) {
        var vm = this;

        vm.close = close;
        vm.exportToXLS = exportToXLS;

        var charityName = localStorage.getItem('rspl-charity');
        var today = moment().format('MM-DD-YYYY');
        var exportFileName = charityName + ' Donor Database as of ' + today + '.xlsx';

        vm.pagination = {
            current_page: 1,
            per_page: 100
        }

        vm.contactsToExport = [];
        var responseTimes = 0;

        activate();

        function activate() {
            getContacts();
        }

        function close() {
            $uibModalInstance.dismiss();
        }

        function getContacts() {
            var sendDate = (new Date()).getTime();
            vm.isLoading = true;
            var data = {
                page: vm.pagination.current_page,
                per_page: 100,
                sort_by: 'donations_count',
                order: 'desc'
            };

            UsersService.searchAll(data).then(function (response) {
                vm.pagination.current_page = parseInt(response.headers().current_page);
                vm.pagination.total_pages = parseInt(response.headers().total_pages);

                response.data.forEach(function(donor) {
                    if (donor.address) { donor.address = donor.address.replace(/#/g, '').replace(/,/g, ';'); }
                    if (donor.first_name) { donor.first_name = donor.first_name.replace(/#/g, '').replace(/,/g, ';'); }
                    if (donor.last_name) { donor.last_name = donor.last_name.replace(/#/g, '').replace(/,/g, ';'); }
                    delete donor.reference_name;
                    delete donor.address2;
                    donor = _.forEach(donor, function (value, key){
                        if (value === null) {
                            donor[key] = '';
                        }
                    })
                })

                vm.contactsToExport = vm.contactsToExport.concat(response.data);

                var receiveDate = (new Date()).getTime();
                var responseTimeMs = receiveDate - sendDate;
                responseTimes = responseTimes + responseTimeMs;
                var averageResponseTime = responseTimes / vm.pagination.current_page;

                vm.timeLeft = (averageResponseTime / 1000) * (vm.pagination.total_pages - vm.pagination.current_page);
                if (vm.timeLeft > 90) {
                    vm.timeLeftMessage = Math.round(vm.timeLeft / 60) + ' minutes remaining';
                } else {
                    vm.timeLeftMessage = Math.round(vm.timeLeft) + ' seconds remaining';
                }

                if (vm.pagination.total_pages > vm.pagination.current_page) {
                    vm.pagination.current_page = vm.pagination.current_page + 1;
                    getContacts();
                } else {
                    vm.fetchingDone = true;
                }
            }).catch(function (errorData) {
                if (errorData.data) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                }
                vm.isLoading = false;
            });
        }

        function exportToXLS() {
            alasql("SELECT * INTO XLSX('"+exportFileName+"',{headers:true}) FROM ? ",  [vm.contactsToExport]); // eslint-disable-line no-undef
            close();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('EditContactController', EditContactController);

    /** @ngInject */
    function EditContactController($uibModalInstance, contact, ContactService) {
        var vm = this;

        vm.close = close;
        vm.editContact = editContact;
        vm.editingContact = false;
        vm.contact = contact;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function editContact(contact) {
            vm.editingContact = true;
            ContactService.updateContact(contact)
                .success(function (data) {
                    $uibModalInstance.close(data);
                    vm.editingContact = false;
                })
                .error(function (errorData) {
                    vm.editingContact = false;
                    console.log(errorData);
                    vm.addAlert('danger', errorData.message);
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('AddContactController', AddContactController);

    /** @ngInject */
    function AddContactController($uibModalInstance, ContactService) {
        var vm = this;

        vm.close = close;
        vm.addContact = addContact;
        vm.addingContact = false;
        vm.homeType = 'house';


        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function addContact() {
            vm.addingContact = true;
            ContactService.createContact(vm.contact)
                .success(function (data) {
                    $uibModalInstance.close(data);
                    vm.addingContact = false
                })
                .error(function (errorData) {
                    var additionalMsg = '';
                    vm.addingContact = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('EditGroupController', EditGroupController);

    /** @ngInject */
    function EditGroupController($stateParams, DonorGroupService, ContactService) {
        var vm = this;

        vm.selectAllGroupContacts = selectAllGroupContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.selectContactItem = selectContactItem;
        vm.addContactsToGroup = addContactsToGroup;
        vm.removeContactsFromGroup = removeContactsFromGroup;
        vm.editDonorGroup = editDonorGroup;
        vm.getContactsByCharityId = getContactsByCharityId;
        vm.getAllGroups = getAllGroups;
        vm.getSelectedGroup = getSelectedGroup;

        vm.groupContactsSelected = false;
        vm.allContactsSelected = false;
        vm.scrollConfig = {
            autoHideScrollbar: false,
            theme: 'dark-3',
            scrollInertia: 0,
            axis: 'y',
            advanced: {
                updateOnContentResize: true
            }
        };

        var previousGroupId;

        activate();

        vm.fetchingAllContacts = false;
        vm.fetchingGroupContacts = false;


        function activate() {
            vm.current_group = {};
            vm.current_group.id = $stateParams.id;
            getAllGroups();
            getDonorGroup(vm.current_group.id);

        }

        function getDonorGroup(id) {
            vm.fetchingGroupContacts = true;
            DonorGroupService.getGroupById(id)
                .success(function (data) {
                    vm.current_group = data;
                    DonorGroupService.getGroupContacts(id)
                        .success(function (data) {
                            vm.current_group.contacts = data;
                            getContactsByCharityId('app_user');
                            vm.fetchingGroupContacts = false;
                        });

                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.fetchingGroupContacts = false;
                })
        }

        function getContactsByCharityId(filter) {
            vm.fetchingAllContacts = true;
            vm.activeFilter = filter;
            vm.selectedGroup = null;
            ContactService.getContactsByCharityId(filter)
                .success(function (data) {
                    vm.contacts = data;
                    removeContactIfIsInGroup();
                    vm.fetchingAllContacts = false;

                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.fetchingAllContacts = false;

                })
        }

        function removeContactIfIsInGroup() {
            var ids = [];
            vm.contacts.forEach(function (each, i) {
                vm.current_group.contacts.forEach(function (contact) {
                    if(each.id === contact.id) {
                        ids.push(each.id);
                    }
                })
            });
            ids.forEach(function (id) {
                vm.contacts.forEach(function (contact) {
                    if (id === contact.id) {
                        var i = vm.contacts.indexOf(contact);
                        vm.contacts.splice(i, 1);
                    }
                })
            });
        }

        function selectAllGroupContacts() {
            if(!vm.current_group.contacts.length) { return }
            if (!vm.groupContactsSelected) {
                vm.current_group.contacts.forEach(function (contact) {
                    contact['selected'] = true;
                })
            } else {
                vm.current_group.contacts.forEach(function (contact) {
                    contact['selected'] = false;
                })
            }
            vm.groupContactsSelected = !vm.groupContactsSelected;
        }
        function selectAllContacts() {
            if(!vm.contacts.length) { return }
            if (!vm.allContactsSelected) {
                vm.contacts.forEach(function (contact) {
                    contact['selected'] = true;
                })
            } else {
                vm.contacts.forEach(function (contact) {
                    contact['selected'] = false;
                })
            }
            vm.allContactsSelected = !vm.allContactsSelected;
        }

        function selectContactItem(contact) {
            if (angular.isDefined(contact['selected'])) {
                contact['selected'] = !contact['selected'];
            } else {
                contact['selected'] = true;
            }
        }

        function addContactsToGroup() {
            var ids = [];
            vm.contacts.forEach(function (contact) {
                if (contact['selected']) {
                    var i = vm.contacts.indexOf(contact);
                    ids.push(contact.id);
                    vm.selectContactItem(contact);
                    vm.current_group.contacts.push(contact);
                }
            });
            ids.forEach(function (id) {
                vm.contacts.forEach(function (contact) {
                    if (id === contact.id) {
                        var i = vm.contacts.indexOf(contact);
                        vm.contacts.splice(i, 1);
                    }
                })
            });
            if(vm.allContactsSelected) {
                vm.allContactsSelected = !vm.allContactsSelected;
            }
        }
        function removeContactsFromGroup() {
            var ids = [];
            vm.current_group.contacts.forEach(function (contact) {
                if (contact['selected']) {
                    var i = vm.current_group.contacts.indexOf(contact);
                    ids.push(contact.id);
                    vm.selectContactItem(contact);
                    vm.contacts.push(contact);
                }
            });
            ids.forEach(function (id) {
                vm.current_group.contacts.forEach(function (contact) {
                    if (id === contact.id) {
                        var i = vm.current_group.contacts.indexOf(contact);
                        vm.current_group.contacts.splice(i, 1);
                    }
                })
            });
            if(vm.groupContactsSelected) {
                vm.groupContactsSelected = !vm.groupContactsSelected;
            }
            if (vm.activeFilter === 'previous_group') {
                getSelectedGroup(previousGroupId);
            } else {
                getContactsByCharityId(vm.activeFilter);
            }
        }

        function editDonorGroup() {
            vm.editingGroup = true;
            vm.current_group.contact_ids = [];
            vm.current_group.contacts.forEach(function (contact) {
                vm.current_group.contact_ids.push(contact.id);
            });
            delete vm.current_group.contacts;
            DonorGroupService.updateGroup(vm.current_group)
                .success(function (data) {
                    getDonorGroup(vm.current_group.id);
                    vm.editingGroup = false;
                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.editingGroup = false;

                })
        }

        function getAllGroups() {
            vm.isLoading = true;
            DonorGroupService.getGroupsByCharityId(vm.term)
                .success(function (data) {
                    vm.groups = data;
                    vm.isLoading = false;

                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.isLoading = false;
                })
        }

        function getSelectedGroup(id) {
            vm.fetchingAllContacts = true;
            previousGroupId = id;
            DonorGroupService.getGroupContacts(id)
                .success(function (data) {
                    vm.activeFilter = 'previous_group';
                    vm.contacts = _.differenceBy(data, vm.current_group.contacts, 'id');
                    vm.fetchingAllContacts = false;
                })
        }
    }
})
();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DeleteGroupController', DeleteGroupController);

    /** @ngInject */
    function DeleteGroupController($uibModalInstance, group, DonorGroupService) {
        var vm = this;

        vm.close = close;
        vm.delete_group = delete_group;
        vm.group = group;
        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function delete_group(id) {
            vm.deletingGroup = true;
            DonorGroupService.deleteGroup(id)
                .success(function (data) {
                    $uibModalInstance.close();
                    vm.deletingGroup = false;
                })
                .error(function (errorData) {
                    vm.deletingGroup = false;
                });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('rsplCharityV2')
    .controller('PickupReportController', PickupReportController);

  /** @ngInject */
  function PickupReportController($state, $stateParams, PickupReportService, imageBaseUrl, $uibModal) {
    var vm = this;

    vm.openGallery = openGallery;
    vm.back = back;

    vm.currentDonationId = $stateParams.id;
    vm.imageBaseUrl = imageBaseUrl;
    getReportByDonationId();
    vm.dates = {before: $stateParams.before, after: $stateParams.after};

    function back() {
      $state.go('fleetmanagement.pickupreports', {after: vm.dates.after, before: vm.dates.before});
    }


    function getReportByDonationId() {
      PickupReportService.getReportsByDonation(vm.currentDonationId)
        .success(function (data) {
          vm.report = data[0];
          vm.report.photos.forEach(function (photo, index) {
            photo.index = index;
          });
        })
        .error(function (error) {
          console.log(error);
        })
    }

    function openGallery(index) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/fleetmanagement/pickupreports/pickupreport/imagegallery/gallery.html',
        backdrop: 'static',
        controller: 'PickupReportGalleryController',
        controllerAs: 'pickupReportGalleryCtrl',
        resolve: {
          photos: function () {
            return vm.report.photos;
          },
          index: index
        },
        size: 'lg'
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('SubmittedDonationController', SubmittedDonationController);

    /** @ngInject */
    function SubmittedDonationController($uibModalInstance, donation, DonationsService, $uibModal, $state) {
        var vm = this;

        vm.close = close;

        vm.addAnotherDonation = addAnotherDonation;
        vm.viewCalendar = viewCalendar;

        activate();

        function close() {
            $uibModalInstance.dismiss();
        }

        function activate() {
            vm.donation = donation;
        }

        function addAnotherDonation() {
            $uibModalInstance.close();
            openNewPrompt();
        }

        function viewCalendar() {
            $uibModalInstance.close();
            $state.go('calendar');
        }

        function openNewPrompt() {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'manual-donation',
                templateUrl: 'app/donations/prompts/new/new.html',
                controller: 'NewDonationController',
                controllerAs: 'newCtrl',
                size: 'lg'
            });
            modalInstance.result.then(
                function () {
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('SingleDonationController', SingleDonationController);

    /** @ngInject */
    function SingleDonationController($uibModal, $uibModalInstance, DonationsService, $window, $timeout, baseUrl, imageBaseUrl, TrucksService, donationId, print, env) {
        var vm = this;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;
        vm.somethingChanged = false;
        vm.colorLabelChanged = false;
        vm.truckChanged = false;

        vm.close = close;
        vm.openChangeDatePrompt = openChangeDatePrompt;
        vm.openModal = openModal;
        vm.showTaxReceipt = showTaxReceipt;
        vm.generateTaxReceipt = generateTaxReceipt;
        vm.assignTruck = assignTruck;
        vm.assignLabel = assignLabel;
        vm.assignOrder = assignOrder;
        vm.openInGallery = openInGallery;
        vm.saveNote = saveNote;
        vm.printDonation = printDonation;
        vm.editManualDonation = editManualDonation;
        vm.updateCountAs = updateCountAs;
        vm.isString = isString;
        vm.askDonorForChangeDateApproval = askDonorForChangeDateApproval;
        vm.saveNewDescription = saveNewDescription;

        activate();

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts = [];
            vm.alerts.push({ type: type, msg: msg });
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        vm.taxPopover = {
            templateUrl: 'app/donations/prompts/single/tax-popover/tax-options.html'
        };

        vm.countAsOptions = ['Full AM', 'Full PM', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        vm.countAs = null;

        vm.orders = _.range(1, 5);

        vm.lightboxOptions = {
            fadeDuration: 0.7,
            resizeDuration: 0.4,
            fitImageInViewPort: true,
            positionFromTop: 60,
            showImageNumberLabel: false,
            alwaysShowNavOnTouchDevices: false,
            wrapAround: true
        };

        function isString(option) {
            return angular.isString(option);
        }

        function activate() {
            vm.isLoading = true;
            vm.donationId = donationId;
            vm.charityId = localStorage.getItem('rspl-charity-id');

            vm.slickConfig = {
                dots: true,
                arrows: true,
                focusOnSelect: true,
                nextArrow: '<span class="rspl-icon icon-arrow-right single-donation-arrow"></span>',
                prevArrow: '<span class="rspl-icon icon-arrow-left single-donation-arrow"></span>',
                dotsClass: 'custom_paging',
                customPaging: function (slider, i) {
                    return (i + 1) + '/' + slider.slideCount;
                }
            };
            getTrucks();
            getLabels();
            getDonation();
        }

        function getDonation() {
            vm.isLoading = true;
            DonationsService.getDonation(donationId).success(function (data) {
                vm.donation = data;
                if (vm.donation.request.truck) {
                    vm.truck = vm.donation.request.truck;
                }
                if (vm.donation.request.pickup_label) {
                    vm.label = vm.donation.request.pickup_label;
                }
                if (vm.donation.request.pickup_order_number) {
                    vm.order = vm.donation.request.pickup_order_number;
                }
                if (vm.donation.request.count_as) {
                    vm.countAs = vm.donation.request.count_as;
                } else {
                    vm.countAs = 1;
                }

                vm.orders = _.range(1, vm.donation.request.pickup_order_number_max + 1);

                vm.imagesLoaded = true;
                vm.isLoading = false;
                vm.donation.description = vm.donation.description ? vm.donation.description.split(', ').join('\n') : '';

                preparePhotos();

                if (print) {
                    $timeout(function () {
                        printDonation()
                    }, 0);
                }
            }).error(function () {
                vm.noDonation = true;
                vm.isLoading = false;
            })
        }

        function openChangeDatePrompt() {
            if (vm.donation.manual) {
                openManualChangeDatePrompt();
            } else {
                askDonorForChangeDateApproval(vm.donation)
            }
        }

        function openManualChangeDatePrompt() {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/donations/prompts/changeDate/changeDate.html',
                controller: 'ChangeDateController',
                controllerAs: 'changeDateCtrl',
                resolve: {
                    donation: vm.donation,
                    shouldAccept: false
                },
                size: 'sm'
            });
            modalInstance.result.then(
                function () {
                    vm.somethingChanged = true;
                })
        }

        function askDonorForChangeDateApproval(donation) {
            var modalInstance = $uibModal.open({
                animation: true,
                windowClass: 'approval-modal',
                backdrop: 'static',
                templateUrl: 'app/donations/prompts/donorApproval/donor.approval.html',
                controller: 'DonorApprovalController',
                controllerAs: 'approvalCtrl',
                resolve: {
                    donation: donation
                }
            });
            modalInstance.result.then(
                function () {
                    getDonation();
                    vm.somethingChanged = true;
                })
        }

        function openModal(type) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/donations/prompts/' + type + '/' + type + '.html',
                controller: type.charAt(0).toUpperCase() + type.slice(1) + 'Controller',
                controllerAs: type + 'Ctrl',
                resolve: {
                    donation: vm.donation
                },
                size: 'xs'
            });
            modalInstance.result.then(
                function () {
                    getDonation();
                    vm.somethingChanged = true;
                })
        }

        function getTrucks() {
            TrucksService.showAllTrucks()
                .success(function (data) {
                    vm.trucks = data;
                })
                .error(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                });
        }

        function getLabels() {
            TrucksService.getLabels()
                .success(function (data) {
                    vm.labels = data;
                })
                .error(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                });
        }

        function preparePhotos() {
            vm.donation.photos.forEach(function (photo) {
                if (env === 'production') {
                    photo.fullPath = vm.imageBaseUrl + '/cdn-cgi/image/width=800,quality=75' + photo.url;
                } else {
                    photo.fullPath = vm.imageBaseUrl + photo.url;
                }
            })
        }

        function showTaxReceipt() {
          $window.open("https://main-service.production.resupply.tech/api/v2/donations/"  + vm.donation.id + "/render_tax_receipt", '_blank');
        }

        function generateTaxReceipt() {
            vm.generatingTaxReceipt = true;
            DonationsService.generateTaxReceipt(donationId)
                .success(function () {
                    $timeout(function () {
                        DonationsService.getDonation(donationId)
                            .success(function (donation) {
                                vm.donation.tax_receipt_pdf_url = donation.tax_receipt_pdf_url;
                                showTaxReceipt();
                                vm.generatingTaxReceipt = false;
                            })
                    }, 10000);
                })
        }

        function assignTruck() {
            DonationsService.assignTruck(vm.donation.id, vm.donation.request.id, vm.truck.id).success(function () {
                vm.addAlert('success', 'Truck assigned successfully');
                vm.somethingChanged = true;
                vm.truckChanged = true;
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function assignLabel() {
            DonationsService.assignLabel(vm.donation.id, vm.donation.request.id, vm.label.id).success(function () {
                vm.addAlert('success', 'Color Label assigned successfully');
                vm.somethingChanged = true;
                vm.colorLabelChanged = true;
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function assignOrder() {
            DonationsService.assignOrder(vm.donation.id, vm.donation.request.id, vm.order).success(function () {
                vm.addAlert('success', 'Order Number assigned successfully');
                vm.somethingChanged = true;
                vm.orderNumberChanged = true;
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function updateCountAs(donation) {
            if (angular.isString(vm.countAs)) {
                var charityId = localStorage.getItem('rspl-charity-id');
                var zip = angular.fromJson(localStorage.getItem('rspl-auth-data'))[0].charity.zip;

                var now = moment(new Date()); //todays date
                var end = moment(donation.request.date); // another date
                var duration = moment.duration(end.diff(now));
                if (duration._data.hours > 0) {
                    duration._data.days = duration._data.days + 1
                }

                var pickupRange = {
                    start_date_offset: duration._data.days,
                    end_date_offset: duration._data.days
                };
                DonationsService.pickUpDateOptions(charityId, zip, pickupRange)
                    .success(function (data) {
                        var slots = 0;
                        if (vm.countAs === 'Full PM') {
                            slots = data[0].pm + donation.request.count_as;
                        } else if (vm.countAs === 'Full AM') {
                            slots = data[0].am + donation.request.count_as;
                        }
                        DonationsService.updateDonationCountAs(vm.donation.id, vm.donation.request.id, slots).success(function () {
                            vm.addAlert('success', 'Count As updated successfully');
                            vm.somethingChanged = true;
                            vm.countAsChanged = true;
                        }).error(function (errorData) {
                            vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                        });
                    })
                    .error(function (error) {
                        console.log(error);
                    })
            } else {
                DonationsService.updateDonationCountAs(vm.donation.id, vm.donation.request.id, vm.countAs).success(function () {
                    vm.addAlert('success', 'Count As updated successfully');
                    vm.somethingChanged = true;
                    vm.countAsChanged = true;
                }).error(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                });
            }
        }

        function openInGallery(donation) {
            if (donation.photos.length > 0 && donation.photos[0].url) {
                $uibModal.open({
                    animation: true,
                    windowClass: 'gallery-modal',
                    templateUrl: 'app/donations/prompts/single/gallery/gallery.html',
                    controller: 'GalleryController',
                    controllerAs: 'galleryCtrl',
                    resolve: {
                        donation: donation
                    },
                    size: 'lg'
                });
            }
        }

        function saveNewDescription() {
            vm.isSavingDescription = true;
            DonationsService.updateDonationDescription(donationId, vm.donation.description)
                .success(function () {
                    vm.isSavingDescription = false;
                    vm.addAlert('success', 'Donation description saved successfully');
                })
                .error(function (data) {
                    console.log(data);
                    vm.isSavingDescription = false;
                    vm.addAlert('danger', 'Oops, - ' + data.message);
                })
        }

        function saveNote() {
            vm.alerts = [];
            vm.isSavingNote = true;
            DonationsService.updateDonationNote(donationId, vm.donation.request.id, vm.donation.request.notes)
                .success(function () {
                    vm.isSavingNote = false;
                    vm.addAlert('success', 'Donation note saved successfully');
                })
                .error(function (data) {
                    vm.isSavingNote = false;
                    vm.addAlert('danger', 'Oops, - ' + data.message);
                })
        }

        function printDonation() {
            $window.print();
        }

        function editManualDonation() {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/donations/prompts/edit-manual-donation/edit-donation.html',
                controller: 'EditManualDonationController',
                controllerAs: 'editDonationCtrl',
                size: 'lg',
                resolve: {
                    reject: false,
                    date: new Date(),
                    donation: vm.donation
                }
            });
            modalInstance.result.then(
                function () {
                    getDonation();
                })
        }

        function close() {
            var changes = {};
            if (vm.somethingChanged) {
                if (vm.colorLabelChanged) {
                    changes.label = vm.label;
                }
                if (vm.truckChanged) {
                    changes.truck = vm.truck;
                }
                if (vm.countAsChanged) {
                    changes.countAs = vm.countAs;
                }
                if (vm.orderNumberChanged) {
                    changes.order = vm.order;
                }
                $uibModalInstance.close(changes);
            } else {
                $uibModalInstance.dismiss();
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('RescheduleController', RescheduleController);

    /** @ngInject */
    function RescheduleController($uibModalInstance, donation, DonationsService) {
        var vm = this;

        vm.close = close;
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.selectTime = selectTime;
        vm.changeDate = changeDate;
        vm.previousWeek = previousWeek;
        vm.nextWeek = nextWeek;

        vm.currentStep = 1;
        vm.stepTitle = 'Change date?';

        vm.pickupRange = {
            start_date_offset: 1,
            end_date_offset: 30
        };
        vm.pickupDays = {
            availableDays: null,
            selectedWeek: null
        };
        vm.charityId = localStorage.getItem('rspl-charity-id');

        activate();

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };


        function activate() {
            getPickUpRescheduleOptions(donation);
        }

        function getPickUpRescheduleOptions(donation) {
            vm.gettingAvailableDays = true;
            var charityId = vm.charityId,
                zip = donation.zip;
            DonationsService.pickUpDateOptions(charityId, zip, vm.pickupRange)
                .success(function (data) {
                    data.forEach(function (item) {
                        item.selected = [];
                    });
                    vm.pickupDays.availableDays = _.chunk(data, 7);
                    vm.pickupDays.selectedWeek = 0;
                    vm.gettingAvailableDays = false;
                })
                .error(function (error) {
                    console.log(error);
                    vm.gettingAvailableDays = false;
                })
        }

        function selectTime(item, period) {
            if (!item.selected) {
                item.selected = [];
            }
            if (item.selected.indexOf(period) !== -1) {
                item.selected.splice(item.selected.indexOf(period), 1);
            } else {
                item.selected.push(period);
            }
        }

        function close() {
            $uibModalInstance.close();
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }

        function confirm() {
            vm.stepTitle = 'Pick available times';
            vm.currentStep++;
        }

        function changeDate() {
            vm.alerts = [];
            vm.isSubmitting = true;
            var options = [];
            vm.availability = _.flatten(vm.pickupDays.availableDays);
            angular.forEach(vm.availability, function (item) {
                if (item.selected && item.selected.length > 0) {
                    angular.forEach(item.selected, function (selected) {
                        var itemToAdd = {};
                        itemToAdd.date = item.date;
                        itemToAdd.part_of_day = selected;
                        options.push(itemToAdd);
                    });
                }
            });
            DonationsService.rescheduleDonation(options, donation.id, donation.request.id)
                .success(function () {
                    vm.stepTitle = 'Confirm action';
                    vm.currentStep++;
                    vm.isSubmitting = false;
                })
                .error(function (errorData) {
                    vm.addAlert('danger', 'Oops: ' + errorData.message);
                    vm.isSubmitting = false;
                })

        }

        function previousWeek() {
            vm.pickupDays.selectedWeek -= 1;
        }

        function nextWeek() {
            vm.pickupDays.selectedWeek += 1;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('RejectController', RejectController);

    /** @ngInject */
    function RejectController($uibModalInstance, donation, DonationsService) {
        var vm = this;

        vm.close = close;
        vm.reject = reject;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function reject() {
            vm.isLoading = true;
            DonationsService.rejectDonation(donation.id, donation.request.id, vm.reason)
                .success(function () {
                    vm.isLoading = false;
                    $uibModalInstance.close();
                })
                .error(function (errorData) {
                    vm.alerts = [];
                    vm.isLoading = false;
                    vm.addAlert('danger', 'Oops, Something went wrong, ' + errorData.message);
                })
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('NoTaxController', NoTaxController);

    /** @ngInject */
    function NoTaxController($uibModalInstance) {
        var vm = this;

        vm.close = close;

        function close() {
            $uibModalInstance.close();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
            .controller('NewDonationController', NewDonationController);

    /** @ngInject */
    function NewDonationController($uibModalInstance, $http, baseUrl, $scope, TrucksService, ProfileService, DonationsService, PhotoService, UsersService, $q, $uibModal) {
        var vm = this;
        vm.baseUrl = baseUrl;

        vm.accordion = {
            donorInfo: true,
            pickupDetails: false,
            optionalDetails: false
        };
        vm.isNewDonor = false;
        vm.loadingZips = false;
        vm.donationItems = [];
        vm.newItemCount = 1;
        vm.pickupRange = {
            start_date_offset: -3,
            end_date_offset: 300
        };
        vm.scheduleLink = 'https://charity.resupplyme.com/#/schedule';
        vm.makingException = false;

        vm.submitForm = submitForm;
        vm.removePhoto = removePhoto;
        vm.getUsers = getUsers;
        vm.removePhoto = removePhoto;
        vm.getZipCodes = getZipCodes;
        vm.donorPicked = donorPicked;
        vm.setDonorType = setDonorType;
        vm.getPickUpDateOptions = getPickUpDateOptions;
        vm.onZipChange = onZipChange;
        vm.previousWeek = previousWeek;
        vm.nextWeek = nextWeek;
        vm.close = close;
        vm.selectPickupDate = selectPickupDate;
        vm.addItem = addItem;
        vm.removeItem = removeItem;
        vm.updateItem = updateItem;
        vm.setDescription = setDescription;
        vm.counterIncrement = counterIncrement;
        vm.counterDecrement = counterDecrement;
        vm.openSubmittedPrompt = openSubmittedPrompt;
        vm.editContact = editContact;
        vm.isString = isString;
        vm.makeException = makeException;

        vm.countAsOptions = ['Full AM', 'Full PM', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function isString(option) {
            return angular.isString(option);
        }

        activate();

        function activate() {

            vm.stepData = {
                donationId: null,
                requestId: null,
                userId: null,
                data: null,
                step: 0
            };
            vm.charityId = localStorage.getItem('rspl-charity-id');
            vm.files = [];
            vm.allFiles = [];
            vm.donationForm = {};
            vm.donationForm.photos = [];
            vm.donationForm.part_of_day = 'am';
            vm.pickupDays = {};
            $scope.$watch('newCtrl.files', function () {
                vm.allFiles = vm.allFiles.concat(vm.files);
            });

            getTrucks();
            getLabels();
        }

        function close() {
            $uibModalInstance.dismiss();
        }

        function selectPickupDate(day, part_of_day) {
            vm.donationForm.part_of_day = part_of_day;
            vm.donationForm.pickupDay = day;
        }

        function removePhoto(event, index) {
            event.stopPropagation();
            vm.allFiles.splice(index, 1);
        }

        function submitForm() {
            vm.isSubmitting = true;
            vm.alerts = [];
            if (vm.newItem) {
                addItem();
            }
            startDonation();
        }

        function startDonation() {
            switch (vm.stepData.step) {
                case 0:
                    setDonor();
                    break;
                case 1:
                    donationStart();
                    break;
                case 2:
                    uploadPhotos();
                    break;
                case 3:
                    updateDonation();
                    break;
                case 4:
                    updateDonationRequest();
                    break;
                case 5:
                    publishDonation();
                    break;
                case 6:
                    acceptDonation();
                    break;
                default:
                    break;
            }
        }

        function setDonor() {
            if (!vm.isNewDonor && vm.selectedDonor) {
                vm.stepData.userId = vm.selectedDonor.id;
                setDonorData(vm.selectedDonor);
                vm.stepData.step = 1;
                donationStart();
            } else if (vm.isNewDonor) {
                ProfileService.createContact(vm.donor, 'manual')
                    .success(function (data) {
                        vm.stepData.userId = data.id;
                        vm.stepData.step = 1;
                        setDonorData(vm.donor);
                        donationStart();
                    })
                    .error(function (errorData) {
                        if (errorData.additional_data && errorData.additional_data.phone) {
                            UsersService.getUserByPhone(vm.donor.phone)
                                .success(function (data) {
                                    vm.stepData.userId = data[0].id;
                                    vm.stepData.step = 1;
                                    donationStart();
                                })
                                .error(function () {
                                    vm.isSubmitting = false;
                                    vm.addAlert('danger', 'Ooops, something went wrong, please contact your administrator');
                                })
                        } else {
                            var additionalMsg = '';
                            vm.isSubmitting = false;
                            for (var prop in errorData.additional_data) {
                                additionalMsg += prop + " " + errorData.additional_data[prop];
                            }
                            vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                        }
                    })
            }
        }

        function getUsers(name) {
            var data = null;
            if (name) {
                data = {
                    term: name
                };
            }
            return UsersService.searchAll(data).then(function (response) {
                return response.data.map(function (item) {
                    item.name = item.first_name + " " + item.last_name;
                    return item;
                });
            });
        }

        function getTrucks() {
            TrucksService.showAllTrucks().success(function (data) {
                vm.trucks = data;
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function getZipCodes(val) {
            vm.loadingZips = true;
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/zips?code=' + val
            }).then(function (response) {
                vm.loadingZips = false;
                return response.data.map(function (item) {
                    return item.code;
                });
            })
        }


        function donationStart() {
            DonationsService.startDonation(vm.stepData.userId)
                .success(function (data) {
                    vm.stepData.donationId = data.id;
                    vm.stepData.requestId = data.request.id;
                    vm.stepData.step = 2;
                    uploadPhotos();
                })
                .error(function (errorData) {
                    vm.isSubmitting = false;
                    vm.addAlert('danger', 'Oops: ' + errorData.message + ' - ' + errorData.additional_data);
                })

        }

        function uploadPhotos() {
            var promises = [];
            for (var i = 0; i < vm.allFiles.length; i++) {
                var promise = PhotoService.uploadPhoto(vm.allFiles[i]);
                promises.push(promise);
            }
            $q.all(promises).then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.donationForm.photos.push(data[i].data.id);
                }
                vm.stepData.step = 3;
                updateDonation();
            });
        }

        function updateDonation() {
            DonationsService.updateDonation(vm.stepData.donationId, vm.donationForm)
                .success(function () {
                    vm.stepData.step = 4;
                    updateDonationRequest();
                })
                .error(function (errorData) {
                    vm.isSubmitting = false;
                    vm.addAlert('danger', 'Oops: ' + errorData.message + ' - ' + errorData.additional_data);
                });
        }

        function updateDonationRequest() {
            DonationsService.updateDonationRequest(vm.donationForm.pickupDay.date, vm.donationForm.part_of_day, vm.charityId, vm.stepData.donationId, vm.stepData.requestId)
                .success(function () {
                    vm.stepData.step = 5;
                    publishDonation();
                })
                .error(function (errorData) {
                    vm.isSubmitting = false;
                    vm.addAlert('danger', 'Oops: ' + errorData.message + ' - ' + errorData.additional_data);
                })
        }

        function updateCountAs() {
            if (angular.isString(vm.countAs)) {
                var charityId = localStorage.getItem('rspl-charity-id');
                var zip = angular.fromJson(localStorage.getItem('rspl-auth-data'))[0].charity.zip;
                var now = moment(new Date()); //todays date
                var end = moment(vm.donationForm.pickupDay.date); // another date
                var duration = moment.duration(end.diff(now));
                if (duration._data.hours > 0) {
                    duration._data.days = duration._data.days + 1
                }
                var pickupRange = {
                    start_date_offset: duration._data.days,
                    end_date_offset: duration._data.days
                };
                DonationsService.pickUpDateOptions(charityId, zip, pickupRange)
                    .success(function (data) {
                        var slots = 0;
                        if (vm.countAs === 'Full PM') {
                            slots = data[0].pm
                        } else if (vm.countAs === 'Full AM') {
                            slots = data[0].am
                        }
                        DonationsService.updateDonationCountAs(vm.stepData.donationId, vm.stepData.requestId, slots).success(function () {
                            vm.addAlert('success', 'Count As updated successfully');
                        }).error(function (errorData) {
                            vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                        });
                    })
                    .error(function (error) {
                        console.log(error);
                    })
            } else {
                DonationsService.updateDonationCountAs(vm.stepData.donationId, vm.stepData.requestId, vm.countAs).success(function () {
                }).error(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                });
            }
        }

        function getLabels() {
            TrucksService.getLabels()
                .success(function (data) {
                    vm.labels = data;
                })
                .error(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                });
        }

        function assignLabel() {
            DonationsService.assignLabel(vm.stepData.donationId, vm.stepData.requestId, vm.label.id)
                .success(function () {
                })
                .error(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                });
        }

        function publishDonation() {
            DonationsService.publishDonation(vm.stepData.donationId, vm.stepData.requestId)
                .success(function () {
                    vm.stepData.step = 6;
                    if (vm.countAs) {
                        updateCountAs()
                    }
                    if (vm.label) {
                        assignLabel()
                    }
                    acceptDonation();
                })
                .error(function (errorData) {
                    vm.isSubmitting = false;
                    if (errorData.message === 'Charity is not available') {
                        vm.stepData.step = 4;
                        vm.addAlert('danger', 'Oops, Charity is not available, seems like you need to expand your <a target="_blank" href="https://charity.resupplyme.com/#/schedule">schedule</a>');
                    } else {
                        vm.addAlert('danger', 'Oops: ' + errorData.message + ' - ' + errorData.additional_data);
                    }
                })
        }

        function acceptDonation() {
            DonationsService.acceptDonation(vm.stepData.donationId, vm.stepData.requestId)
                .success(function () {
                    vm.stepData.step = 0;
                    vm.isSubmitting = false;
                    var donation = {
                        firstName: vm.donationForm.first_name,
                        lastName: vm.donationForm.last_name,
                        date: vm.donationForm.pickupDay.date
                    };
                    if (vm.truck) {
                        DonationsService.assignTruck(vm.stepData.donationId, vm.stepData.requestId, vm.truck.id)
                            .success(function () {
                                $uibModalInstance.close();
                                vm.openSubmittedPrompt(donation);
                            })
                            .error(function (errorData) {
                                $uibModalInstance.close();
                            });
                    } else {
                        $uibModalInstance.close();
                        vm.openSubmittedPrompt(donation);
                    }

                })
                .error(function (errorData) {
                    vm.isSubmitting = false;
                    vm.addAlert('danger', 'Oops: ' + errorData.message + ' - ' + errorData.additional_data);
                })
        }

        function openSubmittedPrompt(donation) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'submitted-donation',
                templateUrl: 'app/donations/prompts/submitted/submitted.html',
                controller: 'SubmittedDonationController',
                controllerAs: 'submittedCtrl',
                resolve: {
                    donation: donation
                },
                size: 'sm'
            });
            modalInstance.result.then(
                function () {
                })
        }

        function donorPicked() {
            vm.isNewDonor = false;

            if (!vm.selectedDonor.address || !vm.selectedDonor.city || !vm.selectedDonor.state || !vm.selectedDonor.zip) {
                vm.donorProfileIncomplete = true;
            } else {
                vm.donorProfileIncomplete = false;
                setDonorData(vm.selectedDonor);
                vm.getPickUpDateOptions();
            }
        }

        function setDonorData(data) {
            vm.donationForm.first_name = data.first_name;
            vm.donationForm.last_name = data.last_name;
            vm.donationForm.email = data.email;
            vm.donationForm.phone = data.phone;
            vm.donationForm.address = data.address;
            vm.donationForm.city = data.city;
            vm.donationForm.state = data.state;
            vm.donationForm.zip = data.zip;
        }

        function setDonorType(isNew) {
            vm.isNewDonor = isNew;
            vm.pickupDays.availableDays = null;
            if (isNew) {
                vm.selectedDonor = null;
            } else {
                vm.donor = null;
            }
        }

        function getPickUpDateOptions() {
            vm.gettingAvailableDays = true;
            vm.donationForm.part_of_day = null;
            vm.donationForm.pickupDay = null;
            vm.pickupDays.availableDays = [];
            var charityId = vm.charityId,
                zip = null;
            if (!vm.isNewDonor) {
                zip = vm.selectedDonor.zip;
            } else {
                zip = vm.donor.zip;
            }
            DonationsService.pickUpDateOptions(charityId, zip, vm.pickupRange)
                .success(function (data) {
                    vm.pickupDays.availableDays = _.chunk(data, 7);
                    vm.pickupDays.selectedWeek = 0;
                    vm.gettingAvailableDays = false;
                })
                .error(function (error) {
                    console.log(error);
                    vm.gettingAvailableDays = false;
                })
        }

        function makeException() {
            vm.makingException = true;
            vm.donationForm.pickupDay.warningConfirmed = true;
            vm.makingException = false;
        }

        function onZipChange() {
            if (vm.donor.zip && vm.donor.zip.match(/[0-9]{5}/)) {
                populateZipData();
                getPickUpDateOptions();
            } else {
                vm.pickupDays.availableDays = null;
            }
        }

        function populateZipData() {
            DonationsService.getZipCodes(vm.donor.zip)
                .success(function (data) {
                    if (data.length) {
                        vm.donor.city = data[0].city;
                        vm.donor.state = data[0].state;
                    }
                })
        }

        function previousWeek() {
            vm.pickupDays.selectedWeek -= 1;
        }

        function nextWeek() {
            vm.pickupDays.selectedWeek += 1;
        }

        function setDescription() {
            vm.donationForm.description = '';
            if (vm.donationItems.length) {
                vm.donationItems.forEach(function (item, index) {
                    vm.donationForm.description += item.name;
                    vm.donationForm.description += ' x' + item.count;
                    if (index !== vm.donationItems.length - 1) {
                        vm.donationForm.description += ', ';
                    }
                })
            } else {
                vm.donationForm.description = null;
            }
        }

        function addItem() {
            if (!vm.newItem) {
                return;
            }
            var donationItem = {
                name: vm.newItem,
                count: vm.newItemCount
            };
            vm.donationItems.push(donationItem);
            vm.newItem = null;
            vm.newItemCount = 1;
            setDescription();
        }

        function removeItem(item) {
            var index = vm.donationItems.indexOf(item);
            vm.donationItems.splice(index, 1);
            setDescription();
        }

        function updateItem(item) {
            var index = vm.donationItems.indexOf(item);
            vm.donationItems[index] = item;
            setDescription();
        }

        function counterIncrement(item) {
            item.count = item.count + 1;
            setDescription();
        }

        function counterDecrement(item) {
            item.count = item.count - 1;
            if (item.count === 0) {
                vm.removeItem(item);
            }
            setDescription();
        }

        function editContact(contact) {
            var contact_copy = angular.copy(contact);
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'edit-contact-modal',
                templateUrl: 'app/database/donormanagement/prompts/editcontact/editcontact.html',
                controller: 'EditContactController',
                controllerAs: 'editContactCtrl',
                resolve: {
                    contact: contact_copy
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function (donor) {
                    donor.name = donor.first_name + " " + donor.last_name;
                    vm.selectedDonor = donor;
                    donorPicked();
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('EditManualDonationController', EditManualDonationController);

    /** @ngInject */
    function EditManualDonationController($uibModalInstance, baseUrl, imageBaseUrl, DonationsService, TrucksService, donation, $scope, PhotoService, $q) {
        var vm = this;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;

        vm.donation = donation;
        vm.files = [];
        vm.allFiles = [];

        vm.close = close;
        vm.submitForm = submitForm;
        vm.removePhoto = removePhoto;
        vm.removeExistingPhoto = removeExistingPhoto;

        vm.scheduleLink = 'https://charity.resupplyme.com/#/schedule';

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        vm.today = function () {
            vm.donationForm.pickedDate = new Date();
        };

        function close() {
            $uibModalInstance.dismiss();
        }


        activate();

        function activate() {
            vm.charityId = localStorage.getItem('rspl-charity-id');
            vm.files = [];
            vm.allFiles = [];
            vm.donationForm = {};
            vm.donorForm = {};
            vm.donationForm.photos = [];

            $scope.$watch('editDonationCtrl.files', function () {
                vm.allFiles = vm.allFiles.concat(vm.files);
            });

            setDonorData(donation.request.donor);
            setDonationData(donation);
            getTrucks();
        }

        function getTrucks() {
            TrucksService.showAllTrucks().success(function (data) {
                vm.trucks = data;
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function submitForm() {
            vm.isSubmitting = true;
            vm.alerts = [];
            uploadPhotos();
        }

        function removePhoto(index) {
            vm.allFiles.splice(index, 1);
        }

        function removeExistingPhoto(index) {
            vm.donationForm.donationPhotos.splice(index, 1);
        }


        function uploadPhotos() {
            var promises = [];
            for (var i = 0; i < vm.allFiles.length; i++) {
                var promise = PhotoService.uploadPhoto(vm.allFiles[i]);
                promises.push(promise);
            }
            $q.all(promises).then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.donationForm.photos.push(data[i].data.id);
                }

                updateDonation();
            });
        }


        function updateDonation() {
            prepareOldPhotoIds();
            DonationsService.updateDonation(vm.donation.id, vm.donationForm)
                .success(function () {
                    updateDonationRequest();
                })
                .error(function (errorData) {
                    vm.isSubmitting = false;
                    vm.addAlert('danger', 'Oops: ' + errorData.message + ' - ' + errorData.additional_data);
                });
        }

        function updateDonationRequest() {
            DonationsService.updateDonationRequest(vm.donationForm.date, vm.donationForm.part_of_day, vm.charityId, vm.donation.id, vm.donation.request.id)
                .success(function () {
                    if (vm.donationForm.truck) {
                        DonationsService.assignTruck(vm.donation.id, vm.donation.request.id, vm.donationForm.truck.id)
                            .success(function () {
                                $uibModalInstance.close();
                            })
                            .error(function (errorData) {
                                vm.isSubmitting = false;
                                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                            });
                    } else {
                        $uibModalInstance.close();
                    }
                })
                .error(function (errorData) {
                    vm.isSubmitting = false;
                    vm.addAlert('danger', 'Oops: ' + errorData.message + ' - ' + errorData.additional_data);
                })
        }

        function setDonorData(data) {
            vm.donorForm.first_name = data.first_name;
            vm.donorForm.last_name = data.last_name;
            vm.donorForm.email = data.email;
            vm.donorForm.phone = data.phone;
            vm.donorForm.address = data.address;
            vm.donorForm.city = data.city;
            vm.donorForm.state = data.state;
            vm.donorForm.zip = data.zip;
        }

        function setDonationData(data) {
            vm.donationForm.description = data.description;
            vm.donationForm.special_instructions = data.special_instructions;
            vm.donationForm.estimated_price = angular.isString(data.estimated_price) ? parseFloat(data.estimated_price.split('$')[1]) : parseFloat(data.estimated_price);
            vm.donationForm.date = moment(data.request.date).add(new Date().getTimezoneOffset(), 'm').toDate();
            vm.donationForm.part_of_day = data.request.part_of_day;
            vm.donationForm.truck = data.request.truck;
            vm.donationForm.donationPhotos = data.photos;
            vm.donationForm.photos = [];
            vm.donationForm.address = data.address;
            vm.donationForm.city = data.city;
            vm.donationForm.state = data.state;
            vm.donationForm.zip = data.zip;
        }

        function prepareOldPhotoIds () {
            if (vm.donationForm.donationPhotos.length > 0) {
                for (var j = 0; j < vm.donationForm.donationPhotos.length; j++) {
                    vm.donationForm.photos.push(vm.donationForm.donationPhotos[j].id)
                }
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DonorApprovalController', DonorApprovalController);

    /** @ngInject */
    function DonorApprovalController($uibModalInstance, donation, $uibModal) {
        var vm = this;

        vm.close = close;
        vm.nextStep = nextStep;
        vm.donation = donation;
        vm.openChangeDateManualPrompt = openChangeDateManualPrompt;
        vm.openChangeDatePrompt = openChangeDatePrompt;

        vm.radioOptions = [
            {
                label: 'I want to get donor’s approval.',
                value: true
            },
            {
                label: vm.donation.request.status !== 'pending' ? 'Change date without donor’s approval.' : 'Change date without donor’s approval and accept this donation.',
                value: false
            }
        ];

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function openChangeDatePrompt() {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/donations/prompts/reschedule/reschedule.html',
                controller: 'RescheduleController',
                controllerAs: 'rescheduleCtrl',
                resolve: {
                    donation: donation
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function () {
                    vm.somethingChanged = true;
                    $uibModalInstance.close();
                })
        }

        function openChangeDateManualPrompt() {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/donations/prompts/changeDate/changeDate.html',
                controller: 'ChangeDateController',
                controllerAs: 'changeDateCtrl',
                resolve: {
                    donation: donation,
                    shouldAccept: donation.request.status === 'accepted' ? false : true

                },
                size: 'sm'
            });
            modalInstance.result.then(
                function () {
                    $uibModalInstance.close();
                })
        }

        function nextStep() {
            if(vm.needsApproval) {
                vm.openChangeDatePrompt();
            } else {
                vm.openChangeDateManualPrompt();
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('CompleteController', CompleteController);

    /** @ngInject */
    function CompleteController($uibModalInstance, donation, DonationsService) {
        var vm = this;

        vm.close = close;
        vm.complete = complete;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function complete() {
            vm.isLoading = true;
            DonationsService.completeDonation(donation.id, donation.request.id)
                .success(function () {
                    vm.isLoading = false;
                    $uibModalInstance.close();
                })
                .error(function () {
                    vm.addAlert('danger', 'Oops, Something went wrong, contact your Administrator');
                })
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ClaimController', ClaimController);

    /** @ngInject */
    function ClaimController($uibModalInstance, donation, DonationsService) {
        var vm = this;

        vm.close = close;
        vm.accept = accept;

        vm.isLoading = false;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function accept() {
            vm.isLoading = true;
            var options = [{
                date: donation.request.status === 'awaiting_user_response' ? donation.initialRequest.date : donation.request.date,
                part_of_day: donation.request.status === 'awaiting_user_response' ? donation.initialRequest.part_of_day : donation.request.part_of_day
            }];
            DonationsService.rescheduleDonation(options, donation.id, donation.request.id)
                .success(function () {
                    vm.isLoading = false;
                    $uibModalInstance.close();
                })
                .error(function () {
                    vm.addAlert('danger', 'Oops, Something went wrong, contact your Administrator');
                    vm.isLoading = false;
                });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ChangeDateController', ChangeDateController);

    /** @ngInject */
    function ChangeDateController($uibModalInstance, donation, DonationsService, shouldAccept) {
        var vm = this;

        vm.close = close;
        vm.changeDate = changeDate;
        vm.donation = donation;

        prepareDonationDate();

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({ type: type, msg: msg });
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function prepareDonationDate() {
            var dt = new Date();
            var tz = dt.getTimezoneOffset();
            vm.donation.request.date = moment(vm.donation.request.date);
            if (tz > 0) {
                vm.donation.request.date = vm.donation.request.date.add(tz, 'minutes');
            }
            vm.donation.request.date = vm.donation.request.date.toDate();
        }

        function changeDate() {
            vm.isLoading = true;
            if (shouldAccept) {
                DonationsService.updateDonationRequest(vm.donation.request.date, vm.donation.request.part_of_day, localStorage.getItem('rspl-charity-id'), vm.donation.id, vm.donation.request.id)
                    .success(function () {
                        DonationsService.acceptDonation(vm.donation.id, vm.donation.request.id)
                            .success(function () {
                                vm.isLoading = false;
                                $uibModalInstance.close();
                            })

                    })
                    .error(function (errorData) {
                        vm.isLoading = false;
                        vm.addAlert('danger', 'Oops, Something went wrong, ' + errorData.message);
                    });
            } else {
                DonationsService.updateDonationRequest(vm.donation.request.date, vm.donation.request.part_of_day, localStorage.getItem('rspl-charity-id'), vm.donation.id, vm.donation.request.id)
                    .success(function () {
                        vm.isLoading = false;
                        $uibModalInstance.close();
                    })
                    .error(function (errorData) {
                        vm.isLoading = false;
                        vm.addAlert('danger', 'Oops, Something went wrong, ' + errorData.message);
                    });
            }

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('CancelController', CancelController);

    /** @ngInject */
    function CancelController($uibModalInstance, donation, DonationsService) {
        var vm = this;

        vm.close = close;
        vm.cancel = cancel;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function cancel() {
            vm.isLoading = true;
            DonationsService.cancelDonation(donation.id, donation.request.id, vm.reason)
                .success(function () {
                    vm.isLoading = false;
                    $uibModalInstance.close();
                })
                .error(function (errorData) {
                    vm.alerts = [];
                    vm.isLoading = false;
                    vm.addAlert('danger', 'Oops, Something went wrong, ' + errorData.message);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('AcceptController', AcceptController);

    /** @ngInject */
    function AcceptController($uibModalInstance, donation, DonationsService) {
        var vm = this;

        vm.close = close;
        vm.accept = accept;

        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function accept() {
            vm.isLoading = true;
            DonationsService.acceptDonation(donation.id, donation.request.id)
                .success(function () {
                    vm.isLoading = false;
                    $uibModalInstance.close({});
                })
                .error(function () {
                    vm.isLoading = false;
                    vm.addAlert('danger', 'Oops, Something went wrong, contact your Administrator');
                })
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('OutreachController', OutreachController);

    /** @ngInject */
    function OutreachController(ScheduleService, ItemTypesService) {
        var vm = this;
        vm.toolbar = [
            ['bold', 'italics', 'ul', 'insertLink']
        ];

        vm.check = check;

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        vm.filters = [
            {
                id: "2m",
                title: "Inactive donors for 2 months"
            }, {
                id: "4m",
                title: "Inactive donors for 4 months"
            }, {
                id: "6m",
                title: "Inactive donors for 6 months"
            }, {
                id: "hv",
                title: "High value donors"
            }, {
                id: "all",
                title: "All donors"
            }, {
                id: "cat",
                title: "By "
            }, {
                id: "zip",
                title: "By "
            }
        ];

        activate();

        function activate() {
            vm.automatic = true;
            getZipsFromSchedule();
            getItemTypes();
        }

        function check(filter) {
            if (vm.checked === filter) {
                delete vm.checked;
            } else {
                vm.checked = filter;
            }
        }

        function getZipsFromSchedule() {
            vm.allZips = [];
            ScheduleService.getScheduleTemplate()
                .success(function (data) {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            for (var y = 0; y < data[i].zips.length; y++) {
                                vm.allZips.push(data[i].zips[y].code);
                            }
                        }
                        vm.uniqueZips = Array.from(new Set(vm.allZips));
                    } else {
                        vm.scheduleEmpty = true;
                        vm.isLoading = false;
                    }
                })
                .error(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                    vm.isLoading = false;
                })
        }

        function getItemTypes() {
            ItemTypesService.getItemTypes().success(function (data) {
                vm.itemTypes = data;
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                vm.isLoading = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('SingleGroupController', SingleGroupController);

    /** @ngInject */
    function SingleGroupController($uibModal, $stateParams, DonorGroupService, $state) {
        var vm = this;

        vm.edit_contact = edit_contact;
        vm.deleteContactPrompt = deleteContactPrompt;
        vm.deleteGroupPrompt = deleteGroupPrompt;
        vm.getGroupContacts = getGroupContacts;

        activate();
        function activate() {
            vm.gettingGroup = false;
            vm.current_group = {};
            vm.current_group.id = $stateParams.id;
            getDonorGroup(vm.current_group.id);
        }
        function getDonorGroup(id) {
            vm.gettingGroup = true;
            DonorGroupService.getGroupById(id)
                .success(function (data) {
                    vm.current_group = data;
                    getGroupContacts(vm.current_group.id);
                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.gettingGroup = false;
                })
        }

        function getGroupContacts(id, name) {
            vm.gettingGroup = true;
            DonorGroupService.getGroupContacts(id, name)
                .success(function (data) {
                    vm.current_group.contacts = data;
                    vm.gettingGroup = false;
                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.gettingGroup = false;
                })
        }

        function edit_contact(contact) {
            var contact_copy = angular.copy(contact);
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'edit-contact-modal',
                templateUrl: 'app/database/donormanagement/prompts/editcontact/editcontact.html',
                controller: 'EditContactController',
                controllerAs: 'editContactCtrl',
                resolve: {
                    contact: contact_copy
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function () {
                    getDonorGroup(vm.current_group.id);
                })
        }

        function deleteContactPrompt(contact) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'delete-contact-modal',
                templateUrl: 'app/database/donorgroups/singlegroup/prompts/deletecontact/deletecontact.html',
                controller: 'DeleteContactController',
                controllerAs: 'delContCtrl',
                size: 'xs',
                resolve: {
                    contact: contact
                }
            });
            modalInstance.result.then(
                function () {
                    updateDonorGroup(contact);
                })
        }
        function deleteGroupPrompt(group) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'delete-donors-group',
                templateUrl: 'app/database/donorgroups/prompts/deletegroup/deletegroup.html',
                controller: 'DeleteGroupController',
                controllerAs: 'delCtrl',
                resolve: {
                    group: group
                },
                size: 'xs'
            });
            modalInstance.result.then(
                function () {
                    $state.go('database.donorgroups.allgroups');
                })
        }
        function updateDonorGroup(contact) {
            vm.current_group.contact_ids = [];
            var i = vm.current_group.contacts.indexOf(contact);
            vm.current_group.contacts.splice(i, 1);
            vm.current_group.contacts.forEach(function (contact) {
                vm.current_group.contact_ids.push(contact.id);
            });
            DonorGroupService.updateGroup(vm.current_group)
                .success(function () {
                    getDonorGroup(vm.current_group.id);
                })
                .error(function (error) {
                    console.log(error);
                })
        }
    }
})
();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('donorgroup', donorgroup);

    /** @ngInject */
    function donorgroup() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/database/donorgroups/creategroup/creategroup.directive.html',
            controller: DonorGroupCreateController,
            controllerAs: 'newGroupCtrl',
            bindToController: true
        };

        return directive;
    }

    /** @ngInject */
    function DonorGroupCreateController(ContactService, DonorGroupService, $scope, UtilsService, $timeout) {
        var vm = this;

        vm.allContactsSelected = false;
        vm.groupContactsSelected = false;
        vm.getContactsByCharityId = getContactsByCharityId;
        vm.selectContactItem = selectContactItem;
        vm.selectAllContacts = selectAllContacts;
        vm.selectAllGroupContacts = selectAllGroupContacts;
        vm.addContactsToGroup = addContactsToGroup;
        vm.removeContactsFromGroup = removeContactsFromGroup;
        vm.createNewGroup = createNewGroup;
        vm.checkValidation = checkValidation;
        vm.getAllGroups = getAllGroups;
        vm.getSelectedGroup = getSelectedGroup;
        vm.nextPage = nextPage;
        vm.previousPage = previousPage;
        vm.selectContactsFromAllPages = selectContactsFromAllPages;

        vm.isLoading = false;
        vm.creatingContactsFromCSVdone = true;
        vm.contactsSelected = [];

        vm.scrollConfig = {
            autoHideScrollbar: false,
            theme: 'dark-3',
            scrollInertia: 0,
            axis: 'y',
            advanced: {
                updateOnContentResize: true
            }
        };

        vm.pagination = {
            currentPage: 1,
            itemsPerPage: 100,
            totalPages: 1
        };

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        activate();

        function activate() {
            getContactsByCharityId('app_user');
            getAllGroups();
            vm.new_group = {
                contacts: []
            };
            //handle save group event from parent
            $scope.$on('CREATE_DONOR_GROUP', function (event, data) {
                if (!event.defaultPrevented) {
                    event.defaultPrevented = true;
                    createNewGroup();
                }
            });

            $scope.$on('DONOR_GROUP_SELECTED', function (event, data) {
                if (!event.defaultPrevented) {
                    event.defaultPrevented = true;
                    vm.new_group.contacts = [];
                    getContactsByCharityId('app_user')
                }
            });

            $scope.$on('CSV_READY', function (event, data) {
                convertCsvToJson(data.content)
            });
        }

        function getContactsByCharityId(filter, currentPage, keepSelection) {
            vm.activeFilter = filter;
            vm.selectedGroup = null;
            vm.isLoading = true;
            if (!keepSelection) {
                vm.contactsSelected = [];
                vm.allContactsSelected = false;
            }

            ContactService._getContactsByCharityId(filter, currentPage)
                .then(function (data) {
                    data.data.length === 0 ? vm.noAvailableContacts = true : vm.noAvailableContacts = false;
                    vm.pagination.currentPage = data.headers().current_page;
                    vm.pagination.totalItems = data.headers().total_pages * vm.pagination.itemsPerPage;
                    if (data.headers().total_pages === '0') {
                        vm.pagination.totalPages = 1;
                    } else {
                        vm.pagination.totalPages = data.headers().total_pages;
                    }
                    vm.contacts = _.differenceBy(data.data, vm.new_group.contacts, 'id');
                    if (vm.allContactsSelected) {
                        vm.contacts.forEach(function (contact) {
                            contact['selected'] = true;
                        });
                    }
                    vm.isLoading = false;
                })
                .catch(function () {
                    vm.isLoading = false;
                });
        }

        function selectAllGroupContacts() {
            if (!vm.new_group.contacts.length) {
                return
            }
            if (!vm.groupContactsSelected) {
                vm.new_group.contacts.forEach(function (contact) {
                    contact['selected'] = true;
                })
            } else {
                vm.new_group.contacts.forEach(function (contact) {
                    contact['selected'] = false;
                })
            }
            vm.groupContactsSelected = !vm.groupContactsSelected;
        }

        function selectAllContacts() {
            if (!vm.contacts.length) {
                return
            }
            if (!vm.allContactsSelected) {
                vm.contacts.forEach(function (contact) {
                    contact['selected'] = true;
                })
            } else {
                vm.contacts.forEach(function (contact) {
                    contact['selected'] = false;
                })
            }
            vm.allContactsSelected = !vm.allContactsSelected;
            $timeout(function () {
                vm.contactsSelected = vm.contacts.filter(function (item) {
                    return item.selected;
                })
            })
        }

        function selectContactsFromAllPages(isInitial) {
            vm.isLoading = true;
            if (isInitial) {
                vm.selectedContacts = [];
                vm.currentPage = 1;
            }
            ContactService._getContactsByCharityId(vm.activeFilter, vm.currentPage)
                .then(function (data) {
                    vm.selectedContacts = _.concat(vm.selectedContacts, data.data);
                    if (vm.currentPage < vm.pagination.totalPages) {
                        vm.currentPage++;
                        selectContactsFromAllPages(false)
                    } else {
                        vm.contactsSelected = vm.selectedContacts;
                        if (!vm.allContactsSelected) {
                            vm.contacts.forEach(function (contact) {
                                contact['selected'] = true;
                            });
                            vm.contactsSelected.forEach(function (contact) {
                                contact['selected'] = true;
                            })
                        } else {
                            vm.contacts.forEach(function (contact) {
                                contact['selected'] = false;
                            });
                            vm.contactsSelected.forEach(function (contact) {
                                contact['selected'] = false;
                            });
                            vm.contactsSelected = [];
                        }
                        vm.allContactsSelected = !vm.allContactsSelected;
                        vm.isLoading = false;
                    }
                });


        }

        function selectContactItem(contact) {
            contact.selected = !contact.selected;
            var updatedContactIndex = _.findIndex(vm.contactsSelected, function (o) {
                return o.id === contact.id;
            });

            if (updatedContactIndex > -1) {
                vm.contactsSelected[updatedContactIndex].selected = !vm.contactsSelected[updatedContactIndex].selected;
            } else {
                vm.contactsSelected.push(contact)
            }

            vm.contactsSelected = vm.contactsSelected.filter(function (item) {
                return item.selected;
            })
        }

        function addContactsToGroup() {
            vm.new_group.contacts = _.uniqBy(_.concat(vm.new_group.contacts, _.filter(vm.contactsSelected, function (contact) {
                return contact.selected;
            })), 'id');
            vm.contacts = _.differenceBy(vm.contacts, vm.new_group.contacts, 'id');
            vm.contactsSelected = [];

            if (vm.allContactsSelected) {
                vm.allContactsSelected = !vm.allContactsSelected;
            }

            if (vm.new_group.name && vm.new_group.name.length > 0) {
                $scope.$emit('DONOR_GROUP_VALID', {valid: true});
                vm.groupValid = true;
            } else {
                $scope.$emit('DONOR_GROUP_VALID', {valid: false});
                vm.groupValid = false;
            }
        }

        function removeContactsFromGroup() {
            vm.new_group.contacts = _.filter(vm.new_group.contacts, function (contact) {
                return !contact.selected;
            });

            if (vm.groupContactsSelected) {
                vm.groupContactsSelected = !vm.groupContactsSelected;
            }

            if (vm.activeFilter === 'previous_group') {
                getSelectedGroup(vm.previousGroupId);
            } else if (vm.activeFilter === 'csv') {
                vm.contacts = [];
            } else {
                getContactsByCharityId(vm.activeFilter);
            }

            if (vm.new_group.name && vm.new_group.name.length > 0 && vm.new_group.contacts && vm.new_group.contacts.length > 0) {
                $scope.$emit('DONOR_GROUP_VALID', {valid: true});
                vm.groupValid = true;
            } else {
                $scope.$emit('DONOR_GROUP_VALID', {valid: false});
                vm.groupValid = false;
            }
        }

        function createNewGroup() {
            if (!vm.creatingContactsFromCSVdone) {
                alert('CSV Upload still in progress, please wait');
            } else {
                vm.creating_group = true;
                vm.new_group.contact_ids = [];
                vm.new_group.contacts.forEach(function (contact) {
                    vm.new_group.contact_ids.push(contact.id);
                });
                DonorGroupService.createGroup(vm.new_group)
                    .success(function (data) {
                        delete vm.new_group.contacts;
                        vm.creating_group = false;
                        //notify parent
                        $scope.$emit('DONOR_GROUP_CREATED', data);
                    })
                    .error(function (errorData) {
                        // delete vm.new_group.contacts;
                        vm.creating_group = false;
                        $scope.$emit('DONOR_GROUP_FAILED', errorData);
                        vm.addAlert('danger', 'Oops, Something went wrong, ' + errorData.message);
                    })
            }
        }

        function checkValidation() {
            if (vm.new_group.name && vm.new_group.name.length > 0 && vm.new_group.contacts && vm.new_group.contacts.length > 0) {
                $scope.$emit('DONOR_GROUP_VALID', {valid: true});
                vm.groupValid = true;
            } else {
                $scope.$emit('DONOR_GROUP_VALID', {valid: false});
                vm.groupValid = false;
            }
        }

        function getAllGroups() {
            vm.isLoading = true;
            DonorGroupService.getGroupsByCharityId(vm.term)
                .success(function (data) {
                    vm.groups = data;
                    vm.isLoading = false;
                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.isLoading = false;
                })
        }

        function getSelectedGroup(id, isInitial) {
            vm.isLoading = true;
            vm.previousGroupId = id;
            vm.contactsSelected = [];
            if (isInitial) {
                vm.allContactsSelected = false;
            }
            DonorGroupService._getGroupContacts(vm.previousGroupId, vm.pagination.currentPage)
                .then(function (response) {
                    response.data.length === 0 ? vm.noAvailableContacts = true : vm.noAvailableContacts = false;
                    vm.activeFilter = 'previous_group';
                    vm.pagination.currentPage = response.headers().current_page;
                    vm.pagination.totalPages = response.headers().total_pages;
                    vm.contacts = _.differenceBy(response.data, vm.new_group.contacts, 'id');
                    if (vm.allContactsSelected) {
                        vm.contacts.forEach(function (contact) {
                            contact['selected'] = true;
                        });
                    }

                    vm.contactsSelected = vm.contactsSelected.filter(function (item) {
                        return item.selected;
                    });
                    vm.isLoading = false;
                })
        }

        function convertCsvToJson(content) {
            vm.isLoading = true;
            var jsonArr = angular.fromJson(UtilsService.csvToJson(content));
            jsonArr = _.filter(jsonArr, function (contact) {
                return contact.first_name || contact.last_name || contact.phone || contact.email || contact.zip || contact.state || contact.city;
            });
            var chunks = _.chunk(jsonArr, 100);
            var time = 'contacts.csv' + new Date().getTime();
            vm.activeFilter = 'csv';
            vm.contacts = [];
            vm.new_group.contacts = [];
            var itemsProcessed = 0;
            vm.creatingContactsFromCSVdone = false;
            chunks.forEach(function (chunk, index, array) {
                var csvData = {};
                csvData.contacts = chunk;
                csvData.reference_name = time;
                ContactService.createContacts(csvData)
                    .success(function (data) {
                        vm.new_group.contacts = _.concat(vm.new_group.contacts, data);
                        vm.isLoading = false;
                        itemsProcessed++;
                        if (itemsProcessed === array.length) {
                            vm.creatingContactsFromCSVdone = true;
                            checkValidation();
                        }
                    });

            });
        }

        function nextPage() {
            vm.pagination.currentPage++;
            if (vm.activeFilter === 'previous_group') {
                getSelectedGroup(vm.previousGroupId, vm.pagination.currentPage)
            } else {
                getContactsByCharityId(vm.activeFilter, vm.pagination.currentPage, true);
            }

        }

        function previousPage() {
            vm.pagination.currentPage--;
            if (vm.activeFilter === 'previous_group') {
                getSelectedGroup(vm.previousGroupId, vm.pagination.currentPage)
            } else {
                getContactsByCharityId(vm.activeFilter, vm.pagination.currentPage, true);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('CreateGroupController', CreateGroupController);

    /** @ngInject */
    function CreateGroupController($state, $scope) {
        var vm = this;

        //handle saved group event
        $scope.$on('DONOR_GROUP_CREATED', function (event, data) {
            if (!event.defaultPrevented) {
                event.defaultPrevented = true;
                $state.go('database.donorgroups.allgroups');
            }
        });
    }
})
();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DeleteExceptionController', DeleteExceptionController);

    /** @ngInject */
    function DeleteExceptionController($uibModalInstance, exception, ScheduleService) {
        var vm = this;

        vm.close = close;
        vm.deleteException = deleteException;
        function close() {
            $uibModalInstance.dismiss();
        }

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function deleteException() {
            vm.deleting = true;
            ScheduleService.deleteScheduleException(exception)
                .success(function (data) {
                    $uibModalInstance.close();
                    vm.deleting = false;
                })
                .error(function (errorData) {
                    vm.deleting = false;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('SmsNotificationsController', SmsNotificationsController);

    /** @ngInject */
    function SmsNotificationsController($rootScope, NotificationsService) {
        var vm = this;

        vm.insertVariable = insertVariable;
        vm.saveNotificationTemplate = saveNotificationTemplate;
        vm.deleteCustomTemplate = deleteCustomTemplate;
        vm.toggleAction = toggleAction;

        activate();

        function activate() {
            getDefaultNotificationsTemplates(true);
        }

        function insertVariable(varValue) {
            $rootScope.$broadcast('INSERT_VARIABLE', varValue);
        }

        function getDefaultNotificationsTemplates(isInitial) {
            NotificationsService.getDefaultNotificationsTemplates()
                .success(function (data) {
                    vm.defaultTemplates = _.groupBy(data, 'alert_type').sms;
                    vm.defaultTemplates.forEach(function (template) {
                        template.default = true;
                    });
                    getNotificationsTemplates(isInitial);
                })
        }

        function getNotificationsTemplates(isInitial) {
            NotificationsService.getNotificationsTemplates()
                .success(function (data) {
                    vm.customTemplates = _.groupBy(data, 'alert_type').sms;
                    if (vm.customTemplates && vm.customTemplates.length) {
                        vm.customTemplates.forEach(function (template) {
                            template.default = false;
                        });

                        vm.customTemplates.forEach(function (template) {
                            var matchedIndex = findTemplateIndex(template);
                            if (matchedIndex !== -1) {
                                vm.defaultTemplates[matchedIndex] = template;
                            }
                        })
                    }
                    if (isInitial) {
                        vm.actionType = vm.defaultTemplates[0];
                    } else {
                        var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = vm.defaultTemplates[updatedIndex];
                        }
                    }
                    

                })
        }

        function saveNotificationTemplate() {
            vm.isSaving = true;
            if (vm.actionType.default) {
                createNotificationTemplate();
            } else {
                updateNotificationTemplate();
            }

        }

        function createNotificationTemplate() {
            NotificationsService.createNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                    
                })
        }

        function updateNotificationTemplate() {
            NotificationsService.updateNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                })
        }

        function deleteCustomTemplate() {
            vm.isDeleting = true;
            NotificationsService.deleteCustomTemplate(vm.actionType.id)
                .success(function () {
                    vm.actionType.default = true;
                    getDefaultNotificationsTemplates(false);
                    vm.isDeleting = false;
                })
        }

        function findTemplateIndex(template) {
            if (template) {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': template.alert_type, 'alert_subtype': template.alert_subtype });
            } else {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': vm.actionType.alert_type, 'alert_subtype': vm.actionType.alert_subtype });
            }
        }

        function toggleAction() {
            vm.actionType.disabled = !vm.actionType.disabled;
            saveNotificationTemplate();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('PushNotificationsController', PushNotificationsController);

    /** @ngInject */
    function PushNotificationsController($rootScope, NotificationsService) {
        var vm = this;

        vm.insertVariable = insertVariable;
        vm.saveNotificationTemplate = saveNotificationTemplate;
        vm.deleteCustomTemplate = deleteCustomTemplate;
        vm.toggleAction = toggleAction;

        activate();

        function activate() {
            getDefaultNotificationsTemplates(true);
        }

        function insertVariable(varValue) {
            $rootScope.$broadcast('INSERT_VARIABLE', varValue);
        }

        function getDefaultNotificationsTemplates(isInitial) {
            NotificationsService.getDefaultNotificationsTemplates()
                .success(function (data) {
                    vm.defaultTemplates = _.groupBy(data, 'alert_type').push;
                    vm.defaultTemplates.forEach(function (template) {
                        template.default = true;
                    });
                    getNotificationsTemplates(isInitial);
                })
        }

        function getNotificationsTemplates(isInitial) {
            NotificationsService.getNotificationsTemplates()
                .success(function (data) {
                    vm.customTemplates = _.groupBy(data, 'alert_type').push;
                    if (vm.customTemplates && vm.customTemplates.length) {
                        vm.customTemplates.forEach(function (template) {
                            template.default = false;
                        });

                        vm.customTemplates.forEach(function (template) {
                            var matchedIndex = findTemplateIndex(template);
                            if (matchedIndex !== -1) {
                                vm.defaultTemplates[matchedIndex] = template;
                            }
                        })
                    }
                    if (isInitial) {
                        vm.actionType = vm.defaultTemplates[0];
                    } else {
                        var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = vm.defaultTemplates[updatedIndex];
                        }
                    }
                    

                })
        }

        function saveNotificationTemplate() {
            vm.isSaving = true;
            if (vm.actionType.default) {
                createNotificationTemplate();
            } else {
                updateNotificationTemplate();
            }

        }

        function createNotificationTemplate() {
            NotificationsService.createNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                    
                })
        }

        function updateNotificationTemplate() {
            NotificationsService.updateNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                })
        }

        function deleteCustomTemplate() {
            vm.isDeleting = true;
            NotificationsService.deleteCustomTemplate(vm.actionType.id)
                .success(function () {
                    vm.actionType.default = true;
                    getDefaultNotificationsTemplates(false);
                    vm.isDeleting = false;
                })
        }

        function findTemplateIndex(template) {
            if (template) {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': template.alert_type, 'alert_subtype': template.alert_subtype });
            } else {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': vm.actionType.alert_type, 'alert_subtype': vm.actionType.alert_subtype });
            }
        }

        function toggleAction() {
            vm.actionType.disabled = !vm.actionType.disabled;
            saveNotificationTemplate();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('InAppNotificationsController', InAppNotificationsController);

    /** @ngInject */
    function InAppNotificationsController($rootScope, NotificationsService) {
        var vm = this;

        vm.insertVariable = insertVariable;
        vm.saveNotificationTemplate = saveNotificationTemplate;
        vm.deleteCustomTemplate = deleteCustomTemplate;
        vm.toggleAction = toggleAction;

        activate();

        function activate() {
            getDefaultNotificationsTemplates(true);
        }

        function insertVariable(varValue) {
            $rootScope.$broadcast('INSERT_VARIABLE', varValue);
        }

        function getDefaultNotificationsTemplates(isInitial) {
            NotificationsService.getDefaultNotificationsTemplates()
                .success(function (data) {
                    vm.defaultTemplates = _.groupBy(data, 'alert_type').in_app;
                    vm.defaultTemplates.forEach(function (template) {
                        template.default = true;
                    });
                    getNotificationsTemplates(isInitial);
                })
        }

        function getNotificationsTemplates(isInitial) {
            NotificationsService.getNotificationsTemplates()
                .success(function (data) {
                    vm.customTemplates = _.groupBy(data, 'alert_type').in_app;
                    if (vm.customTemplates && vm.customTemplates.length) {
                        vm.customTemplates.forEach(function (template) {
                            template.default = false;
                        });

                        vm.customTemplates.forEach(function (template) {
                            var matchedIndex = findTemplateIndex(template);
                            if (matchedIndex !== -1) {
                                vm.defaultTemplates[matchedIndex] = template;
                            }
                        })
                    }
                    if (isInitial) {
                        vm.actionType = vm.defaultTemplates[0];
                    } else {
                        var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = vm.defaultTemplates[updatedIndex];
                        }
                    }
                    

                })
        }

        function saveNotificationTemplate() {
            vm.isSaving = true;
            if (vm.actionType.default) {
                createNotificationTemplate();
            } else {
                updateNotificationTemplate();
            }

        }

        function createNotificationTemplate() {
            NotificationsService.createNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                    
                })
        }

        function updateNotificationTemplate() {
            NotificationsService.updateNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                })
        }

        function deleteCustomTemplate() {
            vm.isDeleting = true;
            NotificationsService.deleteCustomTemplate(vm.actionType.id)
                .success(function () {
                    vm.actionType.default = true;
                    getDefaultNotificationsTemplates(false);
                    vm.isDeleting = false;
                })
        }

        function findTemplateIndex(template) {
            if (template) {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': template.alert_type, 'alert_subtype': template.alert_subtype });
            } else {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': vm.actionType.alert_type, 'alert_subtype': vm.actionType.alert_subtype });
            }
        }

        function toggleAction() {
            vm.actionType.disabled = !vm.actionType.disabled;
            saveNotificationTemplate();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('EmailNotificationsController', EmailNotificationsController);
    /** @ngInject */
    function EmailNotificationsController($timeout, $window, NotificationsService) {
        var vm = this;

        vm.insertVariable = insertVariable;
        vm.saveNotificationTemplate = saveNotificationTemplate;
        vm.deleteCustomTemplate = deleteCustomTemplate;
        vm.toggleAction = toggleAction;

        activate();

        function activate() {
            getDefaultNotificationsTemplates(true);
        }

        function insertVariable(e, variable) {
            e.preventDefault();
            $timeout(function() {
                var sel;
                sel = $window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    vm.rango = sel.getRangeAt(0);
                    vm.rango.insertNode(document.createTextNode('{{' + variable + '}}'));
                    vm.variable = '';
    
                    return sel.getRangeAt(0);
                }
            })
        }

        function getDefaultNotificationsTemplates(isInitial) {
            NotificationsService.getDefaultNotificationsTemplates()
                .success(function (data) {
                    vm.defaultTemplates = _.groupBy(data, 'alert_type').email;
                    vm.defaultTemplates.forEach(function (template) {
                        template.default = true;
                    });
                    getNotificationsTemplates(isInitial);
                })
        }

        function getNotificationsTemplates(isInitial) {
            NotificationsService.getNotificationsTemplates()
                .success(function (data) {
                    vm.customTemplates = _.groupBy(data, 'alert_type').email;
                    if (vm.customTemplates && vm.customTemplates.length) {
                        vm.customTemplates.forEach(function (template) {
                            template.default = false;
                        });

                        vm.customTemplates.forEach(function (template) {
                            var matchedIndex = findTemplateIndex(template);
                            if (matchedIndex !== -1) {
                                vm.defaultTemplates[matchedIndex] = template;
                            }
                        })
                    }
                    if (isInitial) {
                        vm.actionType = vm.defaultTemplates[0];
                    } else {
                        var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = vm.defaultTemplates[updatedIndex];
                        }
                    }
                    

                })
        }

        function saveNotificationTemplate() {
            vm.isSaving = true;
            if (vm.actionType.default) {
                createNotificationTemplate();
            } else {
                updateNotificationTemplate();
            }

        }

        function createNotificationTemplate() {
            NotificationsService.createNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                    
                })
        }

        function updateNotificationTemplate() {
            NotificationsService.updateNotificationTemplate(vm.actionType)
                .success(function (data) {
                    var updatedIndex = findTemplateIndex();
                        if (updatedIndex !== -1) {
                            vm.actionType = data;
                            vm.actionType.default = false;
                            vm.defaultTemplates[updatedIndex] = vm.actionType;
                        }
                        vm.isSaving = false;
                })
        }

        function deleteCustomTemplate() {
            vm.isDeleting = true;
            NotificationsService.deleteCustomTemplate(vm.actionType.id)
                .success(function () {
                    vm.actionType.default = true;
                    getDefaultNotificationsTemplates(false);
                    vm.isDeleting = false;
                })
        }

        function findTemplateIndex(template) {
            if (template) {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': template.alert_type, 'alert_subtype': template.alert_subtype });
            } else {
                return _.findIndex(vm.defaultTemplates, { 'alert_type': vm.actionType.alert_type, 'alert_subtype': vm.actionType.alert_subtype });
            }
        }

        function toggleAction() {
            vm.actionType.disabled = !vm.actionType.disabled;
            saveNotificationTemplate();
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('rsplCharityV2')
    .controller('TacController', TacController);

  /** @ngInject */
  function TacController($uibModalInstance) {
    var vm = this;

    vm.cancel = cancel;

    function cancel() {
      $uibModalInstance.dismiss();
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('LoginRolesController', LoginRolesController);

    /** @ngInject */
    function LoginRolesController($uibModalInstance, roles, user, ActionCableSocketWrangler, ActionCableConfig, socketBaseUrl, $state, $rootScope, LoginService) {
        var vm = this;

        vm.setLoginData = setLoginData;

        vm.userRoles = roles;

        localStorage.setItem('rspl-auth-data', angular.toJson(roles));

        vm.role = _.filter(vm.userRoles.roles, function (role) {
            return role.authorization.type === 'charity_admin';
        });

        vm.close = close;

        vm.alerts = [];

        vm.addAlert = addAlert;
        vm.tempCharity = null;

        function addAlert(type, msg) {
            vm.alerts.push({type: type, msg: msg});
        }

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function setLoginData(item) {
            vm.tempCharity = item;
            localStorage.setItem('rspl-token', item.authorization.token);
            localStorage.setItem('rspl-refresh-token', item.authorization.refresh_token);
            localStorage.setItem('rspl-user-id', user.id);
            localStorage.setItem('rspl-charity', item.charity.name);
            localStorage.setItem('rspl-charity-id', item.charity.id);
            localStorage.setItem('rspl-user', angular.toJson(user));
            localStorage.setItem('twilio-token', item.authorization.twilio_token.fcm_token);
            localStorage.setItem('twilio-identity', item.authorization.twilio_token.identity);
            ActionCableConfig.wsUri = socketBaseUrl + localStorage.getItem('rspl-token');
            localStorage.setItem('rspl-contract-signed', item.charity.contract_signed);
            $rootScope.$broadcast('login_event');
            redirect();
        }

        function redirect() {
            if ($state.current.name !== 'calendar') {
                $state.go(LoginService.checkForContract(vm.tempCharity));
            } else {
                $state.reload();
            }
            close();
        }

        function close() {
            $uibModalInstance.dismiss();
            if (!localStorage.getItem('rspl-token')) {
                localStorage.clear();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ExpiredController', ExpiredController);

    /** @ngInject */
    function ExpiredController($uibModalInstance) {
        var vm = this;

        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('TruckregistrationController', TruckregistrationController);

    /** @ngInject */
    function TruckregistrationController() {
        var vm = this;

        activate();

        function activate() {
        }


    }
})();
(function () {
    // 'use strict';
    angular
        .module('rsplCharityV2')
        .directive('scrollDirective', ['$window', '$timeout', scrollDirective]);

    function scrollDirective($window, $timeout) {
        var t = $timeout;
        return {
            link: function (scope, elem) {
                $timeout(function () {
                    if (elem.hasClass('names-colon-row')) {
                        elem.on('scroll', function (e) {
                            $(document).find('.am-pm-colon-row').eq(elem.index()).scrollTop($(this).scrollTop());
                        });
                    } else if (elem.hasClass('am-pm-colon-row')) {
                        elem.on('scroll', function (e) {
                            $(document).find('.names-colon-row').eq(elem.index()).scrollTop($(this).scrollTop());
                        });
                    }
                }, 0);
            }
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('PickupReportService', PickupReportService);

    /** @ngInject */
    function PickupReportService($http, baseUrl, DonationsService) {
        var service = this;

        service.getReports = getReports;
        service.getReportsByDonation = getReportsByDonation;
        service.getReportsStatus = getReportsStatus;
        service.markReportAsSeen = markReportAsSeen;

        function getReports(p) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/reports',
                params: p
            }).success(function (data) {
                return DonationsService.prepareReportDonations(data);
            })
        }

        function getReportsByDonation(donation_id) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/donations/' + donation_id + '/reports'
            }).success(function (data) {
                return DonationsService.prepareReportDonations(data);
            })
        }

        function getReportsStatus() {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/report_alerts'
            }).success(function (data) {
                return data;
            })
        }

        function markReportAsSeen(id) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/' + charityId + '/report_alerts/' + id + '/read'
            }).success(function (data) {
                return data;
            })
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('PickupReportsController', PickupReportsController);

    /** @ngInject */
    function PickupReportsController(PickupReportService, TrucksService, $state, $rootScope, $stateParams) {
        var vm = this;

        vm.nextWeek = nextWeek;
        vm.previousWeek = previousWeek;
        vm.getReports = getReports;
        vm.openReport = openReport;

        vm.params = {
            truck: null,
            after: moment().startOf('IsoWeek').format('YYYY-MM-DD'),
            before: moment().endOf('IsoWeek').format('YYYY-MM-DD')
        };

        if ($stateParams.after && $stateParams.before) {
            vm.params.before = $stateParams.before;
            vm.params.after = $stateParams.after;
            getReports();
        } else {
            getReports();
        }
        
        getTrucks();

        function nextWeek() {
            vm.params.after = moment(vm.params.after).add(7, 'days').format('YYYY-MM-DD');
            vm.params.before = moment(vm.params.before).add(7, 'days').format('YYYY-MM-DD');
            getReports();
        }

        function previousWeek() {
            vm.params.after = moment(vm.params.after).subtract(7, 'days').format('YYYY-MM-DD');
            vm.params.before = moment(vm.params.before).subtract(7, 'days').format('YYYY-MM-DD');
            getReports();
        }

        function getTrucks() {
            TrucksService.showAllTrucks()
                .success(function (data) {
                    vm.trucks = data;
                });
        }

        function getReports() {
            if (vm.selectedTruck) {
                vm.params.truck = vm.selectedTruck.id
            }
            vm.isLoading = true;
            PickupReportService.getReports(vm.params)
                .success(function (data) {
                    vm.reports = data;
                    getUnseenReports();
                })
                .error(function (error) {
                    console.log(error);
                })
        }

        function getUnseenReports() {
            PickupReportService.getReportsStatus()
                .success(function (data) {
                    vm.newReports = data;
                    vm.reports.forEach(function (report) {
                        report.report_alert = vm.newReports[_.findIndex(vm.newReports, function (item) {
                            return item.report_id === report.id
                        })];
                        report.seen = !_.some(vm.newReports, {'report_id': report.id});
                    });
                    vm.isLoading = false;
                })
        }

        function openReport(id, reportAlert, params) {
            if (reportAlert) {
                PickupReportService.markReportAsSeen(reportAlert.id)
                    .success(function () {
                        $rootScope.$broadcast('reports_count_updated');
                    })
            }
            $state.go('fleetmanagement.pickupreport', {id: id, before: params.before, after: params.after});
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('LiveviewController', LiveviewController);

    /** @ngInject */
    function LiveviewController(TrucksService, $rootScope, $uibModal, DonationsService, ProfileService, $q, $timeout, $filter) {
        var vm = this;

        vm.nextDay = nextDay;
        vm.previousDay = previousDay;
        vm.openDonation = openDonation;
        vm.assignTruck = assignTruck;
        vm.optimizeAllRoutes = optimizeAllRoutes;
        vm.optimizeRoutesByTruck = optimizeRoutesByTruck;

        vm.params = {};

        vm.params.start_date = moment().startOf('day').toDate();
        vm.params.end_date = moment().endOf('day').toDate();

        vm.donationsWithInvalidCoordinates = [];
        vm.invalidExpanded = false;

        vm.datePicker = {
            startDate: vm.params.start_date,
            endDate: vm.params.end_date
        };

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        activate();

        function activate() {
            getCharity();
            getTrucks();
            getDonations();
        }

        function getTrucks() {
            TrucksService.showAllTrucks()
                .success(function (data) {
                    if (data.length > 0) {
                        vm.allTrucks = data;
                        //removing trucks without location coordinates
                        vm.trucks = _.filter(data, function (truck) {
                            return truck.lat;
                        });
                        if (vm.trucks.length === 0) {
                            openNoTrucksPrompt(
                                {
                                    msg: 'You don\'t have any trucks on the move at the moment.',
                                    title: 'No trucks on the move',
                                    shouldAssignTruck: false
                                });
                        }
                    } else {
                        openNoTrucksPrompt(
                            {
                                msg: 'You don\'t have any trucks to assign donation pickup.\n' +
                                    'Go to Truck Registration or click the button below.',
                                title: 'No trucks assigned',
                                shouldAssignTruck: true
                            });
                    }

                });
        }

        var syncTruckEvent = $rootScope.$on('SYNC_TRUCK_LOCATION', function (event, data) {
            if (_.findIndex(vm.trucks, function (truck) {
                return truck.id === data.truck.truck_id;
            }) > -1)
                vm.trucks[_.findIndex(vm.trucks, function (truck) {
                    return truck.id === data.truck.truck_id;
                })].lat = data.truck.lat;
            vm.trucks[_.findIndex(vm.trucks, function (truck) {
                return truck.id === data.truck.truck_id;
            })].lng = data.truck.lng;
        });

        $rootScope.$on('$destroy', syncTruckEvent);

        vm.showMarkerData = function (event, marker) {
            vm.hoveredTruck = marker;
        };

        vm.hideMarkerData = function () {
            vm.hoveredTruck = {};
        };

        vm.showDonationData = function (event, marker) {
            event.stopPropagation();
            vm.hoveredDonation = marker;
        };

        vm.hideDonationData = function () {
            vm.hoveredDonation = {};
        };

        function openNoTrucksPrompt(promptData) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/fleetmanagement/liveview/prompts/no-trucks/no-trucks.html',
                controller: 'NoTrucksPromptController',
                controllerAs: 'ctrl',
                resolve: {
                    promptData: promptData
                },
                size: 'md'
            });
        }

        function nextDay() {
            vm.params.start_date.setDate(vm.params.start_date.getDate() + 1);
            vm.params.start_date = moment(vm.params.start_date).startOf('day').toDate();
            vm.params.end_date = moment(vm.params.start_date).endOf('day').toDate();

            getDonations();
        }

        function previousDay() {
            vm.params.start_date.setDate(vm.params.start_date.getDate() - 1);
            vm.params.start_date = moment(vm.params.start_date).startOf('day').toDate();
            vm.params.end_date = moment(vm.params.start_date).endOf('day').toDate();

            getDonations();
        }

        function getCharity() {
            ProfileService.getCharity()
                .success(function (data) {
                    vm.charity = data;
                })
                .error(function () {
                    vm.addAlert('danger', 'Error occured, Please contact Support');
                })
        }

        function getDonations() {
            vm.isLoading = true;
            DonationsService.searchDonations(vm.params)
                .then(function (data) {
                    var allDonations = data.data;

                    vm.donationsWithInvalidCoordinates = _.filter(allDonations, function (donation) {
                        return donation.lat === null;
                    });

                    allDonations = _.filter(allDonations, function (donation) {
                        return donation.lat !== null;
                    });
                    allDonations = _.filter(allDonations, function (donation) {
                        return donation.request.date === $filter('date')(vm.params.start_date, 'yyyy-MM-dd');
                    });
                    vm.donations = _.filter(allDonations, function (donation) {
                        return donation.request.status === 'accepted' || donation.request.status === 'completed';
                    });
                    if (vm.donations.length) {
                        vm.donations.forEach(function (donation, index) {
                            if (donation.request.status === 'completed') {
                                donation.request.status_label = 'completed'
                            } else if (donation.request.status === 'accepted' && donation.request.pickup_arrived) {
                                donation.request.status_label = 'arrived'
                            } else if (donation.request.status === 'accepted' && !donation.request.pickup_arrived && donation.request.pickup_started) {
                                donation.request.status_label = 'started'
                            } else {
                                donation.request.status_label = 'accepted'
                            }
                            if (index === vm.donations.length - 1) {
                                vm.isLoading = false;
                            }
                        });
                    } else {
                        vm.isLoading = false;
                    }

                })
                .catch(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong' + (errorData.data.message ? ', ' + errorData.data.message : ''));
                    vm.isLoading = false;
                });
        }

        function assignTruck(donation) {
            DonationsService.assignTruck(donation.id, donation.request.id, donation.request.truck.id).success(function () {
                vm.addAlert('success', 'Truck assigned successfully');
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function openDonation(donation) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'single-donation-modal',
                templateUrl: 'app/donations/prompts/single/single.donation.html',
                controller: 'SingleDonationController',
                controllerAs: 'singleCtrl',
                resolve: {
                    donationId: donation.id,
                    print: false
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function (changes) {
                    if (changes.label) {
                        donation.request.pickup_label = changes.label;
                    }
                    if (changes.truck) {
                        donation.request.truck = changes.truck;
                    }
                    if (changes.countAs) {
                        donation.request.count_as = changes.countAs;
                    }
                    if (changes.order) {
                        getDonations();
                    }

                })
        }

        function optimizeAllRoutes() {
            vm.isOptimizing = true;
            var promises = [];
            angular.forEach(vm.allTrucks, function (truck) {
                var promise = optimizeRoutesByTruck(truck.id, vm.params.start_date, true);
                promises.push(promise);
            });

            $q.all(promises)
                .then(function () {
                    $timeout(function () {
                        getDonations();
                        console.log('all-done');
                        vm.isOptimizing = false;
                    }, 500);

                })
                .catch(function (errorData) {
                    errorData = errorData.data;
                    vm.isOptimizing = false;
                    console.log(errorData);
                });

        }

        function optimizeRoutesByTruck (truckId, date, forAllTrucks) {
            if (!forAllTrucks) {
                vm.isOptimizingForSingleTruck = true;
            }
            TrucksService.optimizeAllRoutes(truckId, moment(date).format('YYYY-MM-DD'))
                .success(function () {
                    if (!forAllTrucks){
                        getDonations();
                        vm.isOptimizingForSingleTruck = false;
                    }
                })
                .error(function () {
                    vm.isOptimizingForSingleTruck = false;
                })

        }

        vm.styles = [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            }
        ];

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ListviewController', ListviewController);

    /** @ngInject */
    function ListviewController(TrucksService, $uibModal, DonationsService, $timeout, $scope, $stateParams, ScheduleService) {
        var vm = this;

        vm.nextWeek = nextWeek;
        vm.previousWeek = previousWeek;
        vm.openNewPrompt = openNewPrompt;
        vm.openDonation = openDonation;
        vm.createColorLabel = createColorLabel;
        vm.deleteColorLabel = deleteColorLabel;
        vm.selectTruck = selectTruck;
        vm.toggleAccordion = toggleAccordion;
        vm.expand = expand;
        vm.nextDay = nextDay;
        vm.previousDay = previousDay;
        vm.expand = expand;
        vm.prepareDate = prepareDate;
        vm.openDatepicker = openDatepicker;
        vm.getDonations = getDonations;
        vm.setDate = setDate;
        vm.checkDay = checkDay;
        vm.toggleDay = toggleDay;

        vm.scrollConfig = {
            autoHideScrollbar: true,
            theme: 'dark-3',
            scrollInertia: 0,
            axis: 'x',
            advanced: {
                updateOnContentResize: true
            }
        };
        vm.datePickerConfig = {
            showWeeks: false,
            startingDay: 1
        };
        vm.params = {};
        vm.datepicker = {};
        var date = new Date();
        date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
        if (date.getDay() === 1) {
            vm.params.start_date = date;
        } else if (date.getDay() === 0) {
            vm.params.start_date = new Date(date.getTime() - 60 * 60 * 24 * 1000 * 6);
        } else {
            vm.params.start_date = new Date(date.getTime() - 60 * 60 * 24 * 1000 * (date.getDay() - 1));
        }

        vm.params.end_date = angular.copy(vm.params.start_date);
        vm.params.end_date.setDate(vm.params.end_date.getDate() + 6);
        if ($stateParams.date) {
            vm.params.start_date = $stateParams.date;
            vm.params.end_date = $stateParams.date;
        }
        vm.accordion = {
            unassignedPickups: true,
            colorCoding: true
        };
        vm.expanded = true;

        vm.periods = ['am', 'pm'];

        activate();

        function activate() {
            vm.isLoading = true;
            getScheduleTemplate();
            getTrucks();
            getLabels();
        }

        function setDate() {
            vm.params.start_date.setHours(0, 0, 0, 0);
            vm.params.end_date = new Date(vm.params.start_date);
            vm.params.end_date.setHours(23, 59, 59, 999);
            getDonations();
        }

        function getTrucks() {
            vm.isLoadingTrucks = true;
            TrucksService.showAllTrucks()
                .success(function (data) {
                    $timeout(function () {
                        vm.trucks = data;
                        vm.displayedTrucks = angular.fromJson(sessionStorage.getItem('rspl-fleet-selected-trucks'));
                        if (vm.displayedTrucks) {
                            vm.trucks.forEach(function (truck) {
                                if (_.findIndex(vm.displayedTrucks, { 'id': truck.id }) > -1) {
                                    truck.selected = true;
                                }
                            })
                        } else {
                            if (vm.trucks.length > 0) {
                                if (vm.trucks.length > 4) {
                                    for (var i = 0; i < 4; i++) {
                                        vm.trucks[i].selected = true;
                                    }
                                } else {
                                    for (var j = 0; j < vm.trucks.length; j++) {
                                        vm.trucks[j].selected = true;
                                    }
                                }
                                vm.displayedTrucks = _.filter(vm.trucks, function (truck) {
                                    return truck.selected;
                                });
                            }
                        }
                        vm.isLoadingTrucks = false;
                    }, 1000);
                });
        }

        function getLabels() {
            TrucksService.getLabels()
                .success(function (data) {
                    vm.colorLabels = data;
                })
        }

        function getDonations() {
            vm.isLoading = true;
            DonationsService.searchDonations(vm.params)
                .then(function (data) {
                    prepareDates();
                    var allDonations = data.data;
                    var acceptedDonations = _.filter(allDonations, function (donation) {
                        return donation.request.status === 'accepted' || donation.request.status === 'completed';
                    });
                    vm.acceptedDonationsWithTruckAssigned = _.filter(acceptedDonations, function (donation) {
                        return donation.request.truck;
                    });
                    vm.unassignedDonations = _.filter(acceptedDonations, function (donation) {
                        return !donation.request.truck;
                    });
                    vm.unassignedDonationsByDate = _.groupBy(vm.unassignedDonations, 'request.date');
                    vm.acceptedDonationsWithTruckAssignedByDate = _.groupBy(vm.acceptedDonationsWithTruckAssigned, 'request.date');
                    vm.acceptedDonationsWithTruckAssignedSingleDay = _.toArray(vm.acceptedDonationsWithTruckAssignedByDate);
                    vm.isLoading = false;
                })
                .catch(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong' + (errorData.data.message ? ', ' + errorData.data.message : ''));
                    vm.isLoading = false;
                });
        }

        function nextWeek() {
            vm.params.end_date.setDate(vm.params.end_date.getDate() + 7);
            vm.params.start_date.setDate(vm.params.start_date.getDate() + 7);
            getDonations();
        }

        function previousWeek() {
            vm.params.end_date.setDate(vm.params.end_date.getDate() - 7);
            vm.params.start_date.setDate(vm.params.start_date.getDate() - 7);
            getDonations();
        }

        function nextDay() {
            vm.params.start_date.setDate(vm.params.start_date.getDate() + 1);
            vm.params.start_date = moment(vm.params.start_date).startOf('day').toDate();
            vm.params.end_date = moment(vm.params.start_date).endOf('day').toDate();
            getDonations();
        }

        function previousDay() {
            vm.params.start_date.setDate(vm.params.start_date.getDate() - 1);
            vm.params.start_date = moment(vm.params.start_date).startOf('day').toDate();
            vm.params.end_date = moment(vm.params.start_date).endOf('day').toDate();
            getDonations();
        }

        function prepareDates() {
            vm.dates = [];
            var dt = moment(vm.params.start_date).startOf('day');
            var end = moment(vm.params.end_date).startOf('day');
            while (dt <= end) {
                vm.dates.push({
                    date: moment(new Date(dt)).format('YYYY-MM-DD'),
                    disabled: checkDay(moment(new Date(dt)).format('YYYY-MM-DD'))
                });
                dt = moment(dt).add(1, 'day').startOf('day');
            }
        }

        function openNewPrompt(date) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'manual-donation',
                templateUrl: 'app/donations/prompts/new/new.html',
                controller: 'NewDonationController',
                controllerAs: 'newCtrl',
                resolve: {
                    reject: false,
                    date: function () {
                        return moment(date).toDate();
                    }
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function () {
                })
        }

        function openDonation(donation, shouldPrint, shouldReload) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'single-donation-modal',
                templateUrl: 'app/donations/prompts/single/single.donation.html',
                controller: 'SingleDonationController',
                controllerAs: 'singleCtrl',
                resolve: {
                    donationId: donation.id,
                    print: shouldPrint
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function (changes) {
                    if (changes.label) {
                        donation.request.pickup_label = changes.label;
                    }
                    if (changes.truck) {
                        donation.request.truck = changes.truck;
                    }
                    if (changes.countAs) {
                        donation.request.count_as = changes.countAs;
                    }
                    if (changes.order) {
                        donation.request.pickup_order_number = changes.order;
                    }

                    if (shouldReload) {
                        getDonations();
                    }
                })
        }

        function createColorLabel() {
            TrucksService.createLabel(vm.newLabelName, vm.newLabelColor)
                .success(function () {
                    vm.showNewLabelForm = false;
                    vm.newLabelName = null;
                    vm.newLabelColor = null;
                    getLabels();
                })
        }

        function deleteColorLabel(id) {
            TrucksService.deleteLabel(id)
                .success(function () {
                    getLabels();
                    var pickupsWithDeletedLabel = _.filter(vm.acceptedDonationsWithTruckAssigned, function (donation) {
                        if (donation.request.pickup_label) {
                            return donation.request.pickup_label.id === id;
                        }
                    });
                    pickupsWithDeletedLabel.forEach(function (donation) {
                        donation.request.pickup_label = null;
                    })
                })
        }

        function selectTruck(truck) {
            if (vm.displayedTrucks.length < 4 || truck.selected) {
                truck.selected = !truck.selected;
                vm.displayedTrucks = _.filter(vm.trucks, function (truck) {
                    return truck.selected;
                });
                sessionStorage.setItem('rspl-fleet-selected-trucks', angular.toJson(vm.displayedTrucks));
            }
        }

        function toggleAccordion(param) {
            vm.accordion[param] = !vm.accordion[param];
        }

        function expand() {
            vm.expanded = !vm.expanded;
        }

        function openDatepicker() {
            vm.datePickerOpened = true;
        }

        function prepareDate(day) {
            return new Date(day);
        }

        function getScheduleTemplate() {
            ScheduleService.getScheduleTemplate()
                .success(function (data) {
                    vm.scheduleTemplate = _.groupBy(data, function (template) {
                        return template.date
                    });
                    getScheduleExceptions(true);
                })
        }

        function getScheduleExceptions(shouldFetchDonations) {
            ScheduleService.getScheduleExceptions()
                .success(function (data) {
                    vm.scheduleExceptions = _.groupBy(data, function (exception) {
                        return exception.date
                    });
                    if (shouldFetchDonations) {
                        getDonations();
                    }
                })
        }

        function checkDay(day) {
            day = moment(day).format('YYYY-MM-DD');
            var dayName = moment(day).format('dddd');
            if (!vm.scheduleTemplate[dayName] && !vm.scheduleExceptions[day]) {
                return true;
            } else if (vm.scheduleExceptions[day] && (vm.scheduleExceptions[day][0].am + vm.scheduleExceptions[day][0].pm < 1)) {
                return true;
            } else {
                return false;
            }
        }

        function toggleDay(day, isDisabled) {
            day = moment(day).format('YYYY-MM-DD');
            var dayName = moment(day).format('dddd');
            if (vm.scheduleExceptions[day]) {
                if (!isDisabled) {
                    var currentException = vm.scheduleExceptions[day][0],
                        id = currentException.id,
                        am = 0,
                        pm = 0,
                        zips = currentException.zips;
                    updateException({ id: id, date: day, am: am, pm: pm, zips: zips }, true);
                } else {
                    vm.exception = vm.scheduleExceptions[day][0];
                    openExceptionsModal(day, vm.exception, 'update', vm.scheduleTemplate[dayName]);
                }
            } else {
                var tempException = { date: day, am: 0, pm: 0, zips: [] };
                var selectedDay = moment(tempException.date).format('dddd');
                var template = _.filter(vm.scheduleTemplate, function (t) {
                    return t[0].date === selectedDay;
                });

                if (template[0]) {
                    template[0].forEach(function (item) {
                        item.zips.forEach(function (zip) {
                            tempException.zips.push(zip)
                        })
                    })
                }

                if (!isDisabled) {
                    createException(tempException, true);
                } else {
                    vm.exception = { date: day, am: null, pm: null, zips: [] };
                    openExceptionsModal(day, vm.exception, 'create');
                }
            }
        }

        function openExceptionsModal(day, exception, process, defaultState) {
            day = moment(day).format('YYYY-MM-DD');
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/calendar/exception-modal/exception-modal.html',
                controller: 'ExceptionModalController',
                controllerAs: 'excCtrl',
                resolve: {
                    date: function () {
                        return moment(day).toDate();
                    },
                    exception: function () {
                        return exception;
                    },
                    process: function () {
                        return process;
                    },
                    defaultState: function () {
                        return defaultState;
                    }
                },
                size: 'md'
            });

            modalInstance.result.then(
                function (day, disabled) {
                    var index = _.findIndex(vm.dates, function (item) {
                        return item.date === day
                    });
                    vm.dates[index].disabled = disabled;
                    getScheduleExceptions();
                })
        }

        function createException(exception, disabled) {
            ScheduleService.createScheduleException(exception)
                .success(function (response) {
                    var index = _.findIndex(vm.dates, function (item) {
                        return item.date === response.date
                    });
                    vm.dates[index].disabled = disabled;
                    getScheduleExceptions();
                })
        }

        function updateException(exception, disabled) {
            ScheduleService.updateException(exception)
                .success(function (response) {
                    var index = _.findIndex(vm.dates, function (item) {
                        return item.date === response.date
                    });
                    vm.dates[index].disabled = disabled;
                    getScheduleExceptions();
                })
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DonationHubController', DonationHubController);

    /** @ngInject */
    function DonationHubController(DonationsService, baseUrl, imageBaseUrl, $uibModal, ScheduleService, $timeout) {
        var vm = this;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;

        vm.nextWeek = nextWeek;
        vm.previousWeek = previousWeek;
        vm.changeView = changeView;
        vm.openClaimPrompt = openClaimPrompt;
        vm.getDonations = getDonations;
        vm.pageChanged = pageChanged;
        vm.onZipAdded = onZipAdded;
        vm.onZipRemoved = onZipRemoved;

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({ type: type, msg: msg });
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        vm.loadTags = function (query) {
            return ScheduleService.searchForZipCodes(query);
        };

        activate();

        function activate() {
            vm.isLoading = true;
            vm.type = 'active';
            vm.charityId = localStorage.getItem('rspl-charity-id');

            vm.slickConfig = {
                dots: true,
                arrows: true,
                focusOnSelect: true,
                nextArrow: '<span class="rspl-icon icon-arrow-right"></span>',
                prevArrow: '<span class="rspl-icon icon-arrow-left"></span>',
                dotsClass: 'custom_paging',
                customPaging: function (slider, i) {
                    return (i + 1) + '/' + slider.slideCount;
                }
            };
            vm.pagination = {
                currentPage: 1,
                itemsPerPage: 100,
                totalItems: 0
            };

            vm.params = {
                page: vm.pagination.currentPage,
                "status[]": ['in_pool'],
                "zips[]": []
            };

            var date = new Date();
            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
            if (date.getDay() === 1) {
                vm.params.start_date = date;
            } else if (date.getDay() === 0) {
                vm.params.start_date = new Date(date.getTime() - 60 * 60 * 24 * 1000 * 6);
            } else {
                vm.params.start_date = new Date(date.getTime() - 60 * 60 * 24 * 1000 * (date.getDay() - 1));
            }

            vm.params.end_date = angular.copy(vm.params.start_date);
            vm.params.end_date.setDate(vm.params.end_date.getDate() + 6);

            vm.view = localStorage.getItem('rspl-view');
            vm.view = vm.view ? vm.view : 'list';

            getDonations();
        }

        function getDonations() {
            vm.alerts = [];
            vm.isLoading = true;
            vm.params["zips[]"] = vm.zipCodes && vm.zipCodes.length > 0 ? vm.zipCodes : [];

            if (vm.category) {
                vm.params.category = vm.category.name;
            } else {
                delete vm.params.category;
            }
            DonationsService.searchDonations(vm.params)
                .then(function (data) {
                    vm.pagination.currentPage = data.headers().current_page;
                    vm.pagination.totalItems = data.headers().total_pages * vm.pagination.itemsPerPage;
                    vm.donations = data.data;
                    angular.forEach(vm.donations, function (donation) {
                        donation.seen = true;
                        var exp = moment(new Date(new Date(donation.request.date).getTime() - 60 * 60 * 24 * 1000));
                        var curr = moment(new Date());
                        if (exp.diff(curr) <= 0) {
                            donation.expiration = 0;
                            donation.expiration_soon = true;
                        } else {
                            if (exp.diff(curr) <= 60 * 60) {
                                donation.expiration_soon = true;
                            } else {
                                donation.expiration_soon = false;
                            }
                            donation.expiration = exp;
                        }
                    });
                    getUnseenHubDonations();
                    vm.isLoading = false;
                }).catch(function (errorData) {
                    if (errorData.data.message === 'Parameter zips is missing') {
                        vm.addAlert('danger', 'Something went wrong. Please populate your pickup schedule to see donations from the hub');
                        vm.isLoading = false;
                    } else {
                        vm.addAlert('danger', 'Something went wrong' + (errorData.data.message ? ', ' + errorData.data.message : ''));
                        vm.isLoading = false;
                    }

                });
        }

        function nextWeek() {
            vm.params.end_date.setDate(vm.params.end_date.getDate() + 7);
            vm.params.start_date.setDate(vm.params.start_date.getDate() + 7);
            getDonations();
        }

        function previousWeek() {
            vm.params.end_date.setDate(vm.params.end_date.getDate() - 7);
            vm.params.start_date.setDate(vm.params.start_date.getDate() - 7);
            getDonations();
        }

        function changeView() {
            if (vm.view === 'table') {
                vm.view = 'list';
            } else {
                vm.view = 'table';
            }
            localStorage.setItem('rspl-view', vm.view);
        }

        function openClaimPrompt(donation, event) {
            event.stopPropagation();
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/donations/prompts/claim/claim.html',
                controller: 'ClaimController',
                controllerAs: 'claimCtrl',
                resolve: {
                    donation: donation
                },
                size: 'xs'
            });
            modalInstance.result.then(
                function () {
                    getDonations();
                })
        }

        function pageChanged() {
            vm.params.page = vm.pagination.currentPage;
            vm.getDonations();
        }

        function onZipAdded(tag) {
            $timeout(function () {
                if (!tag.code) {
                    vm.zips.splice(-1, 1);
                    ScheduleService.searchForZipCodes(tag.text)
                        .success(function (data) {
                            var newTag = data[0];
                            vm.zips.push(newTag);
                        })
                }
                vm.zipCodes = _.map(vm.zips, 'code');
                getDonations();
            }, 0)
        }

        function onZipRemoved() {
            $timeout(function () {
                vm.zipCodes = _.map(vm.zips, 'code');
                getDonations();
            }, 0)
        }

        function getUnseenHubDonations() {
            DonationsService.getHubStatus()
                .success(function (data) {
                    data = _.uniqBy(data, 'donation_id');
                    vm.newHubDonations = data;
                    vm.donations.forEach(function (donation) {
                        donation.donation_alert = vm.newHubDonations[_.findIndex(vm.newHubDonations, function (item) {
                            return item.donation_id === donation.id
                        })];
                        donation.seen = !_.some(vm.newHubDonations, { 'donation_id': donation.id });
                    });
                })
        }

    }
})();

(function () {
  "use strict";

  angular
    .module("rsplCharityV2")
    .controller("UsersListController", UsersListController);

  /** @ngInject */
  function UsersListController(UsersService, $uibModal, $scope) {
    var vm = this;

    vm.getUsers = getUsers;
    vm.pageChanged = pageChanged;
    vm.nextPage = nextPage;
    vm.search = search;
    vm.sort = sort;
    vm.editUser = editUser;
    vm.addUser = addUser;
    vm.deleteUser = deleteUser;
    vm.restoreUser = restoreUser;

    vm.alerts = [];
    $scope.cont = {};

    vm.addAlert = function (type, msg) {
      vm.alerts.push({ type: type, msg: msg });
    };

    vm.closeAlert = function (index) {
      vm.alerts.splice(index, 1);
    };

    activate();

    function activate() {
      vm.scrollOptions = {
        limit: 100
      };
      vm.pagination = {
        currentPage: 1,
        per_page: 50
      };
      getUsers();
    }

    function getUsers() {
      vm.isLoading = true;
      if (vm.pagination.currentPage === 1) {
        vm.users = [];
      }
      var data = {
        page: vm.pagination.currentPage,
        sort_by: vm.pagination.sort,
        order: vm.pagination.order,
        per_page: vm.pagination.per_page
      };
      data.term = vm.donor;
      UsersService.search(data)
        .then(function (response) {
          vm.pagination.currentPage = response.headers().current_page;
          vm.pagination.totalPages = response.headers().total_pages;
          if (vm.pagination.currentPage === 1) {
            vm.users = response.data;
          } else {
            vm.users = vm.users.concat(response.data);
          }
          vm.isLoading = false;
          vm.isSearching = false;
        })
        .catch(function (errorData) {
          if (errorData.data) {
            vm.addAlert("danger", "Something went wrong, " + errorData.message);
          }
          vm.isLoading = false;
          vm.isSearching = false;
        });
    }

    function pageChanged() {
      vm.params.page = vm.pagination.currentPage;
      vm.getUsers();
    }

    function nextPage() {
      vm.pagination.currentPage++;
      vm.getUsers();
    }

    function search(name) {
      vm.isSearching = true;
      vm.pagination.currentPage = 1;
      vm.getUsers(name);
    }

    function sort(sort) {
      vm.pagination.currentPage = 1;
      if (vm.pagination.sort === sort) {
        if (vm.pagination.order === "asc") {
          vm.pagination.order = "desc";
        } else {
          vm.pagination.order = "asc";
        }
      } else {
        vm.pagination.sort = sort;
      }
      vm.getUsers();
    }

    function editUser(user) {
      console.log(1);
      var user_copy = angular.copy(user);
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: "static",
        windowClass: "edit-user-modal",
        templateUrl: "app/database/users-list/prompts/edit/edit-user.html",
        controller: "EditUserController",
        controllerAs: "editUserCtrl",
        resolve: {
          user: user_copy
        },
        size: "lg"
      });
      modalInstance.result.then(function (updatedUser) {
        var userIndex = _.findIndex(vm.users, function (user) {
          return user.id === updatedUser.id;
        });
        vm.users[userIndex] = updatedUser;
      });
    }

    function addUser() {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: "static",
        windowClass: "edit-user-modal",
        templateUrl: "app/database/users-list/prompts/add/add-user.html",
        controller: "AddUserController",
        controllerAs: "addUserCtrl",
        size: "lg"
      });
      modalInstance.result.then(function () {});
    }

    function deleteUser(user) {
      UsersService.deleteUser(user.id).then(function () {vm.users = []; getUsers()})
    }

    function restoreUser(user) {
      UsersService.restoreUser(user.id).then(function () {vm.users = []; getUsers()})
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DonorManagementController', DonorManagementController);

    /** @ngInject */
    function DonorManagementController(UsersService, $uibModal, $scope) {
        var vm = this;

        vm.getUsers = getUsers;
        vm.pageChanged = pageChanged;
        vm.nextPage = nextPage;
        vm.search = search;
        vm.sort = sort;
        vm.viewDonor = viewDonor;
        vm.remove = remove;
        vm.editDonor = editDonor;
        vm.addDonor = addDonor;
        vm.openExportModal = openExportModal;

        vm.alerts = [];
        $scope.cont = {};

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        activate();

        function activate() {
            vm.scrollOptions = {
                limit: 100
            };
            vm.pagination = {
                currentPage: 1,
                sort: 'first_name',
                order: 'asc',
                per_page: 50
            };
            getUsers();
        }

        function getUsers() {
            vm.isLoading = true;
            if (vm.pagination.currentPage === 1) {
                vm.users = [];
            }
            var data = {
                page: vm.pagination.currentPage,
                sort_by: vm.pagination.sort,
                order: vm.pagination.order,
                per_page: vm.pagination.per_page
            };
            data.term = vm.donor;
            UsersService.searchAll(data).then(function (response) {
                vm.pagination.currentPage = response.headers().current_page;
                vm.pagination.totalPages = response.headers().total_pages;
                response.data = _.filter(response.data, function(donor) {
                    return donor.phone;
                })
                if (vm.pagination.currentPage === 1) {
                    vm.users = response.data;
                } else {
                    vm.users = vm.users.concat(response.data);
                }
                vm.isLoading = false;
                vm.isSearching = false;
            }).catch(function (errorData) {
                if (errorData.data) {
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                }
                vm.isLoading = false;
                vm.isSearching = false;
            });
        }

        function pageChanged() {
            vm.params.page = vm.pagination.currentPage;
            vm.getUsers();
        }

        function nextPage() {
            vm.pagination.currentPage++;
            vm.getUsers();
        }

        function search(name) {
            vm.isSearching = true;
            vm.pagination.currentPage = 1;
            vm.getUsers(name);
        }

        function sort(sort) {
            vm.pagination.currentPage = 1;
            if (vm.pagination.sort === sort) {
                if (vm.pagination.order === 'asc') {
                    vm.pagination.order = 'desc';
                } else {
                    vm.pagination.order = 'asc';
                }
            } else {
                vm.pagination.sort = sort;
            }
            vm.getUsers();
        }

        function viewDonor(donor) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/database/donormanagement/prompts/view/view.html',
                controller: 'ViewDonorController',
                controllerAs: 'viewCtrl',
                resolve: {
                    donor: donor
                },
                size: 'lg'
            });
        }

        function editDonor(contact) {
            var contact_copy = angular.copy(contact);
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'edit-contact-modal',
                templateUrl: 'app/database/donormanagement/prompts/editcontact/editcontact.html',
                controller: 'EditContactController',
                controllerAs: 'editContactCtrl',
                resolve: {
                    contact: contact_copy
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function (updatedContact) {
                    var userIndex = _.findIndex(vm.users, function(user) { return user.id === updatedContact.id; });
                    vm.users[userIndex] = updatedContact;
                })
        }

        function addDonor() {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'edit-contact-modal',
                templateUrl: 'app/database/donormanagement/prompts/add/add-contact.html',
                controller: 'AddContactController',
                controllerAs: 'addContactCtrl',
                size: 'lg'
            });
            modalInstance.result.then(
                function () {

                })
        }

        function remove(donor) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/database/donormanagement/prompts/remove/remove.html',
                controller: 'RemoveDonorController',
                controllerAs: 'removeCtrl',
                resolve: {
                    donor: donor
                },
                size: 'sm'
            });
        }

        function openExportModal() {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/database/donormanagement/prompts/export-modal/export-modal.html',
                controller: 'ExportContactsModalController',
                controllerAs: 'exportContactsCtrl',
                resolve: {
                    params: vm.params
                },
                size: 'lg'
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DonorGroupsController', DonorGroupsController);

    /** @ngInject */
    function DonorGroupsController($uibModal, DonorGroupService) {
        var vm = this;

        vm.deleteGroupPrompt = deleteGroupPrompt;
        vm.getAllGroups = getAllGroups;
        vm.isLoading = false;
        activate();

        function activate() {
            getAllGroups();
        }

        function getAllGroups() {
            vm.isLoading = true;
            DonorGroupService.getGroupsByCharityId(vm.term)
                .success(function (data) {
                    vm.donor_groups = data;
                    vm.isLoading = false;

                })
                .error(function (errorData) {
                    console.log(errorData);
                    vm.isLoading = false;
                })
        }

        function deleteGroupPrompt(group) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'delete-donors-group',
                templateUrl: 'app/database/donorgroups/prompts/deletegroup/deletegroup.html',
                controller: 'DeleteGroupController',
                controllerAs: 'delCtrl',
                resolve: {
                    group: group
                },
                size: 'xs'
            });
            modalInstance.result.then(
                function () {
                    getAllGroups();
                })
        }
    }
})
();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('DonorGroupService', DonorGroupService);

    /** @ngInject */
    function DonorGroupService($http, baseUrl) {
        var service = this;

        service.createGroup = createGroup;
        service.getGroupById = getGroupById;
        service.getGroupContacts = getGroupContacts;
        service._getGroupContacts = _getGroupContacts;
        service.getGroupsByCharityId = getGroupsByCharityId;
        service.updateGroup = updateGroup;
        service.deleteGroup = deleteGroup;
        function createGroup(data) {
            var charityId = localStorage.getItem('rspl-charity-id');
            var contacts = angular.copy(data);
            delete contacts.contacts;
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/' + charityId + '/groups',
                data: contacts
            }).success(function (data) {
                return data;
            })
        }

        function getGroupById(groupId) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/groups/' + groupId
            }).success(function (data) {
                return data;
            })
        }

        function getGroupContacts(groupId, name) {
            if (!name) {
                name = null;
            }
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/groups/' + groupId+'/contacts',
                params: {
                    name: name
                }
            }).success(function (data) {
                return data;
            })
        }

        function _getGroupContacts(groupId, page) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/groups/' + groupId+'/contacts',
                params: {
                    page: page
                }
            }).then(function (data) {
                return data;
            })
        }

        function getGroupsByCharityId(term) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/groups/',
                params: {
                    name: term
                }
            }).success(function (data) {
                return data;
            })
        }

        function updateGroup(data) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/' + charityId + '/groups/' + data.id,
                data: data
            }).success(function (data) {
                return data;
            })
        }

        function deleteGroup(id) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "DELETE",
                url: baseUrl + '/api/v2/charities/' + charityId + '/groups/' + id
            }).success(function (data) {
                return data;
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('ContactService', ContactService);

    /** @ngInject */
    function ContactService($http, baseUrl) {
        var service = this;

        service.createContact = createContact;
        service.createContacts = createContacts;
        service.getContactById = getContactById;
        service.getContactsByCharityId = getContactsByCharityId;
        service._getContactsByCharityId = _getContactsByCharityId;
        service.updateContact = updateContact;
        service.deleteContact = deleteContact;

        function createContact(data) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/' + charityId + '/contacts',
                data: data
            }).success(function (data) {
                return data;
            })
        }

        function createContacts(data) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/' + charityId + '/contacts/bulk_create',
                data: data
            }).success(function (data) {
                return data;
            })
        }

        function getContactById(contactId) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/contacts/' + contactId
            }).success(function (data) {
                return data;
            })
        }
        function updateContact(contact) {
            var contactId = contact.id;
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/' + charityId + '/contacts/' + contactId,
                data: contact
            }).success(function (data) {
                return data;
            })
        }
        function deleteContact(id) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "DELETE",
                url: baseUrl + '/api/v2/charities/' + charityId + '/contacts/' + id
            }).success(function (data) {
                return data;
            })
        }

        function getContactsByCharityId(filter) {
            var _filter = filter === 'call_log' ? filter+'='+encodeURIComponent(localStorage.getItem('rspl-voicemail-phone')) : filter;
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/contacts?'+_filter
            }).success(function (data) {
                return data;
            })
        }

        function _getContactsByCharityId(filter, page) {
            var _filter = filter === 'call_log' ? filter+'='+encodeURIComponent(localStorage.getItem('rspl-voicemail-phone')) : filter;
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/contacts?'+_filter+'&page='+page
            }).then(function (data) {
                return data;
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DonationsController', DonationsController);

    /** @ngInject */
    function DonationsController(DonationsService, ItemTypesService, UsersService, PrintService, baseUrl, imageBaseUrl, $state, $uibModal, $timeout, $window, $scope) {
        var vm = this;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;

        vm.getDonations = getDonations;
        vm.nextDay = nextDay;
        vm.previousDay = previousDay;
        vm.nextWeek = nextWeek;
        vm.previousWeek = previousWeek;
        vm.nextMonth = nextMonth;
        vm.previousMonth = previousMonth;
        vm.changeType = changeType;
        vm.timeTypeChanged = timeTypeChanged;
        vm.openDatepicker = openDatepicker;
        vm.changeView = changeView;
        vm.getUsers = getUsers;
        vm.getTaxReceipt = getTaxReceipt;
        vm.startConversation = startConversation;
        vm.openChangeDatePrompt = openChangeDatePrompt;
        vm.pageChanged = pageChanged;
        vm.search = search;
        vm.print = print;
        vm.openDonation = openDonation;
        vm.openNewPrompt = openNewPrompt;

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        activate();

        function activate() {
            vm.isLoading = true;
            vm.type = 'active';
            vm.charityId = localStorage.getItem('rspl-charity-id');
            vm.activeStatuses = [{
                id: 'accepted'
            }, {
                id: 'pending'
            }, {
                id: 'awaiting_user_response'
            }];
            vm.historyStatuses = [{
                id: 'completed'
            }, {
                id: 'canceled'
            }];

            vm.timeType = 'weekly';
            vm.timeTypes = ['daily', 'weekly', 'monthly', 'custom'];
            vm.datePickerOpened = false;
            vm.statuses = vm.activeStatuses;
            vm.slickConfig = {
                dots: true,
                arrows: true,
                focusOnSelect: true,
                nextArrow: '<span class="rspl-icon icon-arrow-right"></span>',
                prevArrow: '<span class="rspl-icon icon-arrow-left"></span>',
                dotsClass: 'custom_paging',
                customPaging: function (slider, i) {
                    return (i + 1) + '/' + slider.slideCount;
                }
            };
            vm.dateRangeConfig = {
                applyClass: 'btn-default',
                locale: {
                    format: 'DD MMM'
                },
                eventHandlers: {
                    "apply.daterangepicker": function () {
                        vm.getDonations();
                    }
                }
            };
            vm.pagination = {
                currentPage: 1,
                itemsPerPage: 100,
                totalItems: 0
            };

            vm.params = {
                page: vm.pagination.currentPage
            };

            vm.status = [];
            vm.weekly = null;
            vm.category = null;

            var date = new Date();
            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
            if (date.getDay() === 1) {
                vm.params.start_date = date;
            } else if (date.getDay() === 0) {
                vm.params.start_date = new Date(date.getTime() - 60 * 60 * 24 * 1000 * 6);
            } else {
                vm.params.start_date = new Date(date.getTime() - 60 * 60 * 24 * 1000 * (date.getDay() - 1));
            }

            vm.params.end_date = angular.copy(vm.params.start_date);
            vm.params.end_date.setDate(vm.params.end_date.getDate() + 6);

            vm.datePicker = {
                startDate: vm.params.start_date,
                endDate: vm.params.end_date
            };

            vm.view = localStorage.getItem('rspl-view');
            vm.view = vm.view ? vm.view : 'list';

            getItemTypes();
        }

        function getDonations() {
            vm.isLoading = true;

            vm.params["status[]"] = vm.status && vm.status.length > 0 ? vm.status.map(function (a) {
                return a.id;
            }) : vm.statuses.map(function (a) {
                return a.id;
            });
            if (vm.category) {
                vm.params.category = vm.category.name;
            } else {
                delete vm.params.category;
            }

            if (vm.timeType === 'daily') {
                vm.params.end_date = new Date(vm.params.start_date.getTime() + 60 * 60 * 24 * 1000 - 1);
            } else if (vm.timeType === 'custom') {
                vm.params.end_date = vm.datePicker.endDate;
                vm.params.start_date = vm.datePicker.startDate;
            }

            if (vm.donor) {
                vm.params.contact_id = vm.donor.id;
            } else {
                delete vm.params.contact_id;
            }
            DonationsService.searchDonations(vm.params).then(function (data) {
                vm.pagination.currentPage = data.headers().current_page;
                vm.pagination.totalItems = data.headers().total_pages * vm.pagination.itemsPerPage;
                vm.donations = data.data;
                vm.donationsToExport = angular.copy(vm.donations);
                vm.donationsToExport.forEach(function (donation) {
                    donation.date = donation.request.date;
                    donation.status = donation.request.status;
                    donation.donor = donation.requests[0].donor.first_name + " " + donation.requests[0].donor.last_name;
                    donation.address = donation.address.replace(/#/g, '').replace(/,/g, ';');
                    donation.description = donation.description ? donation.description.replace(/#/g, '').replace(/,/g, ';').replace(/"/g, '``').replace(/\n/g, " ") : '/';
                    donation.email = donation.request.donor.email
                    donation.label = donation.request.pickup_label ? donation.request.pickup_label.name : null;
                    delete donation.address2;
                    delete donation.special_instructions;
                    delete donation.request;
                    delete donation.initialRequest;
                    delete donation.content;
                    delete donation.photos;
                    delete donation.requests;
                    delete donation.lat;
                    delete donation.lng;
                    delete donation.tax_receipt_pdf_ready;
                    delete donation.tax_receipt_pdf_url;
                    delete donation.handling_required;
                });
                vm.isLoading = false;
                vm.isSearching = false;
            }).catch(function (errorData) {
                vm.addAlert('danger', 'Something went wrong' + (errorData.data.message ? ', ' + errorData.data.message : ''));
                vm.isSearching = false;
                vm.isLoading = false;
            });
        }

        function nextDay() {
            vm.params.start_date.setDate(vm.params.start_date.getDate() + 1);
            vm.getDonations();
        }

        function previousDay() {
            vm.params.start_date.setDate(vm.params.start_date.getDate() - 1);
            vm.getDonations();
        }

        function nextWeek() {
            vm.params.end_date.setDate(vm.params.end_date.getDate() + 7);
            vm.params.start_date.setDate(vm.params.start_date.getDate() + 7);
            vm.getDonations();
        }

        function previousWeek() {
            vm.params.end_date.setDate(vm.params.end_date.getDate() - 7);
            vm.params.start_date.setDate(vm.params.start_date.getDate() - 7);
            vm.getDonations();
        }

        function nextMonth() {
            vm.params.start_date = new Date(vm.params.start_date.getFullYear(), vm.params.start_date.getMonth() + 1, 1, 0, 0, 0);
            vm.params.end_date = new Date(vm.params.start_date.getTime());
            vm.params.end_date = new Date(vm.params.end_date.setMonth(vm.params.end_date.getMonth() + 1) - 1);
            vm.getDonations();
        }

        function previousMonth() {
            vm.params.start_date = new Date(vm.params.start_date.getFullYear(), vm.params.start_date.getMonth() - 1, 1, 0, 0, 0);
            vm.params.end_date = new Date(vm.params.start_date.getTime());
            vm.params.end_date = new Date(vm.params.end_date.setMonth(vm.params.end_date.getMonth() + 1) - 1);
            vm.getDonations();
        }

        function changeView() {
            if (vm.view === 'table') {
                vm.view = 'list';
            } else {
                vm.view = 'table';
            }
            localStorage.setItem('rspl-view', vm.view);
        }

        function changeType(type) {
            vm.type = type;
            if (vm.type === 'active') {
                vm.statuses = vm.activeStatuses;
            }
            if (vm.type === 'history') {
                vm.statuses = vm.historyStatuses;
            }
            vm.status = [];
            vm.getDonations();
        }

        function timeTypeChanged() {
            vm.params.start_date = new Date(vm.params.start_date);
            vm.params.end_date = new Date(vm.params.end_date);
            if (vm.timeType === 'monthly') {
                vm.params.start_date = new Date(vm.params.start_date.getFullYear(), vm.params.start_date.getMonth(), 1, 0, 0, 0)
                vm.params.end_date = new Date(vm.params.start_date.getTime());
                vm.params.end_date = new Date(vm.params.end_date.setMonth(vm.params.end_date.getMonth() + 1) - 1);
            } else if (vm.timeType === 'weekly') {
                vm.params.start_date = vm.params.start_date.getDay() === 1 ? vm.params.start_date : new Date(vm.params.start_date.getTime() - 60 * 60 * 24 * 1000 * (vm.params.start_date.getDay() - 1));
                vm.params.end_date = angular.copy(vm.params.start_date);
                vm.params.end_date.setDate(vm.params.end_date.getDate() + 6);
            } else if (vm.timeType === 'custom') {
                vm.datePicker.endDate = vm.params.end_date;
                vm.datePicker.startDate = vm.params.start_date;
            }
            vm.getDonations();
        }

        function openDatepicker() {
            vm.datePickerOpened = true;
        }

        function getUsers(name) {
            var data = null;
            if (name) {
                data = {
                    name: name
                };
            }
            return UsersService.searchAll(data).then(function (response) {
                return response.data.map(function (item) {
                    item.name = item.first_name + " " + item.last_name;
                    return item;
                });
            });
        }


        function startConversation(donation, event) {
            event.stopPropagation();
            localStorage.setItem('rspl-start-conversation', angular.toJson({
                id: donation.request.donor.id,
                first_name: donation.request.donor.first_name,
                last_name: donation.request.donor.last_name
            }));
            $state.go('messages');
        }

        function getTaxReceipt(donation, event) {
            if (event) event.stopPropagation();
            if (donation.tax_receipt_pdf_ready && donation.tax_receipt_pdf_url) {
                $window.open(donation.tax_receipt_pdf_url, '_blank');
            } else if (!donation.tax_receipt_pdf_ready && !donation.tax_receipt_pdf_url) {
                DonationsService.getTaxLink(donation.id)
                    .then(function (response) {
                        donation.tax_receipt_pdf_url = response.data.url;
                        if (!response.data.url) {
                            $timeout(function() {
                                vm.getTaxReceipt(donation)
                            }, 1000);
                        } else {
                            $window.open(donation.tax_receipt_pdf_url, '_blank');
                        }
                    })
                    .catch(function (error) {
                        vm.addAlert('danger', 'Something went wrong, ' + error.message);
                    })
            } else if (donation.tax_receipt_pdf_ready && !donation.tax_receipt_pdf_url) {
                $window.open(baseUrl + '/tax-receipts/' + donation.id + '/tax-receipt.pdf', '_blank');
            }
        }

        function openNewPrompt() {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'manual-donation',
                templateUrl: 'app/donations/prompts/new/new.html',
                controller: 'NewDonationController',
                controllerAs: 'newCtrl',
                size: 'lg'
            });
            modalInstance.result.then(
                function () {
                    getDonations();
                })
        }

        function openChangeDatePrompt(donation, e) {
            e.stopPropagation();
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/donations/prompts/reschedule/reschedule.html',
                controller: 'RescheduleController',
                controllerAs: 'rescheduleCtrl',
                resolve: {
                    donation: donation
                },
                size: 'sm'
            });
            modalInstance.result.then(
                function () {
                    getDonations();
                })
        }


        function pageChanged() {
            vm.params.page = vm.pagination.currentPage;
            vm.getDonations();
        }

        function getItemTypes() {
            ItemTypesService.getItemTypes().success(function (data) {
                vm.itemTypes = data;
                vm.getDonations();
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                vm.isLoading = false;
            });
        }

        function print() {
            PrintService.print("database", {
                donations: vm.donations,
                viewType: vm.timeType,
                dateTo: vm.params.start_date,
                dateFrom: vm.params.end_date,
                category: vm.category ? vm.category.name : 'Undefined category',
                statuses: vm.status && vm.status.length > 0 ? getStatuseNames() : 'All statuses'
            });
        }

        function getStatuseNames() {
            var statuses = '';
            angular.forEach(vm.status, function (e, i) {
                if (i > 0) {
                    statuses += ", ";
                }
                statuses += e.id;
            });
            return statuses;
        }


        function search() {
            vm.isSearching = true;
            getDonations();
        }

        function openDonation(donationId, shouldPrint, e) {
            if (e) e.stopPropagation();
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'single-donation-modal',
                templateUrl: 'app/donations/prompts/single/single.donation.html',
                controller: 'SingleDonationController',
                controllerAs: 'singleCtrl',
                resolve: {
                    donationId: donationId,
                    print: shouldPrint
                },
                size: 'lg'
            });
            modalInstance.result.then(
                function () {
                    getDonations();
                })
        }

        function showTaxReceiptNotReadyModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/donations/prompts/no-tax/no-tax.html',
                controller: 'NoTaxController',
                controllerAs: 'noTaxCtrl',
                size: 'sm'
            });
        }
        $scope.$on('MODAL_CLOSED', function () {
            getDonations();
        });

    }
})
();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('UtilsService', UtilsService);

    /** @ngInject */
    function UtilsService() {
        var service = this;

        service.csvToJson = csvToJson;

        function csvToJson(csv) {
            var array = CSVToArray(csv);
            var objArray = [];
            for (var i = 1; i < array.length; i++) {
                objArray[i - 1] = {};
                for (var k = 0; k < array[0].length && k < array[i].length; k++) {
                    var key = array[0][k];
                    objArray[i - 1][key] = array[i][k]
                }
            }

            var json = angular.toJson(objArray);
            var str = json.replace(/},/g, "},\r\n");

            return str;
        }

        function CSVToArray(strData, strDelimiter) {
            strDelimiter = (strDelimiter || ",");
            var objPattern = new RegExp((
            "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
            // Standard fields.
            "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
            var arrData = [[]];
            var arrMatches = null;
            while (arrMatches == objPattern.exec(strData)) {
                var strMatchedDelimiter = arrMatches[1];
                if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)) {
                    arrData.push([]);
                }
                if (arrMatches[2]) {
                    var strMatchedValue = arrMatches[2].replace(
                        new RegExp("\"\"", "g"), "\"");
                } else {
                    strMatchedValue = arrMatches[3];
                }
                arrData[arrData.length - 1].push(strMatchedValue);
            }
            return (arrData);
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('textBoxWithVars', textBoxWithVars);

    /** @ngInject */
    function textBoxWithVars($rootScope) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var variableInsert = $rootScope.$on('INSERT_VARIABLE', function (e, val) {
                    var domElement = element[0];

                    if (document.selection) {
                        domElement.focus();
                        var sel = document.selection.createRange();
                        sel.text = val;
                        domElement.focus();
                    } else if (domElement.selectionStart || domElement.selectionStart === 0) {
                        var startPos = domElement.selectionStart;
                        var endPos = domElement.selectionEnd;
                        var scrollTop = domElement.scrollTop;
                        domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
                        domElement.focus();
                        domElement.selectionStart = startPos + val.length;
                        domElement.selectionEnd = startPos + val.length;
                        domElement.scrollTop = scrollTop;
                    } else {
                        domElement.value += val;
                        domElement.focus();
                    }
                    element.trigger('input'); 

                });
                $rootScope.$on('$destroy', variableInsert);
            }
        }
    }

})();



(function() {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('limitTo', limitTo);

    /** @ngInject */
    function limitTo() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                var limit = parseInt(attrs.limitTo);
                angular.element(elem).on("keypress", function(e) {
                    if (this.value.length == limit) e.preventDefault();
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('fileReader', fileReader);

    /** @ngInject */
    function fileReader() {
        return {
            scope: {
                fileReader:"="
            },
            link: function(scope, element) {
                $(element).on('change', function(changeEvent) {
                    var files = changeEvent.target.files;
                    if (files.length) {
                        var r = new FileReader();
                        r.onload = function(e) {
                            var contents = e.target.result;
                            scope.$apply(function () {
                                scope.fileReader = contents;
                                scope.testing = contents;
                            });
                            scope.$emit('CSV_READY', {content: contents});
                        };

                        r.readAsText(files[0]);

                    }
                });
            }


        };
    }

})();


(function() {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('onlyNumbers', onlyNumbers);

    /** @ngInject */
    function onlyNumbers() {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {
                elm.on('keydown', function (event) {
                    if (event.which === 64 || event.which === 16) {
                        // to allow numbers
                        return false;
                    } else if (event.which >= 48 && event.which <= 57) {
                        // to allow numbers
                        return true;
                    } else if (event.which >= 96 && event.which <= 105) {
                        // to allow numpad number
                        return true;
                    } else if (event.which === 191) {
                        // to allow slash
                        return true;
                    } else if ([8, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {
                        // to allow backspace, enter, escape, arrows
                        return true;
                    } else {
                        event.preventDefault();
                        // to stop others
                        return false;
                    }
                });
            }
        }
    }

})();



(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('TrackingService', TrackingService);

    /** @ngInject */
    function TrackingService($http, $window, analyticsUrl, apiVersion, env) {
        var service = this;

        service.track = track;
        service.register = register;


        function register() {
                if (env === 'production' && localStorage.getItem("rspl-fingerprint")) {
                var browserData = angular.fromJson(localStorage.getItem("rspl-browser-data"));
                return $http({
                    method: "POST",
                    url: analyticsUrl + '/devices',
                    data: {
                        "uid": localStorage.getItem("rspl-fingerprint"),
                        "platform": "web",
                        "os_version": browserData.os + " " + browserData.osVersion,
                        "model": browserData.browser + " " + browserData.browserVersion,
                        "device_type": "browser"
                    }
                }).success(function (data) {
                    return data;
                })
            }

        }

        function track(title, data) {
            if (env === 'production' && localStorage.getItem("rspl-device-id") && localStorage.getItem('rspl-user-id')) {
                $window.ga('send', 'event', title);
                return $http({
                    method: "POST",
                    url: analyticsUrl + '/events',
                    data: {
                        "name": title,
                        "content": angular.toJson(data),
                        "app_version": "1.0.0",
                        "platform": navigator.platform,
                        "user_id": localStorage.getItem('rspl-user-id'),
                        "api_version": apiVersion,
                        "event_type": "event",
                        "app": "web-app",
                        "device_id": localStorage.getItem("rspl-device-id")
                    }
                }).success(function (data) {
                    return data;
                })
            }
        }
    }

})();


(function() {
  'use strict';

  angular
    .module('rsplCharityV2')
    .directive('secNavbar', secNavbar);

  /** @ngInject */
  function secNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/secondary-nav/secondary_navbar.html',
      scope: {
        creationDate: '='
      },
      controller: SecondaryNavbarController,
      controllerAs: 'secNav',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SecondaryNavbarController() {
      // var vm = this;

    }
  }

})();

/**
 * Created by dms on 2/10/18.
 */
(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('PrintService', PrintService);

    /** @ngInject */
    function PrintService($http, $rootScope, $timeout, $compile, $q) {
        var service = this;

        service.print = print;

        function print(tmpl, data) {
            var template = printTemplates[tmpl];
            var printScope = $rootScope.$new();
            angular.extend(printScope, data);
            var element = $compile(angular.element('<div>' + template + '</div>'))(printScope);
            var renderAndPrintPromise = $q.defer();
            var waitForRenderAndPrint = function () {
                if (printScope.$$phase || $http.pendingRequests.length) {
                    $timeout(waitForRenderAndPrint, 1000);
                } else {
                    // Replace printHtml with openNewWindow for debugging
                    printHtml(element.html()).then(function () {
                        $rootScope.isBeingPrinted = false;
                        renderAndPrintPromise.resolve();
                    });
                    printScope.$destroy();
                }
                return renderAndPrintPromise.promise;
            };
            waitForRenderAndPrint();
        }

        var printHtml = function (html) {
            var deferred = $q.defer();
            var hiddenFrame = angular.element('<iframe style="visibility: hidden"></iframe>').appendTo('body')[0];
            hiddenFrame.contentWindow.printAndRemove = function () {
                hiddenFrame.contentWindow.print();
                angular.element(hiddenFrame).remove();
                deferred.resolve();
            };
            var htmlContent = "<!doctype html>" +
                "<html>" +
                "<head> \
                <link href='https://fonts.googleapis.com/css?family=Roboto:400,700' rel='stylesheet'> \
                <style> \
                @media print{\
                    * { \
                      font-family: 'Roboto', sans-serif !important; \
                      -webkit-print-color-adjust: exact;\
                      print-color-adjust: exact;\
                    }\
                  }\
                  @media print { \
                    tr, th, td {\
                        padding-left: 0px; \
                    }\
                    td {\
                    padding-right: 5px; \
                    }\
                    tr {\
                        height: 50px;\
                    }\
                    table, tr, th, td { \
                        font-family: 'Arial' !important;\
                        text-align: left !important; \
                        font-size: 18px; \
                        border-spacing: 0px !important; \
                        border-collapse: collapse !important;\
                         \
                    }\
                    .separator-header { \
                        height: 54px !important; \
                        background-color: #94c5ec;\
                        color: #1c4f90; \
                        padding-left: 20px; \
                        } \
                    .separator-header th{ \
                        color: #1c4f90; \
                    }\
                    .separator-header th:first-child{ \
                        border-top-left-radius: 8px !important;\
                    }\
                    .separator-header th:last-child{ \
                        border-top-right-radius: 8px !important;\
                    }\
                    .date-header { \
                        height: 54px !important; \
                        color: #1c4f90; \
                        padding-left: 20px; \
                        } \
                    .donor-entry{ \
                        height: 70px !important;\
                        border-top: 1px solid #c0c0c0 \
                    }\
                    .additional-instructions{\
                        height: 54px; \
                    }\
                    .additional-instructions-label{\
                        color: #1c4f90; \
                    }\
                    .text-uppercase{\
                        text-transform: uppercase;\
                    }\
                    .text-capitalize{\
                        text-transform: capitalize;\
                    }\
                  } \
                </style> \
                </head>" +
                '<body onload="printAndRemove();">' +
                html +
                '</body>' +
                "</html>";
            var doc = hiddenFrame.contentWindow.document.open("text/html", "replace");
            doc.write(htmlContent);
            doc.close();
            return deferred.promise;
        };


        var printTemplates = {

            calendar:
            '<div class="rspl-print">' +
            '<img ng-src="assets/images/rspl-logo-2.png" alt="Resupply" style="height: 30px">' +
            // '<h1>Pavilion of Hope</h1>' +
            '<h2> Calendar - <span class="text-capitalize">{{viewType}}</span> </h2>' +
            '<p>Filters: <span class="text-capitalize">{{viewType}}</span> {{dateFrom | date: "dd MMM"}} {{dateTo ? "-" : ""}} {{dateTo | date: "dd MMM"}}, {{trucks}} </p>' +
            '<table id="print-content" ng-repeat="day in dates" style="width: 100%">' +
            '<thead>' +
            '<tr>' +
            '<th class="date-header" colspan="7">{{day.date | date: "EEEE, dd MMM"}}</th>' +
            '</tr>' +
            '<tr class="separator-header" ng-if="donations[day.date].length">' +
            '<th style="width: 15%">Donor</th>' +
            '<th style="width: 10%">Date</th>' +
            '<th style="width: 5%">Time</th>' +
            '<th style="width: 25%">Address</th>' +
            '<th style="width: 5%">Zip</th>' +
            '<th style="width: 25%">Phone</thsty>' +
            '<th style="width: 15%">Truck</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody ng-repeat="d in donations[day.date]">' +
            '<tr class="donor-entry">' +
            '<td>{{d.request.donor.first_name}} {{d.request.donor.last_name}}</td>' +
            '<td>{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.date : d.request.date | date : "MMM dd"}}</td>' +
            '<td class="text-uppercase">{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.part_of_day : d.request.part_of_day}}</td>' +
            '<td>{{d.address}}</td>' +
            '<td>{{d.zip}}</td>' +
            '<td>{{d.phone}}</td>' +
            '<td>{{d.request.truck.model}}</td>' +
            '</tr>' +
            '<tr class="additional-instructions" ng-if="d.special_instructions">' +
            '<td colspan="7">Instructions for the driver: {{d.special_instructions}}</td>' +
            '</tr>' +
            '</tbody>' +
            '<tbody ng-if="!donations[day.date].length">' +
            '<tr colspan="7" class="empty-placeholder text-center">' +
            '<td>Nothing scheduled for this day</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '</div>',

            database:
            '<div style="color: #5a5a5a; font-family: \'Circular\';" class="rspl-print">' +
            '<img ng-src="assets/images/rspl-logo-2.png" alt="Resupply" style="height: 30px">' +
            '<p><Showing: <span class="text-capitalize">{{viewType}}</span> {{dateFrom | date: "dd MMM"}} {{dateTo ? "-" : ""}} {{dateTo | date: "dd MMM"}}, {{category}}, {{statuses}} </p>' +
            '<table id="print-content"  style="width: 100%">' +
            '<thead>' +
            '<tr>' +
            '<th>Donor</th>' +
            '<th>Date</th>' +
            '<th>Address</th>' +
            '<th>Phone</th>' +
            '<th>$</th>' +
            '<th>Status</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr ng-repeat="d in donations">' +
            '<td>{{d.request.donor.first_name}} {{d.request.donor.last_name}}</td>' +
            '<td class="text-uppercase">{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.date : d.request.date | date : "MM-dd-yy"}} {{d.request.status === \'awaiting_user_response\' ? d.initialRequest.part_of_day : d.request.part_of_day}}</td>' +
            '<td>{{d.address}}</td>' +
            '<td>{{d.phone}}</td>' +
            '<td>${{d.estimated_price}}</td>' +
            '<td class="text-capitalize">{{d.request.status === \'awaiting_user_response\' ? \'Waiting\' : d.request.status}}</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '</div>'
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('PaymentService', PaymentService);

    /** @ngInject */
    function PaymentService($http, baseUrl) {
        var service = this;

        service.submitPayment = submitPayment;

        function submitPayment(token) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/'+charityId+'/billing',
                data: {
                    stripe_token: token
                }
            }).success(function (data) {
                return data;
            })
        }


    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('PaymentController', PaymentController);

    /** @ngInject */
    function PaymentController(PaymentService, ProfileService, $state, $timeout, stripeKey) {
        var vm = this;
        vm.termsAndConditions = false;
        vm.check_terms = check_terms;
        vm.cc_format = cc_format;
        vm.card_number_format = card_number_format;
        vm.pay = pay;

        getCharity();

        function getCharity(){
            ProfileService.getCharity()
                .success(function (data) {
                    if (data.contract_signed) {
                        localStorage.setItem('rspl-contract-signed', true);
                        $state.go('dashboard')
                    }
                })
        }

        vm.scrollConfig = {
            autoHideScrollbar: false,
            theme: 'dark-3',
            scrollInertia: 0,
            axis: 'y',
            advanced: {
                updateOnContentResize: true
            }
        };

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function check_terms() {
            vm.termsAndConditions = !vm.termsAndConditions;
        }

        function cc_format(value) {
            var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
            var matches = v.match(/\d{4,16}/g);
            var match = matches && matches[0] || '';
            var parts = [];
            for (var i = 0, len = match.length; i < len; i += 4) {
                parts.push(match.substring(i, i + 4))
            }
            if (parts.length) {
                return parts.join('-')
            } else {
                return value
            }
        }

        function card_number_format(e) {
            var val = e.currentTarget.value;
            var formatted = cc_format(val);
            e.currentTarget.value = formatted;
        }


        var stripe = Stripe(stripeKey);
        var elements = stripe.elements();

        var style = {
            base: {
                iconColor: '#666EE8',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: 'Helvetica Neue',
                fontSize: '15px',

                '::placeholder': {
                    color: '#CFD7E0'
                }
            }
        };

        var cardNumberElement = elements.create('cardNumber', {
            style: style
        });
        cardNumberElement.mount('#card-number-element');

        var cardExpiryElement = elements.create('cardExpiry', {
            style: style
        });
        cardExpiryElement.mount('#card-expiry-element');

        var cardCvcElement = elements.create('cardCvc', {
            style: style
        });
        cardCvcElement.mount('#card-cvc-element');

        cardNumberElement.on('change', function (event) {
            setOutcome(event);
        });

        cardExpiryElement.on('change', function (event) {
            setOutcome(event);
        });

        cardCvcElement.on('change', function (event) {
            setOutcome(event);
        });

        function pay() {
            vm.isSubmitting = true;
            var form = document.querySelector('form');
            var extraDetails = {
                name: form.querySelector('input[name=cardholder-name]').value,
                address_zip: document.getElementById('postal-code').value,
                address_line1: document.getElementById('billing_address').value
            };
            stripe.createToken(cardNumberElement, extraDetails).then(setOutcome, handleError);
        }

        function setOutcome(result) {
            var errorElement = document.querySelector('.error');
            errorElement.classList.remove('visible');
            if (result.token) {
                PaymentService.submitPayment(result.token.id)
                    .success(function () {
                        localStorage.setItem('rspl-contract-signed', true);
                        $state.go('dashboard');
                        vm.isSubmitting = false;
                    })
                    .error(function (errorData) {
                        vm.isSubmitting = false;
                        vm.addAlert('danger', 'Oops, an error occurred: ' + errorData.message);
                    })
            } else if (result.error) {
                errorElement.textContent = result.error.message;
                errorElement.classList.add('visible');
                $timeout(function () {
                    vm.isSubmitting = false;
                }, 0);
            }
        }

        function handleError() {
            console.log('error');
            vm.isSubmitting = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('mainNav', mainNav);

    /** @ngInject */
    function mainNav() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: NavbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavbarController(
            $uibModal,
            $state,
            $window,
            $document,
            ProfileService,
            $rootScope,
            $scope,
            LoginService,
            DonationsService,
            NotificationsService,
            $interval,
            $timeout,
            ActionCableChannel,
            ActionCableSocketWrangler,
            PickupReportService) {

            var vm = this;
            vm.logout = logout;
            vm.toggleSidebar = toggleSidebar;
            vm.closeMenu = closeMenu;
            vm.toggleClass = toggleClass;
            vm.toggleFleetManagement = toggleFleetManagement;
            vm.toggleDatabase = toggleDatabase;
            vm.fleetmanagement = false;
            vm.database = false;
            vm.collapse = collapse;
            vm.toggleNotification = toggleNotification;
            var userId;
            var tokenRefreshInProgress = false;
            vm.notification_alerts = [];
            vm.alertsError = false;
            vm.openDonation = openDonation;
            vm.markAsRead = markAsRead;
            vm.changeCharity = changeCharity;
            vm.getUserRoles = getUserRoles;

            function getUserRoles(roles) {
                vm.role = _.filter(roles, function (role) {
                    return role.authorization.type === 'charity_admin';
                });
            }

            var conversationsInterval;
            var animationInterval;
            vm.hasStripeAccount = true;

            vm.scrollConfig = {
                autoHideScrollbar: true,
                theme: 'minimal-dark',
                scrollInertia: 0,
                axis: 'y',
                advanced: {
                    updateOnContentResize: true
                }
            };

            activate();

            if (vm.loggedIn) {
                // getSchedule();
                getNotificationAlerts(true);
                vm.active = $state.current.name;
            }

            function changeCharity() {
                if (vm.authData) {
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/login/login-roles-modal/login.roles.modal.html',
                        backdrop: 'static',
                        controller: 'LoginRolesController',
                        controllerAs: 'loginRolesCtrl',
                        resolve: {
                            roles: function () {
                                return vm.authData
                            },
                            user: function () {
                                return angular.fromJson(localStorage.getItem('rspl-user'))
                            }
                        },
                        size: 'sm'
                    });
                }
            }

            function activate() {
                vm.charityName = localStorage.getItem('rspl-charity');
                userId = localStorage.getItem('rspl-user-id');
                if (userId) {
                    getUser(userId);
                    vm.loggedIn = true;
                    getHubStatus();
                    getReportsStatus();
                    if (!ActionCableSocketWrangler.connected && !ActionCableSocketWrangler.connecting || !vm.consumer) {
                        connectToAppSocket();
                    }
                } else {
                    vm.loggedIn = false;
                }

                vm.dynamicPopover = {
                    templateUrl: 'app/components/navbar/userOptions.html'
                };

                vm.authData = angular.fromJson(localStorage.getItem('rspl-auth-data'));
                getUserRoles(vm.authData);

            }

            function connectToAppSocket() {
                ActionCableSocketWrangler.start();

                vm.consumer = new ActionCableChannel('ApplicationChannel', {});
                vm.actionCallback = function (result) {
                    $timeout(function () {
                        switch (result.event) {
                            case 'new_donation_in_pool':
                                getHubStatus();
                                break;
                            case 'report_created':
                                getReportsStatus();
                                break;
                            case 'pending_donation':
                                getDonations();
                                break;
                            case 'sync_truck_location':
                                if ($state.current.name === 'fleetmanagement.liveview') {
                                    $rootScope.$broadcast('SYNC_TRUCK_LOCATION', { truck: result });
                                }
                                break;
                            default:
                                console.log(result);
                        }
                    }, 0)
                };
                vm.consumer.subscribe(vm.actionCallback).then(function () {
                    $scope.$on("$destroy", function () {
                        vm.consumer.unsubscribe();
                    });
                });
            }

            function getDonations() {
                DonationsService.searchDonations({
                    "status[]": ['pending']
                }).success(function (data) {
                    vm.pendingDonations = data.length;
                })
            }

            var stateChange = $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from) {
                $rootScope.previousState = from.name;
                vm.active = to.name;
                $timeout(function () {
                    if (vm.active === 'payment') {
                        $('.rspl-content').css('padding-left', '0');
                        $('.sidebar').css('display', 'none');
                    } else {
                        $('.rspl-content').css('padding-left', '250');
                        $('.sidebar').css('display', 'block');
                    }
                }, 0);

                if (vm.active !== 'dashboard') {
                    $("#notification-container").removeClass('show-nav');
                }
                collapse();
                if (from.name) {
                    activate();
                }
            });

            var loggedIn = $rootScope.$on('login_event', function () {
                getNotificationAlerts(true);
                getAppData();
                vm.authData = angular.fromJson(localStorage.getItem('rspl-auth-data'));
                getUserRoles(vm.authData);
            });

            var hubCount = $rootScope.$on('hub_count_updated', function () {
                getHubStatus();
            });

            var reportsCount = $rootScope.$on('reports_count_updated', function () {
                getReportsStatus();
            });

            $rootScope.$on('$destroy', stateChange, loggedIn, hubCount, reportsCount);

            var refreshToken = $scope.$on('refresh-token', function () {
                if (!tokenRefreshInProgress) {
                    tokenRefreshInProgress = true;
                    LoginService.refreshToken()
                        .success(function (data) {
                            localStorage.setItem('rspl-token', data.authorization.token);
                            localStorage.setItem('rspl-refresh-token', data.authorization.refresh_token);
                            tokenRefreshInProgress = false;
                            $state.reload();
                        })
                        .error(function () {
                            localStorage.clear();
                            tokenRefreshInProgress = false;
                            $state.go('signup');
                        });
                }
            });

            var hasStripeAccount = $scope.$on('STRIPE_ACCOUNT_CONNECTED', function () {
                vm.hasStripeAccount = true;
            });

            $rootScope.$on('$destroy', refreshToken, hasStripeAccount);

            function getUser(id) {
                ProfileService.getUser(id).success(function (data) {
                    vm.user = data;
                })
            }

            function logout() {
                $interval.cancel(conversationsInterval);
                localStorage.clear();
                ActionCableSocketWrangler.stop();
                $state.go('login');
                vm.loggedIn = false;
                vm.consumer.unsubscribe();
                $rootScope.$$listeners.SYNC_TRUCK_LOCATION = [];
                closeMenu();
            }

            function toggleSidebar() {
                angular.element($document[0].body).toggleClass('small-sidebar');
            }

            function closeMenu() {
                if ($window.innerWidth < 992) {
                    angular.element($document[0].body).removeClass('small-sidebar');
                }
            }

            function toggleNotification() {
                $("#notification-container").toggleClass('show-nav');
            }

            function toggleClass() {
                vm.voicemail = !vm.voicemail;
                if (angular.element($document[0].body).hasClass('small-sidebar') && vm.voicemail && $window.innerWidth > 992) {
                    angular.element($document[0].body).toggleClass('small-sidebar');
                }
            }

            function toggleFleetManagement() {
                vm.fleetmanagement = !vm.fleetmanagement;
                if (angular.element($document[0].body).hasClass('small-sidebar') && vm.fleetmanagement && $window.innerWidth > 992) {
                    angular.element($document[0].body).toggleClass('small-sidebar');
                }
            }

            function toggleDatabase() {
                vm.database = !vm.database;
                if (angular.element($document[0].body).hasClass('small-sidebar') && vm.database && $window.innerWidth > 992) {
                    angular.element($document[0].body).toggleClass('small-sidebar');
                }
            }

            function collapse() {
                vm.active.split('.')[0] !== 'fleetmanagement' ? vm.fleetmanagement = false : vm.fleetmanagement = true;
                vm.active.split('.')[0] !== 'database' ? vm.database = false : vm.database = true;
            }

            function getNotificationAlerts(isLaunch) {
                NotificationsService.getNotificationAlerts()
                    .success(function (data) {
                        vm.notification_alerts = data;
                        vm.alertsError = false;
                        if (isLaunch && data.length > 0) {
                            $timeout(function () {
                                $("#notification-container").addClass('show-nav');
                            }, 0);
                        }
                        if (data.length > 0) {
                            if (!animationInterval || animationInterval.$$state.status !== 0) {
                                animationInterval = $interval(function () {
                                    $('.notif-toogler').toggleClass('tada');
                                }, 1500);
                            }
                        } else {
                            $('.notif-toogler').removeClass('tada');
                            if (animationInterval) {
                                $interval.cancel(animationInterval);
                            }
                        }
                    })
                    .error(function () {
                        vm.alertsError = true;
                        vm.notification_alerts = [];
                    })
            }

            function openDonation(donationId, shouldPrint, e) {
                if (e) e.stopPropagation();
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    windowClass: 'single-donation-modal',
                    templateUrl: 'app/donations/prompts/single/single.donation.html',
                    controller: 'SingleDonationController',
                    controllerAs: 'singleCtrl',
                    resolve: {
                        donationId: donationId,
                        print: shouldPrint
                    },
                    size: 'lg'
                });
                modalInstance.result.then(
                    function () {
                        getDonations();
                    })
            }

            function markAsRead(id) {
                NotificationsService.markAsRead(id)
                    .success(function () {
                        var index = _.findIndex(vm.notification_alerts, function (alert) {
                            return alert.id === id;
                        });
                        if (index !== -1) {
                            vm.notification_alerts.splice(index, 1);
                        }
                        if (vm.notification_alerts.length === 0) {
                            $('.notif-toogler').removeClass('tada');
                            $interval.cancel(animationInterval);
                        }
                    })

            }

            function getAppData() {
                LoginService.getAppData()
                    .success(function (data) {
                        checkClientVersion(data.content)
                    })
                    .error(function () {

                    })
            }

            function getHubStatus() {
                DonationsService.getHubStatus()
                    .success(function (data) {
                        data = _.uniqBy(data, 'donation_id');
                        vm.newHubDonationsCount = data.length;
                    })
            }

            function getReportsStatus() {
                PickupReportService.getReportsStatus()
                    .success(function (data) {
                        vm.newReportsCount = data.length;
                    })
            }

            function checkClientVersion(appData) {
                var currentVersion = parseFloat(localStorage.getItem('rspl-client-version'));
                if (!currentVersion) {
                    localStorage.setItem('rspl-client-version', appData.front_version);
                    // location.reload(true);
                } else if (currentVersion !== appData.front_version) {
                    localStorage.setItem('rspl-client-version', appData.front_version);
                    location.reload(true);
                }
            }

        }
    }

})();

(function () {
    'use strict';
    angular.module('rsplCharityV2').directive('csvDownload', function postLink() {
        var directive = {
            restrict: 'E',
            transclude: true,
            template: '<a href=\"{{hreflink}}\" download=\"{{filename}}\" ng-bind-html="label"></a>',
            scope: {
                inputArray: '=',
                filename: '@filename',
                hreflink: '@hreflink',
                label: '@label'
            },
            controller: ExportController
        };

        /** @ngInject */
        function ExportController($scope) {
            if (angular.isUndefined($scope.label)) {
                $scope.label = "Download Data";
            }

            var getHeader = function () {
                if ($scope.columnHeader) {
                    return $scope.columnHeader;
                }
                // no header, so build it
                $scope.columnHeader = [];
                // loop through all data in case some objects are incomplete
                for (var i in $scope.inputArray) {
                    var keys = Object.keys($scope.inputArray[i]);
                    for (var j in keys) {
                        var key = keys[j];
                        $scope.columnHeader[key] = key;
                    }
                }

                return $scope.columnHeader;
            };

            // the biggest difference here is I'm using the header instead of the keys for the header row
            var convertArrayOfObjectsToCSV = function () {
                var result, ctr, keys, columnDelimiter, lineDelimiter;

                var header = getHeader() || null;
                if (header === null) {
                    return null;
                }

                columnDelimiter = ',';
                lineDelimiter = '\n';

                keys = Object.keys(header);

                result = '';
                keys.forEach(function (key) {
                    if (key !== 'photos') {
                        var dataVal = header[key];
                        if (angular.isUndefined(dataVal)) {
                            dataVal = '';
                        }
                        result += '\"' + dataVal + '\"' + columnDelimiter; // handle embedded commas
                    }
                });
                result += columnDelimiter;
                result += lineDelimiter;

                $scope.inputArray.forEach(function (item) {
                    ctr = 0;
                    keys.forEach(function (key) {
                        if (key !== 'photos') {
                            if (ctr > 0) {
                                result += columnDelimiter;
                            }
                            var dataVal = item[key];
                            if (key === 'content') {
                                dataVal = "";
                                var i = 0;
                                item[key].forEach(function (e) {
                                    if (i > 0) {
                                        dataVal += ",";
                                    }
                                    dataVal += e.item_type;
                                    i++;
                                });
                            } else if (key === 'requests') {
                                if (dataVal[0] && dataVal[0].donor)
                                    dataVal = dataVal[0].donor.first_name + " " + dataVal[0].donor.last_name;
                            }
                            if (angular.isUndefined(dataVal)) {
                                dataVal = '';
                            }
                            result += '\"' + dataVal + '\"'; // handle embedded commas
                            ctr++;
                        }
                    });
                    result += lineDelimiter;
                });

                return result;
            };

            var generateCSVLink = function () {
                if (angular.isUndefined($scope.filename)) {
                    $scope.filename = 'export.csv';
                }

                var csv = convertArrayOfObjectsToCSV();
                if (csv === null) {
                    return;
                }

                if (!csv.match(/^data:text\/csv/i)) {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                }

                $scope.hreflink = encodeURI(csv);

            };

            generateCSVLink();

        }

        return directive;

    });
})();
(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('donationRequests', donationRequests);

    /** @ngInject */

    function donationRequests() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/donation-requests/donation-requests.html',
            controller: DonationRequestsController,
            scope: {
                donation: '='
            },
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function DonationRequestsController(DonationsService, $uibModal, imageBaseUrl, $rootScope) {
            var vm = this;

            vm.openDonation = openDonation;
            vm.imageBaseUrl = imageBaseUrl;

            vm.scrollConfig = {
                autoHideScrollbar: false,
                theme: 'dark-3',
                scrollInertia: 0,
                axis: 'x',
                advanced: {
                    updateOnContentResize: true
                }
            };

            activate();

            var newDonationPublished = $rootScope.$on('NEW_PENDING_DONATION', function () {
                getPendingDonations();
            });

            $rootScope.$on('$destroy', newDonationPublished);

            function activate() {
                getPendingDonations();
            }

            function getPendingDonations() {
                vm.isLoadingRequests = true;
                DonationsService.searchDonations({ "status[]": ['pending'] }).then(function (data) {
                    vm.pendingDonations = data.data;
                    vm.pendingDonations.forEach(function (donation) {
                        var exp = moment(donation.request.expires_at);
                        var curr = moment();
                        if (exp.diff(curr) <= 0) {
                            donation.expiration = 0;
                        } else {
                            if (exp.diff(curr) <= 60 * 60) {
                                donation.expiration_soon = true;
                            } else {
                                donation.expiration_soon = false;
                            }
                            donation.expiration = exp;
                        }
                    });
                    vm.isLoadingRequests = false;
                }).catch(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong' + (errorData.data.message ? ', ' + errorData.data.message : ''));
                    vm.isLoadingRequests = false;
                });
            }

            function openDonation(donation, shouldPrint, e) {
                if (e) e.stopPropagation();
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    windowClass: 'single-donation-modal',
                    templateUrl: 'app/donations/prompts/single/single.donation.html',
                    controller: 'SingleDonationController',
                    controllerAs: 'singleCtrl',
                    resolve: {
                        donationId: donation.id,
                        print: shouldPrint
                    },
                    size: 'lg'
                });
                modalInstance.result.then(
                    function () {
                        getPendingDonations();
                    })
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('donationCard', donationCard);

    /** @ngInject */

    // donation => donation object : JSON
    // cardType => ['db', 'hub', 'calendar, 'calendar-actions-needed'] :STRING
    // display => ['small', 'large'] : CONTROLLER PROP

    function donationCard() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/donation-card/donation-card.html',
            scope: {
                donation: '=',
                cardType: '@',
                display: '=',
                noActions: '='
            },
            controller: DonationCardController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function DonationCardController(DonationsService, $uibModal, $state, $window, env, $scope, $rootScope, imageBaseUrl) {
            var vm = this;
            vm.openDonation = openDonation;
            vm.openChangeDatePrompt = openChangeDatePrompt;
            vm.startConversation = startConversation;
            vm.getTaxReceipt = getTaxReceipt;

            vm.moreOptions = {
                templateUrl: 'app/calendar/moreOptions.html'
            };

            vm.moreOptionsActionsNeeded = {
                templateUrl: 'app/calendar/moreOptionsActionsNeeded.html'
            };

            activate();

            function activate() {
                vm.d = vm.donation;
                vm.imageBaseUrl = imageBaseUrl;
                preparePhotos();
                vm.slickConfig = {
                    dots: true,
                    arrows: true,
                    focusOnSelect: true,
                    nextArrow: '<span class="rspl-icon icon-arrow-right"></span>',
                    prevArrow: '<span class="rspl-icon icon-arrow-left"></span>',
                    dotsClass: 'custom_paging',
                    customPaging: function (slider, i) {
                        return (i + 1) + '/' + slider.slideCount;
                    }
                };
            }

            function openDonation(donation, shouldPrint, e) {
                if (e) e.stopPropagation();
                if (donation.donation_alert) {
                    DonationsService.markDonationAsSeen(donation.donation_alert.id)
                        .success(function () {
                            $rootScope.$broadcast('hub_count_updated');
                            donation.seen = true;
                        })
                }
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    windowClass: 'single-donation-modal',
                    templateUrl: 'app/donations/prompts/single/single.donation.html',
                    controller: 'SingleDonationController',
                    controllerAs: 'singleCtrl',
                    resolve: {
                        donationId: donation.id,
                        print: shouldPrint
                    },
                    size: 'lg'
                });
                modalInstance.result.then(
                    function (changes) {
                        if (changes.label) {
                            donation.request.pickup_label = changes.label;
                        }
                        if (changes.truck) {
                            donation.request.truck = changes.truck;
                        }
                        if (changes.countAs) {
                            donation.request.count_as = changes.countAs;
                        }
                        if (changes.order) {
                            donation.request.pickup_order_number = changes.order;
                        }
                        $scope.$emit('MODAL_CLOSED');
                    })
            }

            function openChangeDatePrompt(donation, e) {
                e.stopPropagation();
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    templateUrl: 'app/donations/prompts/reschedule/reschedule.html',
                    controller: 'RescheduleController',
                    controllerAs: 'rescheduleCtrl',
                    resolve: {
                        donation: donation
                    },
                    size: 'sm'
                });
                modalInstance.result.then(
                    function () {
                        $scope.$emit('MODAL_CLOSED');
                    })
            }

            function startConversation(donation, event) {
                event.stopPropagation();
                localStorage.setItem('rspl-start-conversation', angular.toJson({
                    id: donation.request.donor.id,
                    first_name: donation.request.donor.first_name,
                    last_name: donation.request.donor.last_name
                }));
                $state.go('messages');
            }

            function getTaxReceipt(donation, event) {
                if (event) event.stopPropagation();
                $window.open("https://main-service.production.resupply.tech/api/v2/donations/"  + vm.d.id + "/render_tax_receipt", '_blank');
            }

            function preparePhotos() {
                vm.d.photos.forEach(function (photo) {
                    if (env === 'production') {
                        photo.fullPath = vm.imageBaseUrl + '/cdn-cgi/image/width=400,quality=75' + photo.url;
                    } else {
                        photo.fullPath = vm.imageBaseUrl + photo.url;
                    }
                })
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('dayColumn', dayColumn);

    /** @ngInject */

    function dayColumn() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/day-column/day-column.html',
            controller: DayColumnController,
            scope: {
                day: '=',
                display: '=',
                truck: '='
            },
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function DayColumnController(DonationsService, $uibModal, imageBaseUrl, ScheduleService, $scope) {
            var vm = this;

            $scope.$watch('vm.truck', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    filterDonationsByTruck(newValue);
                }
            });

            vm.openDonation = openDonation;
            vm.openNewDonationPrompt = openNewDonationPrompt;
            vm.imageBaseUrl = imageBaseUrl;
            vm.toggleDay = toggleDay;
            vm.loadMoreDonations = loadMoreDonations;

            vm.donations = [];
            vm.showAwaitingDonations = true;
            vm.dayName = moment(vm.day.date).format('dddd');

            vm.scrollConfig = {
                autoHideScrollbar: false,
                theme: 'dark-3',
                scrollInertia: 0,
                axis: 'x',
                advanced: {
                    updateOnContentResize: true
                }
            };

            vm.params = {
                start_date: vm.day.date,
                end_date: vm.day.date,
                per_page: 5,
                page: 1,
                truck_id: vm.truck ? vm.truck.id : null,
                "status[]": ['completed', 'accepted', 'awaiting_user_response']
            }

            
            vm.scheduleTemplate = _.groupBy(angular.fromJson(localStorage.getItem('rspl-schedule')), 'date');

            activate();

            function activate() {
                getDonations(true);
                getException();
            }

            function getDonations(isInitial) {
                if (isInitial) {
                    vm.isLoading = true;
                }
                DonationsService.searchDonations(vm.params).then(function (response) {
                    vm.donations = _.concat(vm.donations, response.data);
                    vm.donations = vm.donations.filter(function (donation) {
                        return donation.request.date === vm.day.date;
                    })
                    vm.params.total_pages = response.headers().total_pages;
                    vm.params.current_page = response.headers().current_page;
                    vm.awaitingUserResponseDonations = vm.donations.filter(function (donation) {
                        return donation.request.status === 'awaiting_user_response'
                    })
                    vm.isLoading = false;
                })

            }

            function loadMoreDonations() {
                vm.params.page = vm.params.page + 1;
                getDonations(false);
            }

            function filterDonationsByTruck(truck) {
                if (truck !== angular.isDefined) {
                    vm.params.page = 1;
                    if (truck !== null) {
                        vm.params.truck_id = truck.id;
                        vm.donations = [];
                    } else {
                        vm.params.truck_id = null;
                        vm.donations = [];
                    }
                    getDonations(true);
                }
            }

            function getException() {
                ScheduleService.getScheduleExceptions({ date: vm.day.date })
                    .success(function (response) {
                        if (response.length) {
                            vm.exception = response[0];
                            vm.day.disabled = vm.exception.am + vm.exception.pm < 1
                        } else {
                            vm.exception = null;
                            vm.day.disabled = isDayOff();
                        }
                    })
            }

            function isDayOff() {
                if (!vm.scheduleTemplate[vm.dayName]) {
                    return true;
                } else if (vm.scheduleTemplate[vm.dayName][0].am + vm.scheduleTemplate[vm.dayName][0].pm < 1) {
                    return true;
                } else {
                    return false;
                }
            }

            function openDonation(donation, shouldPrint, e) {
                if (e) e.stopPropagation();
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    windowClass: 'single-donation-modal',
                    templateUrl: 'app/donations/prompts/single/single.donation.html',
                    controller: 'SingleDonationController',
                    controllerAs: 'singleCtrl',
                    resolve: {
                        donationId: donation.id,
                        print: shouldPrint
                    },
                    size: 'lg'
                });
                modalInstance.result.then(
                    function () {
                        vm.params.page = 1;
                        vm.donations = [];
                        getDonations();
                    })
            }

            function openNewDonationPrompt(date) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    windowClass: 'manual-donation',
                    templateUrl: 'app/donations/prompts/new/new.html',
                    controller: 'NewDonationController',
                    controllerAs: 'newCtrl',
                    resolve: {
                        reject: false,
                        date: function () {
                            return moment(date).toDate();
                        }
                    },
                    size: 'lg'
                });
                modalInstance.result.then(
                    function () {
                        vm.params.page = 1;
                        vm.donations = [];
                        getDonations();
                    })
            }

            function toggleDay(day, isDisabled) {
                if (vm.exception) {
                    if (!isDisabled) {
                        var currentException = vm.exception,
                            id = currentException.id,
                            am = 0,
                            pm = 0,
                            zips = currentException.zips;
                        updateException({ id: id, date: day, am: am, pm: pm, zips: zips }, true);
                    } else {
                        openExceptionsModal(day, vm.exception, 'update', vm.scheduleTemplate[vm.dayName]);
                    }
                } else {
                    var tempException = { date: day, am: 0, pm: 0, zips: [] };
                    var template = _.filter(vm.scheduleTemplate, function (t) {
                        return t[0].date === vm.dayName;
                    });

                    if (template.length) {
                        template[0].forEach(function (item) {
                            if (item.zips) {
                                item.zips.forEach(function (zip) {
                                    tempException.zips.push(zip)
                                })
                            }

                        })
                    }

                    if (!isDisabled) {
                        createException(tempException, true);
                    } else {
                        vm.exception = { date: day, am: null, pm: null, zips: [] };
                        openExceptionsModal(day, vm.exception, 'create');
                    }
                }
            }

            function openExceptionsModal(day, exception, process, defaultState) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    templateUrl: 'app/calendar/exception-modal/exception-modal.html',
                    controller: 'ExceptionModalController',
                    controllerAs: 'excCtrl',
                    resolve: {
                        date: function () {
                            return moment(day).toDate();
                        },
                        exception: function () {
                            return exception;
                        },
                        process: function () {
                            return process;
                        },
                        defaultState: function () {
                            return defaultState;
                        }
                    },
                    size: 'md'
                });

                modalInstance.result.then(
                    function (result) {
                        vm.day.disabled = result.dayDisabled;
                        vm.exception = result.exception;
                    })

            }

            function createException(exception, disabled) {
                ScheduleService.createScheduleException(exception)
                    .success(function (response) {
                        vm.day.disabled = disabled;
                        vm.exception = response;
                    })
            }

            function updateException(exception, disabled) {
                ScheduleService.updateException(exception)
                    .success(function (response) {
                        vm.day.disabled = disabled;
                        vm.exception = response;
                    })
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('actionNeededDonations', actionNeededDonations);

    /** @ngInject */

    function actionNeededDonations() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/action-needed-donations/action-needed-donations.html',
            controller: ActionNeededDonationsController,
            scope: {
                donation: '='
            },
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ActionNeededDonationsController(DonationsService, $uibModal, imageBaseUrl, $scope) {
            var vm = this;

            vm.openDonation = openDonation;
            vm.imageBaseUrl = imageBaseUrl;

            vm.scrollConfig = {
                autoHideScrollbar: false,
                theme: 'dark-3',
                scrollInertia: 0,
                axis: 'x',
                advanced: {
                    updateOnContentResize: true
                }
            };

            activate();

            function activate() {
                getActionNeededDonations();
            }

            function getActionNeededDonations() {
                vm.isLoadingActionNeeded = true;
                DonationsService.searchDonations({ "action_required": true }).then(function (data) {
                    vm.actionNeededDonations = data.data;
                    angular.forEach(vm.actionNeededDonations, function (donation) {
                        donation.expiration = moment(new Date(new Date(donation.request.status === 'awaiting_user_response'
                            ? donation.initialRequest.date : donation.request.date).getTime() - 60 * 60 * 24 * 1000));
                    });
                    vm.isLoadingActionNeeded = false;
                    $scope.$broadcast('timer-start');
                }).catch(function (errorData) {
                    vm.addAlert('danger', 'Something went wrong' + (errorData.data.message ? ', ' + errorData.data.message : ''));
                    vm.isLoadingActionNeeded = false;
                });
            }

            function openDonation(donation, shouldPrint, e) {
                if (e) e.stopPropagation();
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    windowClass: 'single-donation-modal',
                    templateUrl: 'app/donations/prompts/single/single.donation.html',
                    controller: 'SingleDonationController',
                    controllerAs: 'singleCtrl',
                    resolve: {
                        donationId: donation.id,
                        print: shouldPrint
                    },
                    size: 'lg'
                });
                modalInstance.result.then(
                    function () {
                        getActionNeededDonations();
                    })
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('TaxReceiptBuilderController', TaxReceiptBuilderController);

    /** @ngInject */
    function TaxReceiptBuilderController(ProfileService, imageBaseUrl, $rootScope, PhotoService) {
        var vm = this;
        vm.imageSelected = imageSelected;
        vm.saveTaxReceipt = saveTaxReceipt;

        vm.imageBaseUrl = imageBaseUrl;

        vm.imageIsSelected = false;
        vm.isOpenColorPicker = false;
        vm.charityName = localStorage.getItem('rspl-charity');
        vm.today = new Date();
        vm.receiptData = {
            photo: {
                url: null
            }
        };

        activate();

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        function activate() {
            ProfileService.getCharity()
                .success(function (data) {
                    data.tc_tint ? vm.receiptData.tc_tint = data.tc_tint : vm.receiptData.tc_tint = '#7378f4';
                    data.tc_note ? vm.receiptData.tc_note = data.tc_note : vm.receiptData.tc_note = 'Tax benefits for charitable contributions are available only to taxpayers who itemize deductions. To claim a deduction please refer to IRS publication 561. No goods or services were provided to the donor.';
                    data.tc_logo_url ? vm.receiptData.photo.url = data.tc_logo_url : vm.receiptData.photo = {};
                })
        }

        function imageSelected() {
            vm.imageIsSelected = !vm.imageIsSelected;
        }

        function uploadPhoto() {
            vm.isSubmitting = true;
            PhotoService.uploadPhoto(vm.receiptData.photo.file)
                .success(function (image) {
                    updateProfile(image);
                })
                .error(function (errorData) {
                    var additionalMsg = '';
                    vm.isSubmitting = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                });
        }

        function saveTaxReceipt() {
            if (vm.imageIsSelected && vm.receiptData.photo.file) {
                uploadPhoto();
            } else {
                updateProfile()
            }
        }

        function updateProfile(image) {
            var data = angular.copy(vm.receiptData);
            if (image) {
                data.tc_logo_url = vm.imageBaseUrl + image.url;
            }
            delete (data.photo);
            ProfileService.updateCharity(data)
                .success(function () {
                    vm.addAlert('success', 'Tax Receipt updated successfully.');
                    $rootScope.$broadcast('account-updated');
                    vm.isSubmitting = false;
                })
                .error(function (errorData) {
                    var additionalMsg = '';
                    vm.isSubmitting = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                });
        }

    }
})();

/**
 * Created by dms on 2/10/18.
 */
(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('ScheduleService', ScheduleService);

    /** @ngInject */
    function ScheduleService($http, baseUrl) {
        var service = this;

        service.getScheduleTemplate = getScheduleTemplate;
        service.updateScheduleTemplate = updateScheduleTemplate;
        service.searchForZipCodes = searchForZipCodes;
        service.addNewSchedulteTemplate = addNewSchedulteTemplate;
        service.createScheduleException = createScheduleException;
        service.deleteScheduleException = deleteScheduleException;
        service.getScheduleExceptions = getScheduleExceptions;
        service.updateException = updateException;

        function getScheduleTemplate(params) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id') + '/schedules',
                params: params
            }).success(function (data) {
                return data;
            })
        }

        function searchForZipCodes(code) {
            return $http({
                method: "GET",
                url: baseUrl + (code ? ('/api/v2/zips?code=' + code) : '/api/v2/zips')
            }).success(function (data) {
                angular.forEach(data, function (item) {
                    item.text = item.code;
                });
                return data;
            })
        }

        function updateScheduleTemplate(item) {
            var zipCodes = [];
            if (item.zips) {
                for (var i = 0; i < item.zips.length; i++) {
                    zipCodes.push(item.zips[i].id);
                }
            }
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id') + '/schedules/' + item.id,
                data: {
                    am: item.am,
                    pm: item.pm,
                    zip_ids: zipCodes
                }
            }).success(function (data) {
                return data;
            })
        }

        function addNewSchedulteTemplate(item) {
            var zipCodes = [];
            if (item.zips) {
                for (var i = 0; i < item.zips.length; i++) {
                    zipCodes.push(item.zips[i].id);
                }
            }
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id') + '/schedules',
                data: {
                    date: item.date,
                    am: item.am,
                    pm: item.pm,
                    zip_ids: zipCodes
                }
            }).success(function (data) {
                return data;
            })
        }

        function createScheduleException(item) {
            var zipCodes = [];
            if (item.zips) {
                for (var i = 0; i < item.zips.length; i++) {
                    zipCodes.push(item.zips[i].id);
                }
            }
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id') + '/schedule_changes',
                data: {
                    date: moment(item.date).format('YYYY-MM-DD'),
                    am: item.am,
                    pm: item.pm,
                    zip_ids: zipCodes
                }
            }).success(function (data) {
                return data;
            })
        }

        function deleteScheduleException(item) {
            return $http({
                method: "DELETE",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id') + '/schedule_changes/' + item.id
            }).success(function (data) {
                return data;
            })
        }

        function getScheduleExceptions(params) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id') + '/schedule_changes/',
                params: params
            }).success(function (data) {
                return data;
            })
        }

        function updateException(exception) {
            var zipCodes = [];
            if (exception.zips) {
                for (var i = 0; i < exception.zips.length; i++) {
                    zipCodes.push(exception.zips[i].id);
                }
            }
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id') + '/schedule_changes/' + exception.id,
                data: {
                    date: moment(exception.date).format('YYYY-MM-DD'),
                    am: exception.am,
                    pm: exception.pm,
                    zip_ids: zipCodes
                }
            }).success(function (data) {
                return data;
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ScheduleController', ScheduleController);

    /** @ngInject */
    function ScheduleController($q, ScheduleService, $window, $rootScope, $uibModal) {
        var vm = this;
        vm.tab = 'default';
        vm.exceptions = [];
        vm.addException = addException;
        vm.saveExceptions = saveExceptions;
        vm.createException = createException;
        vm.openDeleteExceptionPrompt = openDeleteExceptionPrompt;

        vm.updateScheduleTemplate = updateScheduleTemplate;
        vm.addNewSchedulteTemplate = addNewSchedulteTemplate;
        vm.tagAdded = tagAdded;

        vm.loadTags = function (query) {
            return ScheduleService.searchForZipCodes(query);
        };

        vm.alerts = [];
        vm.newDates = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        var hl = $window.location.href.split("/");
        vm.href = hl[0] + "//" + hl[2];

        vm.getGeometry = function (zip) {
            return {
                "url": "https://production.resupply.media/kml/" + zip.code + ".kml"
            }
        };

        activate();

        function activate() {
            getScheduleTemplate();
            getAllExceptions();
        }

        function tagAdded(tag, item) {
            if (!tag.code) {
                item.zips.splice(-1, 1);
                ScheduleService.searchForZipCodes(tag.text)
                    .success(function (data) {
                        var newTag = data[0];
                        item.zips.push(newTag);
                    })
            }
        }

        function getScheduleTemplate() {
            vm.isLoading = true;
            ScheduleService.getScheduleTemplate()
                .success(function (data) {
                    vm.scheduleTemplate = data;
                    angular.forEach(vm.scheduleTemplate, function (item) {
                        switch (item.date) {
                            case 'Monday' :
                                item.order = 0;
                                break;
                            case 'Tuesday' :
                                item.order = 1;
                                break;
                            case 'Wednesday' :
                                item.order = 2;
                                break;
                            case 'Thursday' :
                                item.order = 3;
                                break;
                            case 'Friday' :
                                item.order = 4;
                                break;
                            case 'Saturday' :
                                item.order = 5;
                                break;
                            case 'Sunday' :
                                item.order = 6;
                                break
                        }
                        // item.zips = item.zips.splice(0,20);
                        item.zips = _.uniqBy(item.zips, 'id');
                        angular.forEach(item.zips, function (i) {
                            i.text = i.code;

                        });
                        if (vm.newDates.indexOf(item.date) !== -1) {
                            vm.newDates.splice(vm.newDates.indexOf(item.date), 1);
                        }
                    });
                    vm.isLoading = false;
                })
                .error(function () {
                    vm.isLoading = false;
                })
        }

        function updateScheduleTemplate() {
            vm.isUpdating = true;
            vm.alerts = [];
            var promises = [];
            angular.forEach(vm.scheduleTemplate, function (item) {
                var promise = ScheduleService.updateScheduleTemplate(item);
                promises.push(promise);
            });

            $q.all(promises)
                .then(function () {
                    vm.addAlert('success', 'Templates updated successfully.');
                    vm.isUpdating = false;
                })
                .catch(function (errorData) {
                    errorData = errorData.data;
                    vm.isUpdating = false;
                    var additionalMsg = '';
                    vm.isSubmitting = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                });

        }

        function addNewSchedulteTemplate() {
            vm.isAdding = true;
            vm.alerts = [];
            ScheduleService.addNewSchedulteTemplate(vm.newSchedule)
                .success(function () {
                    if (!vm.scheduleTemplate || vm.scheduleTemplate.length === 0) {
                        $rootScope.$broadcast('account-updated');
                    }
                    vm.isAdding = false;
                    getScheduleTemplate();
                    vm.newSchedule = {};
                    vm.addAlert('success', 'Template added successfully.');
                })
                .error(function (errorData) {
                    vm.isAdding = false;
                    var additionalMsg = '';
                    vm.isSubmitting = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                });
        }

        function addException() {
            vm.exceptions.push({
                date: null,
                am: 0,
                pm: 0,
                zips: [],
                repeat: false,
                datepickerOpen: false
            })
        }



        function createException(item) {
            console.log(item);
            ScheduleService.createScheduleException(item)
                .success(function (data) {
                    vm.addAlert('success', 'Schedule exception added successfully.');
                })
                .error(function (errorData) {
                    vm.addAlert('danger', 'Ooops, ' + errorData.message);
                })
        }

        function getAllExceptions() {
            ScheduleService.getScheduleExceptions()
                .success(function (data) {
                    angular.forEach(data, function (item) {
                        angular.forEach(item.zips, function (i) {
                            i.text = i.code;
                        });
                    });
                    vm.exceptions = data;
                })
                .error(function () {

                })
        }

        function saveExceptions() {
            vm.exceptions.forEach(function(item) {
                if(!item.id) {
                    createException(item);
                } else {
                    updateScheduleException(item);
                }
            })
        }

        function updateScheduleException(exception) {
            ScheduleService.updateException(exception)
                .success(function (data) {
                    console.log(data);
                })
                .error(function (errData) {
                    console.log(errData);
                })
        }

        function openDeleteExceptionPrompt(exception) {
            console.log(exception);
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'delete-exception',
                templateUrl: 'app/account/schedule/prompts/delete-exception.html',
                controller: 'DeleteExceptionController',
                controllerAs: 'delCtrl',
                resolve: {
                    exception: exception
                },
                size: 'xs'
            });
            modalInstance.result.then(
                function () {
                    getAllExceptions();
                })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('RatingsService', RatingsService);

    /** @ngInject */
    function RatingsService($http, baseUrl, $log) {
        var service = this;

        service.getReviews = getReviews;


        function getReviews(id) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/'+id+'/ratings'
            }).success(function (data) {
                return data;
            }).error(function (errorData) {
                $log.error(errorData);
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ReviewsController', ReviewsController);

    /** @ngInject */
    function ReviewsController(RatingsService, ProfileService) {
        var vm = this;

        activate();

        function activate() {
            getReviews();
        }

        function getReviews() {
            vm.isLoading = true;
            RatingsService.getReviews(localStorage.getItem('rspl-charity-id'))
                .success(function (data) {
                    ProfileService.getCharity().success(function (data) {
                        vm.average = data.average_rating;

                    });

                    vm.ratings = data;
                    vm.isLoading = false
                })
                .error(function () {
                    vm.isLoading = false
                })
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('NotificationsService', NotificationsService);

    /** @ngInject */
    function NotificationsService($http, baseUrl) {
        var service = this;

        service.getNotificationAlerts = getNotificationAlerts;
        service.markAsRead = markAsRead;
        service.getNotificationPreferences = getNotificationPreferences;
        service.updatePreference = updatePreference;
        service.getDefaultNotificationsTemplates = getDefaultNotificationsTemplates;
        service.getNotificationsTemplates = getNotificationsTemplates;
        service.createNotificationTemplate = createNotificationTemplate;
        service.updateNotificationTemplate = updateNotificationTemplate;
        service.deleteCustomTemplate = deleteCustomTemplate;

        function getNotificationAlerts() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/alerts'
            }).success(function (data) {
                return data;
            })
        }

        function markAsRead(alertId) {
            return $http({
                method: "DELETE",
                url: baseUrl + '/api/v2/alerts/' + alertId
            }).success(function (data) {
                return data;
            })
        }

        function getNotificationPreferences() {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/'+charityId+'/preferences'
            }).success(function (data) {
                return data;
            })
        }

        function updatePreference(preference) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/'+charityId+'/preferences/'+preference.id,
                data: {
                    email_alert: preference.email_alert,
                    sms_alert: preference.sms_alert
                }
            }).success(function (data) {
                return data;
            })
        }

        function getDefaultNotificationsTemplates() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/alert_global_templates'
            }).success(function (data) {
                return data;
            })
        }

        function getNotificationsTemplates() {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/'+charityId+'/alert_charity_templates'
            }).success(function (data) {
                return data;
            })
        }

        function createNotificationTemplate(template) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/'+charityId+'/alert_charity_templates',
                data: {
                    alert_type: template.alert_type,
                    alert_subtype: template.alert_subtype,
                    title: template.title,
                    body_content: template.body_content,
                    disabled: template.disabled
                }
            }).success(function (data) {
                return data;
            })
        }

        function updateNotificationTemplate(template) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/'+charityId+'/alert_charity_templates/' + template.id,
                data: {
                    alert_type: template.alert_type,
                    alert_subtype: template.alert_subtype,
                    title: template.title,
                    body_content: template.body_content,
                    disabled: template.disabled
                }
            }).success(function (data) {
                return data;
            })
        }

        function deleteCustomTemplate(id) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "DELETE",
                url: baseUrl + '/api/v2/charities/'+charityId+'/alert_charity_templates/' + id
            }).success(function (data) {
                return data;
            })
        }


    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('NotificationPrefController', NotificationPrefController);

    /** @ngInject */
    function NotificationPrefController(NotificationsService) {
        var vm = this;

        vm.tglEmailNotification = tglEmailNotification;
        vm.tglSmsNotification = tglSmsNotification;
        vm.activateAllSms = activateAllSms;
        vm.activateAllEmail = activateAllEmail;

        activate();

        function activate() {
            getNotificationPreferences();
        }

        vm.allSmsActive = true;
        vm.allEmailActive = true;

        function getNotificationPreferences() {
            vm.isLoading = true;
            NotificationsService.getNotificationPreferences()
                .success(function (data) {
                    vm.donationsPrefs.preferences = data;
                    vm.isLoading = false;
                    checkForAllActive();
                })
                .error(function () {
                    vm.isLoading = false;
                })
        }

        function tglSmsNotification(preference) {
            preference.sms_alert = !preference.sms_alert;
            updatePreference(preference);
        }

        function tglEmailNotification(preference) {
            preference.email_alert = !preference.email_alert;
            updatePreference(preference);
        }

        vm.donationsPrefs = {
            allSmsActive: true,
            allEmailActive: true
        };

        function updatePreference(preference) {
            NotificationsService.updatePreference(preference);
        }

        function activateAllSms() {
            vm.donationsPrefs.preferences.forEach(function (pref) {
                if (pref.alert_subtype === 'donations_confirmation_summary'){
                    pref.sms_alert = !vm.allSmsActive;
                    updatePreference(pref);
                }
            });
            vm.allSmsActive = !vm.allSmsActive;
        }

        function activateAllEmail() {
            vm.donationsPrefs.preferences.forEach(function (pref) {
                pref.email_alert = !vm.allEmailActive;
                updatePreference(pref);
            });
            vm.allEmailActive = !vm.allEmailActive;

        }

        function checkForAllActive() {
            vm.donationsPrefs.preferences.forEach(function (pref) {
                if (!pref.sms_alert) {
                    vm.allSmsActive = false;
                }
                if (!pref.email_alert) {
                    vm.allEmailActive = false;
                }
            });
        }

        vm.donationsPrefsAdditional = [
            // {
            //     alert_subtype: "New donation scheduled",
            //     sms_alert: true,
            //     email_alert: true,
            //     web: true,
            //     id: 2
            // },
            {
                alert_subtype: "Reminder to mark donations completed or report an issue",
                sms_alert: true,
                email_alert: true,
                web: true,
                id: 3
            },
            {
                alert_subtype: "Change date request status notification",
                sms_alert: true,
                email_alert: true,
                web: true,
                id: 4
            },
            {
                alert_subtype: "Claim donation from HUB status notification",
                sms_alert: true,
                email_alert: true,
                web: true,
                id: 5
            },
            {
                alert_subtype: "Pending donations about to expire",
                sms_alert: true,
                email_alert: true,
                web: true,
                id: 6
            }
        ];


        vm.messagesPrefs = {
            allSmsActive: true,
            allEmailActive: true,
            allWebActive: true,
            preferences:
                [
                    {
                        prefName: "New message from donor",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 1
                    },
                    {
                        prefName: "New message from driver",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 2
                    }
                ]
        };
        vm.pickupsPrefs = {
            allSmsActive: true,
            allEmailActive: true,
            allWebActive: true,
            preferences:
                [
                    {
                        prefName: "Number of pickups for the day reminder",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 1
                    },
                    {
                        prefName: "Scheduled pickups for tomorrow without assigned truck",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 2
                    }
                ]
        };
        vm.driverPrefs = {
            allSmsActive: true,
            allEmailActive: true,
            allWebActive: true,
            preferences:
                [
                    {
                        prefName: "Driver cancelled a donation",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 1
                    },
                    {
                        prefName: "Driver reported an issue",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 2
                    },
                    {
                        prefName: "Driver did not mark AM donations complete",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 3
                    },
                    {
                        prefName: "Driver received a one star rating",
                        sms_alert: true,
                        email_alert: true,
                        web: true,
                        id: 4
                    }
                ]
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('LogisticsController', LogisticsController);

    /** @ngInject */
    function LogisticsController(ProfileService, ItemTypesService, CausesService, PhotoService, baseUrl, $rootScope) {
        var vm = this;

        vm.editProfile = editProfile;
        vm.selectCause = selectCause;

        vm.baseUrl = baseUrl;
        vm.loaded = 0;
        vm.selectedCauses = 0;

        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };


        activate();

        function activate() {
            getCharity();
        }

        function getCharity() {
            ProfileService.getCharity()
                .success(function (data) {
                    vm.loaded++;
                    vm.userData = data;
                    getItemTypes();
                    getCauses();
                })
                .error(function () {
                    vm.addAlert('danger', 'Error occured, Please contact Support');
                })
        }

        function getItemTypes() {
            ItemTypesService.getItemTypes().success(function (data) {
                vm.itemTypes = data;
                angular.forEach(vm.itemTypes, function (item) {
                    item.selected = false;
                    angular.forEach(vm.userData.item_types, function (i) {
                        if (item.id === i.id) {
                            item.selected = true;
                        }
                    });
                });
                vm.loaded++;
            })
        }

        function getCauses() {
            CausesService.getCauses().success(function (data) {
                vm.causes = data;
                angular.forEach(vm.causes, function (cause) {
                    cause.selected = false;
                    angular.forEach(vm.userData.causes, function (c) {
                        if (cause.id === c.id) {
                            cause.selected = true;
                            vm.selectedCauses++;
                        }
                    });
                });
                vm.loaded++;
            })
        }

        function editProfile() {
            vm.isSubmitting = true;
            var data = angular.copy(vm.userData);
            var ids = [];
            angular.forEach(vm.causes, function (cause) {
                if (cause.selected) {
                    ids.push(cause.id);
                }
            });
            data.causes = ids;
            ids = [];
            angular.forEach(vm.itemTypes, function (item) {
                if (item.selected) {
                    ids.push(item.id);
                }
            });
            data.item_types = ids;
            delete(data.availability);
            delete(data.schedule);
            ProfileService.updateCharity(data)
                .success(function () {
                    vm.addAlert('success', 'Profile updated successfully.');
                    $rootScope.$broadcast('account-updated');
                    vm.isSubmitting = false;
                })
                .error(function (errorData) {
                    var additionalMsg = '';
                    vm.isSubmitting = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                });
        }

        function selectCause(cause) {
            cause.selected = !cause.selected;
            if(cause.selected){
                vm.selectedCauses++;
            } else {
                vm.selectedCauses--;
            }
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('AccountInfoController', AccountInfoController);

    /** @ngInject */
    function AccountInfoController(ProfileService, PhotoService, baseUrl, $rootScope, imageBaseUrl, $scope) {
        var vm = this;

        vm.editProfile = editProfile;
        vm.imageSelected = imageSelected;
        vm.logoSelected = logoSelected;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;
        vm.imageIsSelected = false;


        vm.alerts = [];

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };


        activate();

        function activate() {
            vm.isLoading = true;
            getCharity();
        }

        function getCharity() {
            ProfileService.getCharity()
                .success(function (data) {
                    vm.userData = data;
                    vm.isLoading = false;
                })
                .error(function () {
                    vm.isLoading = false;
                    vm.addAlert('danger', 'Error occured, Please contact Support');
                })
        }

        function editProfile() {
            vm.isSubmitting = true;
            vm.alerts = [];
            if (vm.userData.photo && vm.userData.photo.file) {
                uploadPhoto();
            } else {
                updateProfile();
            }
        }

        function uploadPhoto() {
            PhotoService.uploadPhoto(vm.userData.photo.file)
                .success(function (image) {
                    updateProfile(image);
                })
                .error(function (errorData) {
                    var additionalMsg = '';
                    vm.isSubmitting = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                });
        }

        function updateProfile(image) {
            vm.isSubmitting = true;
            var data = angular.copy(vm.userData);
            if (image) {
                data.photo_id = image.id;
            } else if (data.photo) {
                data.photo_id = data.photo.id;
            }
            delete(data.availability);
            delete(data.schedule);
            delete(data.item_types);
            delete(data.causes);
            ProfileService.updateCharity(data)
                .success(function () {
                    vm.addAlert('success', 'Profile updated successfully.');
                    $rootScope.$broadcast('account-updated');
                    vm.isSubmitting = false;
                })
                .error(function (errorData) {
                    var additionalMsg = '';
                    vm.isSubmitting = false;
                    for (var prop in errorData.additional_data) {
                        additionalMsg += prop + " " + errorData.additional_data[prop];
                    }
                    vm.addAlert('danger', 'Ooops, ' + errorData.message + ' - ' + additionalMsg);
                });
        }


        function imageSelected() {
            vm.imageIsSelected = !vm.imageIsSelected;
        }

        function logoSelected() {
            if (vm.userData.logo.file) {
                PhotoService.uploadPhoto(vm.userData.logo.file)
                    .success(function (image) {
                        vm.userData.logo_url = vm.imageBaseUrl + image.url;
                    })
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .directive('accountSidebar', accountSidebar);

    /** @ngInject */
    function accountSidebar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/account/account-sidebar/account-sidebar.html',
            controller: AccountSidebarController,
            controllerAs: 'accountSidebarCtrl',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function AccountSidebarController($state, $rootScope, $scope, ProfileService) {
            var vm = this;
            vm.active = $state.current.name;
            vm.missing_fields_info = 0;
            vm.missing_fields_logistic = 0;
            var full = 767;
            var empty = 1050;
            vm.percentageFill = 0;
            vm.percentage = 0;

            vm.scrollConfig = {
                autoHideScrollbar: true,
                theme: 'minimal-dark',
                scrollInertia: 0,
                axis: 'y',
                advanced: {
                    updateOnContentResize: true
                }
            };

            $scope.$on('account-updated', function () {
                getData();
            });

            getData();
            function getData() {
                vm.missing_fields_info = 0;
                vm.missing_fields_logistic = 0;
                ProfileService.getCharity().success(function (data) {
                    vm.percentageFill = full + (1 - data.profile_completed_percentage / 100) * (empty - full);
                    vm.percentage = data.profile_completed_percentage;
                    vm.missing_fields = data.missing_fields;
                    angular.forEach(vm.missing_fields, function (e) {
                        if (['picture', 'name', 'address', 'city', 'zip', 'state', 'primary_contact_first_name', 'primary_contact_last_name', 'primary_phone_number', 'primary_email'].indexOf(e) !== -1) {
                            vm.missing_fields_info++;
                        } else if (['tax_id', 'cause'].indexOf(e) !== -1) {
                            vm.missing_fields_logistic++;
                        }
                    });
                })
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ExportModalController', ExportModalController);

    /** @ngInject */
    function ExportModalController($uibModalInstance, DonationsService, params) {
        var vm = this;

        vm.close = close;
        vm.params = params;

        activate();

        function activate() {
            getDonations();
        }

        function close() {
            $uibModalInstance.dismiss();
        }

        function getDonations() {
            DonationsService.searchDonations(params)
            .success(function(response){
                if (response.length > 0) {
                    response.forEach(function (donation, index) {
                        donation.date = donation.request.date;
                        donation.status = donation.request.status;
                        donation.donor = donation.request.donor.first_name + " " + donation.request.donor.last_name;
                        donation.address = donation.address.replace(/#/g, '').replace(/,/g, ';');
                        donation.description = donation.description ? donation.description.replace(/#/g, '').replace(/,/g, ';').replace(/"/g, '``').replace(/\n/g, " ") : '/';
                        donation.truck = donation.request.truck ? donation.request.truck.model : '/';
                        donation.truck = donation.truck.replace(/#/g, '').replace(/,/g, ';');
                        removeUnnecessaryDataFromExport(donation);
                        if (index === response.length - 1) {
                            vm.donationsToExport = response;
                        }
                    });
                } else {
                    vm.donationsToExport = [];
                }
            })
        }

        function removeUnnecessaryDataFromExport(donation) {
            delete donation.address2;
            delete donation.special_instructions;
            delete donation.request;
            delete donation.initialRequest;
            delete donation.content;
            delete donation.photos;
            delete donation.requests;
            delete donation.lat;
            delete donation.lng;
            delete donation.tax_receipt_pdf_ready;
            delete donation.tax_receipt_pdf_url;
            delete donation.handling_required;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('ExceptionModalController', ExceptionModalController);

    /** @ngInject */
    function ExceptionModalController($uibModalInstance, date, exception, process, defaultState, ScheduleService) {
        var vm = this;

        vm.close = close;
        vm.tagAdded = tagAdded;
        vm.updateScheduleException = updateScheduleException;
        vm.createScheduleException = createScheduleException;
        vm.deleteScheduleException = deleteScheduleException;
        vm.saveException = saveException;
        vm.useDefault = useDefault;

        vm.defaultState = defaultState;

        vm.process = process;
        vm.exception = exception;
        vm.date = moment(date).format('YYYY-MM-DD');

        vm.loadTags = function (query) {
            return ScheduleService.searchForZipCodes(query);
        };

        function tagAdded(tag, item) {
            if (!tag.code) {
                item.zips.splice(-1, 1);
                ScheduleService.searchForZipCodes(tag.text)
                    .success(function (data) {
                        var newTag = data[0];
                        item.zips.push(newTag);
                    })
            }
        }

        function saveException() {
            if (vm.process === 'update') {
                updateScheduleException(vm.exception);
            } else if (vm.process === 'create') {
                createScheduleException(vm.exception);
            }
        }

        function useDefault() {
            deleteScheduleException(vm.exception)
        }

        function deleteScheduleException(exception) {
            ScheduleService.deleteScheduleException(exception)
                .then(function () {
                    var dayDisabled = !vm.defaultState || (!!vm.defaultState && (vm.defaultState.am + vm.defaultState.pm === 0));
                    $uibModalInstance.close(dayDisabled)
                })
                .catch(function (error) {
                    console.log(error);
                })
        }

        function updateScheduleException(exception) {
            exception.date = vm.date;
            ScheduleService.updateException(exception)
                .then(function (response) {
                    var dayDisabled = response.am + response.pm > 0;
                    $uibModalInstance.close({dayDisabled: dayDisabled, exception: response.data});
                })
                .catch(function (error) {
                    console.log(error);
                })
        }

        function createScheduleException(exception) {
            exception.date = vm.date;
            ScheduleService.createScheduleException(exception)
                .then(function (response) {
                    console.log(response);
                    var dayDisabled = response.am + response.pm > 0;
                    $uibModalInstance.close({dayDisabled: dayDisabled, exception: response.data})
                })
                .catch(function (error) {
                    console.log(error);
                })

        }

        function close() {
            $uibModalInstance.dismiss();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('ZipsService', ZipsService);

    /** @ngInject */
    function ZipsService($http, baseUrl) {
        var service = this;

        service.search = search;

        function search(code) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/zips?code=' + code
            }).success(function (data) {
                angular.forEach(data, function (item) {
                    item.text = item.code;
                });
                return data;
            })
        }
    }

})();


(function () {
  "use strict";

  angular.module("rsplCharityV2").service("UsersService", UsersService);

  /** @ngInject */
  function UsersService($http, baseUrl) {
    var service = this;

    service.search = search;
    service.searchAll = searchAll;
    service.getUserByPhone = getUserByPhone;
    service.updatePassword = updatePassword;
    service.createUser = createUser;
    service.updateUser = updateUser;
    service.getUserRoles = getUserRoles;
    service.createUserRole = createUserRole;
    service.deleteUser = deleteUser;
    service.restoreUser = restoreUser;

    function search(params) {
      params.charity_users = true;
      return $http({
        method: "GET",
        url: baseUrl + "/api/v2/users/all",
        params: params
      }).success(function (data) {
        return data;
      });
    }

    function searchAll(params) {
      return $http({
        method: "GET",
        url:
          baseUrl +
          "/api/v2/charities/" +
          localStorage.getItem("rspl-charity-id") +
          "/contacts",
        params: params
      }).success(function (data) {
        return data;
      });
    }

    function getUserByPhone(phone) {
      return $http({
        method: "GET",
        url:
          baseUrl +
          "/api/v2/charities/" +
          localStorage.getItem("rspl-charity-id") +
          "/contacts?email_or_phone=" +
          encodeURIComponent(phone)
      }).success(function (data) {
        return data;
      });
    }

    function updatePassword(id, password, token) {
      return $http({
        method: "PUT",
        url: baseUrl + "/api/v2/users/" + id,
        data: {
          password: password
        },
        headers: {
          Authorization: "Bearer " + token
        }
      }).success(function (data) {
        return data;
      });
    }

    function createUser(data, token) {
      data.provider = 'email';
      return $http({
        method: "POST",
        url: baseUrl + "/api/v2/users/",
        data: data,
        headers: {
          Authorization: "Bearer " + token
        }
      }).success(function (data) {
        return data;
      });
    }

    function updateUser(id, data, token) {
      return $http({
        method: "PUT",
        url: baseUrl + "/api/v2/users/" + id,
        data: data,
        headers: {
          Authorization: "Bearer " + token
        }
      }).success(function (data) {
        return data;
      });
    }

    function getUserRoles(id) {
      return $http({
        method: "GET",
        url: baseUrl + "/api/v2/users/" + id + "/user_roles"
      }).success(function (data) {
        return data;
      });
    }

    function createUserRole(id, role, charity_id) {
      return $http({
        method: "POST",
        url: baseUrl + "/api/v2/users/" + id + "/user_roles",
        data: {
          role: role,
          charity_id: charity_id
        }
      }).success(function (data) {
        return data;
      });
    }

    function deleteUser(id) {
      return $http({
        method: "DELETE",
        url: baseUrl + '/api/v2/users/' + id
      }).success(function (data) {
        return data;
      })
    }

    function restoreUser(id) {
      return $http({
        method: "POST",
        url: baseUrl + '/api/v2/users/' + id + '/restore'
      }).success(function (data) {
        return data;
      })
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('PhotoService', PhotoService);

    /** @ngInject */
    function PhotoService($http, baseUrl, Upload) {
        var service = this;

        service.uploadPhoto = uploadPhoto;

        function uploadPhoto(file) {
            return Upload.upload({
                method: 'POST',
                url: baseUrl + '/api/v2/photos',
                data: {
                    content: file
                }
            }).success(function (response) {
                return response;
            }).error(function (errorData) {
                return errorData;
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('AudioService', AudioService);

    /** @ngInject */
    function AudioService($http, baseUrl, Upload) {
        var service = this;

        service.uploadAudio = uploadAudio;

        function uploadAudio(file) {
            return Upload.upload({
                method: 'POST',
                url: baseUrl + '/api/v2/audios',
                data: {
                    content: file
                }
            }).success(function (response) {
                return response;
            }).error(function (errorData) {
                return errorData;
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('TrucksService', TrucksService);

    /** @ngInject */
    function TrucksService($http, baseUrl) {
        var service = this;

        service.showAllTrucks = showAllTrucks;
        service.createTruck = createTruck;
        service.updateTruck = updateTruck;
        service.getLabels = getLabels;
        service.createLabel = createLabel;
        service.deleteLabel = deleteLabel;
        service.optimizeAllRoutes = optimizeAllRoutes;


        function showAllTrucks() {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/trucks'
            }).success(function (data) {
                return data;
            })
        }

        function createTruck(data) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/' + charityId + '/trucks',
                data: data
            }).success(function (data) {
                return data;
            })
        }

        function updateTruck(truckId, data) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/' + charityId + '/trucks/' + truckId,
                data: data
            }).success(function (data) {
                return data;
            })
        }

        function getLabels() {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/pickup_labels'
            }).success(function (data) {
                return data;
            })
        }

        function createLabel(name, color) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "POST",
                data: {
                    color: color,
                    name: name
                },
                url: baseUrl + '/api/v2/charities/' + charityId + '/pickup_labels'
            }).success(function (data) {
                return data;
            })
        }

        function deleteLabel(id) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "DELETE",
                url: baseUrl + '/api/v2/charities/' + charityId + '/pickup_labels/'+id
            }).success(function (data) {
                return data;
            })
        }

        function optimizeAllRoutes(truckId, date) {
            return $http({
                method: "POST",
                data: {
                    truck_id: truckId,
                    date: date
                },
                url: baseUrl + '/api/v2/donation_requests/optimize_pickups'
            }).success(function (data) {
                return data;
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('TrucksController', TrucksController);

    /** @ngInject */
    function TrucksController($scope, baseUrl, imageBaseUrl, TrucksService, PhotoService) {
        var vm = this;

        vm.baseUrl = baseUrl;
        vm.imageBaseUrl = imageBaseUrl;

        vm.getTrucks = getTrucks;
        vm.addTruck = addTruck;
        vm.updateTruck = updateTruck;
        vm.cancelAdd = cancelAdd;

        vm.alerts = [];

        vm.colorOptions = [
            {
                name: 'Blue', 
                code: '#72aad9'
            },
            {
                name: 'Dark Blue',
                code: '#4b70a2'
            },
            {
                name: 'Grey',
                code: '#797979'
            },
            {
                name: 'Orange',
                code: '#fba43f' 
            },
            {
                name: 'Green',
                code: '#5ed47c'
            },
            {
                name: 'Yellow',
                code: '#ffd13f'
            }
        ];
        vm.colorMap = {
            '#72aad9':'Blue', 
            '#4b70a2':'Dark Blue',
            '#797979':'Grey',
            '#fba43f' :'Orange',
            '#5ed47c':'Green',
            '#ffd13f':'Yellow'
        }

        vm.addAlert = function (type, msg) {
            vm.alerts.push({type: type, msg: msg});
        };

        vm.closeAlert = function (index) {
            vm.alerts.splice(index, 1);
        };

        activate();

        function activate() {
            vm.isLoading = true;
            vm.newTruck = {};

            getTrucks();
        }


        function getTrucks() {
            vm.isLoading = true;

            TrucksService.showAllTrucks().success(function (data) {
                vm.trucks = data;
                angular.forEach(vm.trucks, function(truck){
                    truck._color = {
                        name: vm.colorMap[truck.color],
                        code: truck.color
                    }
                });
                vm.isLoading = false;
                
            }).error(function (errorData) {
                console.log(errorData);
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                vm.isLoading = false;
            });
        }

        function addTruck() {
            vm.isAdding = true;
            if (!vm.new_truck.$valid || !vm.newTruck.file || vm.newTruck.file.$error) return;
            PhotoService.uploadPhoto(vm.newTruck.file).success(function (data) {
                TrucksService.createTruck({
                    model: vm.newTruck.model,
                    licence_plate: vm.newTruck.licence_plate,
                    color: vm.newTruck._color.code,
                    photo_id: data.id
                }).success(function () {
                    vm.isAdding = false;
                    cancelAdd();
                    getTrucks();
                }).error(function (errorData) {
                    vm.isAdding = false;
                    vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
                });
            })
        }

        function updateTruck(truck, i) {
            if (truck.file) {
                PhotoService.uploadPhoto(truck.file).success(function (data) {
                    update(truck, i, data);
                });
            } else {
                update(truck, i);
            }
        }

        function update(truck, i, photo) {
            TrucksService.updateTruck(truck.id, {
                model: truck.model,
                licence_plate: truck.licence_plate,
                color: truck._color.code,
                photo_id: photo && photo.id ? photo.id : truck.photo_id
            }).success(function (data) {
                truck = data;
                vm['truck_' + i].$setPristine();
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function cancelAdd() {
            vm.newTruck = {};
            vm.showAdd = false;
        }
    }
})
();

/**
 * Created by dms on 2/10/18.
 */
(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('ProfileService', ProfileService);

    /** @ngInject */
    function ProfileService($http, baseUrl) {
        var service = this;

        service.getUser = getUser;
        service.createUser = createUser;
        service.checkIfUserExists = checkIfUserExists;
        service.createCharityProfile = createCharityProfile;
        service.activateCharityProfile = activateCharityProfile;
        service.getCharity = getCharity;
        service.updateCharity = updateCharity;
        service.createContact = createContact;
        service.activateCharity = activateCharity;


        function getUser(id) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/users/' + id
            }).success(function (data) {
                return data;
            })
        }

        function createUser(firstName, lastName, email, provider, password) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/users',
                data: {
                    provider: provider,
                    first_name: firstName,
                    last_name: lastName,
                    email: email,
                    password: password
                }
            }).success(function (data) {
                return data;
            })
        }

        function createContact(donor, provider) {
            donor.provider = provider;
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/'+localStorage.getItem('rspl-charity-id')+'/contacts',
                data: donor
            }).success(function (data) {
                return data;
            })
        }

        function checkIfUserExists(email) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/users/exist?email_or_phone=' + encodeURIComponent(email)
            }).success(function (data) {
                return data;
            })
        }

        function createCharityProfile(charity) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities',
                data: {
                    name: charity.name,
                    address: charity.address,
                    city: charity.city,
                    zip: charity.zip,
                    state: charity.state,
                    primary_contact_first_name: charity.primary_contact_first_name,
                    primary_contact_last_name: charity.primary_contact_last_name,
                    primary_phone_number: charity.primary_phone_number,
                    primary_email: charity.primary_email,
                    secondary_phone_number: charity.secondary_phone_number,
                    secondary_email: charity.secondary_email,
                    additional_phone_number: charity.additional_phone_number,
                    mission: charity.mission,
                    pickup_process_note: charity.pickup_process_note,
                    tax_id: charity.tax_id,
                    photo_id: charity.photo_id,
                    not_in_demand_items: charity.not_in_demand_items,
                    high_in_demand_items: charity.high_in_demand_items,
                    item_types: charity.itemTypes,
                    causes: charity.causes
                }
            }).success(function (data) {
                return data;
            })
        }

        function activateCharityProfile(claim_token) {
            return $http({
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('rspl-charity-activation-token')
                },
                url: baseUrl + '/api/v2/charities/claim',
                data: {
                    token: claim_token
                }
            }).success(function (data) {
                return data;
            })
        }

        function getCharity() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id')
            }).success(function (data) {
                return data;
            })
        }

        function updateCharity(data) {
            return $http({
                method: "PUT",
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('rspl-charity-activation-token')
                },
                url: baseUrl + '/api/v2/charities/' + localStorage.getItem('rspl-charity-id'),
                data: data
            }).success(function (data) {
                return data;
            })
        }

        function activateCharity(id, token) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/charities/'+id+'/activate',
                headers: {
                    "Authorization" : 'Bearer '+token
                }
            }).success(function (data) {
                return data;
            })
        }


    }

})();


/**
 * Created by dms on 2/10/18.
 */
(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('LoginService', LoginService);

    /** @ngInject */
    function LoginService($http, baseUrl) {
        var service = this;

        service.login = login;
        service.refreshToken = refreshToken;
        service.checkForContract = checkForContract;
        service.hc = hc;
        service.getAppData = getAppData;


        function login(username, password) {
            return $http({
                method: "POST",
                data: {
                    "email": username,
                    "password": password,
                    "scope": "charity",
                    "provider": "email"
                },
                url: baseUrl + '/api/v2/users/authenticate'
            }).success(function (data) {
                return data;
            })
        }

        function refreshToken() {
            return $http({
                method: "POST",
                data: {
                    "token": localStorage.getItem('rspl-refresh-token')
                },
                url: baseUrl + '/api/v2/users/reauthenticate'
            }).success(function (data) {
                return data;
            })
        }

        function checkForContract(data) {

            if (!data.charity.contract_signed) {
                return 'payment'
            } else {
                return 'calendar'
            }
        }

        function hc() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/hc'
            }).success(function (data) {
                return data;
            })
        }

        function getAppData() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/app_status'
            }).success(function (data) {
                return data;
            })
        }

    }

})();


(function () {
  'use strict';

  angular
      .module('rsplCharityV2')
      .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($uibModal, ProfileService, $rootScope, $state, $log, $timeout, UsersService, LoginService, ActionCableSocketWrangler, ActionCableConfig, socketBaseUrl) {
      var vm = this;

      vm.openTaCmodal = openTaCmodal;
      vm.addAlert = addAlert;
      vm.resetPassword = resetPassword;
      vm.login = login;

      vm.termsAndConditions = true;

      vm.alerts = [];

      vm.closeAlert = function (index) {
          vm.alerts.splice(index, 1);
      };

      vm.params = getJsonFromUrl();

      if (vm.params.captain_portal_auth_token && vm.params.charity_id && vm.params.user_id) {
          localStorage.clear();
          ActionCableSocketWrangler.stop();
          localStorage.setItem('rspl-token', vm.params.captain_portal_auth_token);
          localStorage.setItem('rspl-charity-id', vm.params.charity_id);
          localStorage.setItem('rspl-user-id', vm.params.user_id);
          ActionCableConfig.wsUri = socketBaseUrl + localStorage.getItem('rspl-token');
          ProfileService.getCharity()
              .success(function (data) {
                  localStorage.setItem('rspl-charity', data.name);
                  $state.go('calendar');
              });
      }


      if (vm.params.charity_id && vm.params.token && vm.params.user_id) {
          vm.isActivating = true;
          ProfileService.activateCharity(vm.params.charity_id, vm.params.token)
              .success(function () {
                  $timeout(function () {
                      vm.showPasswordResetForm = true;
                  }, 2000)
              })
              .error(function () {
                  vm.isActivating = false;
                  openExpiredTokenModal()
              })
      }

      function addAlert(type, msg) {
          vm.alerts.push({type: type, msg: msg});
      }

      function openTaCmodal() {
          var modalInstance = $uibModal.open({
              animation: true,
              templateUrl: 'app/login/tac/tac.html',
              controller: 'TacController',
              controllerAs: 'tacCtrl',
              size: 'lg'
          });
          modalInstance.result.then(
              function () {

              })
      }

      function openExpiredTokenModal() {
          var modalInstance = $uibModal.open({
              animation: true,
              templateUrl: 'app/login/expired/expired.html',
              controller: 'ExpiredController',
              controllerAs: 'expiredCtrl',
              size: 'lg'
          });
          modalInstance.result.then(
              function () {

              })
      }

      function getJsonFromUrl() {
          var query = location.href.split('?')[1];
          var result = {};
          if (query) {
              query.split("&").forEach(function (part) {
                  var item = part.split("=");
                  result[item[0]] = decodeURIComponent(item[1]);
              });
          }
          return result;
      }

      function resetPassword() {
          UsersService.updatePassword(vm.params.user_id, vm.password, vm.params.token)
              .success(function (data) {
                  vm.isActivating = false;
              })
      }

      function login() {
          vm.isLoading = true;
          vm.alerts = [];
          LoginService.login(vm.username, vm.password)
              .success(function (data) {
                  var role = _.filter(data.roles, function (role) {
                      return role.authorization.type === 'charity_admin';
                  });
                  if (role.length > 1) {
                      $uibModal.open({
                          animation: true,
                          templateUrl: 'app/login/login-roles-modal/login.roles.modal.html',
                          backdrop: 'static',
                          controller: 'LoginRolesController',
                          controllerAs: 'loginRolesCtrl',
                          resolve: {
                              roles: function () {
                                  return role;
                              },
                              user: function () {
                                  return data.user;
                              }
                          },
                          size: 'sm'
                      });
                      vm.isLoading = false;
                  } else if (role.length === 1)  {
                      setLoginData(role, data);
                  } else {
                      vm.addAlert('danger', 'Something went wrong, check your email and password');
                      vm.isLoading = false;
                  }
              })

              .error(function () {
                  vm.addAlert('danger', 'Something went wrong, check your email and password');
                  vm.isLoading = false;
              })
      }

      function setLoginData(role, data) {
          localStorage.setItem('rspl-auth-data', angular.toJson(role));
          localStorage.setItem('rspl-token', role[0].authorization.token);
          localStorage.setItem('rspl-refresh-token', role[0].authorization.refresh_token);
          localStorage.setItem('rspl-user-id', data.user.id);
          localStorage.setItem('rspl-charity', role[0].charity.name);
          localStorage.setItem('rspl-charity-id', role[0].charity.id);
          localStorage.setItem('rspl-user', angular.toJson(data.user));
          localStorage.setItem('rspl-contract-signed', role[0].charity.contract_signed);
          $rootScope.$broadcast('login_event');
          vm.isLoading = false;
          $state.go(LoginService.checkForContract(role[0]));
      }
  }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('ItemTypesService', ItemTypesService);

    /** @ngInject */
    function ItemTypesService($http, baseUrl) {
        var service = this;

        service.getItemTypes = getItemTypes;

        function getItemTypes() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/item_types'
            }).success(function (data) {
                return data;
            })
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('DonationsService', DonationsService);

    /** @ngInject */
    function DonationsService($http, baseUrl, $log) {
        var service = this;

        service.searchDonations = searchDonations;
        service.acceptDonation = acceptDonation;
        service.getTaxLink = getTaxLink;
        service.generateTaxReceipt = generateTaxReceipt;
        service.rejectDonation = rejectDonation;
        service.cancelDonation = cancelDonation;
        service.completeDonation = completeDonation;
        service.startDonation = startDonation;
        service.updateDonation = updateDonation;
        service.updateDonationRequest = updateDonationRequest;
        service.publishDonation = publishDonation;
        service.getRescheduleOptions = getRescheduleOptions;
        service.rescheduleDonation = rescheduleDonation;
        service.getDonation = getDonation;
        service.assignTruck = assignTruck;
        service.assignLabel = assignLabel;
        service.assignOrder = assignOrder;
        service.prepareReportDonations = prepareReportDonations;
        service.prepareDonations = prepareDonations;
        service.prepareDonation = prepareDonation;
        service.updateDonationNote = updateDonationNote;
        service.pickUpDateOptions = pickUpDateOptions;
        service.updateDonationCountAs = updateDonationCountAs;
        service.getHubStatus = getHubStatus;
        service.markDonationAsSeen = markDonationAsSeen;
        service.getZipCodes = getZipCodes;
        service.updateDonationDescription = updateDonationDescription;

        function getDonation(id) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/donations/' + id
            }).success(function (data) {
                return prepareDonation(data);
            })
        }

        function startDonation(id) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations',
                data: {
                    donation_type: 'manual',
                    contact_id: id
                }
            }).success(function (data) {
                return prepareDonation(data);
            })
        }

        function updateDonation(id, donation) {
            if (donation.estimated_price === null) {
                delete donation.estimated_price;
            }
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/donations/' + id,
                data: {
                    estimated_price: donation.estimated_price,
                    zip: donation.zip,
                    city: donation.city ? donation.city : '/',
                    state: donation.state ? donation.state : '/',
                    address: donation.address ? donation.address : '/',
                    photo_ids: donation.photos,
                    special_instructions: donation.special_instructions,
                    description: donation.description
                }
            }).success(function (data) {
                return data;
            })
        }

        function updateDonationRequest(date, part_of_day, charityId, donationId, requestId) {
            var formattedDate = moment(date).format('YYYY-MM-DD');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId,
                data: {
                    date: formattedDate,
                    part_of_day: part_of_day,
                    charity: charityId
                }
            }).success(function (data) {
                return data;
            })
        }

        function publishDonation(donationId, requestId) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/publish'
            }).success(function (data) {
                return data;
            })
        }

        function searchDonations(params) {
            var p = angular.copy(params);
            if (p.end_date)
                p.end_date = moment(params.end_date).format('YYYY-MM-DD');
            if (p.start_date)
                p.start_date = moment(params.start_date).format('YYYY-MM-DD');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/donations',
                params: p
            }).success(function (data) {
                return prepareDonations(data);
            }).error(function (errorData) {
                $log.error(errorData);
            })
        }


        function acceptDonation(donationId, requestId) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/accept'
            }).success(function (data) {
                return data;
            })
        }


        function rejectDonation(donationId, requestId, reason) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/reject',
                data: {
                    reason: reason
                }
            }).success(function (data) {
                return data;
            })
        }

        function cancelDonation(donationId, requestId, reason) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/cancel',
                data: {
                    reason: reason
                }
            }).success(function (data) {
                return data;
            })
        }

        function completeDonation(donationId, requestId) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/complete'
            }).success(function (data) {
                return data;
            })
        }

        function getTaxLink(donationId) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/donations/' + donationId + '/tax_receipt'
            }).success(function (data) {
                return data;
            })
        }

        function generateTaxReceipt(donationId) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/generate_tax_receipt'
            }).success(function (data) {
                return data;
            })
        }

        function getRescheduleOptions() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/pickup_date_options/reschedule'
            }).success(function (data) {
                return data;
            })
        }

        function rescheduleDonation(options, donationId, requestId) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/reschedule',
                data: {
                    options: options
                }
            }).success(function (data) {
                return data;
            })
        }


        function assignTruck(donationId, requestId, truckId) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/assign_truck',
                data: {
                    truck: truckId
                }
            }).success(function (data) {
                return data;
            })
        }

        function assignLabel(donationId, requestId, labelId) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/assign_pickup_label',
                data: {
                    pickup_label_id: labelId
                }
            }).success(function (data) {
                return data;
            })
        }

        function assignOrder(donationId, requestId, orderNumber) {
            return $http({
                method: "POST",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId + '/assign_pickup_order_number',
                data: {
                    pickup_order_number: orderNumber
                }
            }).success(function (data) {
                return data;
            })
        }

        function prepareDonations(donations) {

            donations.forEach(function (donation) {
                prepareDonation(donation);
            });

            return donations;

        }

        function prepareReportDonations(reports) {

            reports.forEach(function (report) {
                prepareDonation(report.donation);
            });

            return reports;

        }

        function prepareDonation(donation) {
            var charityId = localStorage.getItem('rspl-charity-id');
            if (donation.requests.length > 1) {
                donation.requests.sort(function (a, b) {
                    return (moment(a.date) > moment(b.date)) ? 1 : ((moment(b.date) > moment(a.date)) ? -1 : 0);
                });
                donation.initialRequest = donation.requests[0];
                donation.requests = donation.requests.filter(function (request) {
                    return (request.charity_id === parseInt(charityId)) || request.status === 'in_pool'
                });
                if (donation.requests.length === 0) {
                    donation.requests.push(donation.initialRequest);
                }
                angular.forEach(donation.requests, function (e) {
                    if (e.status === 'completed') {
                        donation.request = e;
                    } else if (e.status === 'accepted' && (!donation.request || donation.request.status !== 'completed')) {
                        donation.request = e;
                    } else if (e.status === 'awaiting_user_response' && (!donation.request || (donation.request.status !== 'accepted' && donation.request.status !== 'completed'))) {
                        donation.request = e;
                    } else if (e.status === 'in_pool' && (!donation.request || (donation.request.status !== 'accepted' && donation.request.status !== 'completed' && donation.request.status !== 'awaiting_user_response'))) {
                        donation.request = e;
                    } else if (!donation.request) {
                        donation.request = e;
                    }
                });
            } else {
                donation.request = donation.requests[0];
                donation.initialRequest = donation.requests[0];
            }
            return donation;
        }

        function updateDonationNote(donationId, requestId, note) {
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId,
                data: {
                    notes: note
                }
            }).success(function (data) {
                return data;
            })
        }

        function updateDonationDescription(donationId, description) {
            description = description.split('\n').join(', ');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/donations/' + donationId,
                data: {
                    description: description
                }
            }).success(function (data) {
                return data;
            })
        }

        function updateDonationCountAs(donationId, requestId, countAs) {
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/donations/' + donationId + '/donation_requests/' + requestId,
                data: {
                    count_as: countAs < 1 ? 1 : countAs
                }
            }).success(function (data) {
                return data;
            })
        }

        function pickUpDateOptions(charityId, zip, p) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/pickup_date_options?zip=' + zip + '&charity=' + charityId,
                params: p
            }).success(function (data) {
                return data;
            })
        }

        function getHubStatus() {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/charities/' + charityId + '/donation_alerts'
            }).success(function (data) {
                return data;
            })
        }

        function markDonationAsSeen(id) {
            var charityId = localStorage.getItem('rspl-charity-id');
            return $http({
                method: "PUT",
                url: baseUrl + '/api/v2/charities/' + charityId + '/donation_alerts/' + id + '/read'
            }).success(function (data) {
                return data;
            })
        }

        function getZipCodes(zip) {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/zips?code=' + zip
            }).success(function (data) {
                return data;
            })
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($state, $timeout, $uibModal) {
        var donationId = parseInt($state.params.id);

        activate();

        function activate() {
            if (donationId && donationId < 99999) {
                openDonation(donationId, false)
            }
        }

        function openDonation(donationId, shouldPrint) {
            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                windowClass: 'single-donation-modal',
                templateUrl: 'app/donations/prompts/single/single.donation.html',
                controller: 'SingleDonationController',
                controllerAs: 'singleCtrl',
                resolve: {
                    donationId: donationId,
                    print: shouldPrint
                },
                size: 'lg'
            });
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .service('CausesService', CausesService);

    /** @ngInject */
    function CausesService($http, baseUrl) {
        var service = this;

        service.getCauses = getCauses;

        function getCauses() {
            return $http({
                method: "GET",
                url: baseUrl + '/api/v2/causes'
            }).success(function (data) {
                return data;
            })
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('AccountWrapperController', AccountWrapperController);

    /** @ngInject */
    function AccountWrapperController() {
        var vm = this;

        vm.scrollConfig = {
            autoHideScrollbar: true,
            theme: 'minimal-dark',
            scrollInertia: 0,
            axis: 'y',
            advanced: {
                updateOnContentResize: true
            }
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController(TrucksService, DonationsService, ScheduleService, PrintService, $timeout, $uibModal) {
        var vm = this;

        vm.nextDay = nextDay;
        vm.previousDay = previousDay;
        vm.nextWeek = nextWeek;
        vm.previousWeek = previousWeek;
        vm.nextMonth = nextMonth;
        vm.previousMonth = previousMonth;

        vm.timeTypeChanged = timeTypeChanged;
        vm.truckChanged = truckChanged;
        vm.print = print;
        vm.setViewType = setViewType;
        vm.openExportModal = openExportModal;

        vm.params = {
            start_date: moment().startOf('IsoWeek').format('YYYY-MM-DD'),
            end_date: moment().endOf('IsoWeek').format('YYYY-MM-DD'),
            per_page: 1000,
            truck_id: null,
            "status[]": ['completed', 'accepted', 'awaiting_user_response']
        };

        vm.scrollConfig = {
            autoHideScrollbar: false,
            theme: 'dark-3',
            scrollInertia: 0,
            axis: 'x',
            advanced: {
                updateOnContentResize: true
            }
        };

        vm.dateRangeConfig = {
            applyClass: 'btn-default',
            locale: {
                format: 'DD MMM'
            },
            eventHandlers: {
                "apply.daterangepicker": function () {
                    dateRangeChanged();
                }
            }
        };

        vm.slickConfig = {
            dots: true,
            arrows: true,
            focusOnSelect: true,
            nextArrow: '<span class="rspl-icon icon-arrow-right"></span>',
            prevArrow: '<span class="rspl-icon icon-arrow-left"></span>',
            dotsClass: 'custom_paging',
            customPaging: function (slider, i) {
                return (i + 1) + '/' + slider.slideCount;
            }
        };

        vm.dynamicPopover = {
            templateUrl: 'app/calendar/viewType.html'
        };

        activate();

        function activate() {
            vm.scheduleTemplate = localStorage.getItem('schedule-template');
            if (!vm.scheduleTemplate) {
                getSchedule();
            }

            vm.viewType = localStorage.getItem('rspl-calendar-view-type');
            if (!vm.viewType) {
                vm.viewType = "small";
            }

            vm.today = moment().startOf('day');
            vm.weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            vm.timeType = 'weekly';
            vm.timeTypes = ['daily', 'weekly', 'monthly', 'custom'];

            vm.datePicker = {
                startDate: moment(vm.params.start_date).format('YYYY-MM-DD'),
                endDate: moment(vm.params.end_date).format('YYYY-MM-DD')
            };

            getTrucks();
            prepareDates();

        }

        function getTrucks() {
            TrucksService.showAllTrucks().success(function (data) {
                vm.trucks = data;
            }).error(function (errorData) {
                vm.addAlert('danger', 'Something went wrong, ' + errorData.message);
            });
        }

        function dateRangeChanged() {
            vm.params.start_date = moment(vm.datePicker.startDate).format('YYYY-MM-DD');
            vm.params.end_date = moment(vm.datePicker.endDate).format('YYYY-MM-DD');
            prepareDates();
        }

        function prepareDates() {
            var dates = [];
            var dt = moment(vm.params.start_date).startOf('day');
            var end = moment(vm.params.end_date).startOf('day');
            while (dt <= end) {
                dates.push({
                    date: moment(new Date(dt)).format('YYYY-MM-DD'),
                    disabled: false
                });
                dt = moment(dt).add(1, 'day').startOf('day');
            }
            vm.dates = dates;
        }



        function nextDay() {
            vm.params.start_date = moment(vm.params.start_date).add(1, 'days').format('YYYY-MM-DD');
            vm.params.end_date = vm.params.start_date;
            prepareDates();
        }

        function previousDay() {
            vm.params.start_date = moment(vm.params.start_date).subtract(1, 'days').format('YYYY-MM-DD');
            vm.params.end_date = vm.params.start_date
            prepareDates();
        }

        function nextWeek() {
            vm.params.start_date = moment(vm.params.start_date).add(7, 'days').format('YYYY-MM-DD');
            vm.params.end_date = moment(vm.params.end_date).add(7, 'days').format('YYYY-MM-DD');
            prepareDates();
        }

        function previousWeek() {
            vm.params.start_date = moment(vm.params.start_date).subtract(7, 'days').format('YYYY-MM-DD');
            vm.params.end_date = moment(vm.params.end_date).subtract(7, 'days').format('YYYY-MM-DD');
            prepareDates();
        }

        function nextMonth() {
            vm.params.start_date = moment(vm.params.start_date).add(1, 'months').startOf('month').format('YYYY-MM-DD');
            vm.params.end_date = moment(vm.params.start_date).endOf('month').format('YYYY-MM-DD');
            prepareDates();
        }

        function previousMonth() {
            vm.params.start_date = moment(vm.params.start_date).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            vm.params.end_date = moment(vm.params.start_date).endOf('month').format('YYYY-MM-DD');
            prepareDates();
        }

        function timeTypeChanged() {
            if (vm.timeType === 'monthly') {
                vm.params.start_date = moment().startOf('month').format('YYYY-MM-DD');
                vm.params.end_date = moment().endOf('month').format('YYYY-MM-DD');
            } else if (vm.timeType === 'weekly') {
                vm.params.start_date = moment().startOf('IsoWeek').format('YYYY-MM-DD');
                vm.params.end_date = moment().endOf('IsoWeek').format('YYYY-MM-DD');
            } else if (vm.timeType === 'daily') {
                vm.params.start_date = moment().format('YYYY-MM-DD');
                vm.params.end_date = vm.params.start_date;
            } else if (vm.timeType === 'custom') {
                vm.datePicker.endDate = moment(vm.params.end_date).format('YYYY-MM-DD');
                vm.datePicker.startDate = moment(vm.params.start_date).format('YYYY-MM-DD');
            }
            prepareDates();
        }

        function truckChanged() {
            if (vm.truck) {
                vm.params.truck_id =  vm.truck.id
            } else {
                vm.params.truck_id = null
            }
        }

        function print() {
            vm.isLoadingPrintData = true;
            DonationsService.searchDonations(vm.params)
                .success(function (response) {
                    var printDonations = _.groupBy(response, 'request.date');
                    _.forEach(printDonations, function (value, key) {
                        printDonations[key] = value.filter(function (donation) {
                            return donation.request.status !== 'awaiting_user_response' && donation.request.status !== 'completed'
                        });
                    });
                    PrintService.print("calendar", {
                        donations: printDonations,
                        dates: vm.dates,
                        viewType: vm.timeType,
                        dateTo: vm.params.start_date,
                        dateFrom: vm.params.end_date,
                        trucks: vm.truck && vm.truck.model ? vm.truck.model : "All trucks",
                        weekDays: vm.weekDays
                    });
                    vm.isLoadingPrintData = false;
                })
        }

        function setViewType(type) {
            vm.viewType = type;
            localStorage.setItem('rspl-calendar-view-type', type);
            var body = document.getElementsByTagName('body')[0];
            $timeout(function () {
                body.click();
            }, 200);
        }

        function openExportModal() {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/calendar/export-modal/export-modal.html',
                controller: 'ExportModalController',
                controllerAs: 'exportCtrl',
                resolve: {
                    params: vm.params
                },
                size: 'sm'
            });
        }

        function getSchedule() {
                ScheduleService.getScheduleTemplate({ show_zips: false })
                    .success(function (data) {
                        vm.scheduleTemplate = _.groupBy(data, 'date');
                        localStorage.setItem('rspl-schedule', angular.toJson(data));
                    })
            }

    }
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .run(runBlock);

    /** @ngInject */
    function runBlock(ActionCableConfig, socketBaseUrl) {
        ActionCableConfig.wsUri = socketBaseUrl + localStorage.getItem('rspl-token');
        ActionCableConfig.autoStart = false;
    }

})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('externallogin', {
                url: '/external-login',
                templateUrl: 'app/login/external-login/login.html',
                controller: 'ExternalLoginController',
                controllerAs: 'vm'
            })
            .state('dashboard', {
                url: '/dashboard/:id',
                templateUrl: 'app/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('database', {
                url: '/database',
                template: '<ui-view/>',
                abstract: true
            })
            .state('database.users', {
                url: '/users',
                templateUrl: 'app/database/users-list/users-list.html',
                controller: 'UsersListController',
                controllerAs: 'vm'
            })
            .state('database.donations', {
                url: '/donations',
                templateUrl: 'app/database/donations/donations.html',
                controller: 'DonationsController',
                controllerAs: 'vm'
            })
            .state('database.donormanagement', {
                url: '/donormanagement',
                templateUrl: 'app/database/donormanagement/donormanagement.html',
                controller: 'DonorManagementController',
                controllerAs: 'vm'
            })
            .state('database.donorgroups', {
                url: '/donorgroups',
                template: '<ui-view/>',
                abstract: true
            })
            .state('database.donorgroups.allgroups', {
                url: '/allgroups',
                templateUrl: 'app/database/donorgroups/donorgroups.html',
                controller: 'DonorGroupsController',
                controllerAs: 'vm'
            })
            .state('database.donorgroups.creategroup', {
                url: '/creategroup',
                templateUrl: 'app/database/donorgroups/creategroup/creategroup.html',
                controller: 'CreateGroupController',
                controllerAs: 'vm'
            })
            .state('database.donorgroups.singlegroup', {
                url: '/:id',
                templateUrl: 'app/database/donorgroups/singlegroup/singlegroup.html',
                controller: 'SingleGroupController',
                controllerAs: 'vm'
            })
            .state('database.donorgroups.editgroup', {
                url: '/:id/edit',
                templateUrl: 'app/database/donorgroups/singlegroup/editgroup/editgroup.html',
                controller: 'EditGroupController',
                controllerAs: 'vm'
            })
            .state('donations', {
                url: '/donations',
                template: '<ui-view/>',
                abstract: true
            })
            .state('donations.hub', {
                url: '/hub',
                templateUrl: 'app/donations/hub/hub.html',
                controller: 'DonationHubController',
                controllerAs: 'vm'
            })
            .state('calendar', {
                url: '/calendar',
                templateUrl: 'app/calendar/calendar.html',
                controller: 'CalendarController',
                controllerAs: 'vm'
            })
            .state('account', {
                url: '/account',
                templateUrl: 'app/account/account.html',
                controller: 'AccountWrapperController',
                controllerAs: 'vm',
                abstract: true
            })
            .state('account.schedule', {
                url: '/schedule',
                templateUrl: 'app/account/schedule/schedule.html',
                controller: 'ScheduleController',
                controllerAs: 'vm'
            })
            .state('account.info', {
                url: '/info',
                templateUrl: 'app/account/info/info.html',
                controller: 'AccountInfoController',
                controllerAs: 'vm'
            })
            .state('account.logistics', {
                url: '/logistics',
                templateUrl: 'app/account/logistics/logistics.html',
                controller: 'LogisticsController',
                controllerAs: 'vm'
            })
            .state('account.reviews', {
                url: '/reviews',
                templateUrl: 'app/account/reviews/reviews.html',
                controller: 'ReviewsController',
                controllerAs: 'vm'
            })
            .state('account.taxreceiptbuilder', {
                url: '/taxreceiptbuilder',
                templateUrl: 'app/account/tax-receipt-builder/tax-receipt-builder.html',
                controller: 'TaxReceiptBuilderController',
                controllerAs: 'vm'
            })
            .state('account.notificationpref', {
                url: '/notification-preferences',
                templateUrl: 'app/account/notifications/notification-pref.html',
                controller: 'NotificationPrefController',
                controllerAs: 'vm'
            })
            .state('account.email-notifications', {
                url: '/notifications/email',
                templateUrl: 'app/account/notifications/email/email.html',
                controller: 'EmailNotificationsController',
                controllerAs: 'vm'
            })
            .state('account.in-app-notifications', {
                url: '/notifications/in-app',
                templateUrl: 'app/account/notifications/in-app/in-app.html',
                controller: 'InAppNotificationsController',
                controllerAs: 'vm'
            })
            .state('account.push-notifications', {
                url: '/notifications/push',
                templateUrl: 'app/account/notifications/push/push.html',
                controller: 'PushNotificationsController',
                controllerAs: 'vm'
            })
            .state('account.sms-notifications', {
                url: '/notifications/sms',
                templateUrl: 'app/account/notifications/sms/sms.html',
                controller: 'SmsNotificationsController',
                controllerAs: 'vm'
            })
            .state('fleetmanagement', {
                url: '/fleetmanagement',
                template: '<ui-view/>',
                abstract: true
            })
            .state('fleetmanagement.listview', {
                url: '/listview',
                templateUrl: 'app/fleetmanagement/listview/listview.html',
                controller: 'ListviewController',
                controllerAs: 'vm'
            })
            .state('fleetmanagement.truckregistration', {
                url: '/trucks',
                templateUrl: 'app/trucks/trucks.html',
                controller: 'TrucksController',
                controllerAs: 'vm'
            })
            .state('fleetmanagement.liveview', {
                url: '/liveview',
                templateUrl: 'app/fleetmanagement/liveview/liveview.html',
                controller: 'LiveviewController',
                controllerAs: 'vm'
            })
            .state('fleetmanagement.schedule', {
                url: '/schedule',
                templateUrl: 'app/fleetmanagement/schedule/schedule.html',
                controller: 'ListviewController',
                controllerAs: 'vm'
            })
            .state('fleetmanagement.scheduledayview', {
                url: '/schedule-day-view',
                templateUrl: 'app/fleetmanagement/schedule-day-view/schedule-day-view.html',
                controller: 'ListviewController',
                controllerAs: 'vm',
                params: {
                    date: function ($stateParams) {
                        var date;
                        if($stateParams.date) {
                            date = new Date($stateParams.date);
                        } else {
                            date = new Date();
                        }
                        return date;
                    }
                }
            })
            .state('fleetmanagement.pickupreports', {
                url: '/pickupreports',
                params: {
                    after: '',
                    before: ''
                },
                templateUrl: 'app/fleetmanagement/pickupreports/pickupreports.html',
                controller: 'PickupReportsController',
                controllerAs: 'vm'
            })
            .state('fleetmanagement.pickupreport', {
                url: '/pickupreports/:id?after&before',
                templateUrl: 'app/fleetmanagement/pickupreports/pickupreport/pickupreport.html',
                controller: 'PickupReportController',
                controllerAs: 'vm'
            })
            .state('payment', {
                url: '/payment',
                templateUrl: 'app/components/payment/payment.html',
                controller: 'PaymentController',
                controllerAs: 'vm'
            });

        $urlRouterProvider.otherwise('/calendar');
    }

})();

(function () { 
 return angular.module("rsplCharityV2")
.constant("baseUrl", "https://main-service.production.resupply.tech")
.constant("imageBaseUrl", "https://production.resupply.media")
.constant("chatUrl", "https://chat-service.production.resupply.tech")
.constant("analyticsUrl", "https://analytics.resupply.tech")
.constant("env", "production")
.constant("apiVersion", "api20181219")
.constant("stripeKey", "pk_live_OVt06ALfONjyAFMuMhDW4BLu")
.constant("stripeClientId", "ca_966S0302Gqcp3BvIexYdbqgnmvAl0aXN")
.constant("socketBaseUrl", "wss://main-service.production.resupply.tech/cable?token=");
})();

(function () {
    'use strict';

    angular
        .module('rsplCharityV2')
        .config(config);

    /** @ngInject */
    function config($logProvider, $httpProvider, laddaProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
        $httpProvider.interceptors.push('httpInterceptor');
        laddaProvider.setOption({ /* optional */
            spinnerColor: '#bababa'
        });
    }

})();

angular.module("rsplCharityV2").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/account.html","<div class=manage-account><div class=\"container main\"><div class=rows><account-sidebar class=\"col-xs-12 col-md-5 col-lg-4 second-sidebar\" ng-scrollbars ng-scrollbars-config=accountSidebarCtrl.scrollConfig></account-sidebar><div class=\"col-xs-12 col-md-7 col-lg-8\" ng-scrollbars ng-scrollbars-config=vm.scrollConfig><ui-view></div></div></div></div>");
$templateCache.put("app/calendar/calendar.html","<div class=rspl-calendar><div class=requests-wrapper><donation-requests></donation-requests></div><div class=calendar-wrapper><!----------------------------------------- CALENDAR FILTERS START -----------------------------------------><div class=\"row filter\"><div class=form-date-wrapper><div class=form-datepicker ng-if=\"vm.timeType === \'daily\'\"><div ng-click=vm.previousDay()><i class=\"rspl-icon icon-shevron-left\"></i></div><div><span>{{vm.params.start_date | date: \"dd MMM\"}}</span></div><div ng-click=vm.nextDay()><i class=\"rspl-icon icon-shevron-right\"></i></div></div><div class=form-weekpicker ng-if=\"vm.timeType === \'weekly\'\"><div ng-click=vm.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.start_date | date : \"dd MMM\"}} - {{vm.params.end_date | date : \"dd MMM\"}}</div><div ng-click=vm.nextWeek()><i class=\"rspl-icon icon-shevron-right\"></i></div></div><div class=form-weekpicker ng-if=\"vm.timeType === \'monthly\'\"><div ng-click=vm.previousMonth()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.start_date | date : \"MMM\"}}</div><div ng-click=vm.nextMonth()><i class=\"rspl-icon icon-shevron-right\"></i></div></div><div class=form-daterange ng-if=\"vm.timeType === \'custom\'\"><div><input date-range-picker class=\"form-control date-picker\" type=text ng-model=vm.datePicker placeholder=\"dd MM - dd MM\" options=vm.dateRangeConfig></div></div></div><div><div class=selects><div class=hidden-md><span class=title>Filters</span></div><div><ui-select ng-model=vm.timeType class=rspl-select title=\"Time Type\" append-to-body=true ng-change=vm.timeTypeChanged()><ui-select-match class=text-capitalize>{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"o in vm.timeTypes | filter: $select.search\"><span ng-bind-html=o class=text-capitalize></span></ui-select-choices></ui-select></div><div><ui-select ng-model=vm.truck ng-change=vm.truckChanged(); class=rspl-select title=\"Select Truck\" append-to-body=true><ui-select-match placeholder=\"Select Truck\" class=text-capitalize allow-clear=true>{{$select.selected.model}}</ui-select-match><ui-select-choices repeat=\"o in vm.trucks | filter: $select.search\"><span ng-bind-html=o.model class=text-capitalize></span></ui-select-choices></ui-select></div></div></div><div class=buttons-wrapper><div class=buttons><a class=\"btn btn-primary\" uib-popover-template=vm.dynamicPopover.templateUrl popover-placement=bottom-right popover-trigger=\"\'outsideClick\'\" popover-class=view-type-options><i class=\"rspl-icon icon-view-settings\"></i> </a><a class=\"btn btn-primary\" ng-click=vm.print() ladda=vm.isLoadingPrintData><i class=\"rspl-icon icon-print\"></i> </a><a class=\"btn btn-primary hide-on-small-screen\" ng-click=vm.openExportModal()><i class=\"rspl-icon icon-export\"></i></a></div></div></div><!----------------------------------------- CALENDAR FILTERS END -----------------------------------------><div class=week-wrapper><div class=week-view ng-scrollbars ng-scrollbars-config=vm.scrollConfig><action-needed-donations></action-needed-donations><day-column ng-if=vm.scheduleTemplate ng-repeat=\"day in vm.dates\" day=day display=vm.viewType truck=vm.truck></day-column><div class=clearfix></div></div></div></div></div>");
$templateCache.put("app/calendar/moreOptions.html","<ul><li ng-click=\"vm.startConversation(vm.d, $event)\" class=option-item ng-class=\"{\'disabled\' : vm.d.manual}\"><i class=\"rspl-icon icon-chat\"></i> Chat</li><li ng-click=\"vm.openDonation(vm.d.id, true, $event)\" class=option-item><i class=\"rspl-icon icon-print\"></i> Print</li><li ng-click=\"vm.getTaxReceipt(vm.d, $event)\" class=option-item ng-class=\"{\'disabled\' : !vm.d.manual && vm.d.request.status !== \'completed\'}\"><i class=\"rspl-icon icon-tax\"></i> Tax Receipt</li></ul>");
$templateCache.put("app/calendar/moreOptionsActionsNeeded.html","<ul><li ng-click=\"vm.openModal(\'complete\', vm.d, $event)\" class=option-item>Completed</li><li ng-click=\"vm.openModal(\'cancel\', vm.d, $event)\" class=option-item>Report Issues</li></ul>");
$templateCache.put("app/calendar/viewType.html","<ul><li ng-click=\"vm.setViewType(\'small\')\" class=option-item ng-class=\"{\'active\': vm.viewType === \'small\'}\">Small Cards</li><li ng-click=\"vm.setViewType(\'large\')\" class=option-item ng-class=\"{\'active\': vm.viewType === \'large\'}\">Large Cards</li></ul>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"main dashboard\"><img src=\"/assets/images/Dashboard - preview.png\" alt=\"\"></div>");
$templateCache.put("app/login/login.html","<div class=signup-wrapper><div class=\"container main signup\"><div class=col-lg-6><div class=row><div class=col-lg-12><div class=account><h3>Giving Made Simple</h3><h1>Login to</h1><h1>ReSupply Donation portal</h1><form ng-submit=vm.login()><div class=\"form-group email-input\"><input type=email class=form-control placeholder=Email id=loginEmail ng-model=vm.username></div><div class=\"form-group pass-input\"><input type=password class=form-control placeholder=Password id=loginPassword ng-model=vm.password></div><div class=\"form-group clearfix\"><a target=_blank href=http://reset.charity.resupply.tech/ id=forgot-pass>Forgot password?</a> <a class=\"pull-right clickable\" ng-click=vm.openTaCmodal() id=terms>Terms and conditions</a></div><div class=submit-wrapper style=\"text-align: right; padding-top: 20px\"><button type=submit id=loginBtn class=\"btn btn-primary btn-block\" ladda=vm.isLoading>LOG IN</button></div></form><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div></div></div></div></div><div class=\"col-lg-6 image-container hidden-xs hidden-sm hidden-md\"><div class=image style=\"background-size: contain;background-image:url(\'/assets/images/back-gradient.jpg\')\"><div class=image style=\"background-size: contain; background-repeat:no-repeat; background-image:url(\'/assets/images/city_illustration.png\')\"></div></div></div></div></div><div class=activating-loader ng-if=vm.isActivating><img ng-src=assets/images/loader-white.gif alt=loading ng-if=!vm.showPasswordResetForm><h3 style=\"color: #4884b0\" ng-if=!vm.showPasswordResetForm>Please wait, setting up your account...</h3><div class=reset-form-wrapper ng-if=vm.showPasswordResetForm><div class=reset-logo-wrapper style=\"text-align: left; padding: 20px 0\"><img ng-src=assets/images/rspl-logo-2.png alt=resupply></div><p style=\"font-size: 18px; text-align: left; padding-bottom: 30px\">Fill in your new password and press the submit button in order to change your password.</p><form name=vm.passResetForm ng-submit=vm.resetPassword()><div class=form-group><label>New password</label><input type=password ng-model=vm.password class=form-control required></div><div class=form-group><label>Repeat password</label><input type=password ng-model=vm.password_rpt class=form-control required></div><button type=submit class=\"btn btn-primary btn-block\" ng-disabled=\"vm.passResetForm.$invalid || vm.password !== vm.password_rpt\">SUBMIT</button></form></div></div>");
$templateCache.put("app/trucks/trucks.html","<div class=trucks><div class=main><div class=\"container main\"><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div><div class=\"list-view row\"><div class=\"col-xs-12 col-sm-6 col-lg-4\"><div class=new-truck ng-if=!vm.showAdd ng-click=\"vm.showAdd = !vm.showAdd\"><i class=\"rspl-icon icon-plus\"></i> <span>Add truck</span></div><div class=truck ng-if=vm.showAdd ng-form=vm.new_truck><label for=add-image><img ngf-src=vm.newTruck.file> <i class=\"rspl-icon icon-add-image\"></i> <span>Add Image</span></label><input type=file id=add-image ngf-select ng-model=vm.newTruck.file ngf-multiple=false><div class=\"form-group col-xs-12\"><input class=form-control placeholder=\"Truck Name\" ng-model=vm.newTruck.model required></div><div class=\"form-group col-xs-6\"><input class=form-control placeholder=\"Licence Plate\" ng-model=vm.newTruck.licence_plate required></div><div class=\"form-group col-xs-6\"><ui-select ng-model=vm.newTruck._color class=\"rspl-select color-select\" title=Color append-to-body=true ng-change=\"\"><ui-select-match class=text-capitalize><div class=color-box style=background-color:{{$select.selected.code}}></div><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat=\"o in vm.colorOptions\"><div class=color-box style=background-color:{{o.code}}></div><span ng-bind-html=o.name></span></ui-select-choices></ui-select></div><div class=btn-group><div class=\"btn btn-default\" ng-click=vm.cancelAdd()>Cancel</div><div class=\"btn btn-default\" ng-click=vm.addTruck() ladda=vm.isAdding ng-disabled=\"!vm.new_truck.$valid || !vm.newTruck.file || vm.newTruck.file.$error || !vm.newTruck._color\">Save</div></div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-8\" ng-if=\"vm.isLoading || !vm.trucks || vm.trucks.length === 0\"><div class=truck><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-if=\"!vm.isLoading && (!vm.trucks || vm.trucks.length === 0)\" class=\"text-center no-items\">No trucks</p></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4\" ng-repeat=\"d in vm.trucks\" ng-if=!vm.isLoading><div class=truck ng-form=truck_{{$index}} name=vm.truck_{{$index}}><div class=add-image ngf-select ng-model=d.file ngf-multiple=false><img ngf-src=\"!d.file.$error && d.file\"> <img ng-if=\"!d.file || d.file.$error\" ng-src=\"{{vm.imageBaseUrl}}{{d.photo.url}}?w=360\"> <i class=\"rspl-icon icon-edit-image\"></i></div><div class=\"form-group col-xs-12\"><input class=form-control placeholder=\"Truck Name\" ng-model=d.model required></div><div class=\"form-group col-xs-6\"><input class=form-control placeholder=\"Licence Plate\" ng-model=d.licence_plate required></div><div class=\"form-group col-xs-6\"><ui-select ng-model=d._color class=\"rspl-select color-select\" title=Color append-to-body=true ng-change=\"\"><ui-select-match class=text-capitalize><div class=color-box style=background-color:{{$select.selected.code}}></div><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat=\"o in vm.colorOptions\"><div class=color-box style=background-color:{{o.code}}></div><span ng-bind-html=o.name></span></ui-select-choices></ui-select></div><div class=btn-group><div class=\"btn btn-default btn-block\" ng-click=\"vm.updateTruck(d, $index)\" ng-disabled=\"!vm.truck_{{$index}}.$dirty || !vm.truck_{{$index}}.$valid || (d.file && d.file.$error)\">Save</div></div></div></div></div></div><div class=\"pagination-wrapper text-center\" ng-if=\"!vm.isLoading && vm.pagination.totalItems > 1 && vm.pagination.totalItems > vm.pagination.itemsPerPage\"><ul uib-pagination total-items=vm.pagination.totalItems max-size=5 ng-model=vm.pagination.currentPage items-per-page=vm.pagination.itemsPerPage ng-change=vm.pageChanged() rotate=true force-ellipses=true class=pagination-sm template-url=app/components/ui-components/pagination.html></ul></div></div></div>");
$templateCache.put("app/account/account-sidebar/account-sidebar.html","<div class=second-sidebar><div class=chart><div><svg width=100 height=100 xmlns=http://www.w3.org/2000/svg><g><circle ng-if=\"accountSidebarCtrl.percentage > 0\" id=circle class=circle_animation r=45 cy=50 cx=50 stroke-width=10 stroke=#37cc5f fill=none ng-style=\"{ \'stroke-dashoffset\' : accountSidebarCtrl.percentageFill }\"></circle></g></svg> <span ng-if=\"accountSidebarCtrl.percentage > 0\">{{accountSidebarCtrl.percentage | number : 0}}%</span></div><div><label><span ng-if=\"accountSidebarCtrl.percentage < 100\">Almost </span>Completed</label><p ng-if=\"accountSidebarCtrl.percentage < 100\">Please complete your profile in order to start receiving donations.</p><p ng-if=\"accountSidebarCtrl.percentage === 100\">Great, you are ready to start receiving donations.</p></div></div><ul><li ui-sref=account.info ui-sref-active=active>Basic and Contact Information<div class=\"badge badge-error\" ng-show=\"accountSidebarCtrl.missing_fields_info > 0\"><p>{{accountSidebarCtrl.missing_fields_info}}</p></div></li><li ui-sref=account.logistics ui-sref-active=active>Logistics<div class=\"badge badge-error\" ng-show=\"accountSidebarCtrl.missing_fields_logistic > 0\"><p>{{accountSidebarCtrl.missing_fields_logistic}}</p></div></li><li ui-sref=account.schedule ui-sref-active=active>Daily Pickup Schedule<div class=\"badge badge-error\" ng-show=\"accountSidebarCtrl.missing_fields && accountSidebarCtrl.missing_fields.indexOf(\'schedule\') !== -1\"><p>!</p></div></li><!-- <li class=\"disabled\">Reviews</li>\n        <li class=\"disabled\">Live chat with Customer Success</li>\n        <li class=\"disabled\">Tutorial</li> --><li ui-sref=account.taxreceiptbuilder ui-sref-active=active>Tax Receipt Builder</li><!-- <li class=\"disabled\">FAQ’s</li>\n        <li class=\"disabled\">Terms of agreements</li>\n        <li class=\"disabled\">Payment information</li> --><li class=has-submenu ng-class=\"{\'active\' : false}\"><p>Notifications</p><ul class=submenu><li ui-sref=account.email-notifications ui-sref-active=active>Mail Notifications</li><li ui-sref=account.in-app-notifications ui-sref-active=active>In App Notifications</li><li ui-sref=account.push-notifications ui-sref-active=active>Push Notifications</li><li ui-sref=account.sms-notifications ui-sref-active=active>SMS Notifications</li><li ui-sref=account.notificationpref ui-sref-active=active>Preferences</li></ul></li></ul></div>");
$templateCache.put("app/account/info/info.html","<div class=basic-info><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><form ng-submit=vm.editProfile() ng-if=!vm.isLoading name=vm.infoForm><h3>Basic Information</h3><div class=\"row image-wrapper\"><div class=\"col-xs-12 col-lg-6 image text-center\"><div class=image-holder><img ng-if=vm.userData.photo.file class=\"upload-image profile-photo\" ngf-src=vm.userData.photo.file> <img ng-if=\"(!vm.imageIsSelected && vm.userData.photo.url) || (errorFileCover && vm.userData.photo.url)\" class=\"upload-image profile-photo\" ng-src={{vm.imageBaseUrl}}/{{vm.userData.photo.url}}> <img ng-if=\"(!vm.imageIsSelected && !vm.userData.photo.url) || (errorFileCover && !vm.userData.photo.url)\" ng-src=/assets/images/charity-img@3x.png alt=photo></div><div class=\"btn btn-primary btn-block fileUpload\" ngf-change=vm.imageSelected() ngf-select ng-model=vm.userData.photo.file name=file ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=5MB ngf-model-invalid=errorFileCover><span>Change cover image</span> <i class=\"badge badge-error\" ng-if=\"vm.userData.missing_fields.indexOf(\'picture\') !== -1 && !vm.imageIsSelected\">!</i></div><i class=size-error ng-show=errorFileCover>File too large {{errorFileCover.size / 1000000|number:1}}MB: max 5MB</i></div><div class=\"col-xs-12 col-lg-6 image text-center\"><div class=image-holder><img ng-if=\"!vm.userData.logo_url && vm.userData.logo.file\" class=\"upload-image profile-photo\" ngf-src=vm.userData.logo.file> <img ng-if=vm.userData.logo_url class=\"upload-image profile-photo\" ng-src={{vm.userData.logo_url}}> <img ng-if=\"!vm.userData.logo_url && !vm.userData.logo.file\" ng-src=/assets/images/charity-img@3x.png alt=photo></div><label class=\"btn btn-primary btn-block fileUpload\" for=logo-upload><input type=file class=\"btn btn-primary btn-block fileUpload\" ngf-change=vm.logoSelected() ngf-select ng-model=vm.userData.logo.file name=file ngf-pattern=\"\'image/*\'\" id=logo-upload style=\"display: none\" ngf-accept=\"\'image/*\'\" ngf-max-size=1MB ngf-model-invalid=errorFile> <span>Change logo image</span></label><i class=size-error ng-show=errorFile>File too large {{errorFile.size / 1000000|number:1}}MB: max 1MB</i></div></div><div class=row><div class=\"form-group col-xs-6\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'name\') !== -1 && !vm.userData.name}\"><label>Charity name</label><input type=text class=form-control ng-model=vm.userData.name></div></div><div class=row><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'address\') !== -1 && !vm.userData.address}\"><label>Address</label><input type=text class=form-control ng-model=vm.userData.address></div><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'city\') !== -1 && !vm.userData.city}\"><label>City</label><input type=text class=form-control ng-model=vm.userData.city></div><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'zip\') !== -1 && !vm.userData.zip}\"><label>ZIP</label><input type=text ng-minlength=5 ng-maxlength=6 class=form-control ng-model=vm.userData.zip></div><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'state\') !== -1 && !vm.userData.state}\"><label>State</label><input type=text class=form-control ng-model=vm.userData.state></div></div><h3>Contact Information</h3><div class=row><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'primary_contact_first_name\') !== -1 && !vm.userData.primary_contact_first_name}\"><label>Main Contact First name</label><input type=text class=form-control ng-model=vm.userData.primary_contact_first_name></div><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'primary_contact_last_name\') !== -1 && !vm.userData.primary_contact_last_name}\"><label>Main Contact Last name</label><input type=text class=form-control ng-model=vm.userData.primary_contact_last_name></div><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'primary_phone_number\') !== -1 && !vm.userData.primary_phone_number}\"><label>Pickup Management Phone Number</label><input type=text ng-maxlength=13 ng-minlength=9 class=form-control ng-model=vm.userData.primary_phone_number></div><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'primary_email\') !== -1 && !vm.userData.primary_email}\"><label>Email address</label><input type=email class=form-control ng-model=vm.userData.primary_email></div><div class=\"col-xs-12 col-lg-6 form-group\"><label>Secondary Email address</label><input type=email class=form-control ng-model=vm.userData.secondary_email></div><div class=\"col-xs-12 col-lg-6 form-group\" ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'invoicing_contact\') !== -1 && !vm.userData.invoicing_contact}\"><label>Invoicing contact Email address</label><input type=email class=form-control ng-model=vm.userData.invoicing_contact></div></div><div class=\"row submit-wrapper\"><div class=col-xs-12><button type=submit ladda=vm.isSubmitting class=\"btn btn-primary pull-left\">Save</button></div></div></form></div><div class=alerts><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/account/logistics/logistics.html","<div class=basic-info><div ng-if=\"vm.loaded < 3\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><form ng-submit=vm.editProfile() ng-if=\"vm.loaded === 3\" name=vm.logisticsForm><h3>Logistic</h3><div class=row><div class=col-xs-12><div class=form-group><label>Restricted items</label><input type=text class=form-control placeholder=\"eg. Shoes\" ng-model=vm.userData.not_in_demand_items></div></div><div class=col-xs-12><div class=form-group><label>Select categories of items you are interested in receiving</label><ul class=item-types><li ng-class=\"{\'selected\' : itemType.selected}\" ng-repeat=\"itemType in vm.itemTypes\" ng-click=\"itemType.selected = !itemType.selected\"><img ng-src=assets/images/ic_{{itemType.name}}.svg alt=\"\"><p>{{itemType.name}}</p></li></ul></div></div><div class=col-xs-12><div class=form-group><label>High demand items</label><input type=text class=form-control placeholder=\"eg. Shoes\" ng-model=vm.userData.high_in_demand_items></div></div><div class=col-xs-12><div class=form-group ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'cause\') !== -1 && vm.selectedCauses === 0}\"><label>Causes you support</label><div class=causes><div class=mg-checkbox ng-repeat=\"cause in vm.causes\"><input type=checkbox value={{cause}} ng-checked=cause.selected><label ng-class=\"{\'selected\': cause.selected}\" ng-click=vm.selectCause(cause)></label><span>{{cause.name}}</span></div></div></div></div><div class=col-xs-12><div class=form-group ng-class=\"{\'missing\': vm.userData.missing_fields.indexOf(\'tax_id\') !== -1 && !vm.userData.tax_id}\"><label>Tax ID</label><input type=text class=form-control ng-model=vm.userData.tax_id></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>Mission</label><textarea type=text placeholder=\"Eg. {{vm.userData.name}} is on a mission to protect fish and game lands across the lowland coastal regions.\" class=form-control ng-model=vm.userData.mission></textarea></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>Pickup Process Note</label><textarea type=text placeholder=\"Eg. We can enter your home to pick up used goods.\" class=form-control ng-model=vm.userData.pickup_process_note></textarea></div></div><div class=col-xs-12><div class=form-group><div class=causes><label class=btn-block>Select photo options</label><div class=mg-checkbox><input type=checkbox value={{vm.userData.demands_photos}} ng-checked=vm.userData.demands_photos><label ng-class=\"{\'selected\': vm.userData.demands_photos}\" ng-click=\"vm.userData.demands_photos = !vm.userData.demands_photos\"></label><span>Require pictures in your online scheduling form?</span></div></div></div></div></div><div class=\"row submit-wrapper\"><div class=col-xs-12><button type=submit ladda=vm.isSubmitting class=\"btn btn-primary pull-left\">Save</button></div></div></form></div><div class=alerts><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/account/notifications/notification-pref.html","<div class=notification-pref><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><div ng-if=!vm.isLoading><div class=preferences-wrapper><div class=preferences-group><table><thead><tr><th>Donations</th><th><img ng-src=assets/images/ic_sms.svg></th><th><img ng-src=assets/images/ic_email.svg></th><th><img ng-src=assets/images/ic_web.svg></th></tr></thead><tbody><tr><td>All from this category</td><td><div class=mg-checkbox><input type=checkbox ng-model=vm.allSmsActive ng-checked=vm.allSmsActive><label ng-class=\"{\'selected\': vm.allSmsActive}\" ng-click=vm.activateAllSms()></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=vm.allEmailActive ng-checked=vm.allEmailActive><label ng-class=\"{\'selected\': vm.allEmailActive}\" ng-click=vm.activateAllEmail()></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=true><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td></tr><tr ng-repeat=\"pref in vm.donationsPrefs.preferences | orderBy : \'alert_subtype\'\"><td style=\"text-transform: capitalize\">{{pref.alert_subtype.split(\'_\').join(\' \')}}</td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.sms_alert ng-checked=pref.sms_alert><label ng-class=\"{\'selected\': pref.sms_alert, \'greyed\': pref.alert_subtype !== \'donations_confirmation_summary\'}\" ng-click=vm.tglSmsNotification(pref)></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.email_alert ng-checked=pref.email_alert><label ng-class=\"{\'selected\': pref.email_alert}\" ng-click=vm.tglEmailNotification(pref)></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=true><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td></tr><tr ng-repeat=\"pref in vm.donationsPrefsAdditional\"><td style=\"text-transform: capitalize\">{{pref.alert_subtype.split(\'_\').join(\' \')}}</td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.sms_alert ng-checked=pref.sms_alert><label class=greyed ng-class=\"{\'selected\': pref.sms_alert, \'greyed\': pref.alert_subtype !== \'donations_confirmation_summary\'}\" ng-click=vm.tglSmsNotification(pref)></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.email_alert ng-checked=true><label class=greyed ng-class=\"{\'selected\': pref.email_alert}\" ng-click=vm.tglEmailNotification(pref)></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=true><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td></tr></tbody></table></div><div class=preferences-group><table><thead><tr><th>Pickups</th><th><img ng-src=assets/images/ic_sms.svg></th><th><img ng-src=assets/images/ic_email.svg></th><th><img ng-src=assets/images/ic_web.svg></th></tr></thead><tbody><tr><td>All from this group</td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.pickupsPrefs.allSmsActive><label class=greyed ng-class=\"{\'selected\': vm.pickupsPrefs.allSmsActive}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.pickupsPrefs.allEmailActive><label class=greyed ng-class=\"{\'selected\': vm.pickupsPrefs.allEmailActive}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.pickupsPrefs.allWebActive><label class=greyed ng-class=\"{\'selected\': vm.pickupsPrefs.allWebActive}\"></label></div></td></tr><tr ng-repeat=\"pref in vm.pickupsPrefs.preferences\"><td>{{pref.prefName}}</td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.sms ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.email ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.we ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td></tr></tbody></table></div><div class=preferences-group><table><thead><tr><th>Messages</th><th><img ng-src=assets/images/ic_sms.svg></th><th><img ng-src=assets/images/ic_email.svg></th><th><img ng-src=assets/images/ic_web.svg></th></tr></thead><tbody><tr><td>All from this group</td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.messagesPrefs.allSmsActive><label class=greyed ng-class=\"{\'selected\': vm.messagesPrefs.allSmsActive}\" ng-click=vm.activateAllMessagesPrefsSms()></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.messagesPrefs.allEmailActive><label class=greyed ng-class=\"{\'selected\': vm.messagesPrefs.allEmailActive}\" ng-click=vm.activateAllMessagesPrefsEmail()></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.messagesPrefs.allWebActive><label class=greyed ng-class=\"{\'selected\': vm.messagesPrefs.allWebActive}\" ng-click=vm.activateAllMessagesPrefsWeb()></label></div></td></tr><tr ng-repeat=\"pref in vm.messagesPrefs.preferences\"><td>{{pref.prefName}}</td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.sms ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.email ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.web ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td></tr></tbody></table></div><div class=preferences-group><table><thead><tr><th>From driver</th><th><img ng-src=assets/images/ic_sms.svg></th><th><img ng-src=assets/images/ic_email.svg></th><th><img ng-src=assets/images/ic_web.svg></th></tr></thead><tbody><tr><td>All from this group</td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.driverPrefs.allSmsActive><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.driverPrefs.allEmailActive><label class=greyed ng-class=\"{\'selected\': vm.driverPrefs.allEmailActive}\" ng-click=vm.activateAllDriverPrefsEmail()></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-checked=vm.driverPrefs.allWebActive><label class=greyed ng-class=\"{\'selected\': vm.driverPrefs.allWebActive}\" ng-click=vm.activateAllDriverPrefsWeb()></label></div></td></tr><tr ng-repeat=\"pref in vm.driverPrefs.preferences\"><td>{{pref.prefName}}</td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.sms ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.email ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td><td><div class=mg-checkbox><input type=checkbox ng-model=pref.web ng-checked=true ng-change=vm.checkAllGroups()><label class=greyed ng-class=\"{\'selected\': true}\"></label></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/account/reviews/reviews.html","<div class=reviews><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><div ng-if=!vm.isLoading><h3>Average rating</h3><ng-rate-it ng-model=vm.average read-only=true></ng-rate-it><h3>Donor Reviews</h3><p class=no-reviews ng-if=\"vm.ratings.length === 0\">There are no reviews at the moment</p><div class=\"row review-card\" ng-repeat=\"rating in vm.ratings\"><div class=col-xs-12><div class=pull-left><ng-rate-it ng-model=rating.value read-only=true></ng-rate-it></div><div class=pull-right><p class=name>{{rating.user.first_name}} {{rating.user.last_name}}</p><span class=date>{{rating.date | date: \'dd MMM yyyy\'}}</span></div></div><div class=col-xs-12><h3 class=title>Great</h3></div><div class=col-xs-12><div class=comment><span>{{rating.comment}}</span></div></div></div></div></div>");
$templateCache.put("app/account/schedule/schedule.html","<div class=schedule><div class=\"change-tab clearfix\"><div class=pull-left><label ng-class=\"{\'active\': vm.tab === \'default\'}\"><span>Default Weekly Schedule</span> <input ng-model=vm.tab type=radio value=default></label></div><div class=pull-left><label ng-class=\"{\'active\': vm.tab === \'exceptions\'}\"><span>Schedule Exceptions</span> <input ng-model=vm.tab type=radio value=exceptions></label></div></div><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><div ng-if=\"!vm.isLoading && vm.tab === \'default\'\"><h3>Daily Pickup Schedule</h3><p ng-if=\"!vm.scheduleTemplate || vm.scheduleTemplate.length === 0\">Please populate Daily Pickup Schedule, a lot of features depend on it!</p><div ng-repeat=\"item in vm.scheduleTemplate | orderBy: \'order\' \" class=\"row one-day\"><div class=\"col-xs-12 col-lg-12\"><label>{{item.date}}</label><div class=row><div class=col-xs-2><p><span>AM</span> - Pickups</p><input class=\"form-control pickups-count am\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=item.am></div><div class=col-xs-2><p><span>PM</span> - Pickups</p><input class=\"form-control pickups-count\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=item.pm></div></div><div><p>ZIP codes for pickup area</p><tags-input ng-model=item.zips add-on-paste=true on-tag-added=\"vm.tagAdded($tag, item)\"><auto-complete source=vm.loadTags($query)></auto-complete></tags-input></div></div></div><div class=row ng-if=\"vm.scheduleTemplate && vm.scheduleTemplate.length !== 0\"><div class=col-xs-12><button class=\"btn btn-primary\" ng-click=vm.updateScheduleTemplate() ladda=vm.isUpdating>Save</button></div></div><hr><form ng-submit=vm.addNewSchedulteTemplate() ng-if=\"vm.scheduleTemplate.length < 7\" class=\"row one-day\"><div class=\"col-xs-12 col-lg-12\"><select ng-model=vm.newSchedule.date class=form-control style=\"height: 46px\"><option value=\"\">Select Day</option><option ng-repeat=\"date in vm.newDates\" value={{date}}>{{date}}</option></select><div class=row><div class=col-xs-2><p><span>AM</span> - Pickups</p><input class=\"form-control pickups-count am\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=vm.newSchedule.am></div><div class=col-xs-2><p><span>PM</span> - Pickups</p><input class=\"form-control pickups-count\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=vm.newSchedule.pm></div></div><div><p>ZIP codes for pickup area</p><tags-input ng-model=vm.newSchedule.zips add-on-paste=true on-tag-added=vm.tagAdded($tag)><auto-complete source=vm.loadTags($query)></auto-complete></tags-input></div></div><div class=col-xs-12><button class=\"btn btn-primary\" ladda=vm.isAdding type=submit ng-disabled=!vm.newSchedule>+ Add Day</button></div></form></div><div class=exceptions-wrapper ng-if=\"!vm.isLoading && vm.tab === \'exceptions\'\"><p class=description>Exceptions are made for the purpose of altering your default schedule for specific dates (e.g. truck broke down and can\'t pick up this Wednesday).</p><div class=exceptions><div class=add-exception ng-if=!vm.exceptions.length><p class=title>Looks like you don’t have any exceptions set up yet, would you like to add one?</p><button class=\"btn btn-primary\" ng-click=vm.addException()>Add exception</button></div><div ng-repeat=\"item in vm.exceptions\" class=\"exception row one-day\"><div class=\"col-xs-12 col-lg-12\"><i ng-click=vm.openDeleteExceptionPrompt(item) class=\"rspl-icon icon-delete\"></i><label ng-if=item.date class=datepicker ng-class=\"{\'disabled\' : item.id}\" ng-click=\"item.datepickerOpen = true;\"><img src=assets/images/calendar.png alt=\"\"> {{item.date | date : \'yyyy-MM-dd\'}}</label><label ng-if=!item.date class=datepicker ng-class=\"{\'disabled\' : item.id}\" ng-click=\"item.datepickerOpen = true;\"><img src=assets/images/calendar.png alt=\"\"> Select Date</label><input style=\"display: none\" type=text uib-datepicker-popup={{format}} ng-model=item.date class=\"form-control well well-sm datepicker\" placeholder=\"Start date\" is-open=item.datepickerOpen show-button-bar=false required><div class=row><div class=col-xs-2><p><span>AM</span> - Pickups</p><input class=\"form-control pickups-count am\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=item.am></div><div class=col-xs-2><p><span>PM</span> - Pickups</p><input class=\"form-control pickups-count\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=item.pm></div></div><div><p>ZIP codes for pickup area</p><tags-input ng-model=item.zips add-on-paste=true on-tag-added=\"vm.tagAdded($tag, item)\"><auto-complete source=vm.loadTags($query)></auto-complete></tags-input></div></div></div></div><div class=actions><div class=row><div class=col-xs-6><p ng-click=vm.addException()>Add another exception</p></div><div class=\"col-xs-6 clearfix\"><button class=\"btn btn-primary pull-right\" ng-click=vm.saveExceptions()>Save</button> <button class=\"btn btn-default pull-right\">Cancel</button></div></div></div></div></div><div class=alerts><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/account/tax-receipt-builder/tax-receipt-builder.html","<div class=tax-receipt-builder><h3>Tax Receipt Builder</h3><div class=\"builder clearfix\"><div class=\"build pull-left\"><div class=section><p class=title>Logo</p><div class=\"uploaded-img-preview text-center\"><div ng-if=\"!vm.imageIsSelected && !vm.receiptData.photo.file && !vm.receiptData.photo.url\" class=upload-img-placeholder><img ng-src=assets/images/upload-img-placeholder.png alt=\"\"></div><div ng-if=\"(!vm.imageIsSelected && vm.receiptData.photo) || errorFileLogo\" class=image-wrapper><img class=uploaded-img ng-src={{vm.receiptData.photo.url}} alt=\"\"></div><div ng-if=\"vm.imageIsSelected && vm.receiptData.photo.file\" class=image-wrapper><img class=uploaded-img ngf-src=vm.receiptData.photo.file alt=\"\"></div></div><i class=size-error style=\"color: #ff334e\" ng-show=errorFileLogo>File too large {{errorFileLogo.size / 1000000|number:1}}MB: max 5MB</i> <button class=\"btn btn-primary btn-block text-center upload-btn\" ngf-select ngf-change=vm.imageSelected() name=file ng-model=vm.receiptData.photo.file ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=5MB ngf-model-invalid=errorFileLogo>Upload Logo</button><div class=notes><p class=note>Acceptable file types are .svg, .jpg, .gif or .png files up to 5MB in size.</p></div></div><div class=section><p class=title>Text Color</p><div class=\"color-swatch new\" colorpicker=hex colorpicker-is-open=vm.isOpenColorPicker ng-model=vm.receiptData.tc_tint><div class=\"pull-left color-label\" ng-style=\"{\'background-color\': vm.receiptData.tc_tint}\"></div><div class=color-value>{{vm.receiptData.tc_tint}}</div><div class=\"pull-right expand-control\"><i class=\"rspl-icon icon-shevron-down-small\"></i></div></div></div><div class=section><p class=\"title smaller\">Disclaimer & Notes</p><textarea maxlength=1000 ng-trim=false required ng-model=vm.receiptData.tc_note cols=30 rows=10></textarea><div class=notes><p class=note ng-style=\"{\'color\': 1000 - vm.receiptData.tc_note.length <= 10 ? \'#ef3f4b\' : \'none\'}\">{{vm.receiptData.tc_note.length ? 1000 - vm.receiptData.tc_note.length : 1000}} characters left</p><p class=note>Press <b>ENTER</b> to add a line break</p></div></div></div><div class=\"preview pull-right\"><div class=section><p class=title>Preview</p><div class=tax-receipt><div class=logo-container><div class=uploaded-logo ng-class=\"{\'no-border\' : vm.imageIsSelected || vm.receiptData.photo.url}\"><span ng-if=\"!vm.imageIsSelected || !vm.receiptData.photo.file\" ng-hide=vm.receiptData.photo.url class=upload-logo-placeholder>LOGO</span> <img ng-if=\"vm.imageIsSelected && vm.receiptData.photo.file\" ngf-src=vm.receiptData.photo.file alt=\"\"> <img ng-if=\"!vm.imageIsSelected && vm.receiptData.photo.url\" ng-src={{vm.receiptData.photo.url}} alt=\"\"></div></div><p class=hard>Receipt number: #332</p><p class=\"soft large\" ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Thank you for your donation</p><p class=soft>Below is your receipt</p><div class=receipt-data><div class=row><div class=col-xs-3><p class=hard ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Donor name:</p><p>John Doe</p></div><div class=col-xs-6><p class=hard ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Charity name:</p><p>{{vm.charityName}}</p></div><div class=\"col-xs-3 text-right\"><p class=hard ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Date Issued</p><p>{{vm.today | date : \'dd. MMM yyyy\'}}</p></div></div><div class=row><div class=col-xs-4><p class=hard ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Address:</p><p>1145 Peachtree St NE Atlanta, GA 77236</p></div><div class=\"col-xs-3 col-xs-offset-5 text-right\"><p class=hard ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Tax Id Number</p><p>58-3357646</p></div></div></div><div class=receipt-value><div class=estimated><div class=row><div class=col-xs-6><p class=hard ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Donation list</p><p>DONATION ITEM</p></div><div class=\"col-xs-6 text-right\"><p class=hard ng-style=\"{\'color\': vm.receiptData.tc_tint}\">Estimated Value</p><p>VALUE</p></div></div></div><div class=\"total text-right\"><p class=soft>Total</p><p class=\"soft mid\" ng-style=\"{\'color\': vm.receiptData.tc_tint}\">$0.00</p></div></div><div class=notes><p class=note ng-bind-html=vm.receiptData.tc_note></p></div><div class=\"logo text-right\"><span>Powered by </span><img ng-src=assets/images/rspl-logo-2.png alt=Resupply class=mCS_img_loaded src=assets/images/rspl-logo-2.png></div></div></div></div></div><button class=\"btn btn-primary pull-right\" ladda=vm.isSubmitting ng-click=vm.saveTaxReceipt()>Save Tax Receipt</button></div><div class=alerts><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/calendar/exception-modal/exception-modal.html","<div class=exception-modal><div class=modal-header><h4 class=title>{{excCtrl.process.charAt(0).toUpperCase() + excCtrl.process.substr(1)}} exception for {{excCtrl.date | date: \'dd MMM yyyy\'}}</h4><div class=close-btn ng-click=excCtrl.close()></div></div><div class=inputs><div class=pickups-row><div class=left><p><span>AM</span> - Pickups</p><input class=\"form-control pickups-count am\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=excCtrl.exception.am></div><div class=right><p><span>PM</span> - Pickups</p><input class=\"form-control pickups-count\" type=number min=0 ng-maxlength=4 placeholder=0 ng-model=excCtrl.exception.pm></div></div><div><p>ZIP codes for pickup area</p><tags-input ng-model=excCtrl.exception.zips add-on-paste=true key-property=id display-property=code on-tag-added=\"excCtrl.tagAdded($tag, item)\"><auto-complete source=excCtrl.loadTags($query)></auto-complete></tags-input></div></div><div class=buttons><button class=\"btn btn-primary pull-left\" ng-if=\"excCtrl.process === \'update\'\" ng-click=excCtrl.useDefault()>Use default</button> <button class=\"btn btn-primary pull-right\" ng-click=excCtrl.saveException() ng-class=\"{\'disabled\': !excCtrl.exception.zips.length || excCtrl.exception.am === null  || excCtrl.exception.pm === null}\">Save exception</button></div></div>");
$templateCache.put("app/calendar/export-modal/export-modal.html","<div class=exception-modal><div class=modal-header><h4 class=title>Export donations to CSV file</h4><div class=close-btn ng-click=exportCtrl.close()></div></div><div class=modal-body><p class=export-status>{{exportCtrl.donationsToExport ? \'Donations ready!\' : \'Please wait while we collect your donations...\'}}</p><csv-download ng-if=\"exportCtrl.donationsToExport.length > 0\" ng-click=exportCtrl.close() label=\"Download <i class=\'rspl-icon icon-export\'></i>\" input-array=exportCtrl.donationsToExport filename=database.csv class=\"btn btn-primary\"></csv-download></div></div>");
$templateCache.put("app/components/action-needed-donations/action-needed-donations.html","<div class=\"day-view actions-needed\"><div class=title>Actions needed</div><div class=donations ng-scrollbars><div ng-if=\"vm.isLoadingActionNeeded || !vm.actionNeededDonations || vm.actionNeededDonations.length === 0\"><div ng-show=vm.isLoadingActionNeeded class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-show=\"!vm.isLoadingActionNeeded && (!vm.actionNeededDonations || vm.actionNeededDonations.length === 0)\" class=\"text-center no-items\">No actions needed</p></div><donation-card ng-if=!vm.isLoadingActionNeeded donation=d card-type=calendar-actions-needed display=vm.viewType ng-repeat=\"d in vm.actionNeededDonations\"></donation-card></div></div>");
$templateCache.put("app/components/day-column/day-column.html","<div class=day-view style=\"position: relative\"><div class=title><span>{{vm.day.date | date : \"EEE\"}}</span> <span class=tgl-switch ng-click=\"vm.toggleDay(vm.day.date, vm.day.disabled)\" ng-class=\"{\'disabled\' : vm.day.disabled}\"><label class=tgl-label>{{ vm.day.disabled ? \'CLOSED\' : \'OPEN\' }}</label><div class=indicator></div></span><span class=column-date>{{vm.day.date | date : \"dd MMM\"}}</span></div><div class=\"donations day-column\" ng-scrollbars><div ng-show=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-if=vm.awaitingUserResponseDonations.length class=waiting-count-badge>Date change - Waiting for response <b>{{vm.awaitingUserResponseDonations.length}} spot reserved</b> <b class=tgl-waiting-visibility ng-click=\"vm.showAwaitingDonations = !vm.showAwaitingDonations\"><span ng-if=vm.showAwaitingDonations>Hide</span><span ng-if=!vm.showAwaitingDonations>Show</span> Waiting Donations</b></p><donation-card ng-if=!vm.isLoading donation=d card-type=calendar display=vm.display ng-repeat=\"d in vm.donations\" ng-hide=\"!vm.showAwaitingDonations && d.request.status === \'awaiting_user_response\'\"></donation-card><p ng-if=\"!vm.isLoading && (vm.params.total_pages > vm.params.current_page)\" class=load-more-btn ng-click=vm.loadMoreDonations()>Load more</p><p class=\"empty-placeholder text-center\" ng-if=\"vm.donations.length === 0 && !vm.isLoading\">Nothing scheduled for this day</p><div class=new-donation ng-click=vm.openNewDonationPrompt(vm.day.date)><i class=\"rspl-icon icon-plus\"></i> <span>Add donation</span></div></div></div>");
$templateCache.put("app/components/donation-card/donation-card.html","<div class=donation ng-class=\"{\'awaiting\': vm.d.request.status === \'awaiting_user_response\',\'db-card\': vm.cardType === \'db\', \'hub-card\': vm.cardType === \'hub\', \'calendar-card\': vm.cardType === \'calendar\', \'calendar-actions-needed-card\': vm.cardType === \'calendar-actions-needed\', \'small\': vm.display === \'small\'}\" ng-click=\"vm.openDonation(vm.d, false)\" ng-style=\"vm.cardType === \'calendar\' && {\'margin-bottom\' : \'20px\'}\"><div class=slick-replace ng-style=\"{\'background\': \'url(/assets/images/charity-img@2x.png) center center no-repeat\', \'background-size\': \'cover\'}\" ng-if=\"vm.d.photos.length === 0 && vm.display !== \'small\'\"></div><slick class=slider-for settings=vm.slickConfig ng-if=\"vm.d.photos.length > 0 && vm.display !== \'small\'\" infinite=true slides-to-show=1 slides-to-scroll=1 ng-click=$event.stopPropagation()><div class=slick-item ng-repeat=\"photo in vm.d.photos\" ng-if=!!photo.url><img class=image ng-src={{photo.fullPath}} ng-click=\"vm.openDonation(vm.d, false)\"></div><div class=slick-item ng-if=!vm.d.photos[0].url ng-click=\"vm.openDonation(vm.d, false)\"><div class=image style=\"background-image: url(\'/assets/images/charity-img@2x.png\')\"></div></div></slick><!--<span ng-if=\"vm.cardType === \'calendar-actions-needed\'\" class=\"expires badge badge-error text-capitalize status\"--><!--ng-bind=\"vm.d.expiration.daysBefore()\">--><!--</span>--> <span ng-if=\"vm.cardType === \'db\'\" class=\"badge text-capitalize status\" ng-class=\"{\'badge-primary\' : vm.d.request.status === \'completed\', \'badge-success\' : vm.d.request.status === \'accepted\', \'badge-error\' : vm.d.request.status === \'canceled\', \'badge-orange\' : vm.d.request.status === \'rejected\', \'badge-warning\' : vm.d.request.status === \'pending\' || vm.d.request.status === \'in_pool\'}\">{{vm.d.request.status === \'in_pool\' ? \'In Pool\' : vm.d.request.status === \'awaiting_user_response\' ? \'Waiting for response\': vm.d.request.status}}</span> <span class=truck ng-if=\"vm.display === \'small\' && vm.d.request.truck && vm.cardType !== \'calendar-actions-needed\'\" style=\"background: {{vm.d.request.truck.color}}\">{{vm.d.request.truck.model}}</span><div ng-if=\"vm.cardType === \'hub\'\"><span class=\"expires badge text-capitalize status badge-error\" ng-if=\"vm.d.expiration === 0\">Expired</span><timer ng-if=\"vm.d.expiration !== 0\" class=\"expires badge text-capitalize status\" ng-class=\"{\'badge-default\' : !vm.d.expiration_soon, \'badge-error\' : vm.d.expiration_soon}\" end-time=vm.d.expiration>Expires in {{days * 24 + hours}}:{{minutes&lt;10?\"0\"+minutes:minutes}}:{{seconds&lt;10?\"0\"+seconds:seconds}}</timer><span ng-if=!vm.d.seen class=\"badge badge-error new-hub-item-badge\">New in hub</span></div><div class=data><span class=type ng-if=\"vm.display !== \'small\'\"><span ng-repeat=\"c in vm.d.content track by $index\" class=text-capitalize>{{::c.item_type}}<span ng-if=\"$index < vm.d.content.length - 1\">,</span></span></span><p class=data-top ng-if=\"vm.cardType !== \'hub\'\"><span class=name>{{vm.d.request.donor.first_name ? vm.d.request.donor.first_name : \'/\'}} {{::vm.d.request.donor.last_name}}</span> <span ng-if=\"vm.cardType === \'calendar\'\" class=organization>{{vm.d.request.donor.organization}}</span> <span class=phone>{{vm.d.phone ? vm.d.phone : \'/\'}}</span> <span class=email><a ng-click=$event.stopPropagation() ng-class=\"{ \'not-clickable\': !vm.d.request.donor.email }\" href=mailto:{{vm.d.request.donor.email}} target=_blank>{{vm.d.request.donor.email ? vm.d.request.donor.email : \'/\'}}</a></span></p><div ng-if=\"vm.cardType === \'db\'\"><span class=label>Instructions for driver</span> <span class=\"instructions multi-line\">{{vm.d.special_instructions ? vm.d.special_instructions : \'/\'}}</span></div><div class=date ng-if=\"vm.cardType !== \'calendar-actions-needed\' && vm.display !== \'small\'\"><i class=\"rspl-icon icon-lock\" ng-if=!vm.d.manual></i> <span>{{vm.d.request.status === \'awaiting_user_response\' ? vm.d.initialRequest.date : vm.d.request.date | date: \"dd MMM\"}} | <span class=text-uppercase>{{vm.d.request.status === \'awaiting_user_response\' ? vm.d.initialRequest.part_of_day : vm.d.request.part_of_day}}</span></span> <button class=\"btn btn-primary pull-right hidden\" ng-if=\"vm.d.request.status === \'accepted\' || vm.d.request.status === \'pending\'\" ng-click=\"vm.openChangeDatePrompt(vm.d, $event)\">Change date</button></div><div ng-if=\"vm.display !== \'small\'\" class=data-bottom><span class=address>{{::vm.d.address}}</span><br><span class=submission-date>Submitted: {{::vm.d.submission_date}}</span><div class=zip-full><span class=zip-label>ZIP:</span><span class=zip> {{::vm.d.zip}}</span></div></div><span ng-if=\"vm.display === \'small\'\" class=text-uppercase>{{vm.d.request.status === \'awaiting_user_response\' ? vm.d.initialRequest.part_of_day : vm.d.request.part_of_day}} | <b>{{::vm.d.zip}}</b></span><div class=\"btn more-options\" ng-if=\"vm.display === \'small\' && vm.cardType !== \'calendar-actions-needed\'\" uib-popover-template=vm.moreOptions.templateUrl popover-placement=bottom-right popover-trigger=\"\'outsideClick\'\" popover-class=more-options-popup ng-click=$event.stopPropagation()><i class=\"rspl-icon icon-more\"></i></div><div class=\"btn more-options\" ng-if=\"vm.display === \'small\' && vm.cardType === \'calendar-actions-needed\'\" uib-popover-template=vm.moreOptionsActionsNeeded.templateUrl popover-placement=bottom-right popover-trigger=\"\'outsideClick\'\" popover-class=more-options-popup ng-click=$event.stopPropagation()><i class=\"rspl-icon icon-more\"></i></div><div class=pickup-label ng-if=\"vm.cardType === \'calendar\' && vm.d.request.pickup_label\"><span>{{vm.d.request.pickup_label.name}}</span> <span ng-style=\"{\'background-color\': vm.d.request.pickup_label.color}\"></span></div></div><div class=col-xs-12 ng-if=\"vm.display !== \'small\' && !vm.noActions\"><div ng-if=\"vm.cardType === \'hub\'\" class=\"btn-group row\"><a class=\"btn btn-default col-xs-12\" ng-click=\"vm.openClaimPrompt(vm.d, $event)\"><i class=\"rspl-icon icon-claim-donation\"></i> Claim Donation</a></div><div class=\"btn-group row\" ng-if=\"vm.cardType === \'calendar-actions-needed\'\"><a class=\"btn btn-default col-xs-6\" ng-click=\"vm.openModal(\'complete\', d, $event)\">Completed </a><a class=\"btn btn-default col-xs-6\" ng-click=\"vm.openModal(\'cancel\', d, $event)\">Report Issues</a></div><div ng-if=\"vm.cardType !== \'hub\' && vm.cardType !== \'calendar-actions-needed\'\" class=\"btn-group row\"><a class=\"btn btn-default col-xs-6\" ng-click=\"vm.openDonation(vm.d, true, $event)\" ng-click=$event.stopPropagation()><i class=\"rspl-icon icon-print\"></i></a><div class=\"btn btn-default col-xs-6\" ng-disabled=\"((vm.d.request.status !== \'completed\') && (vm.d.request.status !== \'accepted\'))\" ng-click=\"vm.getTaxReceipt(vm.d, $event)\"><i class=\"rspl-icon icon-tax\"></i></div></div></div></div>");
$templateCache.put("app/components/donation-requests/donation-requests.html","<div class=requests><div class=requests-header><h3>Donation requests</h3></div><div class=col-xs-12><div ng-show=vm.isLoadingRequests class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-show=\"!vm.isLoadingRequests && (!vm.pendingDonations || vm.pendingDonations.length === 0)\" class=\"text-center no-items\">No donation requests</p></div><div class=ul-wrapper ng-if=\"!vm.isLoadingRequests && vm.pendingDonations && vm.pendingDonations.length > 0\"><ul ng-scrollbars ng-scrollbars-config=vm.scrollConfig><li ng-repeat=\"d in vm.pendingDonations\" ng-click=\"vm.openDonation(d, false)\" ng-style=\"{\'background\':\'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(\\\'\' + (d.photos[0].url ? (vm.imageBaseUrl + d.photos[0].url) : \'/assets/images/charity-img@2x.png\') + \'\\\')\',\'background-position\': \'center center\', \'background-size\': \'cover\'}\"><span class=\"expires badge text-capitalize status badge-error\" ng-if=\"d.expiration === 0\">Expired</span><timer ng-if=\"d.expiration !== 0\" class=\"expires badge text-capitalize status\" ng-class=\"{\'badge-default\' : !d.expiration_soon, \'badge-error\' : d.expiration_soon}\" end-time=d.expiration>Expires in {{days * 24 + hours}}:{{minutes&lt;10?\"0\"+minutes:minutes}}:{{seconds&lt;10?\"0\"+seconds:seconds}}</timer><div class=donation-date><i class=\"rspl-icon icon-lock\" ng-if=!d.manual></i> <span>{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.date : d.request.date | date: \"dd MMM\"}} | <span class=text-uppercase>{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.part_of_day : d.request.part_of_day}}</span></span></div><div><span class=zip-label>ZIP:</span><span class=zip>{{::d.zip}}</span></div></li></ul></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top\" ng-if=\"vm.loggedIn && vm.active !== \'login\'\"><div class=container-fluid><button class=\"sidebar-toggle pull-left\" ng-click=vm.toggleSidebar()><i class=\"rspl-icon icon-side-menu\"></i></button><div class=\"logo-wrapper pull-left\"><span>{{vm.charityName}}</span></div><div class=pull-right><a class=\"pull-left notif-toogler animated\" ng-if=\"vm.loggedIn && vm.active !== \'payment\'\" ng-click=vm.toggleNotification()><div class=\"wrap clearfix\" ng-class=\"{\'red\' : vm.notification_alerts.length > 0}\"><div class=\"alert-length pull-left\" ng-if=\"vm.notification_alerts.length > 0\">{{vm.notification_alerts.length}}</div><div class=\"bell pull-left\"><img ng-src=assets/images/bell.svg></div></div></a><ul class=\"nav navbar navbar-right\" ng-class=\"{\'hidden-sm hidden-xs\': vm.loggedIn}\"><li ng-if=vm.loggedIn uib-popover-template=vm.dynamicPopover.templateUrl popover-placement=bottom-right popover-trigger=\"\'outsideClick\'\" popover-class=user-options>Hi, {{vm.user.first_name}} <i class=\"rspl-icon icon-shevron-down-small\"></i></li></ul></div></div><div class=sidebar ng-scrollbars ng-scrollbars-config=vm.scrollConfig><ul class=main-menu><li class=main-menu-item ui-sref=calendar ui-sref-active=active><a ng-click=vm.closeMenu() ui-sref=calendar><i class=\"rspl-icon icon-calendar\" aria-hidden=true></i> <span>Calendar</span></a></li><li class=main-menu-item ng-class=\"{\'active\': vm.active.indexOf(\'database\') !== -1}\"><a class=icon-fix ng-click=vm.toggleDatabase()><i class=\"rspl-icon icon-database\"></i> <span>Database</span></a><ul class=submenu ng-class=\"{\'hide\': !vm.database}\"><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'donations\') !== -1}\" ui-sref=database.donations><a ng-click=vm.closeMenu() ui-sref=database.donations><span>Donations</span></a></li><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'donormanagement\') !== -1}\" ui-sref=database.donormanagement><a ng-click=vm.closeMenu() ui-sref=database.donormanagement><span>Donor Management</span></a></li><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'donorgroups\') !== -1}\" ui-sref=database.donorgroups.allgroups><a ng-click=vm.closeMenu() ui-sref=database.donorgroups.allgroups><span>Donor Groups</span></a></li><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'users\') !== -1}\" ui-sref=database.users><a ng-click=vm.closeMenu() ui-sref=database.users><span>User Management</span></a></li></ul></li><li class=main-menu-item ui-sref=donations.hub ui-sref-active=active><a ng-click=vm.closeMenu() ui-sref=donations.hub><i class=\"rspl-icon icon-donation-hub\" aria-hidden=true></i> <span>Donations Hub</span></a><div class=\"badge badge-error\" ng-show=\"vm.newHubDonationsCount > 0\"><p>{{vm.newHubDonationsCount}}</p></div></li><li class=main-menu-item ng-class=\"{\'active\': vm.active.indexOf(\'account\') !== -1}\" ui-sref=account.info><a ng-click=vm.closeMenu() ui-sref=account.info><i class=\"rspl-icon icon-manage-account\" aria-hidden=true></i> <span>Manage Account</span></a><div class=\"badge badge-error\" ng-show=vm.scheduleEmpty><p>!</p></div></li><li class=main-menu-item ng-class=\"{\'active\': vm.active.indexOf(\'fleetmanagement\') !== -1}\"><a class=icon-fix ng-click=vm.toggleFleetManagement()><i class=\"rspl-icon icon-trucks\"></i> <span>Fleet Management</span></a><div class=\"badge badge-error\" ng-show=\"vm.newReportsCount > 0\"><p>{{vm.newReportsCount}}</p></div><ul class=submenu ng-class=\"{\'hide\': !vm.fleetmanagement}\"><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'listview\') !== -1}\" ui-sref=fleetmanagement.listview><a ng-click=vm.closeMenu() ui-sref=fleetmanagement.listview><span>List View</span></a></li><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'truckregistration\') !== -1}\" ui-sref=fleetmanagement.truckregistration><a ng-click=vm.closeMenu() ui-sref=fleetmanagement.truckregistration><span>Truck Registration</span></a></li><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'liveview\') !== -1}\" ui-sref=fleetmanagement.liveview><a ng-click=vm.closeMenu() ui-sref=fleetmanagement.liveview><span>Live View</span></a></li><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'schedule\') !== -1}\" ui-sref=fleetmanagement.schedule><a ng-click=vm.closeMenu() ui-sref=fleetmanagement.schedule><span>Schedule</span></a></li><li class=submenu-item ng-class=\"{\'active\': vm.active.indexOf(\'pickupreports\') !== -1}\" ui-sref=fleetmanagement.pickupreports><a ng-click=vm.closeMenu() ui-sref=fleetmanagement.pickupreports><span>Pickup Reports</span></a><div class=\"badge badge-error\" ng-show=\"vm.newReportsCount > 0\"><p>{{vm.newReportsCount}}</p></div></li></ul></li></ul><ul class=\"hidden-md hidden-lg logout-xs\"><li><a ui-sref=account.info ng-click=vm.closeMenu()><span>Personal Settings</span></a></li><li><a ng-click=vm.logout()><span>Log out</span></a></li></ul><div class=\"hidden-xs hidden-sm logo\"><span>Powered by </span><img ng-src=assets/images/rspl-logo-2.png alt=Resupply></div></div><div ng-if=\"vm.loggedIn && vm.active !== \'payment\'\" class=\"container-fluid width\" id=notification-container ng-scrollbars ng-scrollbars-config=vm.scrollConfig><div class=\"row notif-head\"><div class=col-md-12>Notification Center</div></div><div ng-if=vm.alertsError class=\"notification-alert error\">Connection on server is unsuccessful !</div><div ng-repeat=\"alert in vm.notification_alerts | orderBy : \'-date\'\" class=\"row notification-alert\"><div class=col-md-12><div class=\"row date\"><div class=col-md-6>{{alert.date | date : \'MMM d yyyy\'}}</div><div class=col-md-6>{{alert.date | date : \'h:mm a\'}}</div></div><div class=\"row text-container\"><div class=col-md-12>{{alert.content}}</div></div><div class=row><div class=\"col buttons\" ng-if=alert.data><div ng-click=vm.openDonation(alert.data.donation.id) class=btn>View Donation</div></div><div class=\"col buttons\"><a ng-click=vm.markAsRead(alert.id)>Ok, got it!</a></div></div></div></div><div class=\"row label-older\"><div class=col-md-12>Older Notifications</div></div><span class=non>No older notification</span></div><div ng-if=\"vm.active.indexOf(\'fundraising\') !== -1 && !vm.hasStripeAccount\" class=missing-stripe-account><p class=text-center>Have in mind that you did not setup your donation account and you won’t be able to recive donation. You can setup your donation account by clicking “Connect To Stripe” button on Account section.</p></div></nav>");
$templateCache.put("app/components/navbar/userOptions.html","<p ui-sref=account.info class=option-item>Personal Settings</p><p ng-click=vm.changeCharity() ng-if=\"vm.role.length > 1\" class=option-item>Change Charity</p><p ng-click=vm.logout() class=option-item>Log out</p>");
$templateCache.put("app/components/payment/payment.html","<div class=payment><div class=\"container-fluid main\"><form name=payment_form class=clearfix ng-submit=vm.pay()><div class=\"form-header row\"><h1>Payment Information</h1></div><div class=\"form-body row\"><div class=inputs-container><input type=hidden name=token><div class=row><div class=col-md-6><label><span><span>Name on Card</span></span> <input name=cardholder-name ng-model=vm.card.holder class=\"field is-empty\" placeholder=\"Jane Doe\" required></label></div><div class=col-md-6><label><span>Card number</span><div id=card-number-element class=field></div></label></div><div class=col-md-9><label><span><span>Billing address</span></span> <input class=\"field is-empty\" ng-model=vm.card.address type=text placeholder=\"eg. 285 South Howard St. SE, Atlanta, 51067\" id=billing_address required></label></div><div class=col-md-3><label><span>Zip</span> <input id=postal-code ng-model=vm.card.zip only-numbers limit-to=5 ng-minlength=5 ng-maxlength=5 name=postal_code class=field placeholder=51067 required></label></div><div class=col-md-9><div class=row><div class=col-md-6><label><span>Expiry date</span><div id=card-expiry-element class=field></div></label></div><div class=col-md-6><label><span>CVC</span><div id=card-cvc-element class=field></div></label></div></div></div><div class=col-md-3><img class=pull-right ng-src=assets/images/powered_by_stripe.svg alt=\"\"></div></div><div class=outcome><div class=error></div></div></div><div class=terms-container><div class=row><div class=col-md-12><p>Terms of Agreement</p><div class=terms ng-scrollbars ng-scrollbars-config=vm.scrollConfig><h4>TradeU LLC dba Resupply - Giving Made Simple</h4><p>ANNUAL PAYMENT PLAN AGREEMENT</p><p>This Annual Payment Plan Agreement (“The Agreement”) is made effective as of (“The Effective Date”) by and between TradeU LLC, a New York Limited Liability Company, and (“the Charity”).</p><p><b>SERVICES.</b> The Resupply Platform is a collection of mobile applications and websites for both Users and Charities. Users can but are not limited to donating goods or time to Charities and other third parties. Donors are able to use the Resupply Platform to donate, while Charities use the Resupply Platform for schedule management, donor management, fleet management, and other Services. FEES. You will pay all fees specified in this Agreement. Except as otherwise specified herein or in an Invoice or Sales Receipt, payment obligations are non-cancelable and fees paid are non-refundable.</p><p><b>PAYMENT.</b> Payment is charged per Charity Account. If a Charity has more than one Charity Account, then they will have to pay the Fees for EACH account. Payment includes an Annual Subscription Fee as well as a monthly total Pickup Fee.<ul><li><b>Annual Subscription Fee.</b> For use of the Resupply Service, Resupply shall be entitled to receive an annual fee of $1,308 (“the Annual Fee”). This annual fee will be billed in monthly installments with respect to each Monthly Period equal to $109 (“the Monthly Fee”). This rate WILL REMAIN FIXED for the life of this Agreement.</li><li><b>Pickup Fee.</b> In addition to the Annual Fee, The Charity shall pay a Pickup Fee of $9.99 on all pickups that were generated from organic Resupply marketing and advertising efforts (“Organic Resupply Donations”). The Charity will be billed at the end of each Monthly Period for all successful Organic Resupply Donations that occurred during that Monthly Period.</li><ul><li>Organic Resupply Donations do not include donations scheduled through Resupply from donors contacting the Charity directly via phone (and the Charity subsequently scheduling a donation through Resupply) or the Charity’s business website (and subsequently scheduling through Resupply).</li></ul></ul></p><p><b>FEATURES INCLUDED.</b></p><p>Charity Account(s)</p><p>Charity Website “Donate Now” Button</p><p>Donation Hub</p><p>All current and future features/services will remain included in the current subscription package without any future upcharges.</p><p><b>BILLING.</b> Resupply accepts credit cards or bank transfer through ACH as the only forms of payment. All currency references are in U.S. dollars. The Charity must provide current, complete, and accurate billing data to Resupply. The Charity must promptly update all billing data to keep the Charity Account current, complete and accurate (such as a change in billing address, credit card number, or credit card expiration date) and the Charity must promptly notify Resupply if the Charity payment method has changed (for example, for loss or theft) or if the Charity becomes aware of a potential breach of security, such as the unauthorized disclosure or use of the Charity name or password. If the Charity fails to provide any of the foregoing information, the Charity agrees that Resupply may continue charging the Charity for any use of Resupply Services under the Annual Payment Plan unless the Charity has terminated the Annual Payment Plan as set forth herein. Resupply will send monthly invoices to the Charity via electronic mail. The Charity agrees to complete payment in a timely manner. The Charity can also elect for automatic billing by signing the Automatic Billing Authorization form attached. If that form is signed, then the Charity will receive a monthly Sales Receipt via electronic mail.</p><p><b>OVERDUE CHARGES.</b> The Charity agrees that in the event Resupply is unable to collect the fees owed, Resupply may take any other steps it deems necessary to collect such fees from the Charity and that the Charity will be responsible for all costs and expenses incurred by Resupply in connection with such collection activity, including collection fees, court costs, and attorney fees.</p><p><b>SUSPENSION OF SERVICES.</b> The Charity agrees that failure to pay in a timely manner may result in loss of access to the Resupply Service until payment is made.</p><p><b>LATE FEES.</b> The Charity has 5 days from receipt of the invoice to remit payment. If the invoice is not paid by the fifth day, Resupply will charge a $40 late fee per week that the invoice remains unpaid.</p><p><b>SALES TAX EXEMPTION CERTIFICATE.</b> The Charity agrees to send a copy of their Sales Tax Exemption Certificate to Resupply in order not to be charged Sales Tax. If the document is not presented, then Sales Tax will be charged until receipt of the Sales Tax Exemption Certificate.</p><p><b>TERMINATION.</b> If the Charity terminates this Agreement they are liable to pay the remaining balance, if any, owed to Resupply. If Resupply terminates this Agreement, the Charity is not liable to pay the remainder of their balance, but must still pay any unpaid fees that were due before the date of termination.</p><p><b>TERM OF AGREEMENT.</b> This Agreement commences on the date the Charity signs it and continues until it is either terminated by the Charity or by Resupply. This agreement will renew automatically, but if the Charity wishes to terminate the Agreement they must give notice 30 days prior.</p><p><b>VENUE.</b> You agree that the laws of the state of New York and US federal law govern this Agreement. You further agree that any disputes or claims that you may have against us will be resolved by a court located in the state of New York and you agree and submit to the exercise of personal jurisdiction of such courts for the purpose of litigating any such claim or action.</p><p>BY AGREEING TO THIS AGREEMENT, YOU ARE (A) WAIVING CLAIMS THAT YOU MIGHT OTHERWISE HAVE AGAINST US BASED ON THE LAWS OF OTHER JURISDICTIONS, INCLUDING YOUR OWN; (B) IRREVOCABLY CONSENTING TO THE EXCLUSIVE JURISDICTION OF, AND VENUE IN, THE STATE OR FEDERAL COURTS IN THE STATE OF NEW YORK OVER ANY DISPUTES OR CLAIMS YOU HAVE WITH US; AND (C) SUBMITTING YOURSELF TO THE PERSONAL JURISDICTION OF SUCH COURTS FOR THE PURPOSE OF RESOLVING ANY SUCH DISPUTES OR CLAIMS.</p><p></p><p><b>ARBITRATION.</b> You agree that any disputes or claims that you may have against us will be (except as stated below) finally and exclusively resolved by binding arbitration. Any election to arbitrate by one party shall be final and binding on the other. The arbitration shall be commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association (“AAA”) and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (“AAA Consumer Rules”). Except as otherwise provided in this Agreement, you and Resupply may litigate in court to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate or enter judgment on the award entered by the arbitrator. YOU UNDERSTAND THAT ABSENT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE THE RIGHT TO A JURY TRIAL.</p><p><b>SEVERABILITY.</b> If any part of this Agreement is held invalid or unenforceable, that portion shall be construed in a manner consistent with applicable law to reflect, as nearly as possible, the original intentions of the parties, and the remaining portions shall remain in full force and effect.</p><p><b>AGREEMENT.</b> The Charity hereby acknowledges by signature below that they understand the various terms of this Agreement and they agree to be bound by the terms of this Agreement.</p></div></div></div></div></div><div class=\"total-price row\"><div class=\"col-md-6 col-xs-6\">Total Monthly Base</div><div class=\"col-md-6 col-xs-6\">$109</div></div><div class=\"form-footer row\"><div class=btn-container><button ladda=vm.isSubmitting type=submit class=\"btn btn-primary\" ng-disabled=\"payment_form.$invalid || !vm.termsAndConditions\">Authorize Payment</button><div class=mg-checkbox><input type=checkbox value={{}} ng-checked=vm.termsAndConditions><label ng-class=\"{\'selected\': vm.termsAndConditions}\" ng-click=vm.check_terms()></label><span>Agree with Terms of Agreement</span></div></div></div></form></div><div class=alerts><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div></div></div>");
$templateCache.put("app/components/secondary-nav/secondary_navbar.html","<div class=bottom-nav><div class=\"container-fluid nav-container\"><div class=row><div class=\"col-xs-3 back-navigation-button\"><p ui-sref=dashboard><i class=\"fa fa-angle-left fa-lg\" aria-hidden=true></i> <span class=hidden-xs>BACK TO DASHBOARD</span></p></div><div class=\"col-xs-6 bottom-nav-title\"><!--<p style=\"text-align: center\">PROFILE</p>--></div><div class=col-xs-3></div></div></div></div>");
$templateCache.put("app/components/ui-components/pagination.html","<ul class=pagination><li ng-if=directionLinks ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\" title=\"Previous Page\"><span class=\"rspl-icon icon-arrow-left\"></span></a></li><li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=selectPage(page.number)>{{page.text}}</a></li><li ng-if=directionLinks ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\" title=\"Next Page\"><span class=\"rspl-icon icon-arrow-right\"></span></a></li></ul>");
$templateCache.put("app/database/donorgroups/donorgroups.html","<div class=donor-groups><div class=main><div class=\"container main\"><div class=\"row filter\"><div class=\"col-xs-12 search-donors\"><form ng-submit=vm.getAllGroups() name=cont.searchForm><div class=\"col-xs-8 col-sm-9 col-lg-10\"><i class=\"rspl-icon icon-search\"></i> <input type=text ng-model=vm.term placeholder=\"Search groups...\" class=form-control></div><div class=\"col-xs-4 col-sm-3 col-lg-2\"><button class=\"btn btn-primary\" type=submit ladda=vm.isSearching ng-disabled=!cont.searchForm.$dirty>Search</button></div></form></div></div><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><div ng-if=!vm.isLoading class=\"main-content row\"><div class=\"col-xs-12 col-sm-4 col-lg-3\"><div ui-sref=database.donorgroups.creategroup class=add_group><i class=\"rspl-icon icon-plus\"></i><p>Create Group</p></div></div><div ng-repeat=\"group in vm.donor_groups | orderBy:\'name\'\" class=\"col-xs-12 col-sm-4 col-lg-3\"><div class=donor_group><div class=donor_group_data><p class=name>{{group.name}}</p><p class=donors_num>{{group.contacts_count}} Donors</p></div><div class=btns_container><div ui-sref=\"database.donorgroups.singlegroup({ id: {{group.id}} })\" class=\"btn btn-default pull-left\">Edit</div><div ng-click=vm.deleteGroupPrompt(group) class=\"btn btn-default pull-left\" id=donor-group-delete>Delete</div></div></div></div></div></div></div></div>");
$templateCache.put("app/database/donations/donations.html","<div class=database><!-- **********************************************   BOTTOM NAV START   ************************************************--><div class=bottom-nav><div class=\"container main\"><div class=form-switch><div ng-click=\"vm.changeType(\'active\')\" ng-class=\"{\'active\': vm.type===\'active\'}\">Active</div><div ng-click=\"vm.changeType(\'history\')\" ng-class=\"{\'active\': vm.type===\'history\'}\">History</div></div><div class=pull-right><a href=\"\" class=\"btn btn-primary\" ng-disabled=\"vm.isLoading || !vm.donations || vm.donations.length === 0\" ng-click=vm.print()><i class=\"rspl-icon icon-print\"></i><label>Print Selection</label></a><div class=\"btn btn-primary\" ng-disabled=\"vm.isLoading || !vm.donations || vm.donations.length === 0\"><csv-download label=\"<i class=\'rspl-icon icon-export\'></i>\n                    <label>Export to CSV</label>\" input-array=vm.donationsToExport filename=database.csv ng-if=\"!vm.isLoading && vm.donationsToExport && vm.donationsToExport.length > 0\"></csv-download><i class=\"rspl-icon icon-export\" ng-if=\"vm.isLoading || !vm.donations || vm.donations.length === 0\"></i><label ng-if=\"vm.isLoading || !vm.donations || vm.donations.length === 0\">Export to CSV</label></div><a href=\"\" class=\"btn btn-primary\" ng-click=vm.changeView()><span ng-if=\"vm.view === \'table\'\"><i class=\"rspl-icon icon-list\"></i><label>List view</label></span><span ng-if=\"vm.view === \'list\'\"><i class=\"rspl-icon icon-table\"></i><label>Table view</label></span></a></div></div></div><!-- **********************************************   BOTTOM NAV END   ************************************************--><div class=main><div class=\"container main\"><!-- **********************************************   DONATIONS FILTERS START   ************************************************--><div class=\"row filter\"><div class=\"col-xs-12 col-md-3\"><div class=form-datepicker ng-if=\"vm.timeType === \'daily\'\"><div ng-click=vm.previousDay()><i class=\"rspl-icon icon-shevron-left\"></i></div><div><span ng-click=vm.openDatepicker()>{{vm.params.start_date | date: \"dd MMM\"}}</span> <input type=text class=\"form-control hidden\" uib-datepicker-popup=\"dd MMM\" ng-model=vm.params.start_date is-open=vm.datePickerOpened datepicker-options=vm.datePickerConfig close-text=Close alt-input-formats=altInputFormats ng-click=vm.openDatepicker() ng-change=vm.getDonations()></div><div ng-click=vm.nextDay()><i class=\"rspl-icon icon-shevron-right\"></i></div></div><div class=form-weekpicker ng-if=\"vm.timeType === \'weekly\'\"><div ng-click=vm.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.start_date | date : \"dd MMM\"}} - {{vm.params.end_date | date : \"dd MMM\"}}</div><div ng-click=vm.nextWeek()><i class=\"rspl-icon icon-shevron-right\"></i></div></div><div class=form-weekpicker ng-if=\"vm.timeType === \'monthly\'\"><div ng-click=vm.previousMonth()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.start_date | date : \"MMM\"}}</div><div ng-click=vm.nextMonth()><i class=\"rspl-icon icon-shevron-right\"></i></div></div><div class=form-daterange ng-if=\"vm.timeType === \'custom\'\"><div><input date-range-picker class=\"form-control date-picker\" type=text ng-model=vm.datePicker placeholder=\"dd MM - dd MM\" options=vm.dateRangeConfig ng-change=vm.getDonations()></div></div></div><div class=\"col-xs-12 col-md-9\"><div class=selects><div class=\"col-xs-12 hidden-md col-lg-2\"><span class=title>Filters</span></div><div class=\"col-xs-12 col-lg-10\"><div class=row><div class=\"col-xs-12 col-sm-4\"><ui-select ng-model=vm.timeType class=rspl-select title=\"Time Type\" append-to-body=true ng-change=vm.timeTypeChanged()><ui-select-match class=text-capitalize>{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"o in vm.timeTypes | filter: $select.search\"><span ng-bind-html=o class=text-capitalize></span></ui-select-choices></ui-select></div><div class=\"col-xs-12 col-sm-8\"><ui-select multiple ng-model=vm.status class=rspl-select title=Status append-to-body=true ng-change=vm.getDonations()><ui-select-match placeholder=Status class=text-capitalize>{{$item.id}}</ui-select-match><ui-select-choices repeat=\"o in vm.statuses | filter: $select.search\"><span ng-bind-html=o.id class=text-capitalize></span></ui-select-choices></ui-select></div></div></div></div></div></div><div class=\"row filter\"><div class=\"col-xs-12 search-donors\"><div><div class=\"col-xs-8 col-sm-9 col-lg-10\"><i class=\"rspl-icon icon-search\"></i> <input type=text ng-model=vm.donor placeholder=\"Search donors...\" uib-typeahead=\"donor as donor.name for donor in vm.getUsers($viewValue)\" class=form-control typeahead-wait-ms=300></div><div class=\"col-xs-4 col-sm-3 col-lg-2\"><a class=\"btn btn-primary\" ng-click=vm.search() ladda=vm.isSearching>Search</a></div></div></div></div><!-- **********************************************   DONATIONS FILTERS END   ************************************************--><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div><!-- **********************************************   TABLE VIEW START   ************************************************--><div ng-if=\"vm.view === \'table\'\" class=table-view><div ng-if=\"vm.isLoading || !vm.donations || vm.donations.length === 0\"><div class=donation><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><p ng-if=\"!vm.isLoading && (!vm.donations || vm.donations.length === 0)\" class=\"text-center no-items\">No donation requests</p></div></div><table ng-if=\"!vm.isLoading && vm.donations && vm.donations.length > 0\" id=print-content><thead><tr><th>Donor</th><th>Date</th><th>Pickup Time</th><th>Address</th><th>Submission Date</th><th>Phone</th><th>Status</th><th style=\"min-width: 140px\">Action</th></tr></thead><tbody><tr ng-repeat=\"d in vm.donations\" ng-click=\"vm.openDonation(d.id, false)\"><td>{{::d.request.donor.first_name}} {{::d.request.donor.last_name}}</td><td>{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.date : d.request.date | date: \"dd MMM yyyy\"}}</td><td class=text-uppercase>{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.part_of_day : d.request.part_of_day}}</td><td>{{::d.address}}</td><td>{{::d.submission_date}}</td><td><span ng-hide=\"d.request.status === \'pending\'\">{{::d.phone}}</span></td><td><span class=\"badge text-capitalize\" ng-class=\"{\'badge-primary\' : d.request.status === \'completed\', \'badge-success\' : d.request.status === \'accepted\', \'badge-error\' : d.request.status === \'canceled\', \'badge-orange\' : d.request.status === \'rejected\', \'badge-warning\' : d.request.status === \'pending\' || d.request.status === \'in_pool\'}\">{{d.request.status === \'in_pool\' ? \'In Pool\' : d.request.status === \'awaiting_user_response\' ? \'Waiting for response\': d.request.status}}</span></td><td><i class=\"rspl-icon icon-chat\" ng-click=\"vm.startConversation(d, $event)\" ng-disabled=d.manual></i> <i class=\"rspl-icon icon-print\" ng-click=\"vm.openDonation(d.id, true, $event)\" ng-click=$event.stopPropagation()></i> <i class=\"rspl-icon icon-tax\" ng-disabled=\"d.request.status !== \'completed\'\" ng-click=\"vm.getTaxReceipt(d, $event)\"></i></td></tr></tbody></table></div><!-- **********************************************   TABLE VIEW END   ************************************************--><!-- **********************************   LIST VIEW START  ********************************--><div ng-if=\"vm.view === \'list\'\" class=\"list-view row\"><div class=\"col-xs-12 col-sm-6 col-lg-4\"><div class=new-donation ng-click=vm.openNewPrompt()><i class=\"rspl-icon icon-plus\"></i> <span>Add donation</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-8\" ng-if=\"vm.isLoading || !vm.donations || vm.donations.length === 0\"><div class=donation><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-if=\"!vm.isLoading && (!vm.donations || vm.donations.length === 0)\" class=\"text-center no-items\">No donation requests</p></div></div><!-- **********************************************   DONATION ITEM START   ************************************************--><div class=\"col-xs-12 col-sm-6 col-lg-4\" ng-repeat=\"d in vm.donations\" ng-if=!vm.isLoading><donation-card donation=d card-type=db></donation-card></div><!-- **********************************************   DONATION ITEM END   ************************************************--></div><!-- **********************************************   LIST VIEW END   ************************************************--></div></div><div class=\"pagination-wrapper text-center\" ng-if=\"!vm.isLoading && vm.pagination.totalItems > 1 && vm.pagination.totalItems > vm.pagination.itemsPerPage\"><ul uib-pagination total-items=vm.pagination.totalItems max-size=5 ng-model=vm.pagination.currentPage items-per-page=vm.pagination.itemsPerPage ng-change=vm.pageChanged() rotate=true force-ellipses=true class=pagination-sm template-url=app/components/ui-components/pagination.html></ul></div></div>");
$templateCache.put("app/database/donormanagement/donormanagement.html","<div class=\"main donor-management\"><div class=bottom-nav><div class=\"container main\"><div class=action-buttons><a class=\"btn btn-primary\" ui-sref=database.donorgroups.creategroup><i class=\"rspl-icon icon-group\"></i><label>Create Group</label></a><a class=\"btn btn-primary btn-excel\" ng-click=vm.openExportModal();><img ng-src=assets/images/ic_excel_white.svg><label>Export Your Donor List to Excel</label></a><a class=\"btn btn-primary\" ng-click=vm.addDonor()><i class=\"rspl-icon icon-add-donor\"></i><label>Add Donor</label></a></div></div></div><div class=main><div class=\"container main\"><div class=\"row filter\"><div class=\"col-xs-12 search-donors\"><form ng-submit=vm.search(vm.donor)><div class=\"col-xs-8 col-sm-9 col-lg-10\"><i class=\"rspl-icon icon-search\"></i> <input type=text ng-model=vm.donor placeholder=\"Search donors...\" class=form-control></div><div class=\"col-xs-4 col-sm-3 col-lg-2\"><button class=\"btn btn-primary\" type=submit ladda=vm.isSearching>Search</button></div></form></div></div><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div><div class=table-view infinite-scroll=vm.nextPage() infinite-scroll-disabled=\"vm.pagination.currentPage === vm.pagination.totalPages || vm.isLoading || vm.isSearching\" infinite-scroll-immediate-check=false><table id=print-content><thead><tr><th style=\"width: 16%\" class=\"sortable {{vm.pagination.order}}\" ng-click=\"vm.sort(\'first_name\')\" ng-class=\"{\'active\': vm.pagination.sort === \'first_name\'}\">Donor</th><th style=\"width: 8%\">Zip</th><th style=\"width: 16%\">Address</th><th style=\"width: 20%\">Email</th><th style=\"width: 10%\">Phone</th><th style=\"width: 12%\" class=\"sortable {{vm.pagination.order}}\" ng-click=\"vm.sort(\'last_donation_date\')\" ng-class=\"{\'active\': vm.pagination.sort === \'donations_last_date\'}\" style=\"min-width: 160px\">Last Donation</th><th style=\"width: 10%\" class=\"sortable {{vm.pagination.order}}\" ng-click=\"vm.sort(\'donations_count\')\" ng-class=\"{\'active\': vm.pagination.sort === \'donations_count\'}\">Donations</th><th style=\"width: 8%\">Value</th><th style=\"width: 30px\"></th></tr></thead><tbody><tr ng-repeat=\"contact in vm.users\" ng-if=\"(!vm.isLoading && vm.users && vm.users.length > 0) || vm.users.length > 0\"><td><p class=no-margin>{{contact.first_name ? contact.first_name : \'\'}} {{contact.last_name ? contact.last_name : \'\'}}</p><p ng-if=contact.organization class=no-margin style=\"color: #aaaaaa\">{{contact.organization}}</p></td><td>{{contact.zip}}</td><td><span class=addres-first-item ng-if=contact.address>{{contact.address}}</span><span>{{contact.city}}</span></td><td><span class=ellipsis>{{contact.email ? contact.email : \'\'}}</span></td><td><p class=no-margin>{{contact.phone ? contact.phone : \'\'}}</p><p ng-if=contact.alternative_phone class=no-margin style=\"color: #aaaaaa\">{{contact.alternative_phone}}</p></td><td>{{contact.last_donation_date | date: \'dd MMM yyyy\'}}</td><td ng-class=\"{\'has-completed-donation\': contact.donations_count > 0}\">{{contact.donations_count}}<a ng-click=vm.viewDonor(contact)>View all</a></td><td>${{contact.donations_value}}</td><td><img style=\"cursor: pointer\" ng-click=vm.editDonor(contact) ng-src=assets/images/edit.png alt=\"\"></td></tr><tr class=loading ng-if=\"vm.isLoading || !vm.users || vm.users.length === 0\"><td class=loading-wrapper colspan=8><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-if=\"!vm.isLoading && (!vm.users || vm.users.length === 0)\" class=\"text-center no-items\">No Results</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/database/users-list/users-list.html","<div class=\"main donor-management\"><div class=bottom-nav><div class=\"container main\"><div class=action-buttons><a class=\"btn btn-primary\" ng-click=vm.addUser()><i class=\"rspl-icon icon-add-donor\"></i><label>Add User</label></a></div></div></div><div class=main><div class=\"container main\"><div class=\"row filter\"><div class=\"col-xs-12 search-donors\"><form ng-submit=vm.search(vm.donor)><div class=\"col-xs-8 col-sm-9 col-lg-10\"><i class=\"rspl-icon icon-search\"></i> <input type=text ng-model=vm.donor placeholder=\"Search donors...\" class=form-control></div><div class=\"col-xs-4 col-sm-3 col-lg-2\"><button class=\"btn btn-primary\" type=submit ladda=vm.isSearching>Search</button></div></form></div></div><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div><div class=table-view infinite-scroll=vm.nextPage() infinite-scroll-disabled=\"vm.pagination.currentPage === vm.pagination.totalPages || vm.isLoading || vm.isSearching\" infinite-scroll-immediate-check=false><table id=print-content><thead><tr><th style=\"width: 16%\" class=\"sortable {{vm.pagination.order}}\" ng-click=\"vm.sort(\'first_name\')\" ng-class=\"{\'active\': vm.pagination.sort === \'first_name\'}\">Name</th><th style=\"width: 20%\">Email</th><th style=\"width: 20%\">User Roles</th><th style=\"width: 20%\">Account status</th><th style=\"width: 30px\"></th><th style=\"width: 30px\"></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\" ng-if=\"(!vm.isLoading && vm.users && vm.users.length > 0) || vm.users.length > 0\"><td><p class=no-margin>{{user.first_name ? user.first_name : \'\'}} {{user.last_name ? user.last_name : \'\'}}</p><p ng-if=user.organization class=no-margin style=\"color: #aaaaaa\">{{user.organization}}</p></td><td><span class=ellipsis>{{user.email ? user.email : \'\'}}</span></td><td><span class=ellipsis>{{user.user_roles ? user.user_roles.join(\", \") : \'\'}}</span></td><td><span class=ellipsis>{{user.account_status !== \"Removed\" ? \"Active\" : \"Inactive\"}}</span></td><td><img style=\"cursor: pointer\" ng-click=vm.editUser(user) ng-src=assets/images/edit.png alt=\"\"></td><td ng-if=\'user.account_status !== \"Removed\"\'><img style=\"cursor: pointer\" ng-click=\"vm.deleteUser(user); location.reload()\" ng-src=assets/images/delete.svg alt=\"\"></td><td ng-if=\'user.account_status === \"Removed\"\'><img style=\"cursor: pointer\" ng-click=\"vm.restoreUser(user); location.reload()\" ng-src=assets/images/restore_from_trash.svg alt=\"\"></td></tr><tr class=loading ng-if=\"vm.isLoading || !vm.users || vm.users.length === 0\"><td class=loading-wrapper colspan=8><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-if=\"!vm.isLoading && (!vm.users || vm.users.length === 0)\" class=\"text-center no-items\">No Results</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/donations/hub/hub.html","<div class=donations><div class=bottom-nav><div class=\"container main\"><div class=pull-right><a href=\"\" class=\"btn btn-primary\" ng-click=vm.changeView()><span ng-if=\"vm.view === \'table\'\"><i class=\"rspl-icon icon-list\"></i><label>List view</label></span><span ng-if=\"vm.view === \'list\'\"><i class=\"rspl-icon icon-table\"></i><label>Table view</label></span></a></div></div></div><div class=main><div class=\"container main\"><div class=\"row filter\"><div class=\"col-xs-12 col-md-3\"><div class=form-weekpicker><div ng-click=vm.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.start_date | date : \"dd MMM\"}} - {{vm.params.end_date | date : \"dd MMM\"}}</div><div ng-click=vm.nextWeek()><i class=\"rspl-icon icon-shevron-right\"></i></div></div></div><div class=\"col-xs-12 col-md-9\"><div class=selects><div class=\"col-xs-12 hidden-md col-lg-2\"><span class=title>Filters</span></div><div class=\"col-xs-12 col-lg-10\"><div class=row><div class=\"col-xs-12 col-sm-12\"><tags-input ng-model=vm.zips on-tag-added=vm.onZipAdded($tag) on-tag-removed=vm.onZipRemoved() max-tags=6 placeholder=\"Zip code\"><auto-complete source=vm.loadTags($query)></auto-complete></tags-input></div></div></div></div></div></div><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div><div ng-if=\"vm.view === \'table\'\" class=table-view><div class=donation><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><p ng-if=\"!vm.isLoading && (!vm.donations || vm.donations.length === 0)\" class=\"text-center no-items\">No donation requests</p></div><table ng-if=\"!vm.isLoading && vm.donations && vm.donations.length > 0\"><thead><tr><th>Donor</th><th>Date</th><th>Pickup Time</th><th>Address</th><th>Phone</th><th>Expires In</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"d in vm.donations\" ng-click=\"vm.openDonation(d.id, false)\"><td>{{d.request.donor.first_name}} {{d.request.donor.last_name}}</td><td>{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.date : d.request.date | date: \"dd MMM yyyy\"}}</td><td class=text-uppercase>{{d.request.status === \'awaiting_user_response\' ? d.initialRequest.part_of_day : d.request.part_of_day}}</td><td>{{d.address}}</td><td>{{d.phone}}</td><td><span class=\"expires badge text-capitalize status badge-error\" ng-if=\"d.expiration === 0\">Expired</span><timer ng-if=\"d.expiration !== 0\" class=\"expires badge text-capitalize status\" ng-class=\"{\'badge-default\' : !d.expiration_soon, \'badge-error\' : d.expiration_soon}\" end-time=d.expiration>Expires in {{days * 24 + hours}}:{{minutes&lt;10?\"0\"+minutes:minutes}}:{{seconds&lt;10?\"0\"+seconds:seconds}}</timer></td><td><i class=\"rspl-icon icon-claim-donation\" ng-click=\"vm.openClaimPrompt(d, $event)\"></i></td></tr></tbody></table></div><div ng-if=\"vm.view === \'list\'\" class=\"list-view row\"><div class=col-xs-12 ng-if=\"vm.isLoading || !vm.donations || vm.donations.length === 0\"><div class=donation><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-if=\"!vm.isLoading && (!vm.donations || vm.donations.length === 0)\" class=\"text-center no-items\">No donation requests</p></div></div><div class=\"col-xs-12 col-sm-4 col-lg-3\" ng-repeat=\"d in vm.donations\" ng-if=!vm.isLoading><donation-card donation=d card-type=hub></donation-card></div></div></div></div><div class=\"pagination-wrapper text-center\" ng-if=\"!vm.isLoading && vm.pagination.totalItems > 1 && vm.pagination.totalItems > vm.pagination.itemsPerPage\"><ul uib-pagination total-items=vm.pagination.totalItems max-size=5 ng-model=vm.pagination.currentPage items-per-page=vm.pagination.itemsPerPage ng-change=vm.pageChanged() rotate=true force-ellipses=true class=pagination-sm template-url=app/components/ui-components/pagination.html></ul></div></div>");
$templateCache.put("app/fleetmanagement/listview/listview.html","<div class=fleet-list-view><div class=main><div class=\"container main\"><!-- **********************************************   DONATIONS FILTERS START   ************************************************--><div class=\"row filter\"><div class=\"col-xs-12 col-md-3\"><div class=form-weekpicker><div ng-disabled=vm.isLoading class=week-controls ng-click=vm.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.start_date | date : \"dd MMM\"}} - {{vm.params.end_date | date : \"dd MMM\"}}</div><div ng-disabled=vm.isLoading class=week-controls ng-click=vm.nextWeek()><i class=\"rspl-icon icon-shevron-right\"></i></div></div></div><div class=\"col-xs-12 col-md-9\"><button class=\"new-donation-btn pull-right\" ng-click=vm.openNewPrompt()><i class=\"rspl-icon icon-plus\"></i> <span>Add donation</span></button></div></div><div class=fleet-schedule><div class=schedule-header><span>Time</span></div><div class=schedule-body><div class=\"row no-margin\"><div class=\"col-md-8 no-padding-left no-padding-right\"><div ng-if=\"vm.isLoading || vm.isLoadingTrucks\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div class=\"no-trucks-wrapper text-center\" ng-if=\"vm.trucks.length < 1\"><h4 class=text-center>You don\'t have any trucks to assign donation pickup. Go to Truck Registration or click the button below.</h4><button class=\"btn btn-primary\" ui-sref=fleetmanagement.truckregistration>Assign a truck</button></div><div class=days-wrapper ng-if=\"vm.trucks.length > 0 && !vm.isLoading\"><div class=schedule-day ng-repeat=\"day in vm.dates\"><div class=date><img class=icon-expand ng-src=assets/images/expand-arrow.png ui-sref=\"fleetmanagement.scheduledayview({date: vm.prepareDate(day.date)})\"><div class=date-title><p class=day-name>{{day.date | date: \'EEE\'}}</p><p class=day-number>{{day.date | date: \'d\'}}</p><p class=month-name>{{day.date | date: \'MMM\'}}</p></div></div><div class=\"date-period clearfix\"><div class=\"period-label am\"><p>AM</p></div><div class=period-content><div class=truck-schedule ng-repeat=\"truck in vm.displayedTrucks | limitTo:4\"><p class=\"truck-title text-center\" ng-style=\"{\'background-color\':truck.color, \'border-color\':truck.color}\" ng-show=$parent.$first>{{truck.model}}</p><div class=pickup-items ng-scrollbars><div class=pickup-item ng-style=\"{\'border-color\': pickup.request.pickup_label.color}\" ng-click=vm.openDonation(pickup) ng-if=\"pickup.request.truck.id === truck.id && pickup.request.part_of_day === \'am\'\" ng-repeat=\"pickup in vm.acceptedDonationsWithTruckAssignedByDate[day.date] | orderBy: \'request.pickup_order_number\'\"><p class=text-ellipsis ng-if=pickup.description ng-repeat=\"am_item in pickup.description.split(\',\')\">{{am_item}}</p><p ng-if=!pickup.description>No description for this pickup</p></div></div></div></div></div><div class=\"date-period clearfix\"><div class=\"period-label pm\"><p>PM</p></div><div class=period-content><div class=truck-schedule ng-repeat=\"truck in vm.displayedTrucks | limitTo:4\"><div class=pickup-items ng-scrollbars><div class=pickup-item ng-style=\"{\'border-color\': pickup.request.pickup_label.color}\" ng-click=vm.openDonation(pickup) ng-if=\"pickup.request.truck.id === truck.id && pickup.request.part_of_day === \'pm\'\" ng-repeat=\"pickup in vm.acceptedDonationsWithTruckAssignedByDate[day.date] | orderBy: \'request.pickup_order_number\'\"><p class=text-ellipsis ng-if=pickup.description ng-repeat=\"pm_item in pickup.description.split(\',\')\">{{pm_item}}</p><p ng-if=!pickup.description>No description for this pickup</p></div></div></div></div></div></div></div></div><div class=col-md-4><div class=filters ng-hide=\"vm.trucks.length === 0\"><h3>Filters</h3><div ng-if=vm.isLoadingTrucks style=\"padding-top: 40px\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div ng-if=!vm.isLoadingTrucks class=filters-wrapper><h4>Trucks <span>(max 4 can be selected at a time)</span></h4><ul><li class=clearfix ng-repeat=\"truck in vm.trucks\"><p class=pull-left>{{truck.model}}</p><div class=\"mg-checkbox pull-right\"><input type=checkbox value={{truck.selected}} ng-checked=truck.selected><label ng-class=\"{\'selected\': truck.selected}\" ng-click=vm.selectTruck(truck)></label></div></li></ul></div></div><div class=unassigned-pickups ng-class=\"{\'disabled\' : vm.trucks.length === 0}\"><h3>Unassigned pickups</h3><div ng-if=vm.isLoading style=\"padding-top: 100px\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div class=unassigned-pickups-by-date-wrapper ng-scrollbars><div ng-if=!vm.isLoading class=unassigned-pickups-by-date ng-repeat=\"day in vm.dates\"><h4>{{day.date | date : \'EEE, MMM d\'}}</h4><div class=\"pickup-items clearfix\"><div class=pickup-item ng-click=\"vm.openDonation(pickup, false, true)\" ng-repeat=\"pickup in vm.unassignedDonationsByDate[day.date]\"><p>{{pickup.request.donor.last_name + \', \' + pickup.request.donor.first_name.charAt(0)}}</p><p>{{pickup.zip}}</p></div><p ng-if=!vm.unassignedDonationsByDate[day.date].length>No pickups to assign</p></div></div></div></div><div class=color-labels ng-hide=\"vm.trucks.length === 0\"><h3>Color Coding</h3><div ng-if=vm.isLoadingTrucks style=\"padding-top: 40px\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div ng-if=!vm.isLoadingTrucks class=labels-wrapper><ul><li class=clearfix ng-repeat=\"label in vm.colorLabels\"><div class=color-swatch ng-style=\"{\'background-color\': label.color}\"></div><span class=label-name>{{label.name}}</span> <i ng-click=vm.deleteColorLabel(label.id) class=\"rspl-icon icon-delete\"></i></li><li class=clearfix ng-if=vm.showNewLabelForm><div ng-style=\"{\'background-color\': vm.newLabelColor, \'border-color\': vm.newLabelColor }\" class=\"color-swatch new\" colorpicker=hex ng-model=vm.newLabelColor></div><form ng-submit=vm.createColorLabel()><input type=text class=form-control ng-model=vm.newLabelName placeholder=\"Add Label\"> <button type=submit ng-disabled=\"!vm.newLabelName || !vm.newLabelColor\" class=\"btn btn-default\">Save</button></form></li></ul><p ng-click=\"vm.showNewLabelForm = true;\"><span>+</span>Add new label</p></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/fleetmanagement/liveview/liveview.html","<div class=liveview-wrapper><div class=filter><div class=form-date-wrapper><div class=form-datepicker><div ng-disabled=vm.isLoading class=week-controls ng-click=vm.previousDay()><i class=\"rspl-icon icon-shevron-left\"></i></div><div><span>{{vm.params.start_date | date: \"dd MMM\"}}</span> <input type=text class=\"form-control hidden\" uib-datepicker-popup=\"dd MMM\" ng-model=vm.params.start_date ng-change=vm.getDonations()></div><div ng-disabled=vm.isLoading class=week-controls ng-click=vm.nextDay()><i class=\"rspl-icon icon-shevron-right\"></i></div></div></div></div><div class=trucks-wrapper><div class=truck-item ng-repeat=\"truck in vm.trucks\"><div class=\"truck-title clearfix\" ng-style=\"{\'background-color\': truck.color}\" ng-click=\"truck.expanded = !truck.expanded\"><span>{{truck.model}}</span> <i class=\"rspl-icon icon-shevron-down-small\"></i></div><div class=truck-data-body ng-class=\"{\'expanded\' : truck.expanded}\"><h4 class=all-caps>am pickups</h4><div class=pickup-item ng-repeat=\"d in vm.donations | orderBy : \'request.pickup_order_number\'\" ng-if=\"d.request.truck.id === truck.id && d.request.part_of_day === \'am\'\" ng-click=vm.openDonation(d)><div class=status-label ng-class=d.request.status_label><span>{{d.request.status_label}}</span></div><p class=card-title>Pickup</p><p class=order-label ng-if=\"d.request.status === \'accepted\'\">{{d.request.pickup_order_number ? d.request.pickup_order_number === 1 ? d.request.pickup_order_number + \'st\' : d.request.pickup_order_number === 2 ? d.request.pickup_order_number + \'nd\' : d.request.pickup_order_number === 3 ? d.request.pickup_order_number + \'rd\' : d.request.pickup_order_number + \'th\' : \'\' }}</p><h4>{{d.request.donor.first_name + \' \' + d.request.donor.last_name}}</h4><p>{{d.address + \', \' + d.city}}</p><p>ZIP: {{d.zip}}</p></div><h4 class=all-caps>pm pickups</h4><div class=pickup-item ng-repeat=\"d in vm.donations | orderBy : \'request.pickup_order_number\'\" ng-if=\"d.request.truck.id === truck.id && d.request.part_of_day === \'pm\'\" ng-click=vm.openDonation(d)><div class=status-label ng-class=d.request.status_label><span>{{d.request.status_label}}</span></div><p class=card-title>Pickup</p><p class=order-label ng-if=\"d.request.status === \'accepted\'\">{{d.request.pickup_order_number ? d.request.pickup_order_number === 1 ? d.request.pickup_order_number + \'st\' : d.request.pickup_order_number === 2 ? d.request.pickup_order_number + \'nd\' : d.request.pickup_order_number === 3 ? d.request.pickup_order_number + \'rd\' : d.request.pickup_order_number + \'th\' : \'\' }}</p><h4>{{d.request.donor.first_name + \' \' + d.request.donor.last_name}}</h4><p>{{d.address + \', \' + d.city}}</p><p>ZIP: {{d.zip}}</p></div><hr><button class=\"btn btn-primary\" ng-click=\"vm.optimizeRoutesByTruck(truck.id, vm.params.start_date)\" ladda=vm.isOptimizingForSingleTruck>Optimize Route</button></div></div><div class=truck-item><div class=\"truck-title clearfix\" ng-style=\"{\'background-color\': \'#333333\'}\" ng-click=\"vm.invalidExpanded = !vm.invalidExpanded\"><span>Invalid Adress ({{vm.donationsWithInvalidCoordinates.length || 0}})</span> <i class=\"rspl-icon icon-shevron-down-small\"></i></div><div class=truck-data-body ng-class=\"{\'expanded\' : vm.invalidExpanded}\"><i>Donations listed here have invalid coordinates and are not visible on the map</i><h4 class=all-caps>am pickups</h4><div class=pickup-item ng-repeat=\"d in vm.donationsWithInvalidCoordinates | orderBy : \'request.pickup_order_number\'\" ng-if=\"d.request.part_of_day === \'am\'\" ng-click=vm.openDonation(d)><div class=status-label ng-class=d.request.status><span>{{d.request.status}}</span></div><p class=card-title>Pickup</p><p class=order-label ng-if=\"d.request.status === \'accepted\'\">{{d.request.pickup_order_number ? d.request.pickup_order_number === 1 ? d.request.pickup_order_number + \'st\' : d.request.pickup_order_number === 2 ? d.request.pickup_order_number + \'nd\' : d.request.pickup_order_number === 3 ? d.request.pickup_order_number + \'rd\' : d.request.pickup_order_number + \'th\' : \'\' }}</p><h4>{{d.request.donor.first_name + \' \' + d.request.donor.last_name}}</h4><p>{{d.address + \', \' + d.city}}</p><p>ZIP: {{d.zip}}</p></div><h4 class=all-caps>pm pickups</h4><div class=pickup-item ng-repeat=\"d in vm.donationsWithInvalidCoordinates | orderBy : \'request.pickup_order_number\'\" ng-if=\"d.request.part_of_day === \'pm\'\" ng-click=vm.openDonation(d)><div class=status-label ng-class=d.request.status><span>{{d.request.status}}</span></div><p class=card-title>Pickup</p><p class=order-label ng-if=\"d.request.status === \'accepted\'\">{{d.request.pickup_order_number ? d.request.pickup_order_number === 1 ? d.request.pickup_order_number + \'st\' : d.request.pickup_order_number === 2 ? d.request.pickup_order_number + \'nd\' : d.request.pickup_order_number === 3 ? d.request.pickup_order_number + \'rd\' : d.request.pickup_order_number + \'th\' : \'\' }}</p><h4>{{d.request.donor.first_name + \' \' + d.request.donor.last_name}}</h4><p>{{d.address + \', \' + d.city}}</p><p>ZIP: {{d.zip}}</p></div></div></div></div><button class=\"btn btn-optimize\" ng-click=vm.optimizeAllRoutes() ladda=vm.isOptimizing>Optimize All Routes <img ng-src=assets/images/directions.png></button><ng-map zoom-to-include-markers=auto disable-default-u-i=true zoom-control=true scrollwheel=false styles={{vm.styles}} style=\"height: calc(100vh - 60px)\"><custom-marker ng-repeat=\"truck in vm.trucks\" position=\"{{truck.lat}}, {{truck.lng}}\" on-click=vm.showData(truck) on-mouseover=vm.showMarkerData(truck) on-mouseleave=vm.hideMarkerData()><div class=truck-pin ng-style=\"{\'background-color\':truck.color}\"><div class=truck-data ng-if=\"vm.hoveredTruck.id === truck.id\" ng-style=\"{\'border-color\':truck.color}\"><h4>{{truck.model}}</h4><p class=all-caps>{{truck.licence_plate}}</p></div><img ng-src=assets/images/ic_truck.png></div></custom-marker><custom-marker ng-repeat=\"d in vm.donations\" position=\"{{d.lat}}, {{d.lng}}\" on-mouseover=vm.showDonationData(d) on-mouseleave=vm.hideDonationData()><div class=donation-pin ng-style=\"{\'background-color\':d.request.truck.color}\"><div class=donation-data ng-if=\"vm.hoveredDonation.id === d.id\"><i class=dontion-btn ng-click=vm.openDonation(d)>View donation</i><h4>{{d.request.donor.first_name + \' \' + d.request.donor.last_name}}</h4><p>{{d.address + \', \' + d.city}}</p><p>ZIP: {{d.zip}}</p><ui-select ng-model=d.request.truck class=rspl-select title=\"Select Truck\" ng-disabled=\"d.request.status !== \'accepted\'\" append-to-body=true ng-change=vm.assignTruck(d)><ui-select-match placeholder=\"Select Truck\" class=text-capitalize>{{$select.selected.model}}</ui-select-match><ui-select-choices repeat=\"o in vm.allTrucks | filter: $select.search\"><span ng-bind-html=o.model class=text-capitalize></span></ui-select-choices></ui-select></div><span class=no-truck-assigned ng-if=!d.request.truck>?</span> <span class=\"part-of-day all-caps\" ng-if=d.request.truck>{{d.request.part_of_day}}</span> <span ng-if=\"d.request.status === \'completed\'\"><i class=\"fa fa-check\"></i></span> <span ng-if=\"d.request.status === \'accepted\'\">{{d.request.pickup_order_number ? d.request.pickup_order_number === 1 ? d.request.pickup_order_number + \'st\' : d.request.pickup_order_number === 2 ? d.request.pickup_order_number + \'nd\' : d.request.pickup_order_number === 3 ? d.request.pickup_order_number + \'rd\' : d.request.pickup_order_number + \'th\' : \'\' }}</span></div></custom-marker><custom-marker ng-if=vm.charity position=\"{{vm.charity.lat}}, {{vm.charity.lng}}\"><div class=home-pin ng-style=\"{\'background-color\': \'#1c4f90\'}\"><img ng-src=assets/images/home.png></div></custom-marker></ng-map><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/fleetmanagement/pickupreports/pickupreports.html","<div class=pickup-reports><div class=\"container main\"><div class=\"row filter\"><div class=\"col-xs-12 col-md-3\"><div class=form-weekpicker><div ng-disabled=vm.isLoading ng-click=vm.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.after | date : \"dd MMM\"}} - {{vm.params.before | date : \"dd MMM\"}}</div><div ng-disabled=vm.isLoading ng-click=vm.nextWeek()><i class=\"rspl-icon icon-shevron-right\"></i></div></div></div><div class=\"col-xs-12 col-md-9\"><div class=selects><div class=\"col-xs-12 hidden-md col-lg-1\"><span class=title>Filters</span></div><div class=\"col-xs-12 col-lg-11\"><div class=row><div class=\"col-xs-12 col-sm-6\"><ui-select ng-model=vm.selectedTruck class=rspl-select title=Truck append-to-body=true ng-change=vm.getReports()><ui-select-match placeholder=Trucks class=text-capitalize>{{$select.selected.model}}</ui-select-match><ui-select-choices repeat=\"truck in vm.trucks\"><span ng-bind-html=truck.model class=text-capitalize></span></ui-select-choices></ui-select></div><div class=\"col-xs-6 text-right\"><button class=\"btn btn-primary btn-block btn-export\" ng-disabled=\"vm.isLoading || !vm.reports || vm.reports.length === 0\"><csv-download label=\"<i class=\'rspl-icon icon-export\'></i>\n                                <label>Export to CSV</label>\" input-array=vm.reports filename=report.csv ng-if=\"!vm.isLoading && vm.reports && vm.reports.length > 0\"></csv-download><i class=\"rspl-icon icon-export\" ng-if=\"vm.isLoading || !vm.reports || vm.reports.length === 0\"></i><label ng-if=\"vm.isLoading || !vm.reports || vm.reports.length === 0\">Export to CSV</label></button></div></div></div></div></div></div><!--<div class=\"row filter\">--><!--<div class=\"col-xs-12 search-pickups\">--><!--<form class=\"clearfix\" ng-submit=\"vm.getPickups()\">--><!--<div class=\"col-xs-8 col-sm-8 col-lg-8 search-input-wrapper\">--><!--<i class=\"rspl-icon icon-search\"></i>--><!--<input type=\"text\" ng-model=\"vm.searchTerm\"--><!--placeholder=\"Search donors…\"--><!--class=\"form-control\">--><!--</div>--><!--<div class=\"col-xs-4 col-sm-4 col-lg-4 search-submit-wrapper\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-5\">--><!--<button type=\"submit\" class=\"btn btn-primary btn-block search\">--><!--Search--><!--</button>--><!--</div>--><!--<div class=\"col-xs-7\">--><!--<button class=\"btn btn-primary btn-block btn-export\"--><!--ng-disabled=\"vm.isLoading || !vm.reports || vm.reports.length === 0\">--><!--<csv-download--><!--label=\"<i class=\'rspl-icon icon-export\'></i>--><!--<label>Export to CSV</label>\"--><!--input-array=\"vm.reports\"--><!--filename=\"report.csv\"--><!--ng-if=\"!vm.isLoading && vm.reports && vm.reports.length > 0\">--><!--</csv-download>--><!--<i class=\'rspl-icon icon-export\'--><!--ng-if=\"vm.isLoading || !vm.reports || vm.reports.length === 0\"></i>--><!--<label ng-if=\"vm.isLoading || !vm.reports || vm.reports.length === 0\">Export to--><!--CSV</label>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</form>--><!--</div>--><!--</div>--><div class=content><div class=row><div class=col-md-12 ng-if=\"vm.isLoading || (!vm.isLoading && vm.donations.length === 0)\"><div ng-show=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-show=\"!vm.isLoading && (!vm.pendingDonations || vm.pendingDonations.length === 0)\" class=\"text-center no-items\">No donation requests</p></div><div ng-if=\"vm.reports.length === 0 && !vm.isLoading\" class=\"info text-center\"><p class=text-white>NO REPORTS</p></div><div class=col-md-3 ng-repeat=\"report in vm.reports\" ng-if=!vm.isLoading><div class=pickup><div class=info><div class=\"top clearfix\"><span class=date>{{report.donation.request.date | date: \'d MMM y\'}}</span> <span class=\"status-label pull-right badge text-capitalize\" ng-class=\"{\'badge-primary\' : report.donation.request.status === \'completed\', \'badge-error\' : report.donation.request.status === \'canceled\'}\">{{report.donation.request.status}}</span></div><div class=donor-info><h4>{{report.donation.request.donor.first_name + \' \' + report.donation.request.donor.last_name}}</h4><p class=address>{{report.donation.request.donor.address}}, {{report.donation.request.donor.city}} <span>ZIP: {{report.donation.request.donor.zip}}</span></p></div><div class=\"truck-label-wrapper clearfix\"><span class=\"truck-name pull-right\" ng-style=\"{\'background-color\': report.donation.request.truck.color}\">{{report.donation.request.truck.model}}</span></div></div><div class=actions><button class=\"btn btn-default btn-block\" ng-class=\"{\'btn-danger-color\' : !report.seen}\" ng-click=\"vm.openReport(report.donation.id, report.report_alert, vm.params)\">View Report</button></div></div></div></div></div></div></div>");
$templateCache.put("app/fleetmanagement/schedule/pickup-popup.html","<div>Pickup-popup</div>");
$templateCache.put("app/fleetmanagement/schedule/schedule.html","<div class=fleet-schedule><div class=main><div class=\"container main\"><!-- **********************************************   DONATIONS FILTERS START   ************************************************--><div class=\"row filter\"><div class=\"col-xs-12 col-md-3\"><div class=form-weekpicker><div ng-disabled=vm.isLoading class=week-controls ng-click=vm.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i></div><div>{{vm.params.start_date | date : \"dd MMM\"}} - {{vm.params.end_date | date : \"dd MMM\"}}</div><div ng-disabled=vm.isLoading class=week-controls ng-click=vm.nextWeek()><i class=\"rspl-icon icon-shevron-right\"></i></div></div></div><div class=\"col-xs-12 col-md-4\"><div class=switch-view><div class=row><div class=col-xs-4><div class=switch-label><span>Display:</span></div></div><div class=col-xs-8><div class=switcher><button ui-sref=fleetmanagement.scheduledayview>Day</button> <button class=active>Week</button></div></div></div></div></div><div class=\"col-xs-12 col-md-5\"><button class=\"new-donation-btn pull-right\" ng-click=vm.openNewPrompt()><i class=\"rspl-icon icon-plus\"></i> <span>Add donation</span></button></div></div><!-- **********************************************   DONATIONS FILTERS END   ************************************************--><div class=row><div class=col-xs-12><div class=\"schedule-board clearfix\" ng-class=\"{\'expanded\': vm.expanded}\"><div ng-if=\"vm.isLoading || vm.isLoadingTrucks\" class=\"loader-wrapper-full text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div class=\"board-header clearfix\"><div class=\"pull-left board-colon\"><span>Date</span></div><div class=\"pull-left board-colon\"><span>Trucks</span></div><div class=board-colon><div><span>AM</span></div><div><span>PM</span></div></div></div><div class=\"board-body clearfix\" ng-if=!vm.isLoading><div class=board-menu><div class=\"board-menu-actions clearfix\"><div ng-class=\"{\'flipped\': !vm.expanded}\" class=\"collapse-btn pull-right\" ng-click=vm.expand()><img ng-src=assets/images/arrow-right-blue.png alt=loading></div></div><div ng-if=vm.expanded><div ng-class=\"{\'collapsed\': !vm.accordion.unassignedPickups}\" class=board-menu-accordion><div class=\"board-menu-accordion-header clearfix\" ng-click=\"vm.toggleAccordion(\'unassignedPickups\')\"><div class=pull-left><h3>Unassigned Pickups</h3></div><div class=pull-right ng-class=\"{\'flipped\': vm.accordion.unassignedPickups}\"><i class=\"rspl-icon icon-shevron-down-small\"></i></div></div><div class=\"board-menu-accordion-body unassigned-pickups clearfix\" ng-class=\"{\'disabled\' : vm.trucks.length === 0}\"><div ng-if=vm.isLoading style=\"padding-top: 100px\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div class=unassigned-pickups-by-date-wrapper ng-scrollbars><div ng-if=!vm.isLoading class=unassigned-pickups-by-date ng-repeat=\"day in vm.dates\"><h4>{{day.date | date : \'EEE, MMM d\'}}</h4><div class=\"pickup-items clearfix\"><div class=pickup-item ng-click=\"vm.openDonation(pickup, false, true)\" ng-repeat=\"pickup in vm.unassignedDonationsByDate[day.date]\"><p>{{pickup.request.donor.last_name + \', \' + pickup.request.donor.first_name.charAt(0)}}</p><p>{{pickup.zip}}</p></div><p ng-if=!vm.unassignedDonationsByDate[day.date].length>No pickups to assign</p></div></div></div></div></div><div ng-class=\"{\'collapsed\': !vm.accordion.colorCoding}\" class=\"color-coding board-menu-accordion\"><div class=\"board-menu-accordion-header clearfix\"><div class=pull-left><h3>Color Coding</h3></div><div class=pull-right ng-class=\"{\'flipped\': vm.accordion.colorCoding}\"><i ng-click=\"vm.toggleAccordion(\'colorCoding\')\" class=\"rspl-icon icon-shevron-down-small\"></i></div></div><div class=\"board-menu-accordion-body color-labels\"><div ng-if=!vm.isLoadingTrucks class=labels-wrapper><ul><li class=clearfix ng-repeat=\"label in vm.colorLabels\"><div class=color-swatch ng-style=\"{\'background-color\': label.color}\"></div><span class=label-name>{{label.name}}</span> <i ng-click=vm.deleteColorLabel(label.id) class=\"rspl-icon icon-delete\"></i></li><li class=clearfix ng-if=vm.showNewLabelForm><div ng-style=\"{\'background-color\': vm.newLabelColor, \'border-color\': vm.newLabelColor }\" class=\"color-swatch new\" colorpicker=hex ng-model=vm.newLabelColor></div><form ng-submit=vm.createColorLabel()><input type=text class=form-control ng-model=vm.newLabelName placeholder=\"Add Label\"> <button type=submit ng-disabled=\"!vm.newLabelName || !vm.newLabelColor\" class=\"btn btn-default\">Save</button></form></li></ul><p ng-click=\"vm.showNewLabelForm = true;\"><span>+</span>Add new label</p></div></div></div></div></div><div class=\"board-content clearfix\"><div class=\"date-truck-colon pull-left\"><div class=date-truck-row ng-repeat=\"day in vm.dates\"><div class=date ui-sref=\"fleetmanagement.scheduledayview({date: vm.prepareDate(day.date)})\"><p>{{day.date | date: \'EEE\'}}</p><p class=square>{{day.date | date: \'d\'}}</p><p>{{day.date | date: \'MMM\'}}</p><span class=tgl-switch ng-click=\"vm.toggleDay(day.date, vm.checkDay(day.date));$event.stopPropagation()\" ng-class=\"{\'disabled\' : vm.checkDay(day.date)}\"><label class=tgl-label>{{ vm.checkDay(day.date) ? \'CLOSED\' : \'OPEN\' }}</label><div class=indicator></div></span></div><div class=truck-name ng-repeat=\"truck in vm.trucks\"><span ng-style=\"{\'background-color\':truck.color, \'border-color\':truck.color}\">{{truck.model}}</span></div></div></div><div class=am-pm-colon><div class=\"am-pm-day-row clearfix\" ng-repeat=\"day in vm.dates\" ng-class=\"{\'disabled\' : vm.checkDay(day.date)}\"><div class=am-pm-truck-row ng-repeat=\"truck in vm.trucks\"><div class=am ng-scrollbars ng-scrollbars-config=vm.scrollConfig><div class=am-pm-truck-field ng-repeat=\"pickup in vm.acceptedDonationsWithTruckAssignedByDate[day.date] | orderBy: \'request.pickup_order_number\'\" ng-if=\"pickup.request.truck.id === truck.id && pickup.request.part_of_day === \'am\'\" ng-style=\"{\'width\' : pickup.request.count_as < 4 ? pickup.request.count_as * 72 : 4 * 72}\"><div class=am-pm-truck-item ng-style=\"{\'border-color\': pickup.request.pickup_label.color}\" ng-click=vm.openDonation(pickup)><p>{{pickup.request.donor.last_name + \', \' + pickup.request.donor.first_name.charAt(0)}}</p><p>{{pickup.zip}}</p></div></div></div><div class=pm ng-scrollbars ng-scrollbars-config=vm.scrollConfig><div class=am-pm-truck-field ng-repeat=\"pickup in vm.acceptedDonationsWithTruckAssignedByDate[day.date] | orderBy: \'request.pickup_order_number\'\" ng-if=\"pickup.request.truck.id === truck.id && pickup.request.part_of_day === \'pm\'\" ng-style=\"{\'width\' : pickup.request.count_as < 4 ? pickup.request.count_as * 72 : 4 * 72}\"><div class=am-pm-truck-item ng-style=\"{\'border-color\': pickup.request.pickup_label.color}\" ng-click=vm.openDonation(pickup)><p>{{pickup.request.donor.last_name + \', \' + pickup.request.donor.first_name.charAt(0)}}</p><p>{{pickup.zip}}</p></div></div></div></div><div class=am-pm-truck-row ng-if=\"vm.trucks.length < 3\"><div class=am></div><div class=pm></div></div><div class=am-pm-truck-row ng-if=\"vm.trucks.length < 2\"><div class=am></div><div class=pm></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/fleetmanagement/schedule-day-view/schedule-day-view.html","<div class=\"fleet-schedule fleet-schedule-day-view\"><div class=main><div class=\"container main\"><!-- **********************************************   DONATIONS FILTERS START   ************************************************--><div class=\"row filter\"><div class=\"col-xs-12 col-md-3\"><div class=form-datepicker><div ng-disabled=vm.isLoading ng-click=vm.previousDay()><i class=\"rspl-icon icon-shevron-left\"></i></div><div><span class=datepicker-value ng-click=vm.openDatepicker()>{{vm.params.start_date | date: \"dd MMM\"}}</span> <input type=text class=\"form-control hidden\" uib-datepicker-popup=\"dd MMM\" ng-model=vm.params.start_date is-open=vm.datePickerOpened datepicker-options=vm.datePickerConfig close-text=Close ng-click=vm.openDatepicker() ng-change=vm.setDate() show-button-bar=false></div><div ng-disabled=vm.isLoading ng-click=vm.nextDay()><i class=\"rspl-icon icon-shevron-right\"></i></div></div></div><div class=\"col-xs-12 col-md-4\"><div class=switch-view><div class=row><div class=col-xs-4><div class=switch-label><span>Display:</span></div></div><div class=col-xs-8><div class=switcher><button class=active>Day</button> <button ui-sref=fleetmanagement.schedule>Week</button></div></div></div></div></div><div class=\"col-xs-12 col-md-5\"><button class=\"new-donation-btn pull-right\" ng-click=vm.openNewPrompt()><i class=\"rspl-icon icon-plus\"></i> <span>Add donation</span></button></div></div><!-- **********************************************   DONATIONS FILTERS START   ************************************************--><div class=row ng-if=!vm.isLoading><div class=col-xs-12><div class=\"schedule-board clearfix\" ng-class=\"{\'expanded\': vm.expanded}\"><div ng-if=\"vm.isLoading || vm.isLoadingTrucks\" class=\"loader-wrapper-full text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div class=board-header><div class=date-info>{{vm.params.start_date | date: \"dd MMM\"}}</div><div class=day-info><span class=tgl-switch ng-click=\"vm.toggleDay(vm.params.start_date, vm.checkDay(vm.params.start_date));$event.stopPropagation()\" ng-class=\"{\'disabled\' : vm.checkDay(vm.params.start_date)}\"><label class=tgl-label>{{ vm.checkDay(vm.params.start_date) ? \'CLOSED\' : \'OPEN\' }}</label><div class=indicator></div></span></div><div class=truck-labels><div class=truck-label-wrapper ng-repeat=\"truck in vm.displayedTrucks\"><span class=truck-label ng-style=\"{\'background-color\': truck.color}\">{{truck.model}}</span></div></div></div><div class=\"board-body clearfix\"><div class=board-menu><div class=\"board-menu-actions clearfix\"><div ng-class=\"{\'flipped\': !vm.expanded}\" class=\"collapse-btn pull-right\" ng-click=vm.expand()><img ng-src=assets/images/arrow-right-blue.png alt=loading></div></div><div ng-if=vm.expanded><div class=filters ng-hide=\"vm.trucks.length === 0\"><h3>Filters</h3><div ng-if=vm.isLoadingTrucks style=\"padding-top: 40px\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div ng-if=!vm.isLoadingTrucks class=filters-wrapper><h4>Trucks <span>(max 4 can be selected at a time)</span></h4><ul><li class=clearfix ng-repeat=\"truck in vm.trucks\"><p class=pull-left>{{truck.model}}</p><div class=\"mg-checkbox pull-right\"><input type=checkbox value={{truck.selected}} ng-checked=truck.selected><label ng-class=\"{\'selected\': truck.selected}\" ng-click=vm.selectTruck(truck)></label></div></li></ul></div></div><div ng-class=\"{\'collapsed\': !vm.accordion.unassignedPickups}\" class=\"board-menu-accordion small\"><div class=\"board-menu-accordion-header clearfix\" ng-click=\"vm.toggleAccordion(\'unassignedPickups\')\"><div class=pull-left><h3>Unassigned Pickups</h3></div><div class=pull-right ng-class=\"{\'flipped\': vm.accordion.unassignedPickups}\"><i class=\"rspl-icon icon-shevron-down-small\"></i></div></div><div class=\"board-menu-accordion-body unassigned-pickups clearfix\" ng-class=\"{\'disabled\' : vm.trucks.length === 0}\"><div ng-if=vm.isLoading style=\"padding-top: 100px\" class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div><div class=unassigned-pickups-by-date-wrapper ng-scrollbars><div ng-if=!vm.isLoading class=unassigned-pickups-by-date ng-repeat=\"day in vm.dates\"><h4>{{day.date | date : \'EEE, MMM d\'}}</h4><div class=\"pickup-items clearfix\"><div class=pickup-item ng-click=\"vm.openDonation(pickup, false, true)\" ng-repeat=\"pickup in vm.unassignedDonationsByDate[day]\"><p>{{pickup.request.donor.last_name + \', \' + pickup.request.donor.first_name.charAt(0)}}</p><p>{{pickup.zip}}</p></div><p ng-if=!vm.unassignedDonationsByDate[day].length>No pickups to assign</p></div></div></div></div></div><div ng-class=\"{\'collapsed\': !vm.accordion.colorCoding}\" class=\"color-coding board-menu-accordion\"><div class=\"board-menu-accordion-header clearfix\"><div class=pull-left><h3>Color Coding</h3></div><div class=pull-right ng-class=\"{\'flipped\': vm.accordion.colorCoding}\"><i ng-click=\"vm.toggleAccordion(\'colorCoding\')\" class=\"rspl-icon icon-shevron-down-small\"></i></div></div><div class=\"board-menu-accordion-body color-labels\"><div ng-if=!vm.isLoadingTrucks class=labels-wrapper><ul><li class=clearfix ng-repeat=\"label in vm.colorLabels\"><div class=color-swatch ng-style=\"{\'background-color\': label.color}\"></div><span class=label-name>{{label.name}}</span> <i ng-click=vm.deleteColorLabel(label.id) class=\"rspl-icon icon-delete\"></i></li><li class=clearfix ng-if=vm.showNewLabelForm><div ng-style=\"{\'background-color\': vm.newLabelColor, \'border-color\': vm.newLabelColor }\" class=\"color-swatch new\" colorpicker=hex ng-model=vm.newLabelColor></div><form ng-submit=vm.createColorLabel()><input type=text class=form-control ng-model=vm.newLabelName placeholder=\"Add Label\"> <button type=submit ng-disabled=\"!vm.newLabelName || !vm.newLabelColor\" class=\"btn btn-default\">Save</button></form></li></ul><p ng-click=\"vm.showNewLabelForm = true;\"><span>+</span>Add new label</p></div></div></div></div></div><div class=\"board-content clearfix\"><div class=\"period-colon pull-left\"><div class=period-label><span>AM</span></div><div class=period-label><span>PM</span></div></div><div class=content-colon><div class=\"content-per-period clearfix\" ng-repeat=\"period in vm.periods\" ng-class=\"{\'disabled\' : vm.checkDay(vm.params.start_date)}\"><div class=pickup-colon ng-repeat=\"truck in vm.displayedTrucks\" ng-scrollbars><div class=pickup ng-repeat=\"pickup in vm.acceptedDonationsWithTruckAssignedSingleDay[0] | orderBy: [\'request.truck.id\',\'request.part_of_day\',\'request.pickup_order_number\']\" ng-if=\"pickup.request.truck.id === truck.id && pickup.request.part_of_day === period\" ng-style=\"{\'border-color\': pickup.request.pickup_label.color, \'color\': pickup.request.pickup_label.color, \'height\': pickup.request.count_as ? \'calc(100px *\' + pickup.request.count_as : \'100px\' }\" ng-click=\"vm.openDonation(pickup, false, true)\"><p class=order-label ng-if=\"pickup.request.status === \'accepted\'\" ng-style=\"{\'color\': pickup.request.pickup_label.color}\">{{pickup.request.pickup_order_number ? pickup.request.pickup_order_number === 1 ? pickup.request.pickup_order_number + \'st\' : pickup.request.pickup_order_number === 2 ? pickup.request.pickup_order_number + \'nd\' : pickup.request.pickup_order_number === 3 ? pickup.request.pickup_order_number + \'rd\' : pickup.request.pickup_order_number + \'th\' : \'\' }}</p><p class=order-label ng-if=\"pickup.request.status === \'completed\'\"><i class=\"fa fa-check\"></i></p><p class=pickup-details>{{pickup.request.donor.last_name}}, {{pickup.request.donor.first_name}} | {{pickup.address}}</p></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/fleetmanagement/truckregistration/truckregistration.html","");
$templateCache.put("app/login/expired/expired.html","<div class=modal-body><div class=modal-container><h3 class=text-center>Your activation link has expired</h3></div></div>");
$templateCache.put("app/login/login-roles-modal/login.roles.modal.html","<div class=login-roles-modal><div class=modal-header><h3 class=modal-title id=modal-title>Choose a charity store</h3><div class=close-btn ng-click=loginRolesCtrl.close()></div></div><div class=modal-body id=modal-body><ul class=login-list><li class=login-list-item ng-repeat=\"item in loginRolesCtrl.userRoles\"><a href=\"\" class=login-list-item-data ng-click=loginRolesCtrl.setLoginData(item)><h3 class=name>{{ item.charity.name }}</h3><p class=address>{{ item.charity.state }} | {{ item.charity.city }} | {{ item.charity.zip }}</p></a></li></ul></div></div>");
$templateCache.put("app/login/tac/tac.html","<div class=modal-body><h3>Software and Services Agreement</h3><div ng-click=tacCtrl.cancel() class=close-btn></div><div class=modal-container><p>TradeU LLC dba Resupply - Giving Made Simple</p><p>Last Updated August 24, 2018</p><p>TradeU LLC (“Resupply,” “we,” or “us”) may periodically make changes to our Software and Services Agreement (indicated by the date above), which will become effective fifteen (15) days following posting for current Charities, or immediately for new Charities. Your continued use of the Resupply Service indicates your acceptance of the changes to the Software and Services Agreement. These Terms expressly supersede prior agreements or arrangements with you. Resupply may immediately terminate this Agreement or any Services with respect to the Charity, or generally cease offering or deny access to the Services or any portion thereof, at any time for any reason.</p><p>1. Scope of Resupply Services</p><p>1.1 The Resupply Platform is a mobile application and website that enables registered users (“Users”) and certain third parties who offer services (third parties who offer charitable services are “Charities” and the services they offer are “Charity Services”) to publish such Charity Services as listings (“Listings”) on the Resupply Platform and to communicate directly with Users that are seeking to schedule such Charity Services (Users using Charity Services are “Donors”). Charity Services may include scheduling a donation pickup, giving a monetary donation, and a variety of other charitable services.</p><p>1.2 As the provider of the Resupply Platform, Resupply does not own, create, sell, resell, provide, control, manage, offer, deliver, or supply any Listings or Charity Services. Charities alone are responsible for their Listings and Charity Services. When Users schedule a donation, they are entering into a contract directly with the Charity. Resupply is not and does not become a party to or other participant in any contractual relationship between Users and Charities, nor is Resupply a Charity. Resupply is not acting as an agent in any capacity for any User or Charity.</p><p>1.3 While we may help facilitate the resolution of disputes, Resupply has no control over and does not guarantee (i) the existence, quality, safety, suitability, or legality of any Listings or Charity Services, (ii) the truth or accuracy of any Listing descriptions, Ratings, Reviews, or other Charity Content (as defined below), or (iii) the performance or conduct of any Charity or third party. Resupply does not endorse any User, Listing or Charity Services. Any references to a Charity being \"verified\" (or similar language) only indicate that the Charity has completed a relevant verification or identification process and nothing else. Any such description is not an endorsement, certification or guarantee by Resupply about any Charity, including of the Charity’s identity or background or whether the Charity is trustworthy, safe or suitable. A Charity should always exercise due diligence and care when deciding whether to schedule a donation or use other Charity Services, or communicate and interact with other Charities, whether online or in person. Images (as defined below) are intended only to indicate a photographic representation of a Listing at the time the photograph was taken, and are therefore not an endorsement by Resupply of any Charity or Listing.</p><p>1.4 If you choose to use the Resupply Platform as a Charity (as defined below), your relationship with Resupply is limited to being an independent, third-party contractor, and not an employee, agent, joint venturer or partner of Resupply for any reason, and you act exclusively on your own behalf and for your own benefit, and not on behalf, or for the benefit, of Resupply.</p><p>1.5 To promote the Resupply Platform and to increase the exposure of Listings to potential Users, Listings and other Charity Content may be displayed on other websites, in applications, within emails, and in online and offline advertisements. To assist Users who speak different languages, Listings and other Charity Content may be translated, in whole or in part, into other languages. Resupply cannot guarantee the accuracy or quality of such translations and Charities are responsible for reviewing and verifying the accuracy of such translations. The Resupply Platform may contain translations powered by Google. Google disclaims all warranties related to the translations, express or implied, including any warranties of accuracy, reliability, and any implied warranties for merchantability, fitness for a particular purpose and noninfringement.</p><p>1.6 The Resupply Platform may contain links to third-party websites or resources (“Third-Party Services”). Such Third-Party Services may be subject to different terms and conditions and privacy practices. Resupply is not responsible or liable for the availability or accuracy of such Third-Party Services, or the content, products, or services available from such Third-Party Services. Links to such Third-Party Services are not an endorsement by Resupply of such Third-Party Services.</p><p>1.7 Due to the nature of the Internet, Resupply cannot guarantee the continuous and uninterrupted availability and accessibility of the Resupply Platform. Resupply may restrict the availability of the Resupply Platform or certain areas or features thereof, if this is necessary in view of capacity limits, the security or integrity of our servers, or to carry out maintenance measures that ensure the proper or improved functioning of the Resupply Platform. Resupply may improve, enhance and modify the Resupply Platform and introduce new Resupply Services from time to time.</p><p>2. Eligibility, Using the Resupply Platform, Charity Verification</p><p>2.1 You must be at least 18 years old and able to enter into a legally binding contract to access and use the Resupply Platform or register an account for a Charity (“Charity Account”). By accessing or using the Resupply Platform you represent and warrant that you are 18 or older and have the legal capacity and authority to enter into a contract. If you are registering to use the Resupply Service on behalf of a legal entity, you further represent and warrant that (i) such legal entity is duly organized and validly existing under the applicable laws of the jurisdiction of its organization, and (ii) you are duly authorized by such legal entity to act on its behalf.</p><p>2.2 You will comply with any applicable laws in your local jurisdiction. You also represent and warrant that you are not listed on any U.S. Government list of prohibited or restricted parties.</p><p>2.3 Resupply may make the access to and use of the Resupply Platform, or certain areas or features of the Resupply Platform, subject to certain conditions or requirements, such as completing a verification process, meeting specific quality or eligibility criteria, meeting Ratings or Reviews thresholds, or meeting completed donation thresholds.</p><p>2.4 Charity verification on the Internet is difficult and we do not assume any responsibility for the confirmation of any Charity’s identity. Notwithstanding the above, for transparency and fraud prevention purposes, and as permitted by applicable laws, we may, but have no obligation to (i) ask Charities to provide a form of government identification or other information or undertake additional checks designed to help verify the identities or backgrounds of Charities, (ii) screen Charities against third party databases or other sources and request reports from service providers.</p><p>2.5 The access to or use of certain areas and features of the Resupply Platform may be subject to separate policies, standards or guidelines, or may require that you accept additional terms and conditions. If there is a conflict between these Terms and terms and conditions applicable to a specific area or feature of the Resupply Platform, the latter terms and conditions will take precedence with respect to your access to or use of that area or feature, unless specified otherwise.</p><p>2.6 Some areas of the Resupply Platform implement Google Maps/Earth mapping services, including Google Maps API(s). Your use of Google Maps/Earth is subject to the Google Maps/Google Earth Additional Terms of Service.</p><p>3. Account Registration</p><p>3.1 You must register an account (“Charity Account\") to access and use certain features of the Resupply Platform, such as accepting or rejecting a Donation. If you are registering a Charity Account for a company or other legal entity, you represent and warrant that you have the authority to legally bind that entity and grant us all permissions and licenses provided in these Terms.</p><p>3.2 You can register a Charity Account using an email address and creating a password.</p><p>3.3 You must provide accurate, current and complete information during the registration process and keep your Charity Account and any additional information up-to-date at all times, such as maximum amount of pickups per day, contact information, and pickup request statuses.</p><p>3.4 You may not register more than one (1) Charity Account unless Resupply authorizes you to do so. You may not assign or otherwise transfer your Charity Account to another party.</p><p>3.5 You are responsible for maintaining the confidentiality and security of your Charity Account credentials and may not disclose your credentials to any third party. You must immediately notify Resupply if you know or have any reason to suspect that your credentials have been lost, stolen, misappropriated, or otherwise compromised or in case of any actual or suspected unauthorized use of your Charity Account. You are liable for any and all activities conducted through your Charity Account, unless such activities are not authorized by you and you are not otherwise negligent (such as failing to report the unauthorized use or loss of your credentials).</p><p>3.6 Resupply may enable features that allow you to authorize other Users or certain third parties to take certain actions that affect your Charity Account. For example, we may allow Drivers to accept or reject Donations on behalf of the Charity. These features do not require that you share your credentials with any other person. No third party is authorized by Resupply to ask for your credentials, and you shall not request the credentials of another Charity.</p><p>3.7 The placement and ranking of Charities in search results on the Resupply Platform may vary and depend on a variety of factors, such as User search parameters and preferences, ratings and reviews, and/or tags related to the people the Charity represents.</p><p>4. The Services</p><p>4.1 The Services comprise mobile applications, websites, and related services (each, an \"Application\"), which enables Users to arrange and schedule donation pickups, including with third party providers of such services and goods under agreement with Resupply or certain of Resupply’s affiliates (\"Third Party Providers\"). Resupply uses User information to help facilitate work-flow between Users and Charities. In order to do so, the Charity will obtain certain pieces of information about the User, such as the User’s address and phone number.</p><p>5. Content</p><p>5.1 Resupply may, at its sole discretion, enable Charities to (i) create, upload, send, receive and store charity related content, such as pickup information or other materials and information on or through the Resupply Platform (\"Charity Content\"); and (ii) access and view Charity Content and any content that Resupply itself makes available on or through the Resupply Platform, including proprietary Resupply content and any content licensed or authorized for use by or through Resupply from a third party (\"Resupply Content\" and together with Charity Content, \"Collective Content\").</p><p>5.2 The Resupply Platform, Resupply Content, and Charity Content may in its entirety or in part be protected by copyright, trademark, and/or other laws of the United States and other countries. You acknowledge and agree that the Resupply Platform and Resupply Content, including all associated intellectual property rights, are the exclusive property of Resupply and/or its licensors or authorizing third-parties. You will not remove, alter or obscure any copyright, trademark, service mark or other proprietary rights notices incorporated in or accompanying the Resupply Platform, Resupply Content or Charity Content. All trademarks, service marks, logos, trade names, and any other source identifiers of Resupply used on or in connection with the Resupply Platform and Resupply Content are trademarks or registered trademarks of Resupply in the United States and abroad. Trademarks, service marks, logos, trade names and any other proprietary designations of third parties used on or in connection with the Resupply Platform, Resupply Content, and/or Collective Content are used for identification purposes only and may be the property of their respective owners.</p><p>5.3 You will not use, copy, adapt, modify, prepare derivative works of, distribute, license, sell, transfer, publicly display, publicly perform, transmit, broadcast or otherwise exploit the Resupply Platform or Collective Content, except to the extent you are the legal owner of certain Charity Content or as expressly permitted in these Terms. No licenses or rights are granted to you by implication or otherwise under any intellectual property rights owned or controlled by Resupply or its licensors, except for the licenses and rights expressly granted in these Terms.</p><p>5.4 Subject to your compliance with these Terms, Resupply grants you a limited, non-exclusive, non-sublicensable, revocable, non-transferable license to (i) download and use the Application on your personal device(s); and (ii) access and view any Collective Content made available on or through the Resupply Platform and accessible to you.</p><p>5.5 By creating, uploading, posting, sending, receiving, storing, or otherwise making available any Charity Content on or through the Resupply Platform, you grant to Resupply a non-exclusive, worldwide, royalty-free, irrevocable, perpetual (or for the term of the protection), sub-licensable and transferable license to such Charity Content to access, use, store, copy, modify, prepare derivative works of, distribute, publish, transmit, stream, broadcast, and otherwise exploit in any manner such Charity Content to provide and/or promote the Resupply Platform, in any media or platform. Unless you provide specific consent, Resupply does not claim any ownership rights in any Charity Content and nothing in these Terms will be deemed to restrict any rights that you may have to use or exploit your Charity Content.</p><p>5.6 Resupply may offer Charities the option of having professional photographers take photographs (“Images”) of their Charity Services, which are made available by the photographer to Charities to include in their Listings with or without a watermark. You are responsible for ensuring that your Charity Service is accurately represented in the Images and you will stop using the Images on or through the Resupply Platform if they no longer accurately represent your Listing, if your Resupply Charity Account is terminated or suspended for any reason. You acknowledge and agree that Resupply shall have the right to use any Images in advertising, marketing and/or any other business purposes in any media or platform, whether in relation to your Listing or otherwise, without further notice or compensation to you. Where Resupply is not the exclusive owner of Images, by using such Images on or through the Resupply Platform, you grant to Resupply an exclusive, worldwide, royalty-free, irrevocable, perpetual (or for the term of the protection), sub-licensable and transferable license to use such Images for advertising, marketing and/or any other business purposes in any media or platform, whether in relation to your Listing or otherwise, without further notice or compensation to you. Resupply in turn grants you a limited, non-exclusive, non-sublicensable, revocable, non-transferable license to use Images outside of the Resupply Platform.</p><p>5.7 You are solely responsible for all Charity Content that you make available on or through the Resupply Platform. Accordingly, you represent and warrant that: (i) you either are the sole and exclusive owner of all Charity Content that you make available on or through the Resupply Platform or you have all rights, licenses, consents and releases that are necessary to grant to Resupply the rights in and to such Charity Content, as contemplated under these Terms; and (ii) neither the Charity Content nor your posting, uploading, publication, submission or transmittal of the Charity Content or Resupply’s use of the Charity Content (or any portion thereof) will infringe, misappropriate or violate a third party\'s patent, copyright, trademark, trade secret, moral rights or other proprietary or intellectual property rights, or rights of publicity or privacy, or result in the violation of any applicable law or regulation.</p><p>5.8 You will not post, upload, publish, submit or transmit any Charity Content that: (i) is fraudulent, false, misleading (directly or by omission or failure to update information) or deceptive; (ii) is defamatory, libelous, obscene, pornographic, vulgar or offensive; (iii) promotes discrimination, bigotry, racism, hatred, harassment or harm against any individual or group; (iv) is violent or threatening or promotes violence or actions that are threatening to any other person; or (v) promotes illegal or harmful activities or substance. Resupply may, without prior notice, remove or disable access to any Charity Content that Resupply finds to be in violation of these Terms or Resupply’s then-current Policies or Standards, or otherwise may be harmful or objectionable to Resupply, its Charites, its Users, third parties, or property.</p><p>5.9 Resupply respects copyright law and expects its Charities to do the same. If you believe that any content on the Resupply Platform infringes copyrights you own, please notify us in accordance with our Copyright Policy.</p><p>5.10 Donations Final.</p><p>5.10.1 ALL DONATIONS THROUGH THE RESUPPLY SERVICE ARE FINAL, AND THERE ARE NO RETURNS, UNLESS THE USER AND THE CHARITY OTHERWISE AGREE AND MAKE ARRANGEMENTS FOR A RETURN OUTSIDE OF THE SERVICE. Resupply will not be responsible for facilitating returns, however we reserve the right to do so as part of our arbitration process in the event of disputes.</p><p>6. Referrals and Promotional Codes.</p><p>6.1 Resupply may, in its sole discretion, create referral and/or promotional codes (\"Promo Codes\") that may be used by Charities. They will receive other features or benefits related to the Services and/or a Third Party Provider\'s services as compensation for their referrals. The Charity agrees that Promo Codes: (i) must be used for the intended audience and purpose, and in a lawful manner; (ii) may not be duplicated, sold or transferred in any manner, or made available to the general public (whether posted to a public form or otherwise), unless expressly permitted by Resupply; (iii) may be disabled by Resupply at any time for any reason without liability to Resupply; (iv) may only be used pursuant to the specific terms that Resupply establishes for such Promo Code; (v) are not valid for cash; and (vi) may expire prior to your use. Resupply reserves the right to withhold funds or other features or benefits obtained through the use of the referral system or Promo Codes by the Charity or any other Charity in the event that Resupply determines or believes that the use of the referral system or redemption of the Promo Code was in error, fraudulent, illegal, or otherwise in violation of Resupply’s Terms.</p><p>7. Payment</p><p>7.1 You understand that use of the Services may result in charges to the Charity for the services or goods the Charity receives (\"Charges\"). Resupply will receive and/or enable your payment of the applicable Charges for services or goods obtained through use of the Services. Charges will be inclusive of applicable taxes where required by law.</p><p>7.2 All Charges and payments will be enabled by Resupply using the credit card payment method or bank transfer method designated in the Account, after which you will receive a receipt by email. If the primary Account payment method is determined to be expired, invalid or otherwise not able to be charged, the Charity agrees that Resupply may use a secondary payment method in the Account, if available. Charges paid by the Charity are final and non-refundable, unless otherwise determined by Resupply.</p><p>7.3 As between the Charity and Resupply, Resupply reserves the right to establish, remove and/or revise Charges for any or all services or goods obtained through the use of the Services at any time in Resupply’s sole discretion. Resupply will use reasonable efforts to inform the Charity of Charges that may apply, provided that the Charity will be responsible for Charges incurred under the Account regardless of the Charity’s awareness of such Charges or the amounts thereof. Resupply may use the proceeds of any Charges for any purpose, subject to any payment obligations it has agreed to with any Third Party Providers or other third parties. Charges you incur will be owed and paid directly to Resupply or its affiliates, where Resupply is solely liable for any obligations to Third Party Providers.</p><p>7.4 The Charity agrees to submit a copy of their Sales Tax Exemption Certification in order to waive sales tax fees on the Payment Plan. If a copy of the document is not in Resupply’s records, the Charity agrees to pay Sales Tax until such a document is received.</p><p>8. Discontinuance of the Resupply Service</p><p>8.1 Resupply may, in its sole discretion and without liability to you, modify, discontinue, terminate, suspend or shut-down (temporarily or permanently) all or any portion of the Resupply Service at any time, without prior notice. Upon any such action by Resupply, you must immediately stop using the Resupply Service.</p><p>9. Acceptable Use</p><p>9.1 When accessing or using the Resupply Service, you agree that you will not violate any law, contract, intellectual property or other third-party right or commit a tort. Without limiting the generality of the foregoing, you agree that you will not do, and will not permit any third party to do, any of the following:</p><p>• Use the Resupply Service if you are not able to form legally binding contracts (for example, if you are under 18);</p><p>• Use the Resupply Service for unlawful purposes or in an unlawful manner;</p><p>• Provide false, inaccurate or misleading information, when registering an account, donating an item, or otherwise;</p><p>• Engage in any unauthorized use of the Resupply Service (including, without limitation, political campaigning, advertising, or marketing);</p><p>• Transmit or otherwise make available any content that is abusive, threatening, obscene, defamatory, libelous, or racially, sexually, religiously, or otherwise objectionable and offensive;</p><p>• Transmit or otherwise make available any content that infringes or violates the intellectual property rights or any other rights of anyone else (including Resupply);</p><p>• Interfere or attempt to interfere with the proper functioning of the Resupply Service, including without limitation transmitting or otherwise making available any content that contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of the Resupply Service;</p><p>• Use another user’s account without permission;</p><p>• Copy, reproduce, reverse engineer, modify, decompile, disassemble or otherwise attempt to derive source code from, create derivative works from, distribute, or publicly display any content (except for your information) or software from the Resupply Service without the prior express written permission of Resupply and any necessary third party;</p><p>• Bypass any robot exclusion headers or other measures we take to restrict access to the Resupply Service or use any software, technology, or device to scrape, spider, or crawl the Resupply Service or harvest or manipulate data;</p><p>• Access without authorization any networks, systems, or databases used in providing the Resupply Service or any accounts associated with Resupply Service, or to access or use any information therein for any purpose;</p><p>• Violate any requirements, policies, procedures or regulations of any network connected to the Resupply Service;</p><p>• Take any action that imposes or might impose (to be determined in our sole discretion) an unreasonable or disproportionately large load on our infrastructure or otherwise interferes with the functioning of the Resupply Service;</p><p>• Use or attempt to use another User’s Account without authorization;</p><p>• Use the Resupply Service in any manner to stalk, harass, invade the privacy of, or otherwise cause harm to, any person;</p><p>• Encourage or induce any third party to engage in any of the activities prohibited under this section; or</p><p>• Do anything that Resupply determines, in its sole discretion, misuses the Resupply Service or otherwise negatively impacts our marketplace.</p><p>9.2 If we believe that you are abusing the Resupply Service in any way, we may investigate and you are obligated to cooperate. We may take any action that we deem appropriate in our sole discretion for such abuse. These actions may include, but are not limited to: temporarily or permanently suspending you from using or accessing the Resupply Service, removing a donation, or withholding a tax credit to you. We reserved the right to report any activity that we believe to be illegal and we will respond to all inquiries initiated by governmental agencies or as otherwise legally required. In addition, we reserve the right to refuse or terminate the access of anyone to the Resupply Service for any reason at our discretion.</p><p>10. Charity Content</p><p>10.1 In the course of using the Resupply Service, we may transmit or otherwise make available certain content (“Charity Content”) that can be accessed and viewed by others. You agree not to post any content that violates this Software and Services Agreement, any applicable end user license agreement, any intellectual property rights of others or any other applicable law. You agree that we are not liable for Charity Content. We reserve the right to remove any Charity Content for any reason at any time.</p><p>10.2 If the Charity posts any Charity Content, the Charity grants to us and our affiliate companies the perpetual sub-licensable right and license to use, copy, display, perform, distribute, modify, adapt, abridge, exploit, and promote the Charity Content in any way and in any commercial or non-commercial medium or form without charge.</p><p>11. Moderation</p><p>11.1 You agree that Resupply may moderate access to and use of the Resupply Service in our sole discretion through any means (including, for example, blocking, filtering, deletion, delay, omission, verification, and/or termination of your access. Furthermore, we have the right to remove your Charity on the Resupply Service if, in our opinion, your post does not comply with the Charity Content standards set out in Sections 9 and 10 above, and any other Resupply Service rules. You agree not to bypass or attempt to bypass such moderation. You further agree that Resupply is not liable for moderating, not moderating or making any representations regarding moderating.</p><p>12. Third Party Sites and Advertisers</p><p>12.1 Resupply Service may include links to third party websites. You agree that we are not responsible or liable for any content or other materials on third party sites (“Third Party Content”), including Third Party Content that may be misleading, incomplete, erroneous, offensive, indecent or otherwise objectionable. You also agree that we are not responsible for content or claims supplied by our advertisers. We are also not responsible for any transactions or dealings between you and any third party or any advertiser. In addition, your business or other dealings or correspondence with such third parties are solely between you and the third parties. Resupply is not responsible or liable for any damage or loss of any sort caused, or alleged to be caused, by or in connection with any such dealings, including the delivery, quality, safety, legality or any other aspect of any good or services that you may purchase or sell to or from a third party.</p><p>13. Copyright Policy</p><p>13.1 Repeat Infringers. We respect the intellectual property rights of others, and we prohibit users from uploading, posting or otherwise transmitting, by use of Resupply Service or any of our services, any materials that violate another party’s intellectual property rights.</p><p>13.1.1 It is our policy, in appropriate circumstances and at our discretion, to disable and/or terminate the accounts of users who may repeatedly infringe or violate the copyrights or other intellectual property rights of any party.</p><p>13.2 Notification of Alleged Copyright Infringement</p><p>13.2.1 If you believe that your work has been copied in a way that constitutes copyright infringement, or that your intellectual property rights have been otherwise violated, please provide our Copyright Agent with the following information:</p><p>(i) An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright or other intellectual property interest;</p><p>(ii) A description of the copyrighted work or other intellectual property that you claim has been infringed;</p><p>(iii) A description of where the material that you claim is infringing is located, with enough detail that we may find it;</p><p>(iv) Your address, telephone number, and email address;</p><p>(v) Your statement that you have a good faith belief that the disputed use is not authorized by the copyright or intellectual property owner, its agent, or the law;</p><p>(vi) Your statement, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright or intellectual property owner or authorized to act on the copyright or intellectual property owner’s behalf.</p><p>13.3 Our Agent for Notice of claims of copyright or other intellectual property infringement can be reached as follows:</p><p>By email: info@resupplyme.com</p><p>14. Intellectual Property Rights</p><p>14.1 Unless otherwise indicated, the Resupply Service and all content, materials, information, functionality and other materials displayed, performed, contained or available on or through the Resupply Service, including, without limitation, the Resupply logo, and all designs, text, graphics, pictures, information, data, sound files, images, illustrations, software, other files, and the selection and arrangement thereof (collectively, the “Materials”) are the proprietary property of Resupply or its affiliates or licensors, and are protected by U.S. and international copyright laws and other intellectual property rights laws.</p><p>14.2 Except as Resupply may expressly state in writing, you may not reproduce, reprint, publish, or otherwise exploit content or technology from Resupply or its suppliers without our express prior written consent.</p><p>15 Termination.</p><p>15.1 We reserve the right to terminate your use of Resupply Service if you violate this Software and Services Agreement or any rules or guidelines published by Resupply or for any other reason in our discretion.</p><p>15.2 You may also terminate your License to access or use the Resupply Service by closing your Resupply Account at any time. If you would like to close your Charity Account please email us at info@resupplyme.com.</p><p>16. Disclaimer of Warranties</p><p>16.1 We provide the Resupply Service and related content “AS IS.” We make no express warranties or guarantees about the Resupply Service. TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL IMPLIED WARRANTIES INCLUDING ANY IMPLIED WARRANTY ARISING FROM ANY WARRANTY THAT Resupply SERVICE AND/OR ANY ITEM SOLD THROUGH THE Resupply SERVICE IS OR WILL BE DONATABLE, OF SATISFACTORY QUALITY, ACCURATE, TIMELY, FIT FOR A PARTICULAR PURPOSE OR NEED, OR NON-INFRINGING. WE DO NOT GUARANTEE THAT RESUPPLY SERVICE WILL MEET YOUR REQUIREMENTS, IS ERROR-FREE, RELIABLE OR WILL OPERATE WITHOUT INTERRUPTION. WE DO NOT WARRANT THAT THE RESUPPLY SERVICE AND/OR MATERIALS OR ITEMS DONATED THROUGH THE RESUPPLY SERVICE WILL BE FREE FROM VIRUSES, \"WORMS,\" \"TROJAN HORSES\" OR OTHER HARMFUL PROPERTIES; OR THAT THE RESUPPLY SERVICE OR MATERIALS OR ITEMS DONATED THROUGH THE RESUPPLY SERVICE ARE NON-INFRINGING.</p><p>16.2 Because some states do not permit disclaimer of implied warranties, you may have additional consumer rights under your local laws.</p><p>17. Assumption of Risk</p><p>17.1 You acknowledge and agree that there are risks associated with utilizing an Internet-based software for the scheduling of donations, including but not limited to, the risk of failure of hardware, software and Internet connections, the risk of malicious software introduction, and the risk that third parties may obtain unauthorized access to information stored within your Charity Account. You acknowledge and agree that Resupply will not be responsible for any communication failures, disruptions, errors, distortions or delays you may experience when using the Resupply Service, however caused.</p><p>17.2 Resupply takes no responsibility for and will not be liable for any losses, damages or claims arising from the use of the Resupply Service, including, but not limited to, any losses, damages or claims arising from (a) server failure or data loss, (b) forgotten passwords, or (c) “phishing,” spam, viruses, third-party attacks or any other unauthorized third-party activities.</p><p>18. Limitation of Liability</p><p>18.1 You may not assert claims for money damages arising from the Resupply Service or anything connected with it. We shall not be liable for any indirect, special, incidental, consequential or exemplary damages, even if we knew or should have known of the possibility of such damages. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability, and the liability of our company, shall be limited to the extent permitted by law.</p><p>19. Indemnity</p><p>19.1 You agree to defend, indemnify, and hold harmless us and our affiliated companies, and our respective employees, contractors, officers, managers, members and agents from all liabilities, claims and expenses, including attorney’s fees that arise from your use or misuse of the Resupply Service. We reserve the right, at our own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will cooperate with us in asserting any available defenses.</p><p>20. Privacy Policy</p><p>20.1 This section describes Resupply’s privacy policy for the Resupply Service, including all online services and functions.</p><p>20.2 Registration. You must register with Resupply in order to use Resupply Service. If you just want to browse, registration is optional. During registration, you will be required to provide contact information. Resupply reserves the right to reject or remove any user registration content that does not meet applicable standards.</p><p>20.3 Cookies. A cookie is a small text file that is stored on a user’s computer for record-keeping purposes. The Resupply Service uses cookies. We use both “session ID cookies” and “persistent cookies.” Resupply uses session cookies to make it easier for you to navigate the Resupply Service. A session ID cookie expires when you close your browser. If you check “remember me on this computer” when logging in to the Resupply Service, Resupply also sets a persistent cookie to store your username and password, so you do not have to enter it more than once. The persistent cookie also enables Resupply to track and target the interests of users to enhance the experience of the Resupply Service. Your web browser allows you to control and limit cookies on your computer. If you reject cookies, you may still use the Resupply Service, but your ability to use some areas or functions may be limited.</p><p>20.4 Email from Resupply. Resupply may use your username and email address to provide you with email communications, such as newsletters and announcements. If you do not wish to receive these kinds of communications, you can opt out by unchecking the email newsletters and announcements boxes during registration. Resupply also offers you the option to unsubscribe from newsletters and announcements by return email or by changing your profile.</p><p>20.5 Text from Resupply. Resupply may use your username and phone number to provide you with text-message communications, such as pickup status or reminders. If you do not wish to receive these kinds of communications, you can opt out by responding with STOP to the message that was sent to you.</p><p>20.6 Information that we Collect. When you use the Resupply Service, we automatically collect and log certain personal information about you, including without limitation your IP address, session time, operating system and related information about the computer or mobile device that you use to access the Resupply Service, and location information. We may also track the Resupply Service to obtain anonymous data that enables us to analyze trends, administer the Resupply Service, track your actions and use of the Resupply Service, record donations, and gather demographic information for aggregate use. Such analysis is not linked to personally identifiable information. Resupply may share aggregated demographic and usage information with its partners and advertisers. This aggregated information is not linked to any personal information that can identify any individual person.</p><p>20.7 Use and Retention. We use the personal information that we collect to operate, improve and personalize the Resupply Service, to contact you and provide customer service, to customize our advertising and marketing, to detect, prevent and mitigate fraudulent or illegal activities and to comply with our legal obligations. We retain your personal information as long as it is required for the operation of the Resupply Service and for us to comply with our legal obligations.</p><p>20.8 Sharing of Information. We disclose personal information to respond to legal requirements, enforce our policies, and to respond to claims that our content or Charity Content violates the intellectual property or other rights of other users or third parties. Personal information will only be disclosed in accordance with applicable laws. Subject to the foregoing, your personal information may be shared with employees and agents of Resupply, third party vendors, consultants, service providers, payment processors and financial institutions who have contracted with Resupply in order for Resupply to efficiently operate the Resupply Service, other users (as necessary to facilitate donations pursuant to the Resupply Service), marketing partners and local and foreign law enforcement or regulatory agencies in response to a subpoena, court order or substantially similar legal procedure.</p><p>20.9 Security. We use technical and administrative security measures to protect your personal information from loss, theft, misuse and unauthorized access. Such measures include, without limitation, firewalls, data encryption, and information access authorization controls.</p><p>21. Choice of Law and Location for Resolving Disputes</p><p>21.1 You agree that the laws of the state of New York and US federal law govern these Software and Services Agreement, their subject matter, your use of the Resupply Service, and any claim or dispute that you may have against us, without regard to its conflict of laws rules, shall have no applicability. You further agree that any disputes or claims that you may have against us will be resolved by a court located in the state of New York and you agree and submit to the exercise of personal jurisdiction of such courts for the purpose of litigating any such claim or action. BY AGREEING TO THESE SOFTWARE AND SERVICES AGREEMENT, YOU ARE (A) WAIVING CLAIMS THAT YOU MIGHT OTHERWISE HAVE AGAINST US BASED ON THE LAWS OF OTHER JURISDICTIONS, INCLUDING YOUR OWN; (B) IRREVOCABLY CONSENTING TO THE EXCLUSIVE JURISDICTION OF, AND VENUE IN, THE STATE OR FEDERAL COURTS IN THE STATE OF NEW YORK OVER ANY DISPUTES OR CLAIMS YOU HAVE WITH US; AND (C) SUBMITTING YOURSELF TO THE PERSONAL JURISDICTION OF SUCH COURTS FOR THE PURPOSE OF RESOLVING ANY SUCH DISPUTES OR CLAIMS.</p><p>22. Arbitration</p><p>22.1 You agree that any disputes or claims that you may have against us will be (except as stated below) finally and exclusively resolved by binding arbitration. Any election to arbitrate by one party shall be final and binding on the other. The arbitration shall be commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association (“AAA”) and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (“AAA Consumer Rules”), both of which are available at the AAA web site www.adr.org. The determination of whether a dispute is subject to arbitration shall be governed by the Federal Arbitration Act and determined by a court rather than an arbitrator. Your arbitration fees and your share of arbitrator compensation shall be governed by the AAA Rules and, where appropriate, limited by the AAA Consumer Rules. The arbitration may be conducted in person, through the submission of documents, by phone or online. The arbitrator will make a decision in writing, and will provide a statement of reasons if requested by a party. Except as otherwise provided in this Agreement, you and Resupply may litigate in court to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate or enter judgment on the award entered by the arbitrator. YOU UNDERSTAND THAT ABSENT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE THE RIGHT TO A JURY TRIAL.</p><p>23. Severability and Integration</p><p>23.1 This contract and any supplemental terms, policies, rules and guidelines communicated to you by Resupply constitute the entire agreement between you and us and supersede all previous written or oral agreements. If any part of the Software and Services Agreement is held invalid or unenforceable, that portion shall be construed in a manner consistent with applicable law to reflect, as nearly as possible, the original intentions of the parties, and the remaining portions shall remain in full force and effect.</p></div></div>");
$templateCache.put("app/account/notifications/email/email.html","<div class=notifications-mng-wrapper><div class=notifications-action-wrapper><div class=row><div class=col-md-2><span class=select-label>Action</span></div><div class=col-md-7><ui-select ng-model=vm.actionType class=rspl-select title=\"Select action\" append-to-body=true><ui-select-match class=text-capitalize>{{$select.selected.alert_subtype.split(\'_\').join(\' \')}}</ui-select-match><ui-select-choices repeat=\"a in vm.defaultTemplates | filter: $select.search\"><span ng-bind-html=\"a.alert_subtype.split(\'_\').join(\' \')\" class=text-capitalize></span></ui-select-choices></ui-select></div><div class=\"col-md-3 text-right\"><span class=tgl-switch ng-click=vm.toggleAction() ng-class=\"{\'disabled\' : vm.actionType.disabled}\"><label class=tgl-label>{{ vm.actionType.disabled ? \'OFF\' : \'ON\' }}</label><div class=indicator></div></span></div></div></div><form name=email-notification-form ng-submit=vm.saveNotificationTemplate()><div class=form-group><label>Email Subject</label><input type=text class=form-control placeholder=\"eg. Donate & Join our Cause\" ng-model=vm.actionType.title></div><div class=form-group><label>Message Body</label><text-angular name=myTextAngular ta-toolbar=\"[[\'bold\', \'italics\', \'redo\', \'undo\', \'clear\'],[\'justifyLeft\', \'justifyCenter\', \'justifyRight\']]\" ng-model=vm.actionType.body_content></text-angular><div class=variables><i class=\"fa fa-question-circle\"></i> <span ng-mousedown=\"vm.insertVariable($event, \'donation_request_date\')\" class=variable-item>Donation Request Date</span> <span ng-mousedown=\"vm.insertVariable($event, \'donation_request_time\')\" class=variable-item>Donation Request Time</span> <span ng-mousedown=\"vm.insertVariable($event, \'donor_first_name\')\" class=variable-item>Donor First Name</span> <span ng-mousedown=\"vm.insertVariable($event, \'donor_last_name\')\" class=variable-item>Donor Last Name</span> <span ng-mousedown=\"vm.insertVariable($event, \'app_link\')\" class=variable-item>App Link</span> <span ng-mousedown=\"vm.insertVariable($event, \'reason\')\" class=variable-item>Cancellation Reason</span></div></div><div class=submit-actions><div class=row><div class=col-md-6><a href=https://resupplyme.atlassian.net/wiki/spaces/RCFKM/pages/306348216/Mail+Custom+Notifications target=_blank class=\"btn btn-primary\">Need Help? FAQs</a></div><div class=col-md-6><div class=text-right><button type=button class=\"btn btn-default\" ng-disabled=vm.actionType.default ng-click=vm.deleteCustomTemplate() ladda=vm.isDeleting>Reset to default</button> <button type=submit class=\"btn btn-primary\" ladda=vm.isSaving>Save</button></div></div></div></div></form></div>");
$templateCache.put("app/account/notifications/in-app/in-app.html","<div class=notifications-mng-wrapper><div class=notifications-action-wrapper><div class=row><div class=col-md-2><span class=select-label>Action</span></div><div class=col-md-7><ui-select ng-model=vm.actionType class=rspl-select title=\"Select action\" append-to-body=true><ui-select-match class=text-capitalize>{{$select.selected.alert_subtype.split(\'_\').join(\' \')}}</ui-select-match><ui-select-choices repeat=\"a in vm.defaultTemplates | filter: $select.search\"><span ng-bind-html=\"a.alert_subtype.split(\'_\').join(\' \')\" class=text-capitalize></span></ui-select-choices></ui-select></div><div class=\"col-md-3 text-right\"><span class=tgl-switch ng-click=vm.toggleAction() ng-class=\"{\'disabled\' : vm.actionType.disabled}\"><label class=tgl-label>{{ vm.actionType.disabled ? \'OFF\' : \'ON\' }}</label><div class=indicator></div></span></div></div></div><form name=in-app-notification-form ng-submit=vm.saveNotificationTemplate()><div class=form-group><label>Title</label><input type=text class=form-control placeholder=\"eg. Happy Hollidays!\" ng-model=vm.actionType.title></div><div class=form-group><label>Message Body</label><textarea text-box-with-vars class=form-control placeholder=\"eg. Bless you, and may you have a wonderful Christmas.\" ng-model=vm.actionType.body_content></textarea><div class=variables><i class=\"fa fa-question-circle\"></i> <span ng-click=\"vm.insertVariable(\'{{donation_request_date}}\')\" class=variable-item>Donation Request Date</span> <span ng-click=\"vm.insertVariable(\'{{donation_request_time}}\')\" class=variable-item>Donation Request Time</span> <span ng-click=\"vm.insertVariable(\'{{donor_first_name}}\')\" class=variable-item>Donor First Name</span> <span ng-click=\"vm.insertVariable(\'{{donor_last_name}}\')\" class=variable-item>Donor Last Name</span> <span ng-click=\"vm.insertVariable(\'{{app_link}}\')\" class=variable-item>App Link</span> <span ng-click=\"vm.insertVariable(\'{{reason}}\')\" class=variable-item>Cancellation Reason</span></div></div><div class=submit-actions><div class=row><div class=col-md-6><a href=https://resupplyme.atlassian.net/wiki/spaces/RCFKM/pages/306348209/In-App+Custom+Notification target=_blank class=\"btn btn-primary\">Need Help? FAQs</a></div><div class=col-md-6><div class=text-right><button type=button class=\"btn btn-default\" ng-disabled=vm.actionType.default ng-click=vm.deleteCustomTemplate() ladda=vm.isDeleting>Reset to default</button> <button type=submit class=\"btn btn-primary\" ladda=vm.isSaving>Save</button></div></div></div></div></form></div>");
$templateCache.put("app/account/notifications/push/push.html","<div class=notifications-mng-wrapper><div class=notifications-action-wrapper><div class=row><div class=col-md-2><span class=select-label>Action</span></div><div class=col-md-7><ui-select ng-model=vm.actionType class=rspl-select title=\"Select action\" append-to-body=true ng-change=vm.actionChanged()><ui-select-match class=text-capitalize>{{$select.selected.alert_subtype.split(\'_\').join(\' \')}}</ui-select-match><ui-select-choices repeat=\"a in vm.defaultTemplates | filter: $select.search\"><span ng-bind-html=\"a.alert_subtype.split(\'_\').join(\' \')\" class=text-capitalize></span></ui-select-choices></ui-select></div><div class=\"col-md-3 text-right\"><span class=tgl-switch ng-click=vm.toggleAction() ng-class=\"{\'disabled\' : vm.actionType.disabled}\"><label class=tgl-label>{{ vm.actionType.disabled ? \'OFF\' : \'ON\' }}</label><div class=indicator></div></span></div></div></div><form name=push-notification-form ng-submit=vm.saveNotificationTemplate()><div class=form-group><label>Title</label><input type=text class=form-control placeholder=\"eg. Happy Hollidays!\" ng-model=vm.actionType.title></div><div class=form-group><label>Message Body</label><textarea text-box-with-vars class=form-control placeholder=\"eg. Bless you, and may you have a wonderful Christmas.\" ng-model=vm.actionType.body_content></textarea><div class=variables><i class=\"fa fa-question-circle\"></i> <span ng-click=\"vm.insertVariable(\'{{donation_request_date}}\')\" class=variable-item>Donation Request Date</span> <span ng-click=\"vm.insertVariable(\'{{donation_request_time}}\')\" class=variable-item>Donation Request Time</span> <span ng-click=\"vm.insertVariable(\'{{donor_first_name}}\')\" class=variable-item>Donor First Name</span> <span ng-click=\"vm.insertVariable(\'{{donor_last_name}}\')\" class=variable-item>Donor Last Name</span> <span ng-click=\"vm.insertVariable(\'{{app_link}}\')\" class=variable-item>App Link</span> <span ng-click=\"vm.insertVariable(\'{{reason}}\')\" class=variable-item>Cancellation Reason</span></div></div><div class=submit-actions><div class=row><div class=col-md-6><a href=https://resupplyme.atlassian.net/wiki/spaces/RCFKM/pages/306282631/Push+Notification+Custom+Message target=_blank class=\"btn btn-primary\">Need Help? FAQs</a></div><div class=col-md-6><div class=text-right><button type=button class=\"btn btn-default\" ng-disabled=vm.actionType.default ng-click=vm.deleteCustomTemplate() ladda=vm.isDeleting>Reset to default</button> <button type=submit class=\"btn btn-primary\" ladda=vm.isSaving>Save</button></div></div></div></div></form></div>");
$templateCache.put("app/account/notifications/sms/sms.html","<div class=notifications-mng-wrapper><div class=notifications-action-wrapper><div class=row><div class=col-md-2><span class=select-label>Action</span></div><div class=col-md-7><ui-select ng-model=vm.actionType class=rspl-select title=\"Select action\" append-to-body=true ng-change=vm.actionChanged()><ui-select-match class=text-capitalize>{{$select.selected.alert_subtype.split(\'_\').join(\' \')}}</ui-select-match><ui-select-choices repeat=\"a in vm.defaultTemplates | filter: $select.search\"><span ng-bind-html=\"a.alert_subtype.split(\'_\').join(\' \')\" class=text-capitalize></span></ui-select-choices></ui-select></div><div class=\"col-md-3 text-right\"><span class=tgl-switch ng-click=vm.toggleAction() ng-class=\"{\'disabled\' : vm.actionType.disabled}\"><label class=tgl-label>{{ vm.actionType.disabled ? \'OFF\' : \'ON\' }}</label><div class=indicator></div></span></div></div></div><form name=sms-notification-form ng-submit=vm.saveNotificationTemplate()><div class=form-group><label>Message Body</label><textarea text-box-with-vars class=form-control placeholder=\"eg. Bless you, and may you have a wonderful Christmas.\" ng-model=vm.actionType.body_content></textarea><div class=variables><i class=\"fa fa-question-circle\"></i> <span ng-click=\"vm.insertVariable(\'{{donation_request_date}}\')\" class=variable-item>Donation Request Date</span> <span ng-click=\"vm.insertVariable(\'{{donation_request_time}}\')\" class=variable-item>Donation Request Time</span> <span ng-click=\"vm.insertVariable(\'{{donor_first_name}}\')\" class=variable-item>Donor First Name</span> <span ng-click=\"vm.insertVariable(\'{{donor_last_name}}\')\" class=variable-item>Donor Last Name</span> <span ng-click=\"vm.insertVariable(\'{{app_link}}\')\" class=variable-item>App Link</span> <span ng-click=\"vm.insertVariable(\'{{reason}}\')\" class=variable-item>Cancellation Reason</span></div></div><div class=submit-actions><div class=row><div class=col-md-6><a href=https://resupplyme.atlassian.net/wiki/spaces/RCFKM/pages/308576283/SMS+Text+Notifications+Customization target=_blank class=\"btn btn-primary\">Need Help? FAQs</a></div><div class=col-md-6><div class=text-right><button type=button class=\"btn btn-default\" ng-disabled=vm.actionType.default ng-click=vm.deleteCustomTemplate() ladda=vm.isDeleting>Reset to default</button> <button type=submit class=\"btn btn-primary\" ladda=vm.isSaving>Save</button></div></div></div></div></form></div>");
$templateCache.put("app/account/schedule/prompts/delete-exception.html","<div class=modal-header><h3 class=modal-title id=modal-title>Delete Exception</h3></div><div class=modal-body id=modal-body><p>Are you sure you want to delete schedule exception?</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=delCtrl.close()>Close</button> <button ladda=delCtrl.deleting class=\"btn btn-primary\" ng-click=delCtrl.deleteException()>Delete</button><div uib-alert ng-repeat=\"alert in delCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=acceptCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/database/donorgroups/creategroup/creategroup.directive.html","<div class=donor-group-directive><div uib-alert ng-repeat=\"alert in newGroupCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=newGroupCtrl.closeAlert($index)>{{alert.msg}}</div><div class=group-editor><div class=select-group><div class=row><div class=col-sm-2><div class=\"btn btn-inverse\" ng-class=\"{\'btn-primary\' : newGroupCtrl.activeFilter === \'app_user\'}\" ng-click=\"newGroupCtrl.getContactsByCharityId(\'app_user\', 1)\" id=app-users>App Users</div></div><div class=col-sm-2><div class=\"btn btn-inverse\" ng-class=\"{\'btn-primary\' : newGroupCtrl.activeFilter === \'non_app_user\'}\" ng-click=\"newGroupCtrl.getContactsByCharityId(\'non_app_user\', 1)\" id=non-app-users>Non App Users</div></div><div class=col-sm-2><div class=\"btn btn-inverse\" ng-class=\"{\'btn-primary\' : newGroupCtrl.activeFilter === \'call_log\'}\" ng-click=\"newGroupCtrl.getContactsByCharityId(\'call_log\', 1)\" id=phone-users>Phone</div></div><div class=col-sm-2><label for=file-upload class=custom-file-upload ng-class=\"{\'btn-primary\' : newGroupCtrl.activeFilter === \'csv\'}\">Upload CSV</label><input id=file-upload file-reader=newGroupCtrl.fileContent type=file accept=.csv></div><div class=col-sm-4><ui-select ng-model=newGroupCtrl.selectedGroup class=\"rspl-select big-select\" title=\"Donor Groups\" append-to-body=true ng-change=\"newGroupCtrl.getSelectedGroup(newGroupCtrl.selectedGroup.id, true)\"><ui-select-match class=text-capitalize placeholder=\"Previous Groups\" allow-clear=false>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"o in newGroupCtrl.groups | filter: $select.search | orderBy:\'name\'\"><span ng-bind-html=\"o.name + \' (\' + o.contacts_count + \')\'\" class=text-capitalize></span></ui-select-choices></ui-select></div></div></div><div class=all_contacts><table><thead><tr><th style=\"width: 20%\"><div class=\"mg-checkbox has-options\" ng-class=\"{\'disabled\' : newGroupCtrl.isLoading}\"><input type=checkbox ng-model=newGroupCtrl.allContactsSelected ng-checked=newGroupCtrl.allContactsSelected><label id=checkbox-label-select-all ng-class=\"{\'selected\': newGroupCtrl.allContactsSelected, \'disabled\': !newGroupCtrl.allContactsSelected}\"></label><div class=check-options><p ng-click=newGroupCtrl.selectAllContacts()>Select this page</p><p ng-class=\"{\'disabled\' : newGroupCtrl.selectedGroup}\" ng-click=newGroupCtrl.selectContactsFromAllPages(true)>Select all pages</p></div></div>Donor</th><th style=\"width: 20%\">Address</th><th style=\"width: 30%\">Email</th><th style=\"width: 15%\">Phone</th><th style=\"width: 15%\">Last donation</th></tr></thead></table><div class=table-body ng-scrollbars ng-scrollbars-config=newGroupCtrl.scrollConfig><table><tbody><div ng-if=newGroupCtrl.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div></tbody><tbody ng-if=!newGroupCtrl.isLoading><h4 class=text-center ng-if=\"newGroupCtrl.contacts.length === 0 && !newGroupCtrl.isLoading && !newGroupCtrl.noAvailableContacts\">All Contacts from this page already inserted</h4><h4 class=text-center ng-if=\"!newGroupCtrl.isLoading && newGroupCtrl.noAvailableContacts\">No Contacts</h4><tr ng-repeat=\"contact in newGroupCtrl.contacts\"><td style=\"width: 20%\"><div class=mg-checkbox><input type=checkbox ng-model=contact.selected ng-checked=contact.selected><label ng-class=\"{\'selected\': contact.selected}\" ng-click=newGroupCtrl.selectContactItem(contact)></label></div>{{contact.first_name+\' \'+contact.last_name}}</td><td style=\"width: 20%\">{{contact.address + \', \' + contact.zip + \' \' + contact.city}}</td><td style=\"width: 30%\">{{contact.email}}</td><td style=\"width: 15%\">{{contact.phone}}</td><td style=\"width: 15%\">{{contact.last_donation_date | date : \'MMM dd yyyy\'}}</td></tr></tbody></table></div><div class=\"contacts-pagination text-center\"><p class=pull-left>{{newGroupCtrl.contactsSelected.length}} Selected</p><i class=\"rspl-icon icon-arrow-left\" ng-class=\"{\'disabled\' : newGroupCtrl.pagination.currentPage == 1 || newGroupCtrl.isLoading}\" ng-click=newGroupCtrl.previousPage()></i> <span>page {{newGroupCtrl.pagination.currentPage}} of {{newGroupCtrl.pagination.totalPages}}</span> <i class=\"rspl-icon icon-arrow-right\" ng-class=\"{\'disabled\' : newGroupCtrl.pagination.currentPage == newGroupCtrl.pagination.totalPages || newGroupCtrl.isLoading}\" ng-click=newGroupCtrl.nextPage()></i></div></div><div class=\"add-remove-contact clearfix\"><div class=\"btns-container pull-left\"><button class=\"btn btn-primary\" ng-click=newGroupCtrl.addContactsToGroup()><img ng-src=assets/images/arrow-down.png alt=\"\"><p>Insert</p></button> <button class=\"btn btn-primary\" ng-click=newGroupCtrl.removeContactsFromGroup() ng-disabled=\"newGroupCtrl.new_group.contacts.length < 1\"><img ng-src=assets/images/arrow-up.png alt=\"\"><p>Remove</p></button></div><form class=\"group_name_form pull-right\"><label for=group_name>New Group Name</label><input id=group_name type=text ng-model=newGroupCtrl.new_group.name ng-change=newGroupCtrl.checkValidation() ng-model-options=\"{ debounce: 500 }\"></form></div><div class=group_contacts><span class=counter ng-if=!newGroupCtrl.creatingContactsFromCSVdone><img ng-src=assets/images/loader_small.gif alt=loading></span><table><thead><tr><th style=\"width: 20%\"><div class=mg-checkbox><input type=checkbox ng-model=newGroupCtrl.groupContactsSelected ng-checked=newGroupCtrl.groupContactsSelected><label id=checkbox-label-selected-all ng-class=\"{\'selected\': newGroupCtrl.groupContactsSelected}\" ng-click=newGroupCtrl.selectAllGroupContacts()></label></div>Donor</th><th style=\"width: 20%\">Address</th><th style=\"width: 30%\">Email</th><th style=\"width: 15%\">Phone</th><th style=\"width: 15%\">Last donation</th></tr></thead></table><div class=empty-group ng-if=!newGroupCtrl.new_group.contacts.length><table><tbody>Create your group here</tbody></table></div><div class=table-body ng-if=newGroupCtrl.new_group.contacts.length ng-scrollbars ng-scrollbars-config=newGroupCtrl.scrollConfig><table><tbody ng-if=newGroupCtrl.new_group><tr ng-repeat=\"contact in newGroupCtrl.new_group.contacts | limitTo: 1000\"><td><div class=mg-checkbox><input type=checkbox ng-model=contact.selected ng-checked=contact.selected><label ng-class=\"{\'selected\': contact.selected}\" ng-click=newGroupCtrl.selectContactItem(contact)></label></div>{{contact.first_name+\' \'+contact.last_name}}</td><td style=\"width: 20%\">{{contact.address + \', \' + contact.zip + \' \' + contact.city}}</td><td style=\"width: 30%\">{{contact.email}}</td><td style=\"width: 15%\"><p>{{contact.phone}}</p><p>{{contact.alternative_phone}}</p></td><td style=\"width: 15%\">{{contact.last_donation_date | date : \'MMM dd yyyy\'}}</td></tr></tbody></table></div><div ng-if=newGroupCtrl.new_group.contacts.length class=contacts-pagination><p class=pull-left>{{newGroupCtrl.new_group.contacts.length}} Contacts</p></div></div></div></div>");
$templateCache.put("app/database/donorgroups/creategroup/creategroup.html","<div class=create-group><div class=bottom-nav><div class=\"main container\"><!--<div class=\"btn btn-primary pull-left\"><span>Back</span></div>--><div class=\"group-action-btns pull-right\"><button class=\"btn btn-cancel\" ui-sref=database.donorgroups.allgroups><span>Cancel</span></button> <button ladda=vm.creating_group ng-click=newGroupCtrl.createNewGroup() class=\"btn btn-primary\" ng-disabled=!newGroupCtrl.groupValid><span>Save</span></button></div></div></div><div class=content><div class=\"main container\"><donorgroup></donorgroup></div></div></div>");
$templateCache.put("app/database/donorgroups/singlegroup/singlegroup.html","<div class=singlegroup><div class=bottom-nav><div class=\"main container\"><div class=\"btn btn-primary pull-left\" ui-sref=database.donorgroups.allgroups><span>Back</span></div><div class=\"group-action-btns pull-right\"><div class=\"btn btn-danger\" ng-click=vm.deleteGroupPrompt(vm.current_group)><span>Delete Group</span></div><!--<div class=\"btn btn-primary\" ui-sref=\"database.donorgroups.editgroup({ id: {{ vm.current_group.id }} })\"><span>Edit Group</span></div>--></div></div></div><div class=content><div class=\"main container\"><div class=filter-bar><div class=\"group-name pull-left\"><p>{{vm.current_group.name + \' (\' + vm.current_group.contacts_count +\')\'}}</p></div><div class=\"search-donors pull-left\"><form ng-submit=\"vm.getGroupContacts(vm.current_group.id, vm.donor)\" name=cont.searchForm><div class=row><div class=\"col-xs-9 pull-left\"><div class=search><i class=\"rspl-icon icon-search\"></i> <input type=text ng-model=vm.donor placeholder=\"Search donors...\" class=form-control></div></div><div class=\"col-xs-3 pull-left\"><div class=search-submit><button class=\"btn btn-primary\" type=submit ladda=vm.isSearching ng-disabled=!cont.searchForm.$dirty>Search</button></div></div></div></form></div></div><div class=donors-table><div ng-if=vm.gettingGroup class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><table ng-if=!vm.gettingGroup><thead><tr><th style=\"width: 20%\">Donor</th><th style=\"width: 20%\">Address</th><th style=\"width: 25%\">Email</th><th style=\"width: 13%\">Phone</th><th style=\"width: 12%\">Last donation</th><th></th></tr></thead><tbody><tr ng-repeat=\"contact in vm.current_group.contacts\"><td style=\"width: 20%\">{{contact.first_name+\' \'+contact.last_name}}</td><td id=contact-address style=\"width: 20%\">{{contact.address + \', \' + contact.zip + \' \' + contact.city}}</td><td style=\"width: 25%\">{{contact.email}}</td><td style=\"width: 13%\">{{contact.phone}}</td><td style=\"width: 12%\">{{contact.last_donation_date | date : \'MMM dd yyyy\'}}</td><td><div class=pull-right><span><img ng-click=vm.edit_contact(contact) ng-src=assets/images/edit.png alt=\"\"> </span><span><img ng-click=vm.deleteContactPrompt(contact) ng-src=assets/images/delete.svg alt=\"\"></span></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/database/donormanagement/outreach/outreach.html","<div class=\"main outreach\"><div class=bottom-nav><div class=\"container main\"><div class=form-switch><div class=active>Outreach</div><div ui-sref=donors>Donors</div></div></div></div><div class=main><div class=\"main container\"><div uib-alert ng-repeat=\"alert in vm.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=vm.closeAlert($index)>{{alert.msg}}</div><div class=outreach-wrapper><div class=row><div class=\"col-xs-12 col-sm-5 col-lg-4\"><div class=row><div class=\"col-xs-12 filters\"><ul><li ng-repeat=\"filter in vm.filters\"><div class=mg-checkbox><input type=checkbox ng-checked=\"vm.checked.id === filter.id\"><label ng-click=vm.check(filter)></label><span ng-click=vm.check(filter)>{{filter.title}}</span><div class=select-wrapper ng-if=\"filter.id === \'zip\'\"><ui-select multiple ng-model=vm.zips class=rspl-select title=ZIP append-to-body=true><ui-select-match placeholder=ZIP>{{$item}}</ui-select-match><ui-select-choices repeat=\"o in vm.uniqueZips | filter: $select.search\"><span ng-bind-html=o></span></ui-select-choices></ui-select></div><div class=category-wrapper ng-if=\"filter.id === \'cat\'\"><ui-select ng-model=vm.selectedCategory class=rspl-select title=Category append-to-body=true><ui-select-match placeholder=Category class=text-capitalize allow-clear=true>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"o in vm.itemTypes | filter: $select.search\"><span ng-bind-html=o.name class=text-capitalize></span></ui-select-choices></ui-select></div></div></li></ul></div></div><div class=\"row footer\"><div class=col-xs-12><div class=mg-checkbox><div class=automatic-info><span>If checked ReSupply will automatically send message to your group of donors every two months.</span> <i class=\"rspl-icon icon-info\">i</i></div><input type=checkbox ng-checked=vm.automatic><label ng-click=\"vm.automatic = !vm.automatic\"></label><span ng-click=\"vm.automatic = !vm.automatic\">Automatic outreach</span></div></div></div></div><form class=\"col-xs-12 col-sm-7 col-lg-8 email\"><div class=recipient><p>To: <span>{{vm.checked.title}} <span ng-if=\"vm.checked.id === \'cat\'\" class=text-capitalize>{{vm.selectedCategory ? vm.selectedCategory.name : \'Category\'}}</span> <span ng-if=\"vm.checked.id === \'zip\' && (!vm.zips || vm.zips.length === 0)\">ZIP</span> <span ng-if=\"vm.checked.id === \'zip\'\" ng-repeat=\"z in vm.zips track by $index\"><span ng-if=\"$index !== 0\">,</span> {{z}} </span></span><span>106 donors on the list</span></p></div><div class=content><input type=text class=form-control placeholder=Subject><div text-angular ng-model=htmlVariable ta-toolbar=vm.toolbar placeholder=\"Your message goes here...\"></div></div><button class=\"btn btn-primary\" type=submit>Send</button></form></div></div></div></div></div>");
$templateCache.put("app/donations/prompts/accept/accept.html","<div class=modal-header><h3 class=modal-title id=modal-title>Accept Donation</h3></div><div class=modal-body id=modal-body><p>Are you sure this donation is acceptable?</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=acceptCtrl.close()>Close</button> <button ladda=acceptCtrl.isLoading class=\"btn btn-primary\" ng-click=acceptCtrl.accept()>Accept</button><div uib-alert ng-repeat=\"alert in acceptCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=acceptCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/donations/prompts/cancel/cancel.html","<div class=modal-header><h3 class=modal-title id=modal-title>Report Issues</h3></div><div class=modal-body id=modal-body><p>Are you sure you want to report issues for this donation?</p><textarea type=text class=form-control ng-model=cancelCtrl.reason placeholder=\"Why are you canceling this donation?\"></textarea></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=cancelCtrl.close()>Close</button> <button ladda=cancelCtrl.isLoading class=\"btn btn-primary\" ng-click=cancelCtrl.cancel()>Cancel Donation</button><div uib-alert ng-repeat=\"alert in cancelCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=cancelCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/donations/prompts/changeDate/changeDate.html","<div class=modal-header><h3 class=modal-title id=modal-title>Change date</h3></div><div class=\"modal-body change-date-manual\" id=modal-body><div class=form-group><label>Pickup date</label>{{vm.donation | json}}<div uib-datepicker ng-model=changeDateCtrl.donation.request.date class=\"well well-sm\" datepicker-options=changeDateCtrl.datePickerOptions></div></div><div class=form-group><label>Pickup time</label><div class=btn-group><div ng-click=\"changeDateCtrl.donation.request.part_of_day = \'am\'\" ng-class=\"{\'btn-primary\' : changeDateCtrl.donation.request.part_of_day === \'am\', \'btn-default\' : changeDateCtrl.donation.request.part_of_day !== \'am\'}\" class=btn>AM</div><div ng-click=\"changeDateCtrl.donation.request.part_of_day = \'pm\'\" ng-class=\"{\'btn-primary\' : changeDateCtrl.donation.request.part_of_day === \'pm\', \'btn-default\' : changeDateCtrl.donation.request.part_of_day !== \'pm\'}\" class=btn>PM</div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=changeDateCtrl.close()>Close</button> <button ladda=changeDateCtrl.isLoading class=\"btn btn-primary\" ng-click=changeDateCtrl.changeDate()>Submit</button><div uib-alert ng-repeat=\"alert in changeDateCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=changeDateCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/donations/prompts/claim/claim.html","<div class=modal-header><h3 class=modal-title id=modal-title>Claim Donation</h3></div><div class=modal-body id=modal-body><p>Are you sure this donation is acceptable?</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=claimCtrl.close()>Close</button> <button ladda=claimCtrl.isLoading class=\"btn btn-primary\" ng-click=claimCtrl.accept()>Claim</button><div uib-alert ng-repeat=\"alert in claimCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=claimCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/donations/prompts/complete/complete.html","<div class=modal-header><h3 class=modal-title id=modal-title>Complete Donation</h3></div><div class=modal-body id=modal-body><p>Are you sure this donation is picked up and you want to mark it as complete?</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=completeCtrl.close()>Close</button> <button ladda=completeCtrl.isLoading class=\"btn btn-primary\" ng-click=completeCtrl.complete()>Complete</button><div uib-alert ng-repeat=\"alert in completeCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=completeCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/donations/prompts/donorApproval/donor.approval.html","<div class=choice-modal><div class=modal-header><h3 class=modal-title id=modal-title>Change date?</h3></div><div class=modal-body id=modal-body><p class=intro>Are you sure you want to make time change request?</p><div class=modal-body-radios><label ng-repeat=\"option in approvalCtrl.radioOptions track by $index\"><input type=radio ng-model=approvalCtrl.needsApproval ng-value=option.value> <span class=checkmark></span> {{ option.label }}</label></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=approvalCtrl.close()>Cancel</button> <button class=\"btn btn-primary\" ng-click=approvalCtrl.nextStep() ng-disabled=\"approvalCtrl.needsApproval === undefined\">Confirm</button><div uib-alert ng-repeat=\"alert in approvalCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=approvalCtrl.closeAlert($index)>{{alert.msg}}</div></div></div>");
$templateCache.put("app/donations/prompts/edit-manual-donation/edit-donation.html","<form name=donationForm class=donation-form ng-submit=editDonationCtrl.submitForm()><div class=modal-header><h3 class=modal-title id=modal-title>Edit Donation</h3><div ng-click=editDonationCtrl.close() class=close-btn></div></div><div class=\"modal-body new-donation\" id=modal-body><div class=\"row selected-donor\"><div class=profile-data ng-if=!editDonationCtrl.donorProfileIncomplete><div class=image ng-if=\"editDonationCtrl.donorForm.photo && editDonationCtrl.donorForm.photo.url\" ng-style=\"{\'background-image\': \'url(\' + editDonationCtrl.baseUrl + \'/\' + editDonationCtrl.donorForm.photo.url + \'?w=360)\'}\"></div><div ng-if=\"!editDonationCtrl.donorForm.photo || !editDonationCtrl.donorForm.photo.url\" class=image ng-style=\"{\'background-image\': \'url(/assets/images/user-img@2x.png)\'}\"></div><div class=name><span>{{editDonationCtrl.donorForm.first_name}} {{editDonationCtrl.donorForm.last_name}}</span> <span>High Rank</span></div><div class=contact-info><span>{{editDonationCtrl.donorForm.address}} {{editDonationCtrl.donorForm.state}}, {{editDonationCtrl.donorForm.city}} - ZIP:<span class=zip>{{editDonationCtrl.donorForm.zip}}</span></span> <span>{{editDonationCtrl.donorForm.phone}}</span> <span>{{editDonationCtrl.donorForm.email}}</span></div></div></div><div class=\"row separator\"><div class=full-width></div></div><div class=row><div class=col-xs-6><div class=images-wrapper style=\"height: 615px\"><div class=\"btn bnt-block\" ngf-select ng-model=editDonationCtrl.files ngf-multiple=true><span class=\"rspl-icon icon-add-image\"></span> <span>Add image</span></div><div class=img-wrapper ng-repeat=\"image in editDonationCtrl.donationForm.donationPhotos\"><img ng-src={{editDonationCtrl.imageBaseUrl}}{{image.url}} class=img-thumbnail> <i class=\"fa fa-times-circle\" ng-click=editDonationCtrl.removeExistingPhoto($index)></i></div><div class=img-wrapper ng-repeat=\"f in editDonationCtrl.allFiles\"><img ngf-src=\"!f.$error && f\" class=img-thumbnail> <i class=\"fa fa-times-circle\" ng-click=editDonationCtrl.removePhoto($index)></i></div></div></div><div class=col-xs-6><div class=form-group><label>Donation Address</label><input type=text class=form-control ng-model=editDonationCtrl.donationForm.address placeholder=Address required></div><div class=row><div class=\"col-xs-5 small-padding-right\"><div class=form-group><label>City</label><input type=text class=form-control ng-model=editDonationCtrl.donationForm.city placeholder=City required></div></div><div class=\"col-xs-4 small-padding-left small-padding-right\"><div class=form-group><label>State</label><input type=text class=form-control ng-model=editDonationCtrl.donationForm.state placeholder=State required></div></div><div class=\"col-xs-3 small-padding-left\"><div class=form-group><label>Zip</label><input type=text class=form-control ng-model=editDonationCtrl.donationForm.zip placeholder=ZIP></div></div></div><div class=form-group><label>Donation description</label><textarea class=form-control ng-model=editDonationCtrl.donationForm.description placeholder=Description></textarea></div><div class=form-group><label>Additional instructions for the driver <span class=optional>Optional</span></label><textarea class=form-control ng-model=editDonationCtrl.donationForm.special_instructions placeholder=Instructions></textarea></div><div class=\"row form-group\"><div class=col-xs-6><div class=\"form-group estimated-price no-margin\"><label>Estimated Price ($)</label><input class=form-control ng-model=editDonationCtrl.donationForm.estimated_price max=5000 min=0 type=number ng-pattern=/^\\d+([,.]\\d+)?$/ step=.01 placeholder=\"eg. 50\"> <i>$</i></div></div><div class=col-xs-6><ui-select ng-model=editDonationCtrl.donationForm.truck class=\"rspl-select truck-select\" title=\"Select Truck\" ng-disabled=\"!editDonationCtrl.trucks || editDonationCtrl.trucks.length === 0\" style=\"margin-top: 26px\"><ui-select-match placeholder=\"Select Truck\" class=text-capitalize allow-clear=true>{{$select.selected.model}}</ui-select-match><ui-select-choices repeat=\"o in editDonationCtrl.trucks | filter: $select.search\"><span ng-bind-html=o.model class=text-capitalize></span></ui-select-choices></ui-select></div></div><div class=form-group><label>Pickup date</label><p class=input-group><input type=text uib-datepicker-popup={{format}} ng-model=editDonationCtrl.donationForm.date class=\"form-control well well-sm datepicker\" datepicker-options=editDonationCtrl.datePickerOptions is-open=editDonationCtrl.datePickerOpened show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default btn-datepicker\" ng-click=\"editDonationCtrl.datePickerOpened = true;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=form-group><label>Pickup time</label><div class=btn-group><div ng-click=\"editDonationCtrl.donationForm.part_of_day = \'am\'\" ng-class=\"{\'btn-primary\' : editDonationCtrl.donationForm.part_of_day === \'am\', \'btn-default\' : editDonationCtrl.donationForm.part_of_day !== \'am\'}\" class=btn>AM</div><div ng-click=\"editDonationCtrl.donationForm.part_of_day = \'pm\'\" ng-class=\"{\'btn-primary\' : editDonationCtrl.donationForm.part_of_day === \'pm\', \'btn-default\' : editDonationCtrl.donationForm.part_of_day !== \'pm\'}\" class=btn>PM</div></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=editDonationCtrl.close() type=button>Close</button> <button ladda=editDonationCtrl.isSubmitting class=\"btn btn-primary\" ng-disabled=donationForm.$invalid type=submit>Save</button><div uib-alert ng-repeat=\"alert in editDonationCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=editDonationCtrl.closeAlert($index) ng-bind-html=alert.msg></div></div></form>");
$templateCache.put("app/donations/prompts/new/new.html","<script type=text/ng-template id=contactTemplate><span class=\"phone\">{{match.model.phone}}</span>\n    <span>{{match.model.first_name}} </span>\n    <span>{{match.model.last_name}}</span></script><form name=donationForm class=donation-form><div class=modal-header><h3 class=modal-title id=modal-title>Add donation & schedule pickup</h3><div ng-click=newCtrl.close() class=close-btn></div></div><div class=\"modal-body create-donation\" id=modal-body><uib-accordion close-others=oneAtATime><div uib-accordion-group class=panel-default is-open=newCtrl.accordion.donorInfo is-disabled=status.isFirstDisabled><uib-accordion-heading><div class=\"panel-heading-inner clearfix\"><span class=title>Donor Info <span class=panel-heading-content ng-if=\"(newCtrl.selectedDonor && newCtrl.selectedDonor.id && !newCtrl.donorProfileIncomplete) || (newCtrl.donor && donationForm.$valid)\"><img src=/assets/images/check-circle.png alt=\"\"> <span ng-if=newCtrl.selectedDonor>{{newCtrl.selectedDonor.name}}, {{newCtrl.selectedDonor.phone}}, {{newCtrl.selectedDonor.address}}, {{newCtrl.selectedDonor.zip}}</span> <span ng-if=newCtrl.donor>{{newCtrl.donor.first_name}} {{newCtrl.donor.last_name}}, {{newCtrl.donor.phone}}, {{newCtrl.donor.address}}, {{newCtrl.donor.zip}}</span> </span></span><i class=\"pull-right rspl-icon\" ng-class=\"{\'icon-shevron-right\': !newCtrl.accordion.donorInfo, \'icon-shevron-left\': newCtrl.accordion.donorInfo}\"></i></div></uib-accordion-heading><div class=donor-info-content><div class=select-donor><div class=row><div class=col-xs-6><div class=\"form-group custom-typeahead-block\" ng-class=\"{\'disabled\' : newCtrl.isNewDonor}\"><label>Search Existing Donor</label><input ng-keypress=\"newCtrl.pickupDays.availableDays = null\" type=text placeholder=\"eg. Gregory Simpson\" ng-model=newCtrl.selectedDonor uib-typeahead=\"donor as donor.name for donor in newCtrl.getUsers($viewValue)\" typeahead-template-url=contactTemplate class=form-control typeahead-wait-ms=300 typeahead-on-select=newCtrl.donorPicked()></div></div><div class=col-xs-6><div class=btn-group><div ng-click=newCtrl.setDonorType(false) ng-class=\"{\'btn-primary\' : !newCtrl.isNewDonor, \'btn-default\' : newCtrl.isNewDonor}\" class=btn>Existing Donor</div><div ng-click=newCtrl.setDonorType(true) ng-class=\"{\'btn-primary\' : newCtrl.isNewDonor, \'btn-default\' : !newCtrl.isNewDonor}\" class=btn>New Donor</div></div></div></div><div class=row><div class=col-xs-12><div ng-if=\"!newCtrl.isNewDonor && newCtrl.selectedDonor && newCtrl.selectedDonor.id\" class=\"selected-donor clearfix\"><div class=profile-data ng-if=!newCtrl.donorProfileIncomplete><div class=row><div class=col-xs-7><div ng-click=newCtrl.getPickUpDateOptions() class=selected-donor-img ng-style=\"{\'background-image\': \'url(/assets/images/user-img@2x.png)\'}\"></div><div class=selected-donor-name><p>{{newCtrl.selectedDonor.first_name}} {{newCtrl.selectedDonor.last_name}}</p><p>{{newCtrl.selectedDonor.organization}}</p><p class=edit-donor ng-click=newCtrl.editContact(newCtrl.selectedDonor)>Edit</p></div></div><div class=col-xs-5><div class=selected-donor-info><p>{{newCtrl.selectedDonor.address}} {{newCtrl.selectedDonor.state}}, {{newCtrl.selectedDonor.city}} - ZIP:<span class=zip> {{newCtrl.selectedDonor.zip}}</span></p><p>{{newCtrl.selectedDonor.phone}}</p><p>{{newCtrl.selectedDonor.email}}</p></div></div></div></div><p class=\"text-center danger\" ng-if=newCtrl.donorProfileIncomplete>Donor profile incomplete, please choose another one.</p></div><div ng-if=newCtrl.isNewDonor class=new-donor><form class=new-donor-form><div class=row><div class=col-xs-6><div class=form-group><label>First Name</label><input class=form-control ng-model=newCtrl.donor.first_name type=text placeholder=John></div></div><div class=col-xs-6><div class=form-group><label>Last Name</label><input class=form-control ng-model=newCtrl.donor.last_name type=text placeholder=Smith></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Email</label><input class=form-control ng-model=newCtrl.donor.email type=email placeholder=example@email.com></div></div><div class=col-xs-6><div class=form-group><label>Phone</label><input class=form-control ng-model=newCtrl.donor.phone type=text placeholder=\"+1 (000) 000-0000\"></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Alternate Phone Number</label><input class=form-control ng-model=newCtrl.donor.alternative_phone type=text placeholder=\"+1 (000) 000-0000\"></div></div><div class=col-xs-6><div class=form-group><label>Organization</label><input class=form-control ng-model=newCtrl.donor.organization type=text placeholder=Organization></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Zip Code <span class=optional>| Required</span></label><input typeahead-on-select=newCtrl.onZipChange() ng-change=newCtrl.onZipChange() class=form-control ng-minlength=5 ng-maxlength=5 ng-model=newCtrl.donor.zip type=text placeholder=ZIP uib-typeahead=\"zip for zip in newCtrl.getZipCodes($viewValue)\" typeahead-loading=newCtrl.loadingZips autocomplete=new-password required> <i ng-show=newCtrl.loadingZips class=\"fa fa-spinner fa-spin\"></i></div></div><div class=col-xs-6><div class=form-group><label>Address</label><input class=form-control ng-model=newCtrl.donor.address type=text placeholder=\"123 Example St\"></div></div></div><div class=row><div class=col-xs-6><div class=row><div class=col-xs-9><div class=form-group><label>City</label><input class=form-control ng-model=newCtrl.donor.city type=text placeholder=City></div></div><div class=col-xs-3><div class=form-group><label>State</label><input class=form-control ng-model=newCtrl.donor.state type=text placeholder=MA ng-minlength=2 ng-maxlength=2></div></div></div></div></div></form></div></div></div></div></div></div><div uib-accordion-group class=panel-default is-open=newCtrl.accordion.pickupDetails><uib-accordion-heading><div class=panel-heading-inner><span class=\"title pickup-details\">Pickup Details <span class=panel-heading-content ng-if=\"newCtrl.donationForm.pickupDay.date && newCtrl.pickupDays.availableDays\"><img src=/assets/images/check-circle.png alt=\"\"> <span>{{newCtrl.donationForm.pickupDay.date | date:\'EEEE - LLLL dd\'}} <span class=all-caps>{{newCtrl.donationForm.part_of_day}}</span><span ng-if=newCtrl.donationForm.description>, {{newCtrl.donationForm.description}}</span></span> </span></span><i class=\"pull-right rspl-icon\" ng-class=\"{\'icon-shevron-right\': !newCtrl.accordion.pickupDetails, \'icon-shevron-left\': newCtrl.accordion.pickupDetails}\"></i></div></uib-accordion-heading><div class=row><div class=\"col-xs-12 no-zip\" ng-if=\"!newCtrl.pickupDays.availableDays.length && !newCtrl.gettingAvailableDays\">PLEASE POPULATE YOUR ZIP CODE TO SEE AVAILABLE PICKUP TIMES</div><div class=\"col-xs-12 alert-box zip-nomatch\" ng-if=\"!day.zip_available && (newCtrl.donationForm.pickupDay.schedule_am === 0 && newCtrl.donationForm.pickupDay.schedule_pm === 0) && !newCtrl.donationForm.pickupDay.warningConfirmed \"><div class=\"alert-icon pull-left\"><img src=/assets/images/alert-circle.png alt=\"\"></div><div class=\"alert-msg pull-left\">This Zip Code is outside of your designated pickup range for {{newCtrl.donationForm.pickupDay.date | date:\'EEEE - LLLL dd\'}}. However, you can make an exception and submit this donation anyways.</div><button ladda=newCtrl.makingException class=\"btn btn-primary btn-block\" ng-click=newCtrl.makeException()>I Understand</button></div><div class=col-xs-12 ng-if=\"!newCtrl.pickupDays.availableDays.length && newCtrl.gettingAvailableDays\"><div class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div></div><div ng-if=\"(newCtrl.selectedDonor && newCtrl.selectedDonor.id || newCtrl.donor) && newCtrl.pickupDays.availableDays.length\" class=col-xs-12><div class=row><div class=\"alert-box clearfix col-xs-12\" ng-if=\"(newCtrl.donationForm.part_of_day === \'am\' && newCtrl.donationForm.pickupDay.schedule_am !== 0 && newCtrl.donationForm.pickupDay.schedule_am - newCtrl.donationForm.pickupDay.am >= newCtrl.donationForm.pickupDay.schedule_am) || (newCtrl.donationForm.part_of_day === \'pm\' && newCtrl.donationForm.pickupDay.schedule_pm !== 0 && newCtrl.donationForm.pickupDay.schedule_pm - newCtrl.donationForm.pickupDay.pm >= newCtrl.donationForm.pickupDay.schedule_pm)\"><div class=\"alert-icon pull-left\"><img src=/assets/images/alert-circle.png alt=\"\"></div><div class=\"alert-msg pull-left\"><p><span>The selected pickup date & time slot is at max capacity, you can make an</span> <span>exception and submit this donation anyways.</span></p></div></div><div class=col-xs-12><div class=\"day-picker clearfix\"><div ng-repeat=\"day in newCtrl.pickupDays.availableDays[newCtrl.pickupDays.selectedWeek]\" class=day-wrapper ng-class=\"{\'greyed\': !day.zip_available, \'activated\': day.date === newCtrl.donationForm.pickupDay.date && newCtrl.donationForm.pickupDay.warningConfirmed }\"><div class=title><span ng-if=!day.zip_available>UNAVAILABLE</span></div><div ng-class=\"{\'selected\': day.date === newCtrl.donationForm.pickupDay.date}\" class=day><h3 class=text-uppercase>{{day.date | date:\'EEE\'}}</h3><p>{{day.date | date:\'MMM d\'}}</p><div class=actions><button tabindex=-1 ng-click=\"newCtrl.selectPickupDate(day, \'am\')\" class=btn ng-class=\"day.date === newCtrl.donationForm.pickupDay.date && newCtrl.donationForm.part_of_day === \'am\' ? \'btn-primary\' : \'btn-default\'\"><span ng-class=\"{\'overload\': day.zip_available && day.schedule_am - day.am >= day.schedule_am && (day.date !== newCtrl.donationForm.pickupDay.date || newCtrl.donationForm.part_of_day !== \'am\')}\"><span>AM</span> <span>{{day.schedule_am - day.am}}/{{day.schedule_am}}</span></span></button> <button tabindex=-1 ng-click=\"newCtrl.selectPickupDate(day, \'pm\')\" class=btn ng-class=\"day.date === newCtrl.donationForm.pickupDay.date && newCtrl.donationForm.part_of_day === \'pm\' ? \'btn-primary\' : \'btn-default\'\"><span ng-class=\"{\'overload\': day.zip_available && day.schedule_pm - day.pm >= day.schedule_pm && (day.date !== newCtrl.donationForm.pickupDay.date || newCtrl.donationForm.part_of_day !== \'pm\')}\"><span>PM</span> <span>{{day.schedule_pm - day.pm}}/{{day.schedule_pm}}</span></span></button></div></div></div></div></div><div class=col-xs-12><div class=weekpick><div class=row><div class=col-xs-6><span ng-if=\"newCtrl.pickupDays.selectedWeek > 0\" ng-click=newCtrl.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i>Before {{newCtrl.pickupDays.availableDays[newCtrl.pickupDays.selectedWeek][0].date | date:\'MMM dd\'}}</span></div><div class=\"col-xs-6 text-right\"><span ng-if=\"newCtrl.pickupDays.selectedWeek < newCtrl.pickupDays.availableDays.length - 1\" ng-click=newCtrl.nextWeek()>After {{newCtrl.pickupDays.availableDays[newCtrl.pickupDays.selectedWeek][newCtrl.pickupDays.availableDays[newCtrl.pickupDays.selectedWeek].length - 1].date | date:\'MMM dd\'}}<i class=\"rspl-icon icon-shevron-right\"></i></span></div></div></div></div></div></div><div class=col-xs-12><div class=transport><div class=row><div class=col-xs-7><form ng-submit=newCtrl.addItem()><div class=row><div class=col-xs-12><div class=form-group><label>Items for Donation</label><div class=form-group ng-repeat=\"item in newCtrl.donationItems\"><div class=row><div class=col-xs-10><input ng-change=newCtrl.updateItem(item) ng-model=item.name type=text placeholder=\"eg. Chair\"><!--<button ng-click=\"newCtrl.removeItem(item)\" type=\"button\" class=\"btn text-only\">--><!-- - Remove--><!--</button>--></div><div class=col-xs-2><div class=\"counter clearfix\"><div class=pull-left>{{item.count}}</div><div class=pull-right><div ng-click=newCtrl.counterIncrement(item) class=count-up><i class=\"glyphicon glyphicon-chevron-up\"></i></div><div ng-click=newCtrl.counterDecrement(item) class=count-down><i class=\"glyphicon glyphicon-chevron-down\"></i></div></div></div></div></div></div><hr ng-if=newCtrl.donationItems.length><div class=row><div class=col-xs-10><input ng-model=newCtrl.newItem type=text placeholder=\"eg. Chair\"></div><div class=col-xs-2><div class=\"counter clearfix\"><div class=pull-left>{{newCtrl.newItemCount}}</div><div class=pull-right><div ng-click=\"newCtrl.newItemCount = newCtrl.newItemCount + 1;newCtrl.setDescription();\" class=count-up><i class=\"glyphicon glyphicon-chevron-up\"></i></div><div ng-class=\"{\'disabled\': newCtrl.newItemCount === 1}\" ng-click=\"newCtrl.newItemCount = newCtrl.newItemCount - 1;newCtrl.setDescription();\" class=count-down><i class=\"glyphicon glyphicon-chevron-down\"></i></div></div></div></div></div></div></div><div class=col-xs-12><button type=submit class=\"btn text-only\" ng-class=\"{\'disabled\': !newCtrl.newItem}\">+ Add Item</button></div></div></form></div><div class=col-xs-5><div class=form-group><label>Truck Assignment</label><ui-select ng-model=newCtrl.truck class=rspl-select title=\"Select Truck\" append-to-body=true ng-disabled=\"!newCtrl.trucks || newCtrl.trucks.length === 0\"><ui-select-match placeholder=\"Select Truck\" class=text-capitalize allow-clear=true>{{$select.selected.model}}</ui-select-match><ui-select-choices repeat=\"o in newCtrl.trucks | filter: $select.search\"><span ng-bind-html=o.model class=text-capitalize></span></ui-select-choices></ui-select></div><div class=form-group><label>Count As</label><ui-select ng-model=newCtrl.countAs class=rspl-select data-title=\"Count As\" append-to-body=true><ui-select-match placeholder=\"Select Count As\" class=text-capitalize>Count as {{$select.selected}}</ui-select-match><ui-select-choices repeat=\"o in newCtrl.countAsOptions | filter: $select.search\" ui-disable-choice=\"newCtrl.isString(o) && o !== \'Full \' + (newCtrl.donationForm.part_of_day | uppercase)\"><span ng-bind-html=\"\'Count as \' + o\" class=text-capitalize></span></ui-select-choices></ui-select></div><div class=form-group><label>Assign Label</label><ui-select ng-model=newCtrl.label class=\"rspl-select color-label-select\" title=\"Select Color\" append-to-body=true><ui-select-match placeholder=\"Set a color\" class=text-capitalize><div class=label-swatch ng-style=\"{\'background-color\': $select.selected.color, \'border-color\': $select.selected.color }\"></div>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"option in newCtrl.labels | filter: $select.search\"><div class=label-swatch ng-style=\"{\'background-color\': option.color, \'border-color\': option.color }\"></div><span ng-bind-html=option.name class=text-capitalize></span></ui-select-choices></ui-select></div></div></div></div></div></div></div><div uib-accordion-group class=panel-default is-open=newCtrl.accordion.optionalDetails><uib-accordion-heading><div class=panel-heading-inner>Optional Details <i class=\"pull-right rspl-icon\" ng-class=\"{\'icon-shevron-right\': !newCtrl.accordion.optionalDetails, \'icon-shevron-left\': newCtrl.accordion.optionalDetails}\"></i></div></uib-accordion-heading><div class=row><div class=col-xs-12><div class=\"donation-images clearfix\"><div class=row><div class=col-xs-7><div class=form-group><label>Donation Images</label><div ngf-select ng-model=newCtrl.files ngf-multiple=true ngf-max-size=10MB ngf-accept=\"\'image/*\'\"><div class=images-wrapper ng-if=!newCtrl.allFiles.length><div class=\"placeholder-img center-full\"><img src=/assets/images/add-image.png alt=\"\"><p>Add Image</p></div></div><div ng-if=newCtrl.allFiles.length class=\"images-wrapper clearfix\"><div class=img-wrapper ng-repeat=\"f in newCtrl.allFiles\"><div class=preview-img><img ngf-src=\"!f.$error && f\"></div><div ng-click=\"newCtrl.removePhoto($event, $index)\" class=remove-img></div></div></div></div></div></div><div class=col-xs-5><div class=selected-donor-info><div class=\"form-group estimated-price\"><label>Estimated Price ($)</label><input class=form-control ng-model=newCtrl.donationForm.estimated_price max=5000 min=0.1 type=number ng-pattern=/^\\d+([,.]\\d+)?$/ step=.01 placeholder=\"Value of All Items\"><!--<i>$</i>--></div><div class=form-group><label>Instructions for the Driver</label><textarea class=form-control ng-model=newCtrl.donationForm.special_instructions placeholder=\"Instructions for the Driver\"></textarea></div></div></div></div></div></div></div></div></uib-accordion></div><div class=modal-footer><div class=row><div class=col-xs-7></div><div class=col-xs-5><button ladda=newCtrl.isSubmitting ng-click=newCtrl.submitForm() ng-disabled=\"!newCtrl.donationForm.pickupDay || ((newCtrl.isNewDonor && donationForm.$invalid) || (!newCtrl.isNewDonor && !newCtrl.selectedDonor || newCtrl.selectedDonor && !newCtrl.selectedDonor.id || newCtrl.donorProfileIncomplete) || (newCtrl.donationForm.pickupDay.schedule_am === 0 && newCtrl.donationForm.pickupDay.schedule_pm === 0) && !newCtrl.donationForm.pickupDay.warningConfirmed)\" class=\"btn btn-primary btn-block\" type=submit>Submit</button></div></div><div uib-alert ng-repeat=\"alert in newCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=newCtrl.closeAlert($index) ng-bind-html=alert.msg></div></div></form>");
$templateCache.put("app/donations/prompts/no-tax/no-tax.html","<div class=modal-header><h3 class=modal-title id=modal-title>Tax Receipt not ready</h3></div><div class=modal-body id=modal-body><p>Sorry, tax receipt not ready, please try again later</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=noTaxCtrl.close()>Ok</button></div>");
$templateCache.put("app/donations/prompts/reject/reject.html","<div class=modal-header><h3 class=modal-title id=modal-title>Move to Hub</h3></div><div class=modal-body id=modal-body><p>Are you sure you want to submit this donation to the hub? <span class=info>If you are unable to pick up this donation, then that is a great option! We\'ve made the donation hub in order to minimize the number of donations that get declined by allowing other charities to view and claim donations from the hub. </span></p><textarea type=text class=form-control ng-model=rejectCtrl.reason placeholder=\"Why are you declining this donation?\"></textarea></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=rejectCtrl.close()>Close</button> <button ladda=rejectCtrl.isLoading class=\"btn btn-primary\" ng-click=rejectCtrl.reject()>Move to Hub</button><div uib-alert ng-repeat=\"alert in rejectCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=rejectCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/donations/prompts/reschedule/reschedule.html","<div class=modal-header><h3 class=modal-title id=modal-title>{{rescheduleCtrl.stepTitle}}</h3><div ng-click=rescheduleCtrl.close() class=close-btn></div></div><div class=modal-body id=modal-body><div class=step1 ng-if=\"rescheduleCtrl.currentStep === 1\"><p class=text-center>Are you sure you want to make a time change request? <span class=danger>Warning! </span>There is a chance donor will decline the time change and risk the success of donation pick up</p></div><div class=\"step2 day-picker-wrapper\" ng-if=\"rescheduleCtrl.currentStep === 2\"><p class=description>Select a new pickup date and time</p><div class=day-picker-inner><div class=row><div class=col-xs-12 ng-if=\"!rescheduleCtrl.pickupDays.availableDays.length && rescheduleCtrl.gettingAvailableDays\"><div class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-blue.gif alt=loading></div></div><div class=col-xs-12 ng-if=\"rescheduleCtrl.pickupDays.availableDays.length && !rescheduleCtrl.gettingAvailableDays\"><div class=\"day-picker clearfix\"><div ng-repeat=\"day in rescheduleCtrl.pickupDays.availableDays[rescheduleCtrl.pickupDays.selectedWeek]\" class=day-wrapper ng-class=\"{\'disabled\': $index === 0 && rescheduleCtrl.pickupDays.selectedWeek === 0}\"><div class=title><span ng-if=\"$index === 0 && rescheduleCtrl.pickupDays.selectedWeek === 0\">Today</span></div><div class=day><h3 class=text-uppercase>{{day.date | date:\'EEE\'}}</h3><p>{{day.date | date:\'MMM d\'}}</p><div class=actions><button tabindex=-1 ng-click=\"rescheduleCtrl.selectTime(day, \'am\')\" class=btn ng-class=\"day.selected && day.selected.indexOf(\'am\') !== -1 ? \'btn-primary\' : \'btn-default\'\"><span ng-class=\"{\'overload\': day.zip_available && day.schedule_am - day.am >= day.schedule_am && (day.selected.indexOf(\'am\') === -1)}\"><span>AM</span> <span ng-if=day.zip_available>{{day.schedule_am - day.am}}/{{day.schedule_am}}</span></span></button> <button tabindex=-1 ng-click=\"rescheduleCtrl.selectTime(day, \'pm\')\" class=btn ng-class=\"day.selected && day.selected.indexOf(\'pm\') !== -1 ? \'btn-primary\' : \'btn-default\'\"><span ng-class=\"{\'overload\': day.zip_available && day.schedule_pm - day.pm >= day.schedule_pm && (day.selected.indexOf(\'pm\') === -1)}\"><span>PM</span> <span ng-if=day.zip_available>{{day.schedule_pm - day.pm}}/{{day.schedule_pm}}</span></span></button></div></div></div></div></div><div class=col-xs-12><div class=weekpick><div class=row><div class=col-xs-6><span ng-if=\"rescheduleCtrl.pickupDays.selectedWeek > 0\" ng-click=rescheduleCtrl.previousWeek()><i class=\"rspl-icon icon-shevron-left\"></i>Before {{rescheduleCtrl.pickupDays.availableDays[rescheduleCtrl.pickupDays.selectedWeek][0].date | date:\'MMM dd\'}}</span></div><div class=\"col-xs-6 text-right\"><span ng-if=\"rescheduleCtrl.pickupDays.selectedWeek < rescheduleCtrl.pickupDays.availableDays.length - 1\" ng-click=rescheduleCtrl.nextWeek()>After {{rescheduleCtrl.pickupDays.availableDays[rescheduleCtrl.pickupDays.selectedWeek][rescheduleCtrl.pickupDays.availableDays[rescheduleCtrl.pickupDays.selectedWeek].length - 1].date | date:\'MMM dd\'}}<i class=\"rspl-icon icon-shevron-right\"></i></span></div></div></div></div></div></div></div><div class=step3 ng-if=\"rescheduleCtrl.currentStep === 3\"><p class=text-center style=\"font-size: 16px\">We have notified the donor about your requested date change and we will get back to you as soon as the donor confirms or declines the time change.</p></div></div><div class=modal-footer ng-class=\"{\'no-border\': rescheduleCtrl.currentStep === 2}\"><div class=step1 ng-if=\"rescheduleCtrl.currentStep === 1\"><button class=\"btn btn-default\" ng-click=rescheduleCtrl.cancel()>Cancel</button> <button class=\"btn btn-primary\" ng-click=rescheduleCtrl.confirm()>Confirm</button></div><div class=step2 ng-if=\"rescheduleCtrl.currentStep === 2\"><!--<button class=\"btn btn-default\" ng-click=\"rescheduleCtrl.cancel()\">Cancel</button>--><div class=row><div class=\"col-xs-5 col-xs-offset-7\"><button ladda=rescheduleCtrl.isSubmitting class=\"btn btn-primary btn-block\" ng-click=rescheduleCtrl.changeDate() id=submit-reschedule>Submit</button></div></div></div><div class=step3 ng-if=\"rescheduleCtrl.currentStep === 3\"><button class=\"btn btn-primary\" ng-click=rescheduleCtrl.close()>Okay</button></div><div uib-alert ng-repeat=\"alert in rescheduleCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=rescheduleCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/donations/prompts/single/single.donation.html","<div class=modal-header><div ng-click=singleCtrl.close() class=close-btn></div></div><div class=modal-body><div ng-if=!singleCtrl.noDonation class=\"main single-donation-screen\" id=printSection><div class=main><div uib-alert ng-repeat=\"alert in singleCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=singleCtrl.closeAlert($index)>{{alert.msg}}</div><div class=\"loader-wrapper text-center\" ng-if=singleCtrl.isLoading><img ng-src=assets/images/loader-blue.gif alt=loading></div><div class=single-donation-wrapper ng-if=!singleCtrl.isLoading><div class=images-wrapper><img ng-src=assets/images/zoom-in.svg alt=zoom class=zoom ng-click=singleCtrl.openInGallery(singleCtrl.donation) ng-if=\"singleCtrl.donation.photos.length > 0 && singleCtrl.donation.photos[0].url\"><slick class=slider-for settings=singleCtrl.slickConfig infinite=true slides-to-show=1 slides-to-scroll=1><div class=slick-item ng-repeat=\"photo in singleCtrl.donation.photos\" ng-if=photo.url><img ng-if=photo.url ng-src={{photo.fullPath}} alt=photo ng-click=singleCtrl.openInGallery(singleCtrl.donation)></div><div class=slick-item ng-if=\"singleCtrl.donation.photos.length === 0 || !singleCtrl.donation.photos[0].url\"><img ng-src=/assets/images/charity-img@3x.png alt=photo></div></slick><div class=donation-content><span class=\"badge text-capitalize status\" ng-class=\"{\'badge-primary\' : singleCtrl.donation.request.status === \'completed\', \'badge-success\' : singleCtrl.donation.request.status === \'accepted\', \'badge-error\' : singleCtrl.donation.request.status === \'canceled\', \'badge-orange\' : singleCtrl.donation.request.status === \'rejected\', \'badge-warning\' : singleCtrl.donation.request.status === \'pending\' || singleCtrl.donation.request.status === \'in_pool\'}\">{{singleCtrl.donation.request.status === \'in_pool\' ? \'In Pool\' : singleCtrl.donation.request.status === \'awaiting_user_response\' ? \'Waiting for response\': singleCtrl.donation.request.status}}</span><p class=items><span ng-repeat=\"item in singleCtrl.donation.content\">{{item.count}}x {{item.item_type}}</span></p></div></div><div class=donation-data><div class=row><div class=col-md-5><h3 class=pull-left><span>{{singleCtrl.donation.request.donor.first_name ? singleCtrl.donation.request.donor.first_name + \' \' : \'/\'}}</span> <span>{{singleCtrl.donation.request.donor.last_name ? singleCtrl.donation.request.donor.last_name : \'/\'}}</span></h3><p class=phone>{{ singleCtrl.donation.request.status===\'in_pool\' ? \'\' : singleCtrl.donation.phone}}</p><p class=email><a href=mailto:{{singleCtrl.donation.request.donor.email}} target=_blank>{{singleCtrl.donation.request.donor .email}}</a></p><p class=\"donation-date pull-left\">{{ singleCtrl.donation.request.status === \'awaiting_user_response\' ? singleCtrl.donation.initialRequest.date : singleCtrl.donation.request.date | date: \"MMM dd\" }} | <span class=text-uppercase>{{singleCtrl.donation.request.status === \'awaiting_user_response\' ? singleCtrl.donation.initialRequest.part_of_day : singleCtrl.donation.request.part_of_day}}</span></p><span class=\"badge text-capitalize status\" ng-if=\"singleCtrl.donation.request.status === \'awaiting_user_response\'\">Date change request made</span><div class=\"btn btn-primary btn-small\" ng-if=\"singleCtrl.donation.request.status == \'pending\' || singleCtrl.donation.request.status == \'accepted\'\" ng-click=singleCtrl.openChangeDatePrompt(singleCtrl.donation) id=change-date-modal>Change date</div><p class=donation-address>{{singleCtrl.donation.address}}{{singleCtrl.donation.city ? \',\' + singleCtrl.donation.city : \'\'}}{{singleCtrl.donation.state? \',\' + singleCtrl.donation.state: \'\'}}</p><p class=submission-date>{{\'Submitted:\' + \' \' + singleCtrl.donation.submission_date}}</p><p class=donation-zip>ZIP: <span>{{singleCtrl.donation.zip}}</span></p><p ng-if=singleCtrl.donation.handling_required class=warning>Indoor Item Removal</p><div class=row ng-if=\"singleCtrl.donation.request.status !== \'in_pool\'\"><div class=col-md-9><ui-select ng-disabled=\"!singleCtrl.trucks || singleCtrl.trucks.length === 0 || (singleCtrl.donation.request.status !== \'accepted\')\" ng-model=singleCtrl.truck class=rspl-select title=\"Select Truck\" append-to-body=true ng-change=singleCtrl.assignTruck()><ui-select-match placeholder=\"Select Truck\" class=text-capitalize>{{$select.selected.model}}</ui-select-match><ui-select-choices repeat=\"o in singleCtrl.trucks | filter: $select.search\"><span ng-bind-html=o.model class=text-capitalize></span></ui-select-choices></ui-select><ui-select ng-model=singleCtrl.countAs class=rspl-select data-title=\"Count As\" append-to-body=true ng-change=singleCtrl.updateCountAs(singleCtrl.donation) ng-disabled=\"singleCtrl.donation.request.status !== \'accepted\'\"><ui-select-match placeholder=\"Select Count As\" class=text-capitalize>Count as {{$select.selected}}</ui-select-match><ui-select-choices repeat=\"o in singleCtrl.countAsOptions | filter: $select.search\" ui-disable-choice=\"singleCtrl.isString(o) && o !== \'Full \' + (singleCtrl.donation.request.part_of_day | uppercase)\"><span ng-bind-html=\"\'Count as \' + o\" class=text-capitalize></span></ui-select-choices></ui-select><ui-select ng-disabled=\"!singleCtrl.labels || singleCtrl.labels.length === 0 || singleCtrl.donation.request.status !== \'accepted\'\" ng-model=singleCtrl.label class=\"rspl-select color-label-select\" title=\"Select Color\" append-to-body=true ng-change=singleCtrl.assignLabel()><ui-select-match placeholder=\"Set a color\" class=text-capitalize><div class=label-swatch ng-style=\"{\'background-color\': $select.selected.color, \'border-color\': $select.selected.color }\"></div>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"o in singleCtrl.labels | filter: $select.search\"><div class=label-swatch ng-style=\"{\'background-color\': o.color, \'border-color\': o.color }\"></div><span ng-bind-html=o.name class=text-capitalize></span></ui-select-choices></ui-select><div class=pickup-ordering><span class=select-label>Pickup order:</span> <span class=part-of-day>{{singleCtrl.donation.request.part_of_day}}</span><ui-select ng-disabled=\"singleCtrl.donation.request.status !== \'accepted\' || !singleCtrl.donation.request.truck\" ng-model=singleCtrl.order class=\"rspl-select order-select\" title=- append-to-body=true ng-change=singleCtrl.assignOrder()><ui-select-match placeholder=- class=text-capitalize>{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"o in singleCtrl.orders | filter: $select.search\"><span ng-bind-html=o class=text-capitalize></span></ui-select-choices></ui-select></div></div></div><div class=for-print><label>Truck</label><p ng-if=singleCtrl.truck>{{singleCtrl.truck.model+\' - \'+singleCtrl.truck.licence_plate}}</p><p ng-if=!singleCtrl.truck>/</p></div></div><div class=col-md-7><label>Instructions for the driver</label><p class=multi-line>{{singleCtrl.donation.special_instructions ? singleCtrl.donation.special_instructions : \'/\'}}</p><div class=donation-description><div class=edit-description><form name=descriptionForm ng-submit=singleCtrl.saveNewDescription()><label>Donation description</label><textarea name=editDesc class=\"form-control description\" ng-model=singleCtrl.donation.description>\n                                        </textarea><button type=submit ladda=singleCtrl.isSavingDescription class=\"btn btn-save btn-primary pull-right\" ng-disabled=!descriptionForm.$dirty>Save description</button></form></div></div><div class=donation-note><form name=notesForm ng-submit=singleCtrl.saveNote()><label>Donation note</label><textarea class=form-control ng-model=singleCtrl.donation.request.notes></textarea><button type=submit ladda=singleCtrl.isSavingNote class=\"btn btn-save btn-primary pull-right\" ng-disabled=\"!notesForm.$dirty || !singleCtrl.donation.request.notes\">Save Note</button></form></div></div></div><hr><div class=\"donation-actions clearfix\"><div class=\"btn btn-disabled pull-left\" ng-if=\"singleCtrl.donation.request.status === \'completed\'\">Completed</div><div class=\"btn btn-primary pull-left btn-icon\" ng-click=\"singleCtrl.openModal(\'claim\')\" ng-if=\"singleCtrl.donation.request.status === \'in_pool\'\"><i class=\"rspl-icon icon-claim-donation\"></i>Claim donation</div><div class=\"btn btn-primary pull-left\" ng-click=\"singleCtrl.openModal(\'accept\')\" ng-if=\"singleCtrl.donation.request.status === \'pending\'\">Accept</div><div class=\"btn btn-primary pull-left\" ng-if=\"singleCtrl.donation.request.status === \'accepted\'\" ng-click=\"singleCtrl.openModal(\'complete\')\">Mark as Completed</div><div class=\"btn btn-transparent pull-left\" ng-if=\"singleCtrl.donation.request.status === \'pending\' && !singleCtrl.donation.manual\" ng-click=\"singleCtrl.openModal(\'reject\')\">Move to Donation Hub</div><div class=\"more-options pull-right\"><button class=\"btn btn-default\" ng-click=\"singleCtrl.openModal(\'cancel\')\" ng-disabled=\"singleCtrl.donation.request.status !== \'accepted\'\">Cancel pickup</button> <button class=\"btn btn-default\" ng-click=singleCtrl.showTaxReceipt()>Tax</button> <button id=printDonation class=\"btn btn-default\" ng-click=singleCtrl.printDonation()>Print</button> <button class=\"btn btn-default\" ng-if=singleCtrl.donation.manual ng-click=singleCtrl.editManualDonation()>Edit</button></div></div></div></div></div></div><h3 class=text-center ng-if=singleCtrl.noDonation style=\"padding: 100px 0 160px 0\">Sorry, donation not found!</h3></div>");
$templateCache.put("app/donations/prompts/submitted/submitted.html","<div class=modal-header><h3 class=modal-title id=modal-title>Donation Submitted</h3><div ng-click=submittedCtrl.close() class=close-btn></div></div><div class=modal-body id=modal-body><div class=content><span><b>{{submittedCtrl.donation.firstName + \' \' + submittedCtrl.donation.lastName}}’s</b> donation has been added</span> <span>to your calendar for <b>{{submittedCtrl.donation.date | date: \'EEEE, MMM dd yyyy\'}}.</b></span></div><div class=\"row actions\"><div class=col-xs-6><button style=\"padding: 9px 10px\" class=\"btn btn-default btn-block\" ng-click=submittedCtrl.addAnotherDonation()>Add Another Donation</button></div><div class=col-xs-6><button class=\"btn btn-primary btn-block\" ng-click=submittedCtrl.viewCalendar()>View Calendar</button></div></div></div>");
$templateCache.put("app/fleetmanagement/pickupreports/pickupreport/pickupreport.html","<div class=pickup-report><div class=\"container main\"><div class=report ng-if=vm.report><div ng-click=vm.back() class=back-btn><span class=arrow-icon><img src=assets/images/arrow-right-blue@3x.png alt=\"\"> </span><span class=back-label>Back</span></div><h3>Driver\'s Report</h3><div class=\"driver-info clearfix\"><div class=\"driver-photo pull-left\"><img ng-src=\"{{vm.report.creator && vm.report.creator.photo ? vm.imageBaseUrl + vm.report.creator.photo.url : \'\'}}\"></div><div class=\"driver-name pull-left\"><h4>{{vm.report.creator ? vm.report.creator.first_name + \' \' + vm.report.creator.last_name : \'No Data\'}}</h4><p>Driver</p></div></div><div class=truck-label-wrapper><span class=truck-label ng-style=\"{\'background-color\': vm.report.donation.requests[0].truck.color}\">{{vm.report.donation.requests[0].truck.model}}</span></div><div class=pickup-description><p class=description>{{vm.report.notes}}</p><div class=\"photos clearfix\"><img ng-repeat=\"photo in vm.report.photos\" ng-src=\"{{vm.imageBaseUrl + photo.url}}\" ng-click=vm.openGallery(photo.index)></div></div><div class=pickup-details><div class=row><div class=col-xs-6><div class=original-pickup-info><h3>Original Pickup Info</h3><donation-card ng-if=vm.report.donation no-actions=true donation=vm.report.donation card-type=db></donation-card></div></div><div class=col-xs-6><div class=items-list><h3>Items List</h3><p ng-repeat=\"a in vm.report.donation.description.split(\',\')\">{{a}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/database/donorgroups/prompts/deletegroup/deletegroup.html","<div class=modal-header><h3 class=modal-title id=modal-title>Delete Group - {{delCtrl.group.name}}</h3></div><div class=modal-body id=modal-body><p>Are you sure you want to delete donors group?</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=delCtrl.close()>Close</button> <button ladda=delCtrl.deletingGroup class=\"btn btn-primary\" ng-click=delCtrl.delete_group(delCtrl.group.id)>Delete</button><div uib-alert ng-repeat=\"alert in delCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=acceptCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/database/donorgroups/singlegroup/editgroup/editgroup.html","<div class=edit-group><div class=bottom-nav><div class=\"main container\"><!--<div class=\"btn btn-primary pull-left\"><span>Back</span></div>--><div class=\"group-action-btns pull-right\"><div class=\"btn btn-cancel\" ui-sref=\"database.donorgroups.singlegroup({ id: {{ vm.current_group.id }} })\"><span>Cancel</span></div><div ladda=vm.editingGroup class=\"btn btn-primary\" ng-class=\"{\'disabled\': !vm.current_group.name || !vm.current_group.contacts.length}\" ng-click=vm.editDonorGroup()><span>Save</span></div></div></div></div><div class=content><div class=\"main container\"><div class=group-editor><div class=select-group><div class=row><div class=col-sm-2><div class=\"btn btn-primary\" ng-class=\"{\'btn-primary\' : vm.activeFilter === \'app_user\'}\" ng-click=\"vm.getContactsByCharityId(\'app_user\')\" id=app-users>App Users</div></div><div class=col-sm-2><div class=\"btn btn-inverse\" ng-class=\"{\'btn-primary\' : vm.activeFilter === \'non_app_user\'}\" ng-click=\"vm.getContactsByCharityId(\'non_app_user\')\" id=non-app-users>Non App Users</div></div><div class=col-sm-2><div class=\"btn btn-inverse\" ng-class=\"{\'btn-primary\' : vm.activeFilter === \'call_log\'}\" ng-click=\"vm.getContactsByCharityId(\'call_log\')\" id=phone-users>Phone</div></div><div class=col-sm-2><div class=\"btn btn-inverse\" disabled>Upload CSV</div></div><div class=col-sm-4><ui-select ng-model=vm.selectedGroup class=\"rspl-select big-select\" title=\"Donor Groups\" append-to-body=true ng-change=vm.getSelectedGroup(vm.selectedGroup.id)><ui-select-match class=text-capitalize placeholder=\"Previous Groups\" allow-clear=false>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"o in vm.groups | filter: $select.search | orderBy:\'name\'\"><span ng-bind-html=o.name class=text-capitalize></span></ui-select-choices></ui-select></div></div></div><div class=all_contacts><table><thead><tr><th><div class=mg-checkbox><input type=checkbox ng-model=vm.allContactsSelected ng-checked=vm.allContactsSelected><label ng-class=\"{\'selected\': vm.allContactsSelected}\" ng-click=vm.selectAllContacts() id=checkbox-label-select-all></label></div>Donor</th><th>Address</th><th>Zip</th><th>Last donation</th><th>Phone</th></tr></thead></table><div class=table-body ng-scrollbars ng-scrollbars-config=vm.scrollConfig><table><tbody><div ng-if=vm.fetchingAllContacts class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div></tbody><tbody ng-if=!vm.fetchingAllContacts><tr ng-repeat=\"contact in vm.contacts\"><td><div class=mg-checkbox><input type=checkbox ng-model=contact.selected ng-checked=contact.selected><label ng-class=\"{\'selected\': contact.selected}\" ng-click=vm.selectContactItem(contact)></label></div>{{contact.first_name+\' \'+contact.last_name}}</td><td>{{contact.address}}</td><td>{{contact.zip}}</td><td>{{contact.last_donation_date | date : \'MMM dd yyyy\'}}</td><td>{{contact.phone}}</td></tr></tbody></table></div></div><div class=\"add-remove-contact clearfix\"><div class=\"btns-container pull-left\"><button class=\"btn btn-primary\" ng-click=vm.addContactsToGroup()><img ng-src=assets/images/arrow-down.png alt=\"\"><p>Insert</p></button> <button class=\"btn btn-primary\" ng-click=vm.removeContactsFromGroup()><img ng-src=assets/images/arrow-up.png alt=\"\"><p>Remove</p></button></div><form class=\"group_name_form pull-right\"><label for=group_name>New Group Name</label><input id=group_name type=text ng-model=vm.current_group.name></form></div><div class=group_contacts><table><thead><tr><th><div class=mg-checkbox><input type=checkbox ng-model=vm.groupContactsSelected ng-checked=vm.groupContactsSelected><label id=checkbox-label-selected-all ng-class=\"{\'selected\': vm.groupContactsSelected}\" ng-click=vm.selectAllGroupContacts()></label></div>Donor</th><th>Address</th><th>Zip</th><th>Last donation</th><th>Phone</th></tr></thead></table><div class=table-body ng-scrollbars ng-scrollbars-config=vm.scrollConfig><table><tbody><div ng-if=vm.fetchingGroupContacts class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div></tbody><tbody ng-if=!vm.fetchingGroupContacts><tr ng-repeat=\"donor in vm.current_group.contacts\"><td><div class=mg-checkbox><input type=checkbox ng-model=donor.selected ng-checked=donor.selected><label ng-class=\"{\'selected\': donor.selected}\" ng-click=vm.selectContactItem(donor)></label></div>{{donor.first_name+\' \'+donor.last_name}}</td><td>{{donor.address}}</td><td>{{donor.zip}}</td><td>{{donor.last_donation_date | date : \'MMM dd yyyy\'}}</td><td>{{donor.phone}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/database/donormanagement/prompts/add/add-contact.html","<div class=modal-header><h3 class=modal-title id=modal-title>Add Donor</h3></div><div class=modal-body id=modal-body><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><form ng-if=!vm.isLoading action=\"\"><div class=row><div class=\"col-sm-6 form-group\"><label for=first_name>First Name</label><input class=form-control id=first_name type=text placeholder=\"eg. Gregory\" ng-model=addContactCtrl.contact.first_name></div><div class=\"col-sm-6 form-group\"><label for=last_name>Last Name</label><input class=form-control id=last_name type=text placeholder=\"eg. Simpson\" ng-model=addContactCtrl.contact.last_name></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=phone_num>Phone</label><input class=form-control id=phone_num type=text placeholder=\"eg. +1 (506) 397 4567\" ng-model=addContactCtrl.contact.phone></div><div class=\"col-sm-6 form-group\"><label for=alt_phone_num>Alternate Phone Number</label><input class=form-control id=alt_phone_num type=text placeholder=\"eg. +1 (506) 397 4567\" ng-model=addContactCtrl.contact.alternative_phone></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=email>Email</label><input class=form-control id=email type=text placeholder=\"eg. gregsimpson@gmail.com\" ng-model=addContactCtrl.contact.email></div><div class=\"col-sm-6 form-group\"><label for=organization>Organization</label><input class=form-control id=organization type=text placeholder=Organization ng-model=addContactCtrl.contact.organization></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=address>Address</label><input class=form-control id=address type=text placeholder=\"eg. Pickup address\" ng-model=addContactCtrl.contact.address></div><div class=\"col-sm-6 form-group\"><label for=address_2>Address line 2</label><input class=form-control id=address_2 type=text placeholder=\"eg. Second address line\" ng-model=addContactCtrl.contact.address2></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=city>City</label><input class=form-control id=city type=text placeholder=\"eg. Atlanta\" ng-model=addContactCtrl.contact.city></div><div class=col-sm-6><div class=row><div class=\"col-sm-6 form-group\"><label for=state>State</label><input class=form-control id=state type=text placeholder=\"eg. Georgia\" ng-model=addContactCtrl.contact.state></div><div class=\"col-sm-6 form-group\"><label for=zip>Zip</label><input class=form-control id=zip type=text placeholder=\"eg. 51067\" ng-model=addContactCtrl.contact.zip></div></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-sm-12 form-group\">--><!--<div class=\"btn-group two-btns clearfix\" style=\"margin-top: 25px\">--><!--<div ng-click=\"addContactCtrl.homeType = \'house\'\"--><!--ng-class=\"{\'btn-primary\' : addContactCtrl.homeType === \'house\', \'btn-default\' : addContactCtrl.homeType !== \'house\'}\"--><!--class=\"btn\">Home--><!--</div>--><!--<div ng-click=\"addContactCtrl.homeType = \'apartment\'\"--><!--ng-class=\"{\'btn-primary\' : addContactCtrl.homeType === \'apartment\', \'btn-default\' : addContactCtrl.homeType !== \'apartment\'}\"--><!--class=\"btn\">Apartment--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"row\" ng-if=\"addContactCtrl.homeType === \'apartment\'\">--><!--<div class=\"col-sm-6 form-group\"><label for=\"gate_code\">Gate Code</label><input class=\"form-control\" id=\"gate_code\" type=\"text\" placeholder=\"eg. 5593\"></div>--><!--<div class=\"col-sm-6\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-6 form-group\"><label for=\"elevator_code\">Elevator Code</label><input class=\"form-control\" id=\"elevator_code\" type=\"text\" placeholder=\"eg. 121212\"></div>--><!--<div class=\"col-sm-6 form-group\"><label for=\"concierge_code\">Concierge Code</label><input class=\"form-control\" id=\"concierge_code\" type=\"text\" placeholder=\"eg. 121212\"></div>--><!--</div>--><!--</div>--><!--</div>--></form></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=addContactCtrl.close()>Cancel</button> <button ladda=addContactCtrl.editingContact class=\"btn btn-primary\" ng-click=addContactCtrl.addContact(addContactCtrl.contact)>Save</button><div uib-alert style=\"margin-top: 30px\" ng-repeat=\"alert in addContactCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=addContactCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/database/donormanagement/prompts/editcontact/editcontact.html","<div class=modal-header><h3 class=modal-title id=modal-title>Edit Donor</h3></div><div class=modal-body id=modal-body><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><form ng-if=!vm.isLoading action=\"\"><div class=row><div class=\"col-sm-6 form-group\"><label for=first_name>First Name</label><input class=form-control id=first_name type=text placeholder=\"eg. Gregory\" ng-model=editContactCtrl.contact.first_name></div><div class=\"col-sm-6 form-group\"><label for=last_name>Last Name</label><input class=form-control id=last_name type=text placeholder=\"eg. Simpson\" ng-model=editContactCtrl.contact.last_name></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=phone_num>Phone</label><input class=form-control id=phone_num type=text placeholder=\"eg. +1 (506) 397 4567\" ng-model=editContactCtrl.contact.phone></div><div class=\"col-sm-6 form-group\"><label for=alt_phone_num>Alternate Phone Number</label><input class=form-control id=alt_phone_num type=text placeholder=\"eg. +1 (506) 397 4567\" ng-model=editContactCtrl.contact.alternative_phone></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=email>Email</label><input class=form-control id=email type=text placeholder=\"eg. gregsimpson@gmail.com\" ng-model=editContactCtrl.contact.email></div><div class=\"col-sm-6 form-group\"><label for=organization>Organization</label><input class=form-control id=organization type=text placeholder=Organization ng-model=editContactCtrl.contact.organization></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=address>Address</label><input class=form-control id=address type=text placeholder=\"eg. Pickup address\" ng-model=editContactCtrl.contact.address></div><div class=\"col-sm-6 form-group\"><label for=address_2>Address line 2</label><input class=form-control id=address_2 type=text placeholder=\"eg. Second address line\" ng-model=editContactCtrl.contact.address2></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=city>City</label><input class=form-control id=city type=text placeholder=\"eg. Atlanta\" ng-model=editContactCtrl.contact.city></div><div class=col-sm-6><div class=row><div class=\"col-sm-6 form-group\"><label for=state>State</label><input class=form-control id=state type=text placeholder=\"eg. Georgia\" ng-model=editContactCtrl.contact.state></div><div class=\"col-sm-6 form-group\"><label for=zip>Zip</label><input class=form-control id=zip type=text placeholder=\"eg. 51067\" ng-model=editContactCtrl.contact.zip></div></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-sm-12 form-group apartment_or_house\">--><!--<button class=\"btn pull-left active\">Apartment</button>--><!--<button class=\"btn pull-left\">House</button>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"col-sm-6 form-group\"><label for=\"gate_code\">Gate Code</label><input class=\"form-control\" id=\"gate_code\" type=\"text\" placeholder=\"eg. 5593\"></div>--><!--<div class=\"col-sm-6\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-6 form-group\"><label for=\"elevator_code\">Elevator Code</label><input class=\"form-control\" id=\"elevator_code\" type=\"text\" placeholder=\"eg. 121212\"></div>--><!--<div class=\"col-sm-6 form-group\"><label for=\"concierge_code\">Concierge Code</label><input class=\"form-control\" id=\"concierge_code\" type=\"text\" placeholder=\"eg. 121212\"></div>--><!--</div>--><!--</div>--><!--</div>--></form></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=editContactCtrl.close()>Cancel</button> <button ladda=editContactCtrl.editingContact class=\"btn btn-primary\" ng-click=editContactCtrl.editContact(editContactCtrl.contact)>Save</button><!--<div uib-alert ng-repeat=\"alert in editContactCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\"--><!--close=\"editContactCtrl.closeAlert($index)\">{{alert.msg}}--><!--</div>--></div>");
$templateCache.put("app/database/donormanagement/prompts/export-modal/export-modal.html","<div class=export-modal><div class=modal-header><div class=close-btn ng-click=exportContactsCtrl.close()></div></div><div class=modal-body><p class=action-title><img ng-src=assets/images/ic_excel.svg> Export Your Donor List to Excel</p><p class=export-status>{{exportContactsCtrl.fetchingDone ? \'Congratulations!\\n Your donor database is ready for you!\' : \'Please wait while we prepare your donor database excel file.\'}}</p><uib-progressbar ng-if=!exportContactsCtrl.fetchingDone max=exportContactsCtrl.pagination.total_pages value=exportContactsCtrl.pagination.current_page><span>{{exportContactsCtrl.timeLeftMessage ? exportContactsCtrl.timeLeftMessage : \'calculating time remaining\'}}</span></uib-progressbar><button ng-if=exportContactsCtrl.fetchingDone ng-click=exportContactsCtrl.exportToXLS() class=\"btn btn-primary btn-excel btn-block\">Click Here to Download Your Donor List to an Excel File</button> <a ng-if=exportContactsCtrl.fetchingDone href=https://resupplyme.atlassian.net/wiki/spaces/RCFKM/pages/318799880/Export+Donor+Database+to+Excel target=_blank class=\"btn btn-primary btn-block\">If you need help downloading your donor list, please press here!</a></div></div>");
$templateCache.put("app/database/donormanagement/prompts/remove/remove.html","<div class=modal-header><h3 class=modal-title id=modal-title>Remove User</h3></div><div class=modal-body id=modal-body><p>Are you sure you want to remove user from donor list?</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=removeCtrl.close()>Close</button> <button ladda=removeCtrl.isLoading class=\"btn btn-primary\" ng-click=removeCtrl.remove()>Remove</button><div uib-alert ng-repeat=\"alert in removeCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=removeCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/database/donormanagement/prompts/view/view.html","<div class=modal-header><h3 class=modal-title id=modal-title>Donor profile</h3><div ng-click=viewCtrl.close() class=close-btn></div></div><div class=\"modal-body view-donor\" id=modal-body><div class=donor><div ng-if=\"viewCtrl.contact.photo && viewCtrl.contact.photo.url\" class=image ng-style=\"{\'background-image\': \'url({{viewCtrl.imageBaseUrl}}{{viewCtrl.contact.photo.url}}?w=360)\'}\"></div><div ng-if=\"!viewCtrl.contact.photo || !viewCtrl.contact.photo.url\" class=image ng-style=\"{\'background-image\': \'url(/assets/images/user-img@2x.png)\'}\"></div><div class=name><span>{{viewCtrl.contact.first_name}} {{viewCtrl.contact.last_name}}</span> <span>High rank</span></div><div class=contact-info><span>{{viewCtrl.contact.address}} {{viewCtrl.contact.state}}, {{viewCtrl.contact.city}} - ZIP:<span class=zip>{{viewCtrl.contact.zip}}</span></span> <span>{{viewCtrl.contact.phone}}</span> <span>{{viewCtrl.contact.email}}</span></div><div class=clearfix></div></div><div class=separator></div><div class=donations-stats><span>Total donations</span> <span id=contact-donations-count>{{viewCtrl.contact.donations_count}}</span> <span>Total value</span> <span>${{viewCtrl.contact.donations_value}}</span></div><div class=separator></div><div class=\"donations row\"><div class=\"col-xs-12 col-sm-6\" ng-repeat=\"d in viewCtrl.donations\"><donation-card donation=d card-type=db></donation-card></div><div class=\"col-xs-12 load-more\" ng-if=\"viewCtrl.totalPages > 0 && viewCtrl.page !== viewCtrl.totalPages && !viewCtrl.isLoading\"><div class=\"btn btn-primary\" ng-click=viewCtrl.nextPage()>Load more</div></div><div class=col-xs-12><div ng-if=viewCtrl.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><p ng-if=\"!viewCtrl.isLoading && (!viewCtrl.donations || viewCtrl.donations.length === 0)\" class=\"text-center no-items\">No donations</p></div><div class=clearfix></div></div></div>");
$templateCache.put("app/database/users-list/prompts/add/add-user.html","<div class=modal-header><h3 class=modal-title id=modal-title>Add User</h3></div><div class=modal-body id=modal-body><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><form ng-if=!vm.isLoading action=\"\"><div class=row><div class=\"col-sm-6 form-group\"><label for=first_name>First Name</label><input class=form-control id=first_name type=text placeholder=\"eg. Gregory\" ng-model=addUserCtrl.user.first_name></div><div class=\"col-sm-6 form-group\"><label for=last_name>Last Name</label><input class=form-control id=last_name type=text placeholder=\"eg. Simpson\" ng-model=addUserCtrl.user.last_name></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=email>Email</label><input class=form-control id=email type=text placeholder=\"eg. gregsimpson@gmail.com\" ng-model=addUserCtrl.user.email></div><div class=\"col-sm-6 form-group\"><label for=password>Password</label><input class=form-control id=password type=text placeholder=\"eg. Password\" ng-model=addUserCtrl.user.password></div></div><div class=row><div class=\"col-sm-6 form-group\"><label>Role</label><div class=form-switch><div ng-click=\"addUserCtrl.role = \'charity_admin\'\" ng-class=\"{\'active\': addUserCtrl.role ===\'charity_admin\'}\">Admin</div><div ng-click=\"addUserCtrl.role = \'charity_driver\'\" ng-class=\"{\'active\': addUserCtrl.role ===\'charity_driver\'}\">Driver</div></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=addUserCtrl.close()>Cancel</button> <button ladda=addUserCtrl.adding class=\"btn btn-primary\" ng-click=addUserCtrl.add(addUserCtrl.user)>Save</button><div uib-alert style=\"margin-top: 30px\" ng-repeat=\"alert in addUserCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=addUserCtrl.closeAlert($index)>{{alert.msg}}</div></div>");
$templateCache.put("app/database/users-list/prompts/edit/edit-user.html","<div class=modal-header><h3 class=modal-title id=modal-title>Edit User</h3></div><div class=modal-body id=modal-body><div ng-if=vm.isLoading class=\"loader-wrapper text-center\"><img ng-src=assets/images/loader-white.gif alt=loading></div><form ng-if=!vm.isLoading action=\"\"><div class=row><div class=\"col-sm-6 form-group\"><label for=first_name>First Name</label><input class=form-control id=first_name type=text placeholder=\"eg. Gregory\" ng-model=editUserCtrl.user.first_name></div><div class=\"col-sm-6 form-group\"><label for=last_name>Last Name</label><input class=form-control id=last_name type=text placeholder=\"eg. Simpson\" ng-model=editUserCtrl.user.last_name></div></div><div class=row><div class=\"col-sm-6 form-group\"><label for=email>Email</label><input class=form-control id=email type=text placeholder=\"eg. gregsimpson@gmail.com\" ng-model=editUserCtrl.user.email></div><div class=\"col-sm-6 form-group\"><label for=password>Password</label><input class=form-control id=password type=text placeholder=Password ng-model=editUserCtrl.user.password></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=editUserCtrl.close()>Cancel</button> <button ladda=editUserCtrl.editingUser class=\"btn btn-primary\" ng-click=editUserCtrl.editUser(editUserCtrl.user)>Save</button><!--<div uib-alert ng-repeat=\"alert in editUserCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\"--><!--close=\"editUserCtrl.closeAlert($index)\">{{alert.msg}}--><!--</div>--></div>");
$templateCache.put("app/donations/prompts/single/gallery/gallery.html","<div class=modal-header><div ng-click=galleryCtrl.close() class=close-btn></div></div><div class=\"gallery images-wrapper\"><slick class=slider-for settings=galleryCtrl.slickConfig infinite=true slides-to-show=1 slides-to-scroll=1><div class=slick-item ng-repeat=\"photo in galleryCtrl.donation.photos\"><img ng-if=galleryCtrl.donation.photos[0].url ng-src={{galleryCtrl.imageBaseUrl+photo.url}} alt=photo></div><div class=slick-item ng-if=\"galleryCtrl.donation.photos.length === 0\"><img ng-src=/assets/images/charity-img@3x.png alt=photo></div></slick></div>");
$templateCache.put("app/donations/prompts/single/tax-popover/tax-options.html","<ul><li ng-click=singleCtrl.showTaxReceipt() class=option-item>Tax preview</li><li ng-click=singleCtrl.generateTaxReceipt() class=option-item>Generate tax receipt</li></ul>");
$templateCache.put("app/fleetmanagement/liveview/prompts/no-trucks/no-trucks.html","<div class=modal-header><h3 class=modal-title id=modal-title>{{ctrl.promptData.title}}</h3><div ui-sref=fleetmanagement.truckregistration class=close-btn></div></div><div class=modal-body id=modal-body><p>{{ctrl.promptData.msg}}</p></div><div class=\"modal-footer text-center\" ng-if=ctrl.promptData.shouldAssignTruck><button class=\"btn btn-primary\" ui-sref=fleetmanagement.truckregistration>Assign a truck</button></div>");
$templateCache.put("app/fleetmanagement/pickupreports/pickupreport/imagegallery/gallery.html","<div class=pickup-report-gallery-modal><div class=modal-header><h3 class=modal-title id=modal-title>Report Gallery</h3><div class=close-btn ng-click=pickupReportGalleryCtrl.close()></div></div><div class=modal-body id=modal-body><div><div uib-carousel active=pickupReportGalleryCtrl.current no-wrap=false class=carousel><div uib-slide ng-repeat=\"photo in pickupReportGalleryCtrl.photos track by photo.index\" index=photo.index><img ng-src=\"{{pickupReportGalleryCtrl.imageBaseUrl + photo.url}}\" class=item-img></div></div></div></div></div>");
$templateCache.put("app/database/donorgroups/singlegroup/prompts/deletecontact/deletecontact.html","<div class=modal-header><h3 class=modal-title id=modal-title>Remove Donor - {{delContCtrl.contact.first_name + \' \' + delContCtrl.contact.last_name}}</h3></div><div class=modal-body id=modal-body><p>Are you sure you want to remove contact from this group?</p></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=delContCtrl.close()>Close</button> <button ladda=delContCtrl.deletingContact class=\"btn btn-primary\" ng-click=delContCtrl.deleteContact(delContCtrl.contact.id)>Remove</button><div uib-alert ng-repeat=\"alert in delContCtrl.alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=delContCtrl.closeAlert($index)>{{alert.msg}}</div></div>");}]);